import Le, { useReducer as xr, useCallback as ie, useEffect as q, memo as Ze, useMemo as Z, useState as K, useRef as Te, useContext as je, useLayoutEffect as Kd, createContext as qn, useId as Zd } from "react";
import { ModalContext as En, useSimpleImport as ep, useGenerate as tp, useAvailableModels as np, useFilterOptions as rp, getOverlayHistoryCount as bo, pushOverlayHistoryState as ip, useEntityNew as op, useExport as ap, useRequest as sp, DialogContext as lp, useAiEventsApi as cp, useSections as Oc } from "@prometheus/hooks";
import { EntityIconNames as Dc, CriteriaTypes as D, AttributeTypes as E, DropdownAttributesIds as m, LimitEvents as Wt, IntervalValue as ye, AttributeDetailsTypes as B, IntervalInclude as hn, DateEdge as Ss, EventPersistence as Ro, CountEvents as tr, OccurrenceCriteria as Is, TypesOfContainer as Ee, NameConflictResolution as Fe, StandardConceptTypes as up, FileExtension as Xr, ImportAtlasAsset as Ra, DateFormat as $t, mapStandardConceptTypes as dp, CollapseType as pp, ValidationMessageType as Fi, EntityTypes as ki, DefinitionKeys as As, CountEventsChar as On, TypesOfCreationBlock as $n, typesOfCreationBlock as hp, containerTypes as fp, IntervalIncludeChar as mp, IntervalValueChars as bs, IntervalValueDateChars as Rs } from "@prometheus/enums";
import { NameWithAliasCell as Ep, ActionCell as xp, EntityImport as Cp, ICON_COLUMN as gp, ID_COLUMN as yp, NAME_COLUMN as vc, CREATED_COLUMN as Tp, UPDATED_COLUMN as Sp, AUTHOR_COLUMN as Ip, EntityTypeCell as Ap, TabWithCounter as en, EntityMessagesTab as bp, ImportMultipleSource as _c, SpinnerWidgetContainer as Xt, TitleWithCount as Jr, FormElement as ze, FormActionsContainer as oo, Section as Oa, PageList as Nc, EntityMessages as Rp, CodeEditor as wc, Statistics as Op, useEntityMessages as Dp, useIsLibraryDataSteward as vp, useArchiveLibraryMember as _p, ErrorPage as Np, NestedInfoWrapper as wp, CohortBaseInfo as Pp, TabsNavigationNew as jp, SecondaryContentWrapper as yi, SpinnerContainer as Pc, Versions as Lp, MetaAttributes as Os, PublishEntity as kp, ExportMultipleSource as Mp, ConfirmationDialog as Vp, SubModuleDescriptionBlock as Up } from "@prometheus/features";
import { Box as W, IconButton as Qr, transparentize as Ds, Icon as ge, Tooltip as We, Input as Ye, useNotifications as Xn, Grid as A, Typography as fe, Radio as Bi, AnalysisIcon as Fp, ContentBlock as nr, Table as Bp, Button as Be, Select as It, DatePicker as rr, Spinner as pt, OutlinedChip as $p, IconActionButton as Cr, useTheme as Gp, CriteriaIcon as zp, DropDownMenu as Rn, AutocompleteInput as $i, Checkbox as hr, Block as gr, Autocomplete as Gi, SEARCH_PRECISION_OPTIONS as zi, useWindowSize as Wp, SearchPrecision as Yp, Dialog as Hp, DialogTitle as qp, DialogContent as Xp, DialogActions as Jp, AISpinner as jc, tooltipClasses as vs, Paper as Qp, Divider as Lc, NewTable as Kp, CheckboxCell as Ti, Skeleton as _s } from "@prometheus/components";
import pe from "@emotion/styled";
import { useNavigate as yr, useParams as kc, useLocation as Zp, useSearchParams as eh, Routes as Mc, Route as on } from "react-router-dom";
import { getReducerWithProduce as ui, api as Ie, getSortDirection as di, axiosInstance as th, getUUID as Dn, createFiltersPanelListConfig as nh, createCrudMethodsListConfig as rh, createHeadersFromMetadataAttributes as ih, createSortingMethodListConfig as oh, createBreadcrumbsEntityConfig as ah, sortBy as sh, isEqual as Pe, getFormatDate as Ns, formatDate as ir, getConceptSetById as Wi, isObject as Oo, unionBy as lh, convertAttributeListDTOToObjectAttributeList as ch, getFilteredDropdownAttributeList as Vc, convertObjectAttributeListToAttributeListDTO as uh, getSortAttributesByCriteria as dh, getFilteredDropdownCriteriaList as _n, isEmpty as fn, isAiGeneratedMetadata as Uc, isAiStatusMetadata as ph, getCodeLanguageByFileExtension as Fc, convertCriteriaListDTOToObjectCriteriaList as Bc, convertObjectCriteriaListToCriteriaListDTO as $c, pickBy as hh, identity as fh, formatFilterListNoFiql as mh, parseStatistics as Eh, pick as xh, mapExcludedToIsExcluded as ws, mapIsExcludedToExcluded as Ch, convertExtendedToLegacyConcepts as Gc, getNumberUUID as Gn } from "@prometheus/utils";
import { Status as ue, EntityActions as Ps } from "@prometheus/types";
import { unstable_batchedUpdates as Si, createPortal as gh } from "react-dom";
import { getSummary as yh, setBreadcrumbs as Th } from "@prometheus/redux";
import { useSelector as Da, useDispatch as zc } from "react-redux";
var Yi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Qo = { exports: {} }, vr = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var js;
function Sh() {
  if (js) return vr;
  js = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, i, o) {
    var s = null;
    if (o !== void 0 && (s = "" + o), i.key !== void 0 && (s = "" + i.key), "key" in i) {
      o = {};
      for (var l in i)
        l !== "key" && (o[l] = i[l]);
    } else o = i;
    return i = o.ref, {
      $$typeof: e,
      type: r,
      key: s,
      ref: i !== void 0 ? i : null,
      props: o
    };
  }
  return vr.Fragment = t, vr.jsx = n, vr.jsxs = n, vr;
}
var _r = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ls;
function Ih() {
  return Ls || (Ls = 1, process.env.NODE_ENV !== "production" && function() {
    function e(x) {
      if (x == null) return null;
      if (typeof x == "function")
        return x.$$typeof === w ? null : x.displayName || x.name || null;
      if (typeof x == "string") return x;
      switch (x) {
        case C:
          return "Fragment";
        case I:
          return "Profiler";
        case y:
          return "StrictMode";
        case _:
          return "Suspense";
        case R:
          return "SuspenseList";
        case M:
          return "Activity";
      }
      if (typeof x == "object")
        switch (typeof x.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), x.$$typeof) {
          case g:
            return "Portal";
          case S:
            return (x.displayName || "Context") + ".Provider";
          case O:
            return (x._context.displayName || "Context") + ".Consumer";
          case N:
            var Y = x.render;
            return x = x.displayName, x || (x = Y.displayName || Y.name || "", x = x !== "" ? "ForwardRef(" + x + ")" : "ForwardRef"), x;
          case P:
            return Y = x.displayName || null, Y !== null ? Y : e(x.type) || "Memo";
          case U:
            Y = x._payload, x = x._init;
            try {
              return e(x(Y));
            } catch {
            }
        }
      return null;
    }
    function t(x) {
      return "" + x;
    }
    function n(x) {
      try {
        t(x);
        var Y = !1;
      } catch {
        Y = !0;
      }
      if (Y) {
        Y = console;
        var k = Y.error, T = typeof Symbol == "function" && Symbol.toStringTag && x[Symbol.toStringTag] || x.constructor.name || "Object";
        return k.call(
          Y,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          T
        ), t(x);
      }
    }
    function r(x) {
      if (x === C) return "<>";
      if (typeof x == "object" && x !== null && x.$$typeof === U)
        return "<...>";
      try {
        var Y = e(x);
        return Y ? "<" + Y + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var x = V.A;
      return x === null ? null : x.getOwner();
    }
    function o() {
      return Error("react-stack-top-frame");
    }
    function s(x) {
      if (L.call(x, "key")) {
        var Y = Object.getOwnPropertyDescriptor(x, "key").get;
        if (Y && Y.isReactWarning) return !1;
      }
      return x.key !== void 0;
    }
    function l(x, Y) {
      function k() {
        v || (v = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          Y
        ));
      }
      k.isReactWarning = !0, Object.defineProperty(x, "key", {
        get: k,
        configurable: !0
      });
    }
    function c() {
      var x = e(this.type);
      return J[x] || (J[x] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), x = this.props.ref, x !== void 0 ? x : null;
    }
    function u(x, Y, k, T, re, b, z, me) {
      return k = b.ref, x = {
        $$typeof: h,
        type: x,
        key: Y,
        props: b,
        _owner: re
      }, (k !== void 0 ? k : null) !== null ? Object.defineProperty(x, "ref", {
        enumerable: !1,
        get: c
      }) : Object.defineProperty(x, "ref", { enumerable: !1, value: null }), x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(x, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(x, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: z
      }), Object.defineProperty(x, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: me
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    }
    function p(x, Y, k, T, re, b, z, me) {
      var ae = Y.children;
      if (ae !== void 0)
        if (T)
          if (te(ae)) {
            for (T = 0; T < ae.length; T++)
              d(ae[T]);
            Object.freeze && Object.freeze(ae);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else d(ae);
      if (L.call(Y, "key")) {
        ae = e(x);
        var le = Object.keys(Y).filter(function($e) {
          return $e !== "key";
        });
        T = 0 < le.length ? "{key: someKey, " + le.join(": ..., ") + ": ...}" : "{key: someKey}", Q[ae + T] || (le = 0 < le.length ? "{" + le.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          T,
          ae,
          le,
          ae
        ), Q[ae + T] = !0);
      }
      if (ae = null, k !== void 0 && (n(k), ae = "" + k), s(Y) && (n(Y.key), ae = "" + Y.key), "key" in Y) {
        k = {};
        for (var de in Y)
          de !== "key" && (k[de] = Y[de]);
      } else k = Y;
      return ae && l(
        k,
        typeof x == "function" ? x.displayName || x.name || "Unknown" : x
      ), u(
        x,
        ae,
        b,
        re,
        i(),
        k,
        z,
        me
      );
    }
    function d(x) {
      typeof x == "object" && x !== null && x.$$typeof === h && x._store && (x._store.validated = 1);
    }
    var f = Le, h = Symbol.for("react.transitional.element"), g = Symbol.for("react.portal"), C = Symbol.for("react.fragment"), y = Symbol.for("react.strict_mode"), I = Symbol.for("react.profiler"), O = Symbol.for("react.consumer"), S = Symbol.for("react.context"), N = Symbol.for("react.forward_ref"), _ = Symbol.for("react.suspense"), R = Symbol.for("react.suspense_list"), P = Symbol.for("react.memo"), U = Symbol.for("react.lazy"), M = Symbol.for("react.activity"), w = Symbol.for("react.client.reference"), V = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, L = Object.prototype.hasOwnProperty, te = Array.isArray, $ = console.createTask ? console.createTask : function() {
      return null;
    };
    f = {
      react_stack_bottom_frame: function(x) {
        return x();
      }
    };
    var v, J = {}, j = f.react_stack_bottom_frame.bind(
      f,
      o
    )(), ee = $(r(o)), Q = {};
    _r.Fragment = C, _r.jsx = function(x, Y, k, T, re) {
      var b = 1e4 > V.recentlyCreatedOwnerStacks++;
      return p(
        x,
        Y,
        k,
        !1,
        T,
        re,
        b ? Error("react-stack-top-frame") : j,
        b ? $(r(x)) : ee
      );
    }, _r.jsxs = function(x, Y, k, T, re) {
      var b = 1e4 > V.recentlyCreatedOwnerStacks++;
      return p(
        x,
        Y,
        k,
        !0,
        T,
        re,
        b ? Error("react-stack-top-frame") : j,
        b ? $(r(x)) : ee
      );
    };
  }()), _r;
}
process.env.NODE_ENV === "production" ? Qo.exports = Sh() : Qo.exports = Ih();
var a = Qo.exports;
const Ah = pe.div`
  box-sizing: border-box;
  display: inline-block;
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  border: 2px solid
    ${({ theme: e }) => e.palette.warning.main};
  margin-right: 8px;
  ::after {
    content: 'i';
    display: inline-block;
    line-height: 12px;
    color: ${({ theme: e }) => e.palette.warning.main};
  }
`, bh = ({
  value: e,
  viewMode: t,
  onRefresh: n,
  row: r
}) => {
  const { versionId: i, currentVersionId: o, terminated: s } = r.original;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: s ? /* @__PURE__ */ a.jsx(W, { display: "flex", children: /* @__PURE__ */ a.jsx(
    Qr,
    {
      color: "warning",
      onClick: () => {
      },
      sx: (l) => ({
        backgroundColor: Ds(0.8, l.palette.grey[500]),
        p: 0,
        my: -1,
        minWidth: 110,
        height: 26,
        fontSize: 14,
        borderRadius: 1,
        pointerEvents: "none",
        color: l.palette.grey[600],
        cursor: "default"
      }),
      children: /* @__PURE__ */ a.jsxs(
        W,
        {
          className: "archived-icon",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          flexWrap: "nowrap",
          children: [
            /* @__PURE__ */ a.jsx(
              ge,
              {
                iconName: "terminated",
                sx: (l) => ({
                  color: l.palette.grey[500],
                  fontSize: 18,
                  mr: 1
                })
              }
            ),
            /* @__PURE__ */ a.jsx("div", { children: "Archived" })
          ]
        }
      )
    }
  ) }) : !!(e && i && o) && /* @__PURE__ */ a.jsx(W, { display: "flex", children: /* @__PURE__ */ a.jsx(
    We,
    {
      text: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "Newer version exists,",
        /* @__PURE__ */ a.jsx("br", {}),
        " would you like to REFRESH it?"
      ] }),
      children: /* @__PURE__ */ a.jsxs(
        Qr,
        {
          color: "warning",
          onClick: () => {
            i && o && n(r.original);
          },
          sx: (l) => ({
            backgroundColor: "#ffead5",
            p: 0,
            my: -1,
            minWidth: 110,
            height: 26,
            fontSize: 14,
            borderRadius: 1,
            pointerEvents: t ? "none" : "all",
            ".refresh-icon": {
              display: "none"
            },
            "&:hover": {
              backgroundColor: Ds(
                0.8,
                l.palette.info.main
              ),
              ".warning-icon": {
                display: "none"
              },
              ".refresh-icon": {
                display: "flex",
                color: l.palette.info.main
              }
            }
          }),
          children: [
            /* @__PURE__ */ a.jsxs(
              W,
              {
                className: "warning-icon",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                flexWrap: "nowrap",
                children: [
                  /* @__PURE__ */ a.jsx(Ah, {}),
                  /* @__PURE__ */ a.jsx("div", { children: "Outdated" })
                ]
              }
            ),
            /* @__PURE__ */ a.jsxs(
              W,
              {
                className: "refresh-icon",
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap",
                justifyContent: "space-around",
                children: [
                  /* @__PURE__ */ a.jsx(
                    ge,
                    {
                      iconName: "reload",
                      color: "info",
                      sx: { fontSize: 16, mr: 1 }
                    }
                  ),
                  /* @__PURE__ */ a.jsx("div", { children: "Refresh" })
                ]
              }
            )
          ]
        }
      )
    }
  ) }) });
}, Rh = {
  createCols: (e, t, n = !1, r = []) => [
    {
      Header: "Name",
      accessor: "name",
      id: "name",
      isCropped: !0,
      width: "100%",
      minWidth: 250,
      maxWidth: 400,
      Cell: (i) => /* @__PURE__ */ a.jsx(
        Ep,
        {
          ...i,
          hasAlias: n,
          onChange: e.onUpdate,
          aliases: r,
          entityType: Dc.COHORT
        }
      )
    },
    {
      Header: "",
      id: "outdatedVersion",
      width: "3%",
      minWidth: 70,
      accessor: (i) => i.currentVersionId && i.currentVersionId !== i.versionId,
      Cell: (i) => /* @__PURE__ */ a.jsx(
        bh,
        {
          ...i,
          viewMode: t,
          onRefresh: e.onRefresh
        }
      )
    },
    ...t ? [] : [
      {
        Header: "",
        accessor: "actions",
        isCropped: !0,
        maxWidth: 100,
        width: "7%",
        disableSortBy: !0,
        Cell: (i) => /* @__PURE__ */ a.jsx(
          xp,
          {
            onEdit: () => e.onEdit(i.row.original.value),
            onRemove: () => e.onRemove(i.row.original.versionId)
          }
        )
      }
    ]
  ]
}, Oh = [
  {
    Component: Ye,
    name: "name",
    label: "Name",
    type: "text"
  },
  {
    Component: Ye,
    name: "description",
    label: "Description",
    type: "text",
    multiline: !0,
    minRows: 2,
    maxRows: 10
  }
], xn = [
  {
    id: D.DEMOGRAPHIC,
    name: "Demographic",
    desc: "",
    value: "Demographic"
  },
  {
    id: D.CONDITION_ERA,
    name: "Condition Era",
    desc: "",
    value: "ConditionEra"
  },
  {
    id: D.CONDITION_OCCURRENCE,
    name: "Condition Occurrence",
    desc: "",
    value: "ConditionOccurrence"
  },
  {
    id: D.DEATH,
    name: "Death",
    desc: "",
    value: "Death"
  },
  {
    id: D.DEVICE_EXPOSURE,
    name: "Device Exposure",
    desc: "",
    value: "DeviceExposure"
  },
  {
    id: D.DOSE_ERA,
    name: "Dose Era",
    desc: "",
    value: "DoseEra"
  },
  {
    id: D.DRUG_ERA,
    name: "Drug Era",
    desc: "",
    value: "DrugEra"
  },
  {
    id: D.DRUG_EXPOSURE,
    name: "Drug Exposure",
    desc: "",
    value: "DrugExposure"
  },
  {
    id: D.LOCATION_REGION,
    name: "Location Region",
    desc: "",
    value: "LocationRegion"
  },
  {
    id: D.MEASUREMENT,
    name: "Measurement",
    desc: "",
    value: "Measurement"
  },
  {
    id: D.OBSERVATION,
    name: "Observation",
    desc: "",
    value: "Observation"
  },
  {
    id: D.OBSERVATION_PERIOD,
    name: "Observation Period",
    desc: "",
    value: "ObservationPeriod"
  },
  {
    id: D.PAYER_PLAN_PERIOD,
    name: "Payer Plan Period",
    desc: "",
    value: "PayerPlanPeriod"
  },
  {
    id: D.PROCEDURE_OCCURRENCE,
    name: "Procedure Occurrence",
    desc: "",
    value: "ProcedureOccurrence"
  },
  {
    id: D.SPECIMEN,
    name: "Specimen",
    desc: "",
    value: "Specimen"
  },
  {
    id: D.VISIT,
    name: "Visit",
    desc: "",
    value: "VisitOccurrence"
  },
  {
    id: D.VISIT_DETAILS,
    name: "Visit detail",
    desc: "",
    value: "VisitDetail"
  },
  {
    id: D.GROUP,
    name: "Group",
    desc: "",
    value: "Group"
  }
], Yc = [
  {
    id: m.FIRST_DIAGNOSIS,
    name: "First diagnosis",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.AGE_AT_ERA_START,
    name: "Age at era start",
    desc: "",
    value: E.AGE_START
  },
  {
    id: m.AGE_AT_ERA_END,
    name: "Age at era end",
    desc: "",
    value: E.AGE_END
  },
  {
    id: m.GENDER,
    name: "Gender",
    desc: "",
    value: E.GENDER
  },
  {
    id: m.LOC_START_DATE,
    name: "Start date",
    desc: "",
    value: E.START_DATE
  },
  {
    id: m.LOC_END_DATE,
    name: "End date",
    desc: "",
    value: E.END_DATE
  },
  {
    id: m.START_DATE,
    name: "Start date",
    desc: "",
    value: E.ERA_START_DATE
  },
  {
    id: m.END_DATE,
    name: "End date",
    desc: "",
    value: E.ERA_END_DATE
  },
  {
    id: m.ERA_CONDITION_COUNT,
    name: "Era condition count",
    desc: "",
    value: E.OCCURRENCE_COUNT
  },
  {
    id: m.ERA_LENGTH,
    name: "Era length",
    desc: "",
    value: E.ERA_LENGTH
  },
  {
    id: m.NESTED,
    name: "Nested",
    desc: "",
    value: E.CORRETALED_CRITERIA
  },
  {
    id: m.AGE_OCCURRENCE,
    name: "Age at occurrence",
    desc: "",
    value: E.AGE
  },
  {
    id: m.CONDITION_STATUS,
    name: "Condition status",
    desc: "",
    value: E.CONDITION_STATUS
  },
  {
    id: m.CONDITION_STATUS_CS,
    name: "Condition status concept set",
    desc: "",
    value: E.CONDITION_STATUS_CS
  },
  {
    id: m.CONDITION_START_DATE,
    name: "Start date",
    desc: "",
    value: E.OCCURRENCE_START_DATE
  },
  {
    id: m.CONDITION_END_DATE,
    name: "End date",
    desc: "",
    value: E.OCCURRENCE_END_DATE
  },
  {
    id: m.CONDITION_TYPE,
    name: "Condition type",
    desc: "",
    value: E.CONDITION_TYPE
  },
  {
    id: m.CONDITION_TYPE_CS,
    name: "Condition type concept set",
    desc: "",
    value: E.CONDITION_TYPE_CS
  },
  {
    id: m.VISIT,
    name: "Visit",
    desc: "",
    value: E.VISIT_TYPE
  },
  {
    id: m.VISIT_CS,
    name: "Visit concept set",
    desc: "",
    value: E.VISIT_TYPE_CS
  },
  {
    id: m.STOP_REASON,
    name: "Stop reason",
    desc: "",
    value: E.STOP_REASON
  },
  {
    id: m.CONDITION_SOURCE_CONCEPT,
    name: "Condition source concept",
    desc: "",
    value: E.CONDITION_SOURCE_CONCEPT
  },
  {
    id: m.PROVIDER_SPECIALTY,
    name: "Provider specialty",
    desc: "",
    value: E.PROVIDER_SPECIALTY
  },
  {
    id: m.DEATH_DATE,
    name: "Death date",
    desc: "",
    value: E.OCCURRENCE_START_DATE
  },
  {
    id: m.DEATH_TYPE,
    name: "Death type",
    desc: "",
    value: E.DEATH_TYPE
  },
  {
    id: m.DEATH_TYPE_CS,
    name: "Death type concept set",
    desc: "",
    value: E.DEATH_TYPE_CS
  },
  {
    id: m.CAUSE_DEATH_SOURCE_CONCEPT,
    name: "Cause of death source concept",
    desc: "",
    value: E.DEATH_SOURCE_CONCEPT
  },
  {
    id: m.FIRST_EXPOSURE,
    name: "First exposure",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.DEVICE_TYPE,
    name: "Device type",
    desc: "",
    value: E.DEVICE_TYPE
  },
  {
    id: m.DEVICE_TYPE_CS,
    name: "Device type concept set",
    desc: "",
    value: E.DEVICE_TYPE_CS
  },
  {
    id: m.UNIQUE_ID,
    name: "Unique ID",
    desc: "",
    value: E.UNIQUE_DEVICE_ID
  },
  {
    id: m.QUANTITY,
    name: "Quantity",
    desc: "",
    value: E.QUANTITY
  },
  {
    id: m.DEVICE_SOURCE_CONCEPT,
    name: "Device source concept",
    desc: "",
    value: E.DEVICE_SOURCE_CONCEPT
  },
  {
    id: m.FIRST_MEASURE,
    name: "First measure",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.MEASUREMENT_DATE,
    name: "Measurement date",
    desc: "",
    value: E.OCCURRENCE_START_DATE
  },
  {
    id: m.MEASUREMENT_TYPE,
    name: "Measurement type",
    desc: "",
    value: E.MEASUREMENT_TYPE
  },
  {
    id: m.MEASUREMENT_TYPE_CS,
    name: "Measurement type concept set",
    desc: "",
    value: E.MEASUREMENT_TYPE_CS
  },
  {
    id: m.OPERATOR,
    name: "Operator",
    desc: "",
    value: E.OPERATOR
  },
  {
    id: m.OPERATOR_CS,
    name: "Operator concept set",
    desc: "",
    value: E.OPERATOR_CS
  },
  {
    id: m.VALUE_AS_CONCEPT,
    name: "Value as concept",
    desc: "",
    value: E.VALUE_AS_CONCEPT
  },
  {
    id: m.VALUE_AS_CONCEPT_CS,
    name: "Value as concept set",
    desc: "",
    value: E.VALUE_AS_CONCEPT_CS
  },
  {
    id: m.VALUE_AS_NUMBER,
    name: "Value as number",
    desc: "",
    value: E.VALUE_AS_NUMBER
  },
  {
    id: m.VALUE_AS_STRING,
    name: "Value as string",
    desc: "",
    value: E.VALUE_AS_STRING
  },
  {
    id: m.UNIT,
    name: "Unit",
    desc: "",
    value: E.UNIT
  },
  {
    id: m.UNIT_CS,
    name: "Unit concept set",
    desc: "",
    value: E.UNIT_CS
  },
  {
    id: m.ABNORMAL_RESULT,
    name: "Abnormal result",
    desc: "",
    value: E.ABNORMAL
  },
  {
    id: m.LOW_RANGE_RATIO,
    name: "Low range ratio",
    desc: "",
    value: E.RANGE_LOW_RATIO
  },
  {
    id: m.HIGH_RANGE_RATIO,
    name: "High range ratio",
    desc: "",
    value: E.RANGE_HIGH_RATIO
  },
  {
    id: m.LOW_RANGE,
    name: "Low range",
    desc: "",
    value: E.RANGE_LOW
  },
  {
    id: m.HIGH_RANGE,
    name: "High range",
    desc: "",
    value: E.RANGE_HIGH
  },
  {
    id: m.MEASUREMENT_SOURCE_CONCEPT,
    name: "Measurement source concept",
    desc: "",
    value: E.MEASUREMENT_SOURCE_CONCEPT
  },
  {
    id: m.FIRST_OBSERVATION,
    name: "First observation",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.OBSERVATION_DATE,
    name: "Observation date",
    desc: "",
    value: E.OCCURRENCE_START_DATE
  },
  {
    id: m.OBSERVATION_TYPE,
    name: "Observation type",
    desc: "",
    value: E.OBSERVATION_TYPE
  },
  {
    id: m.OBSERVATION_TYPE_CS,
    name: "Observation type concept set",
    desc: "",
    value: E.OBSERVATION_TYPE_CS
  },
  {
    id: m.OBSERVATION_SOURCE_CONCEPT,
    name: "Observation source concept",
    desc: "",
    value: E.OBSERVATION_SOURCE_CONCEPT
  },
  {
    id: m.QUALIFIER,
    name: "Qualifier",
    desc: "",
    value: E.QUALIFIER
  },
  {
    id: m.QUALIFIER_CS,
    name: "Qualifier concept set",
    desc: "",
    value: E.QUALIFIER_CS
  },
  {
    id: m.SPECIFY_START_AND_DATE,
    name: "Specific start and end dates",
    desc: "",
    value: E.USER_DEFINED_PERIOD
  },
  {
    id: m.FIRST_OBSERVATION_PERIOD,
    name: "First observation period",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.AGE_AT_START,
    name: "Age at start",
    desc: "",
    value: E.AGE_START
  },
  {
    id: m.AGE_AT_END,
    name: "Age at end",
    desc: "",
    value: E.AGE_END
  },
  {
    id: m.PERIOD_TYPE,
    name: "Period type",
    desc: "",
    value: E.PERIOD_TYPE
  },
  {
    id: m.PERIOD_TYPE_CS,
    name: "Period type concept set",
    desc: "",
    value: E.PERIOD_TYPE_CS
  },
  {
    id: m.PERIOD_START_DATE,
    name: "Period start date",
    desc: "",
    value: E.PERIOD_START_DATE
  },
  {
    id: m.PERIOD_END_DATE,
    name: "Period end date",
    desc: "",
    value: E.PERIOD_END_DATE
  },
  {
    id: m.PERIOD_LENGTH,
    name: "Period length",
    desc: "",
    value: E.PERIOD_LENGTH
  },
  {
    id: m.FIRST_PAYER_PLAN_PERIOD,
    name: "First payer plan period",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.STOP_REASON_SOURCE_CONCEPT,
    name: "Stop reason source concept",
    desc: "",
    value: E.STOP_REASON_SOURCE_CONCEPT
  },
  {
    id: m.SPONSOR_SOURCE_CONCEPT,
    name: "Sponsor source concept",
    desc: "",
    value: E.SPONSOR_SOURCE_CONCEPT
  },
  {
    id: m.PLAN_SOURCE_CONCEPT,
    name: "Plan source concept",
    desc: "",
    value: E.PLAN_SOURCE_CONCEPT
  },
  {
    id: m.PAYER_SOURCE_CONCEPT,
    name: "Payer source concept",
    desc: "",
    value: E.PAYER_SOURCE_CONCEPT
  },
  {
    id: m.STOP_REASON_CONCEPT,
    name: "Stop reason concept",
    desc: "",
    value: E.STOP_REASON_CONCEPT
  },
  {
    id: m.SPONSOR_CONCEPT,
    name: "Sponsor concept",
    desc: "",
    value: E.SPONSOR_CONCEPT
  },
  {
    id: m.PLAN_CONCEPT,
    name: "Plan concept",
    desc: "",
    value: E.PLAN_CONCEPT
  },
  {
    id: m.PAYER_CONCEPT,
    name: "Payer concept",
    desc: "",
    value: E.PAYER_CONCEPT
  },
  {
    id: m.FIRST_PROCEDURE,
    name: "First procedure",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.FIRST_OCCURRENCE,
    name: "First occurrence",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.PROCEDURE_SOURCE_CONCEPT,
    name: "Procedure source concept",
    desc: "",
    value: E.PROCEDURE_SOURCE_CONCEPT
  },
  {
    id: m.MODIFIER,
    name: "Modifier",
    desc: "",
    value: E.MODIFIER
  },
  {
    id: m.MODIFIER_CS,
    name: "Modifier concept set",
    desc: "",
    value: E.MODIFIER_CS
  },
  {
    id: m.PROCEDURE_TYPE,
    name: "Procedure type",
    desc: "",
    value: E.PROCEDURE_TYPE
  },
  {
    id: m.PROCEDURE_TYPE_CS,
    name: "Procedure type concept set",
    desc: "",
    value: E.PROCEDURE_TYPE_CS
  },
  {
    id: m.DOSE_VALUE,
    name: "Dose value",
    desc: "",
    value: E.DOSE_VALUE
  },
  {
    id: m.ERA_EXPOSURE_COUNT,
    name: "Era exposure count",
    desc: "",
    value: E.OCCURRENCE_COUNT
  },
  {
    id: m.DAYS_SUPPLY,
    name: "Days supply",
    desc: "",
    value: E.DAYS_SUPPLY
  },
  {
    id: m.REFILLS,
    name: "Refills",
    desc: "",
    value: E.REFILLS
  },
  {
    id: m.DRUG_TYPE,
    name: "Drug type",
    desc: "",
    value: E.DRUG_TYPE
  },
  {
    id: m.DRUG_TYPE_CS,
    name: "Drug type concept set",
    desc: "",
    value: E.DRUG_TYPE_CS
  },
  {
    id: m.EFFECTIVE_DOSE,
    name: "Effective dose",
    desc: "",
    value: E.EFFECTIVE_DRUG_DOSE
  },
  {
    id: m.ROUTE,
    name: "Route",
    desc: "",
    value: E.ROUTE_CONCEPT
  },
  {
    id: m.ROUTE_CS,
    name: "Route concept set",
    desc: "",
    value: E.ROUTE_CONCEPT_CS
  },
  {
    id: m.RACE,
    name: "Race",
    desc: "",
    value: E.RACE
  },
  {
    id: m.ETHNICITY,
    name: "Ethnicity",
    desc: "",
    value: E.ETHNICITY
  },
  {
    id: m.DRUG_SOURCE_CONCEPT,
    name: "Drug source concept",
    desc: "",
    value: E.DRUG_SOURCE_CONCEPT
  },
  {
    id: m.LOT_NUMBER,
    name: "Lot number",
    desc: "",
    value: E.LOT_NUMBER
  },
  {
    id: m.DOSE_UNIT,
    name: "Dose unit",
    desc: "",
    value: E.DOSE_UNIT
  },
  {
    id: m.DOSE_UNIT_CS,
    name: "Dose unit concept set",
    desc: "",
    value: E.DOSE_UNIT_CS
  },
  {
    id: m.SOURCE_ID,
    name: "Source ID",
    desc: "",
    value: E.SOURCE_ID
  },
  {
    id: m.DISEASE_STATUS,
    name: "Disease status",
    desc: "",
    value: E.DISEASE_STATUS
  },
  {
    id: m.DISEASE_STATUS_CS,
    name: "Disease status concept set",
    desc: "",
    value: E.DISEASE_STATUS_CS
  },
  {
    id: m.ANATOMIC_SITE,
    name: "Anatomic site",
    desc: "",
    value: E.ANATOMIC_SITE
  },
  {
    id: m.ANATOMIC_SITE_CS,
    name: "Anatomic site concept set",
    desc: "",
    value: E.ANATOMIC_SITE_CS
  },
  {
    id: m.SPECIMEN_TYPE,
    name: "Specimen type",
    desc: "",
    value: E.SPECIMEN_TYPE
  },
  {
    id: m.SPECIMEN_TYPE_CS,
    name: "Specimen type concept set",
    desc: "",
    value: E.SPECIMEN_TYPE_CS
  },
  {
    id: m.SPECIMEN_DATE,
    name: "Specimen date",
    desc: "",
    value: E.OCCURRENCE_START_DATE
  },
  {
    id: m.GAP_DAYS,
    name: "Gap days",
    desc: "",
    value: E.GAP_DAYS
  },
  {
    id: m.PLACE_SERVICE_LOCATION,
    name: "Place of service location",
    desc: "",
    value: E.PLACE_SERVICE_LOCATION
  },
  {
    id: m.PLACE_SERVICE_DISTANCE,
    name: "Place of service distance",
    desc: "",
    value: E.PLACE_SERVICE_DISTANCE
  },
  {
    id: m.PLACE_SERVICE,
    name: "Place of service",
    desc: "",
    value: E.PLACE_SERVICE
  },
  {
    id: m.VISIT_SOURCE_CONCEPT,
    name: "Visit source concept",
    desc: "",
    value: E.VISIT_SOURCE_CONCEPT
  },
  {
    id: m.VISIT_LENGTH,
    name: "Visit length",
    desc: "",
    value: E.VISIT_LENGTH
  },
  {
    id: m.VISIT_TYPE,
    name: "Visit type",
    desc: "",
    value: E.VISIT_TYPE
  },
  {
    id: m.VISIT_TYPE_CS,
    name: "Visit type concept set",
    desc: "",
    value: E.VISIT_TYPE_CS
  },
  {
    id: m.FIRST_VISIT,
    name: "First visit",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.FIRST_VISIT_DETAIL,
    name: "First visit detail",
    desc: "",
    value: E.FIRST
  },
  {
    id: m.AGE_AT_VISIT_DETAIL,
    name: "Age at visit detail",
    desc: "",
    value: E.AGE
  },
  {
    id: m.GENDER_CS,
    name: "Gender Concept Set",
    desc: "",
    value: E.GENDER_CS
  },
  {
    id: m.RACE_CS,
    name: "Race Concept Set",
    desc: "",
    value: E.RACE_CS
  },
  {
    id: m.ETHNICITY_CS,
    name: "Ethnicity Concept Set",
    desc: "",
    value: E.ETHNICITY_CS
  },
  {
    id: m.VISIT_DETAIL_START_DATE,
    name: "Start date",
    desc: "",
    value: E.VISIT_DETAIL_START_DATE
  },
  {
    id: m.VISIT_DETAIL_END_DATE,
    name: "End date",
    desc: "",
    value: E.VISIT_DETAIL_END_DATE
  },
  {
    id: m.MODIFY_EVENT_START_END,
    name: "Modify event start/end",
    desc: "",
    value: E.DATE_ADJUSTMENT
  },
  {
    id: m.VISIT_DETAIL_TYPE,
    name: "Visit detail type concept set",
    desc: "",
    value: E.VISIT_DETAIL_TYPE_CS
  },
  {
    id: m.VISIT_DETAIL_LENGTH,
    name: "Visit detail length",
    desc: "",
    value: E.VISIT_DETAIL_LENGTH
  },
  {
    id: m.VISIT_DETAIL_SOURCE_CONCEPT,
    name: "Visit detail Source Concept",
    desc: "",
    value: E.VISIT_DETAIL_SOURCE_CONCEPT
  },
  {
    id: m.PROVIDER_SPECIALTY_CS,
    name: "Provider specialty concept set",
    desc: "",
    value: E.PROVIDER_SPECIALTY_CS
  },
  {
    id: m.PLACE_SERVICE_CS,
    name: "Place of service concept set",
    desc: "",
    value: E.PLACE_SERVICE_CS
  }
], fr = [
  {
    name: "all events",
    value: Wt.ALL
  },
  {
    name: "earliest event",
    value: Wt.FIRST
  },
  {
    name: "latest event",
    value: Wt.LAST
  }
], zn = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 21,
    name: "21"
  },
  {
    value: 30,
    name: "30"
  },
  {
    value: 60,
    name: "60"
  },
  {
    value: 90,
    name: "90"
  },
  {
    value: 120,
    name: "120"
  },
  {
    value: 180,
    name: "180"
  },
  {
    value: 365,
    name: "365"
  },
  {
    value: 548,
    name: "548"
  },
  {
    value: 730,
    name: "730"
  },
  {
    value: 1095,
    name: "1095"
  }
], Ii = [
  {
    value: "undefined",
    name: "all"
  },
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 21,
    name: "21"
  },
  {
    value: 30,
    name: "30"
  },
  {
    value: 60,
    name: "60"
  },
  {
    value: 90,
    name: "90"
  },
  {
    value: 120,
    name: "120"
  },
  {
    value: 180,
    name: "180"
  },
  {
    value: 365,
    name: "365"
  },
  {
    value: 548,
    name: "548"
  },
  {
    value: 730,
    name: "730"
  },
  {
    value: 1095,
    name: "1095"
  }
], ao = {
  Demographic: {
    titleText: "Demographic:",
    baseText: "with the following event criteria",
    baseTextViewMode: "with the following event criteria",
    defaultValue: "",
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.CONDITION_START_DATE,
      m.CONDITION_END_DATE,
      m.RACE,
      m.RACE_CS,
      m.ETHNICITY,
      m.ETHNICITY_CS
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.AGE,
      E.GENDER,
      E.GENDER_CS,
      E.OCCURRENCE_START_DATE,
      E.OCCURRENCE_END_DATE,
      E.RACE,
      E.RACE_CS,
      E.ETHNICITY,
      E.ETHNICITY_CS
    ],
    extendOptions: {
      textBlock1: {
        startText: "Limit qualifying events to",
        control: "select",
        optionsControl: fr,
        endText: "per person"
      }
    }
  },
  ConditionEra: {
    titleText: "Condition Era:",
    baseText: "a condition era of",
    baseTextViewMode: "condition eras of",
    defaultValue: "Any condition",
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_DIAGNOSIS,
      m.AGE_AT_ERA_START,
      m.AGE_AT_ERA_END,
      m.GENDER,
      m.GENDER_CS,
      m.START_DATE,
      m.END_DATE,
      m.ERA_CONDITION_COUNT,
      m.ERA_LENGTH,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.GENDER,
      E.GENDER_CS,
      E.AGE_START,
      E.AGE_END,
      E.ERA_START_DATE,
      E.ERA_END_DATE,
      E.ERA_LENGTH,
      E.OCCURRENCE_COUNT,
      E.CORRETALED_CRITERIA
    ],
    extend: !0,
    extendOptions: {
      textBlock1: {
        startText: "Limit qualifying events to",
        control: "select",
        optionsControl: fr,
        endText: "per person"
      }
    }
  },
  ConditionOccurrence: {
    titleText: "Condition Occurrence:",
    baseText: "a condition occurrence of",
    baseTextViewMode: "condition occurrence of",
    defaultValue: "Any condition",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_DIAGNOSIS,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.CONDITION_STATUS,
      m.CONDITION_STATUS_CS,
      m.CONDITION_START_DATE,
      m.CONDITION_END_DATE,
      m.CONDITION_TYPE,
      m.CONDITION_TYPE_CS,
      m.VISIT,
      m.VISIT_CS,
      m.STOP_REASON,
      m.CONDITION_SOURCE_CONCEPT,
      m.PROVIDER_SPECIALTY,
      m.PROVIDER_SPECIALTY_CS,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.GENDER,
      E.GENDER_CS,
      E.AGE,
      E.OCCURRENCE_START_DATE,
      E.OCCURRENCE_END_DATE,
      E.CONDITION_TYPE,
      E.CONDITION_TYPE_CS,
      E.STOP_REASON,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.CONDITION_STATUS,
      E.CONDITION_STATUS_CS,
      E.VISIT_TYPE,
      E.VISIT_TYPE_CS,
      E.CONDITION_SOURCE_CONCEPT,
      E.CORRETALED_CRITERIA
    ]
  },
  Death: {
    titleText: "Death:",
    baseText: "a death occurrence from",
    baseTextViewMode: "death occurrence of",
    defaultValue: "Any death",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.DEATH_DATE,
      m.DEATH_TYPE,
      m.DEATH_TYPE_CS,
      m.CAUSE_DEATH_SOURCE_CONCEPT,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.GENDER,
      E.GENDER_CS,
      E.AGE,
      E.OCCURRENCE_START_DATE,
      E.DEATH_TYPE,
      E.DEATH_TYPE_CS,
      E.DEATH_SOURCE_CONCEPT,
      E.CORRETALED_CRITERIA
    ]
  },
  DeviceExposure: {
    titleText: "Device Exposure:",
    baseText: "a device exposure of",
    baseTextViewMode: "device exposure of",
    defaultValue: "Any device",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_DIAGNOSIS,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.CONDITION_START_DATE,
      m.CONDITION_END_DATE,
      m.DEVICE_TYPE,
      m.DEVICE_TYPE_CS,
      m.VISIT,
      m.VISIT_CS,
      m.UNIQUE_ID,
      m.QUANTITY,
      m.DEVICE_SOURCE_CONCEPT,
      m.PROVIDER_SPECIALTY,
      m.PROVIDER_SPECIALTY_CS,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.GENDER,
      E.GENDER_CS,
      E.AGE,
      E.OCCURRENCE_START_DATE,
      E.OCCURRENCE_END_DATE,
      E.DEVICE_TYPE,
      E.DEVICE_TYPE_CS,
      E.UNIQUE_DEVICE_ID,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.VISIT_TYPE,
      E.VISIT_TYPE_CS,
      E.QUANTITY,
      E.DEVICE_SOURCE_CONCEPT,
      E.CORRETALED_CRITERIA
    ]
  },
  Group: {
    baseText: "",
    attributes: [],
    wrapCriteria: !0
  },
  DoseEra: {
    titleText: "Dose Era:",
    baseText: "a dose era of",
    baseTextViewMode: "dose eras of",
    defaultValue: "Any drug",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_EXPOSURE,
      m.GENDER,
      m.GENDER_CS,
      m.AGE_AT_ERA_START,
      m.AGE_AT_ERA_END,
      m.START_DATE,
      m.END_DATE,
      m.UNIT,
      m.UNIT_CS,
      m.DOSE_VALUE,
      m.ERA_LENGTH,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.GENDER,
      E.GENDER_CS,
      E.AGE_START,
      E.AGE_END,
      E.ERA_START_DATE,
      E.ERA_END_DATE,
      E.UNIT,
      E.UNIT_CS,
      E.DOSE_VALUE,
      E.ERA_LENGTH,
      E.CORRETALED_CRITERIA
    ]
  },
  DrugEra: {
    titleText: "Drug Era:",
    baseText: "a drug era of",
    baseTextViewMode: "drug era of",
    defaultValue: "Any drug",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_EXPOSURE,
      m.GENDER,
      m.GENDER_CS,
      m.AGE_AT_ERA_START,
      m.AGE_AT_ERA_END,
      m.START_DATE,
      m.END_DATE,
      m.ERA_LENGTH,
      m.ERA_EXPOSURE_COUNT,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.GENDER,
      E.GENDER_CS,
      E.AGE_START,
      E.AGE_END,
      E.ERA_START_DATE,
      E.ERA_END_DATE,
      E.ERA_LENGTH,
      E.OCCURRENCE_COUNT,
      E.CORRETALED_CRITERIA
    ]
  },
  DrugExposure: {
    titleText: "Drug Exposure:",
    baseText: "a drug exposure of",
    baseTextViewMode: "drug exposure of",
    defaultValue: "Any drug",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_EXPOSURE,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.CONDITION_START_DATE,
      m.CONDITION_END_DATE,
      m.DRUG_TYPE,
      m.DRUG_TYPE_CS,
      m.VISIT,
      m.VISIT_CS,
      m.REFILLS,
      m.QUANTITY,
      m.DAYS_SUPPLY,
      m.ROUTE,
      m.ROUTE_CS,
      m.DOSE_UNIT,
      m.DOSE_UNIT_CS,
      m.LOT_NUMBER,
      m.DRUG_SOURCE_CONCEPT,
      m.PROVIDER_SPECIALTY,
      m.PROVIDER_SPECIALTY_CS,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.AGE,
      E.GENDER,
      E.GENDER_CS,
      E.OCCURRENCE_START_DATE,
      E.OCCURRENCE_END_DATE,
      E.DRUG_TYPE,
      E.DRUG_TYPE_CS,
      E.VISIT_TYPE,
      E.VISIT_TYPE_CS,
      E.REFILLS,
      E.QUANTITY,
      E.DAYS_SUPPLY,
      E.ROUTE_CONCEPT,
      E.ROUTE_CONCEPT_CS,
      E.DOSE_UNIT,
      E.DOSE_UNIT_CS,
      E.LOT_NUMBER,
      E.DRUG_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.CORRETALED_CRITERIA
    ]
  },
  Measurement: {
    titleText: "Measurement:",
    baseText: "a measurement of",
    baseTextViewMode: "measurement of",
    defaultValue: "Any Measurement",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_MEASURE,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.MEASUREMENT_DATE,
      m.MEASUREMENT_TYPE,
      m.MEASUREMENT_TYPE_CS,
      m.VISIT,
      m.VISIT_CS,
      m.OPERATOR,
      m.OPERATOR_CS,
      m.VALUE_AS_NUMBER,
      m.VALUE_AS_CONCEPT,
      m.VALUE_AS_CONCEPT_CS,
      m.UNIT,
      m.UNIT_CS,
      m.ABNORMAL_RESULT,
      m.LOW_RANGE,
      m.HIGH_RANGE,
      m.LOW_RANGE_RATIO,
      m.HIGH_RANGE_RATIO,
      m.PROVIDER_SPECIALTY,
      m.PROVIDER_SPECIALTY_CS,
      m.MEASUREMENT_SOURCE_CONCEPT,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.AGE,
      E.GENDER,
      E.GENDER_CS,
      E.OCCURRENCE_START_DATE,
      E.MEASUREMENT_TYPE,
      E.MEASUREMENT_TYPE_CS,
      E.VISIT_TYPE,
      E.VISIT_TYPE_CS,
      E.OPERATOR,
      E.OPERATOR_CS,
      E.VALUE_AS_NUMBER,
      E.VALUE_AS_CONCEPT,
      E.VALUE_AS_CONCEPT_CS,
      E.UNIT,
      E.UNIT_CS,
      E.ABNORMAL,
      E.RANGE_LOW,
      E.RANGE_HIGH,
      E.RANGE_LOW_RATIO,
      E.RANGE_HIGH_RATIO,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.MEASUREMENT_SOURCE_CONCEPT,
      E.CORRETALED_CRITERIA
    ]
  },
  Observation: {
    titleText: "Observation:",
    baseText: "an observation of",
    baseTextViewMode: "observation of",
    defaultValue: "Any Observation",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_OBSERVATION,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.OBSERVATION_DATE,
      m.OBSERVATION_TYPE,
      m.OBSERVATION_TYPE_CS,
      m.VISIT,
      m.VISIT_CS,
      m.VALUE_AS_NUMBER,
      m.VALUE_AS_STRING,
      m.VALUE_AS_CONCEPT,
      m.VALUE_AS_CONCEPT_CS,
      m.QUALIFIER,
      m.QUALIFIER_CS,
      m.UNIT,
      m.UNIT_CS,
      m.OBSERVATION_SOURCE_CONCEPT,
      m.PROVIDER_SPECIALTY,
      m.PROVIDER_SPECIALTY_CS,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.AGE,
      E.GENDER,
      E.GENDER_CS,
      E.OCCURRENCE_START_DATE,
      E.OBSERVATION_TYPE,
      E.OBSERVATION_TYPE_CS,
      E.VISIT_TYPE,
      E.VISIT_TYPE_CS,
      E.VALUE_AS_NUMBER,
      E.VALUE_AS_STRING,
      E.VALUE_AS_CONCEPT,
      E.VALUE_AS_CONCEPT_CS,
      E.QUALIFIER,
      E.QUALIFIER_CS,
      E.UNIT,
      E.UNIT_CS,
      E.OBSERVATION_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.CORRETALED_CRITERIA
    ]
  },
  ObservationPeriod: {
    titleText: "Observation period:",
    baseText: "observation periods with the following criteria",
    baseTextViewMode: "observation period",
    defaultValue: "",
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_OBSERVATION_PERIOD,
      m.SPECIFY_START_AND_DATE,
      m.AGE_AT_START,
      m.AGE_AT_END,
      m.PERIOD_START_DATE,
      m.PERIOD_END_DATE,
      m.PERIOD_TYPE,
      m.PERIOD_TYPE_CS,
      m.PERIOD_LENGTH,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.AGE_START,
      E.AGE_END,
      E.USER_DEFINED_PERIOD,
      E.PERIOD_START_DATE,
      E.PERIOD_END_DATE,
      E.PERIOD_TYPE,
      E.PERIOD_TYPE_CS,
      E.PERIOD_LENGTH,
      E.CORRETALED_CRITERIA
    ],
    extend: !0
  },
  PayerPlanPeriod: {
    titleText: "Payer plan period:",
    baseText: "payer plan periods with the following criteria",
    baseTextViewMode: "payer plan period",
    defaultValue: "",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_PAYER_PLAN_PERIOD,
      m.GENDER,
      m.GENDER_CS,
      m.AGE_AT_START,
      m.AGE_AT_END,
      m.PERIOD_START_DATE,
      m.PERIOD_END_DATE,
      m.PERIOD_LENGTH,
      m.PAYER_CONCEPT,
      m.PLAN_CONCEPT,
      m.SPONSOR_CONCEPT,
      m.STOP_REASON_CONCEPT,
      m.PAYER_SOURCE_CONCEPT,
      m.PLAN_SOURCE_CONCEPT,
      m.SPONSOR_SOURCE_CONCEPT,
      m.STOP_REASON_SOURCE_CONCEPT,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.GENDER,
      E.GENDER_CS,
      E.AGE_START,
      E.AGE_END,
      E.PERIOD_START_DATE,
      E.PERIOD_END_DATE,
      E.PERIOD_LENGTH,
      E.PAYER_CONCEPT,
      E.PLAN_CONCEPT,
      E.SPONSOR_CONCEPT,
      E.STOP_REASON_CONCEPT,
      E.PAYER_SOURCE_CONCEPT,
      E.PLAN_SOURCE_CONCEPT,
      E.SPONSOR_SOURCE_CONCEPT,
      E.STOP_REASON_SOURCE_CONCEPT,
      E.CORRETALED_CRITERIA
    ]
  },
  ProcedureOccurrence: {
    titleText: "Procedure occurrence:",
    baseText: "a procedure occurrence of",
    baseTextViewMode: "procedure occurrence of",
    defaultValue: "Any Procedure",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_PROCEDURE,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.CONDITION_START_DATE,
      m.PROCEDURE_TYPE,
      m.PROCEDURE_TYPE_CS,
      m.VISIT,
      m.VISIT_CS,
      m.MODIFIER,
      m.MODIFIER_CS,
      m.QUANTITY,
      m.PROCEDURE_SOURCE_CONCEPT,
      m.PROVIDER_SPECIALTY,
      m.PROVIDER_SPECIALTY_CS,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.AGE,
      E.GENDER,
      E.GENDER_CS,
      E.OCCURRENCE_START_DATE,
      E.PROCEDURE_TYPE,
      E.PROCEDURE_TYPE_CS,
      E.VISIT_TYPE,
      E.VISIT_TYPE_CS,
      E.MODIFIER,
      E.MODIFIER_CS,
      E.QUANTITY,
      E.PROCEDURE_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.CORRETALED_CRITERIA
    ]
  },
  LocationRegion: {
    titleText: "Location region:",
    baseText: "a location region of",
    baseTextViewMode: "location region of",
    defaultValue: "Any Location region",
    extend: !0,
    attributes: [
      m.LOC_START_DATE,
      m.LOC_END_DATE,
      m.NESTED
    ],
    attributesSort: [
      E.START_DATE,
      E.END_DATE,
      E.CORRETALED_CRITERIA
    ]
  },
  Specimen: {
    titleText: "Specimen:",
    baseText: "a specimen of",
    baseTextViewMode: "specimen of",
    defaultValue: "Any Specimen",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_OCCURRENCE,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.SPECIMEN_DATE,
      m.SPECIMEN_TYPE,
      m.SPECIMEN_TYPE_CS,
      m.QUANTITY,
      m.UNIT,
      m.UNIT_CS,
      m.ANATOMIC_SITE,
      m.ANATOMIC_SITE_CS,
      m.DISEASE_STATUS,
      m.DISEASE_STATUS_CS,
      m.SOURCE_ID,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.AGE,
      E.GENDER,
      E.GENDER_CS,
      E.OCCURRENCE_START_DATE,
      E.SPECIMEN_TYPE,
      E.SPECIMEN_TYPE_CS,
      E.QUANTITY,
      E.UNIT,
      E.UNIT_CS,
      E.ANATOMIC_SITE,
      E.ANATOMIC_SITE_CS,
      E.DISEASE_STATUS,
      E.DISEASE_STATUS_CS,
      E.SOURCE_ID,
      E.CORRETALED_CRITERIA
    ]
  },
  VisitOccurrence: {
    titleText: "Visit:",
    baseText: "a visit occurrence of",
    baseTextViewMode: "visit occurrence of",
    defaultValue: "Any Visit",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_VISIT,
      m.AGE_OCCURRENCE,
      m.GENDER,
      m.GENDER_CS,
      m.CONDITION_START_DATE,
      m.CONDITION_END_DATE,
      m.VISIT_TYPE,
      m.VISIT_TYPE_CS,
      m.VISIT_LENGTH,
      m.VISIT_SOURCE_CONCEPT,
      m.PROVIDER_SPECIALTY,
      m.PROVIDER_SPECIALTY_CS,
      m.PLACE_SERVICE,
      m.PLACE_SERVICE_CS,
      m.PLACE_SERVICE_LOCATION,
      m.PLACE_SERVICE_DISTANCE,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.AGE,
      E.GENDER,
      E.GENDER_CS,
      E.OCCURRENCE_START_DATE,
      E.OCCURRENCE_END_DATE,
      E.VISIT_TYPE,
      E.VISIT_TYPE_CS,
      E.VISIT_LENGTH,
      E.VISIT_SOURCE_CONCEPT,
      E.PROVIDER_SPECIALTY,
      E.PROVIDER_SPECIALTY_CS,
      E.PLACE_SERVICE,
      E.PLACE_SERVICE_CS,
      E.PLACE_SERVICE_LOCATION,
      E.PLACE_SERVICE_DISTANCE,
      E.CORRETALED_CRITERIA
    ]
  },
  VisitDetail: {
    titleText: "Visit Detail:",
    baseText: "a visit detail of",
    baseTextViewMode: "visit occurrence of",
    defaultValue: "Any Visit Detail",
    extend: !0,
    attributes: [
      m.MODIFY_EVENT_START_END,
      m.FIRST_VISIT_DETAIL,
      m.AGE_AT_VISIT_DETAIL,
      m.GENDER_CS,
      m.VISIT_DETAIL_START_DATE,
      m.VISIT_DETAIL_END_DATE,
      m.MODIFY_EVENT_START_END,
      m.VISIT_DETAIL_TYPE,
      m.VISIT_DETAIL_LENGTH,
      m.VISIT_DETAIL_SOURCE_CONCEPT,
      m.PROVIDER_SPECIALTY_CS,
      m.PLACE_SERVICE_CS,
      m.PLACE_SERVICE_LOCATION,
      m.NESTED
    ],
    attributesSort: [
      E.DATE_ADJUSTMENT,
      E.FIRST,
      E.AGE,
      E.GENDER_CS,
      E.VISIT_DETAIL_START_DATE,
      E.VISIT_DETAIL_END_DATE,
      E.DATE_ADJUSTMENT,
      E.VISIT_DETAIL_TYPE_CS,
      E.VISIT_DETAIL_SOURCE_CONCEPT,
      E.VISIT_DETAIL_LENGTH,
      E.PROVIDER_SPECIALTY_CS,
      E.PLACE_SERVICE_CS,
      E.PLACE_SERVICE_LOCATION,
      E.CORRETALED_CRITERIA
    ]
  }
}, ks = [
  {
    value: ye.LESS_THAN,
    name: "before"
  },
  {
    value: ye.LESS_OR_EQUAL_TO,
    name: "on or before"
  },
  {
    value: ye.EQUAL_TO,
    name: "on"
  },
  {
    value: ye.GREATER_THAN,
    name: "after"
  },
  {
    value: ye.GREATER_OR_EQUAL_TO,
    name: "on or after"
  },
  {
    value: ye.BETWEEN,
    name: "between"
  },
  {
    value: ye.NOT_BETWEEN,
    name: "not between"
  }
], Xe = (e, t, n, r) => ({
  startText: t,
  type: B.DROPDOWN,
  defaultParam: {
    value: r,
    name: n
  },
  isExclusion: !0,
  subModule: "concept-sets",
  value: e
}), mr = {
  First: {
    startText: "for the first time in the person's history",
    altStartText: "limited to the patients first observation period",
    type: B.BOOL,
    value: "First"
  },
  AgeAtStart: {
    startText: "with age in years at era start",
    altStartText: "with age in years at period start",
    viewModeTextEnd: "years old at era start",
    type: B.VALUE,
    value: "AgeAtStart"
  },
  AgeAtEnd: {
    startText: "with age in years at era end",
    altStartText: "with age in years at period end",
    viewModeTextEnd: "years old at era end",
    type: B.VALUE,
    value: "AgeAtEnd"
  },
  Gender: {
    startText: "with a gender of",
    type: B.VOCABULARY,
    value: "Gender",
    domainId: "Gender"
  },
  EraStartDate: {
    startText: "start is",
    type: B.DATE,
    viewModeTextStart: "starting",
    value: "EraStartDate"
  },
  EraEndDate: {
    startText: "end is",
    type: B.DATE,
    viewModeTextStart: "ending",
    value: "EraEndDate"
  },
  StartDate: {
    startText: "start is",
    viewModeTextStart: "starting",
    type: B.DATE,
    value: "StartDate"
  },
  EndDate: {
    startText: "end is",
    type: B.DATE,
    viewModeTextStart: "ending",
    value: "EndDate"
  },
  OccurrenceCount: {
    startText: "with occurrence count",
    viewModeTextStart: "containing",
    viewModeTextEnd: "occurrences",
    type: B.VALUE,
    value: "OccurrenceCount"
  },
  EraLength: {
    startText: "with era length",
    viewModeTextStart: "era length is",
    viewModeTextEnd: "days",
    type: B.VALUE,
    value: "EraLength",
    endText: "days"
  },
  Age: {
    startText: "with age",
    viewModeTextEnd: "years old",
    type: B.VALUE,
    value: "Age"
  },
  ConditionStatus: {
    startText: "with a condition status of",
    type: B.VOCABULARY,
    viewModeTextStart: "a condition status that is:",
    value: "ConditionStatus",
    domainId: "Condition Status"
  },
  ConditionStatusCS: Xe(
    "ConditionStatusCS",
    "with a condition status",
    "Any condition status",
    "ANY_CONDITION_STATUS"
  ),
  OccurrenceStartDate: {
    startText: "occurrence start is",
    viewModeTextStart: "starting",
    type: B.DATE,
    value: "OccurrenceStartDate"
  },
  OccurrenceEndDate: {
    startText: "occurrence end is",
    viewModeTextStart: "ending",
    type: B.DATE,
    value: "OccurrenceEndDate"
  },
  ConditionType: {
    startText: "condition type",
    extend: !0,
    type: B.VOCABULARY,
    viewModeTextStart: "a condition type that is:",
    value: "ConditionType",
    secondValue: "ConditionTypeExclude",
    domainId: "Type Concept"
  },
  ConditionTypeCS: Xe(
    "ConditionTypeCS",
    "condition type",
    "Any condition type",
    "ANY_CONDITION_TYPE"
  ),
  VisitType: {
    startText: "visit type",
    altStartText: "with a visit occurrence of:",
    viewModeTextStart: "a visit occurrence that is:",
    type: B.VOCABULARY,
    value: "VisitType",
    secondValue: "VisitTypeExclude",
    domainId: "Visit",
    standardConcept: "Standard",
    extend: !0
    // secondValue: 'VisitTypeExclude',
  },
  VisitTypeCS: Xe(
    "VisitTypeCS",
    "visit type",
    "Any visit type",
    "ANY_VISIT_TYPE"
  ),
  StopReason: {
    startText: "with a stop reason",
    viewModeTextStart: "with a stop reason",
    type: B.TEXT,
    dropdownType: "intervalValue",
    value: "StopReason"
  },
  ConditionSourceConcept: {
    startText: "condition source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_CONDITION",
      name: "Any Condition"
    },
    subModule: "concept-sets",
    value: "ConditionSourceConcept"
  },
  ProviderSpecialty: {
    startText: "with a provider specialty of",
    viewModeTextStart: "a provider specialty that is:",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "ProviderSpecialty",
    domainId: "Provider"
  },
  DeathType: {
    startText: "death type",
    viewModeTextStart: "a death type that is:",
    type: B.VOCABULARY,
    extend: !0,
    value: "DeathType",
    secondValue: "DeathTypeExclude",
    domainId: "Type Concept",
    permamentSecondValue: !0
  },
  DeathTypeCS: Xe(
    "DeathTypeCS",
    "death type",
    "Any death type",
    "ANY_DEATH_TYPE"
  ),
  DeathDate: {
    startText: "occurrence start is",
    viewModeTextStart: "starting",
    type: B.DATE,
    dropdownType: "intervalDate",
    value: "OccurrenceStartDate"
  },
  DeathSourceConcept: {
    startText: "death source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_DEATH",
      name: "Any Death"
    },
    subModule: "concept-sets",
    value: "DeathSourceConcept"
  },
  DeviceType: {
    startText: "device type",
    type: B.VOCABULARY,
    extend: !0,
    viewModeTextStart: "a device type that is:",
    subModule: "concept-sets",
    value: "DeviceType",
    secondValue: "DeviceTypeExclude",
    domainId: "Type Concept"
  },
  DeviceTypeCS: Xe(
    "DeviceTypeCS",
    "device type",
    "Any device type",
    "ANY_DEVICE_TYPE"
  ),
  UniqueDeviceId: {
    startText: "with unique device ID",
    viewModeTextStart: "unique device ID",
    type: B.TEXT,
    dropdownType: "intervalInclude",
    value: "UniqueDeviceId"
  },
  Quantity: {
    startText: "with quantity",
    type: B.VALUE,
    dropdownType: "intervalValue",
    defaultOp: ye.LESS_THAN,
    value: "Quantity"
  },
  DeviceSourceConcept: {
    startText: "device source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_DEVICE",
      name: "Any Device"
    },
    subModule: "concept-sets",
    value: "DeviceSourceConcept"
  },
  Unit: {
    startText: "with unit",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "Unit",
    domainId: "Unit"
  },
  UnitCS: Xe("UnitCS", "with unit", "Any unit", "ANY_UNIT"),
  DoseUnit: {
    startText: "dose unit is",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "DoseUnit",
    domainId: "Unit"
  },
  DoseUnitCS: Xe(
    "DoseUnitCS",
    "dose unit is",
    "Any dose unit",
    "ANY_DOSE_UNIT"
  ),
  DoseValue: {
    startText: "with dose value",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "DoseValue"
  },
  ERA_EXPOSURE_COUNT: {
    startText: "with exposure count",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "OccurrenceCount"
  },
  DrugType: {
    startText: "drug type",
    type: B.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "DrugType",
    secondValue: "DrugTypeExclude",
    domainId: "Type Concept"
  },
  DrugTypeCS: Xe(
    "DrugTypeCS",
    "drug type",
    "Any drug type",
    "ANY_DRUG_TYPE"
  ),
  Refills: {
    startText: "with refills",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "Refills"
  },
  DaysSupply: {
    startText: "with days supply",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "DaysSupply"
  },
  RouteConcept: {
    startText: "route concept is",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "RouteConcept",
    domainId: "Route"
  },
  RouteConceptCS: Xe(
    "RouteConceptCS",
    "route concept is",
    "Any route",
    "ANY_ROUTE"
  ),
  EffectiveDrugDose: {
    startText: "with effective drug dose",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "EffectiveDrugDose"
  },
  LotNumber: {
    startText: "with a lot number",
    type: B.TEXT,
    dropdownType: "intervalValue",
    value: "LotNumber"
  },
  DrugSourceConcept: {
    startText: "drug source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_DRUG",
      name: "Any Drug"
    },
    subModule: "concept-sets",
    value: "DrugSourceConcept"
  },
  MeasurementType: {
    startText: "measurement type",
    type: B.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "MeasurementType",
    secondValue: "MeasurementTypeExclude",
    domainId: "Type Concept"
  },
  MeasurementTypeCS: Xe(
    "MeasurementTypeCS",
    "measurement type",
    "Any measurement type",
    "ANY_MEASUREMENT_TYPE"
  ),
  Operator: {
    startText: "measurement value operator is",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "Operator",
    domainId: "Meas Value Operator"
  },
  OperatorCS: Xe(
    "OperatorCS",
    "measurement value operator is",
    "Any operator",
    "ANY_OPERATOR"
  ),
  ValueAsNumber: {
    startText: "with value as number",
    type: B.VALUE,
    dropdownType: "intervalValue",
    defaultOp: ye.LESS_THAN,
    value: "ValueAsNumber"
  },
  ValueAsString: {
    startText: "with value as string",
    type: B.TEXT,
    dropdownType: "intervalValue",
    value: "ValueAsString",
    defaultOp: hn.CONTAINING
  },
  ValueAsConcept: {
    startText: "with value as concept",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "ValueAsConcept",
    domainId: "Meas Value"
  },
  ValueAsConceptCS: Xe(
    "ValueAsConceptCS",
    "with value as concept",
    "Any value as concept",
    "ANY_VALUE_AS_CONCEPT"
  ),
  Abnormal: {
    startText: "with an abnormal result",
    type: B.BOOL,
    value: "Abnormal"
  },
  RangeLow: {
    startText: "with range low",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "RangeLow"
  },
  RangeHigh: {
    startText: "with range high",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "RangeHigh"
  },
  RangeLowRatio: {
    startText: "with range low ratio",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "RangeLowRatio"
  },
  RangeHighRatio: {
    startText: "with range high ratio",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "RangeHighRatio"
  },
  MeasurementSourceConcept: {
    startText: "measurement source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_MEASUREMENT",
      name: "Any Measurement"
    },
    subModule: "concept-sets",
    value: "MeasurementSourceConcept"
  },
  ObservationType: {
    startText: "observation type",
    type: B.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "ObservationType",
    secondValue: "ObservationTypeExclude",
    domainId: "Type Concept"
  },
  ObservationTypeCS: Xe(
    "ObservationTypeCS",
    "observation type",
    "Any observation type",
    "ANY_OBSERVATION_TYPE"
  ),
  Qualifier: {
    startText: "with qualifier",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "Qualifier",
    domainId: "Condition"
  },
  QualifierCS: Xe(
    "QualifierCS",
    "with qualifier",
    "Any qualifier",
    "ANY_QUALIFIER"
  ),
  ObservationSourceConcept: {
    startText: "observation source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_OBSERVATION",
      name: "Any Observation"
    },
    subModule: "concept-sets",
    value: "ObservationSourceConcept"
  },
  PeriodLength: {
    startText: "with period duration",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "PeriodLength",
    endText: "days"
  },
  UserDefinedPeriod: {
    startText: "using specified period",
    range: !0,
    type: B.DATE,
    dropdownType: "intervalDate",
    value: "UserDefinedPeriod"
  },
  PeriodStartDate: {
    startText: "payer plan period start is",
    altStartText: "observation period start is",
    type: B.DATE,
    dropdownType: "intervalDate",
    value: "PeriodStartDate"
  },
  PeriodEndDate: {
    startText: "payer plan period end is",
    altStartText: "observation period end is",
    type: B.DATE,
    dropdownType: "intervalDate",
    value: "PeriodEndDate"
  },
  PayerConcept: {
    startText: "payer concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_PAYER",
      name: "Any Payer"
    },
    subModule: "concept-sets",
    value: "PayerConcept"
  },
  PlanConcept: {
    startText: "plan concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_PLAN",
      name: "Any Plan"
    },
    subModule: "concept-sets",
    value: "PlanConcept"
  },
  SponsorConcept: {
    startText: "sponsor concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_SPONSOR",
      name: "Any Sponsor"
    },
    subModule: "concept-sets",
    value: "SponsorConcept"
  },
  StopReasonConcept: {
    startText: "stop reason concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_STOP_REASON",
      name: "Any Stop Reason"
    },
    subModule: "concept-sets",
    value: "StopReasonConcept"
  },
  PayerSourceConcept: {
    startText: "payer source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_PAYER_SOURCE",
      name: "Any Payer Source"
    },
    subModule: "concept-sets",
    value: "PayerSourceConcept"
  },
  PlanSourceConcept: {
    startText: "plan source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_PLAN_SOURCE",
      name: "Any Plan Source"
    },
    subModule: "concept-sets",
    value: "PlanSourceConcept"
  },
  SponsorSourceConcept: {
    startText: "sponsor source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_SPONSOR_SOURCE",
      name: "Any Sponsor Source"
    },
    subModule: "concept-sets",
    value: "SponsorSourceConcept"
  },
  StopReasonSourceConcept: {
    startText: "stop reason source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_STOP_REASON_SOURCE",
      name: "Any Stop Reason Source"
    },
    subModule: "concept-sets",
    value: "StopReasonSourceConcept"
  },
  PeriodType: {
    startText: "period type is",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "PeriodType",
    domainId: "Type Concept"
  },
  PeriodTypeCS: Xe(
    "PeriodTypeCS",
    "period type is",
    "Any period type",
    "ANY_PERIOD_TYPE"
  ),
  ProcedureType: {
    startText: "procedure type",
    type: B.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "ProcedureType",
    secondValue: "ProcedureTypeExclude",
    domainId: "Type Concept"
  },
  ProcedureTypeCS: Xe(
    "ProcedureTypeCS",
    "procedure type",
    "Any procedure type",
    "ANY_PROCEDURE_TYPE"
  ),
  Modifier: {
    startText: "modifier is",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "Modifier",
    domainId: "Spec Anatomic Site"
  },
  ModifierCS: Xe(
    "ModifierCS",
    "modifier is",
    "Any modifier",
    "ANY_MODIFIER"
  ),
  ProcedureSourceConcept: {
    startText: "procedure source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_PROCEDURE",
      name: "Any Procedure"
    },
    subModule: "concept-sets",
    value: "ProcedureSourceConcept"
  },
  SpecimenType: {
    startText: "specimen type",
    type: B.VOCABULARY,
    extend: !0,
    subModule: "concept-sets",
    value: "SpecimenType",
    secondValue: "SpecimenTypeExclude",
    domainId: "Type Concept"
  },
  SpecimenTypeCS: Xe(
    "SpecimenTypeCS",
    "specimen type",
    "Any specimen type",
    "ANY_SPECIMEN_TYPE"
  ),
  SPECIMEN_DATE: {
    startText: "occurrence start is",
    type: B.DATE,
    dropdownType: "intervalDate",
    value: "OccurrenceStartDate"
  },
  AnatomicSite: {
    startText: "with anatomic site",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "AnatomicSite",
    domainId: "Spec Anatomic Site"
  },
  AnatomicSiteCS: Xe(
    "AnatomicSiteCS",
    "with anatomic site",
    "Any anatomic site",
    "ANY_ANATOMIC_SITE"
  ),
  PlaceOfServiceLocation: {
    startText: "with a place of service located in",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_LOCATION",
      name: "Any Location"
    },
    subModule: "concept-sets",
    value: "PlaceOfServiceLocation"
  },
  PlaceOfService: {
    startText: "with a place of service of",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "PlaceOfService",
    domainId: "Place of Service"
  },
  VisitSourceConcept: {
    startText: "visit source concept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_VISIT",
      name: "Any Visit"
    },
    subModule: "concept-sets",
    value: "VisitSourceConcept"
  },
  VisitLength: {
    startText: "with visit duration",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "VisitLength"
  },
  PlaceOfServiceDistance: {
    startText: "with distance from a Place of Service to Patient",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "PlaceOfServiceDistance"
  },
  DiseaseStatus: {
    startText: "with disease status",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "DiseaseStatus",
    domainId: "Spec Disease Status"
  },
  DiseaseStatusCS: Xe(
    "DiseaseStatusCS",
    "with disease status",
    "Any disease status",
    "ANY_DISEASE_STATUS"
  ),
  SourceId: {
    startText: "with source ID",
    type: B.TEXT,
    dropdownType: "intervalInclude",
    value: "SourceId"
  },
  Race: {
    startText: "with a race of",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "Race",
    domainId: "Race"
  },
  Ethnicity: {
    startText: "with a ethnicity of",
    type: B.VOCABULARY,
    subModule: "concept-sets",
    value: "Ethnicity",
    domainId: "Ethnicity"
  },
  DateAdjustment: {
    startText: "with date adjustment:",
    type: B.RANGE,
    value: "DateAdjustment",
    domainId: "DateAdjustment"
  },
  VisitDetailStartDate: {
    startText: "visit detail start is",
    type: B.DATE,
    viewModeTextStart: "starting",
    value: "VisitDetailStartDate"
  },
  VisitDetailEndDate: {
    startText: "visit detail end is",
    type: B.DATE,
    viewModeTextStart: "ending",
    value: "VisitDetailEndDate"
  },
  VisitDetailTypeCS: {
    startText: "visit detail type",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_VISIT_DETAIL_TYPE",
      name: "Any visit detail type"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "VisitDetailTypeCS"
  },
  VisitDetailLength: {
    startText: "with visit detail duration",
    type: B.VALUE,
    dropdownType: "intervalValue",
    value: "VisitDetailLength"
  },
  VisitDetailSourceConcept: {
    startText: "visit detail source soncept is",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_VISIT_DETAIL_SOURCE_CONCEPT",
      name: "Any visit detail cource concept"
    },
    subModule: "concept-sets",
    value: "VisitDetailSourceConcept"
  },
  GenderCS: {
    startText: "with a gender",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_GENDER",
      name: "Any gender"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "GenderCS"
  },
  RaceCS: {
    startText: "with a race",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_RACE",
      name: "Any race"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "RaceCS"
  },
  EthnicityCS: {
    startText: "with a ethnicity",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_ETHNICITY",
      name: "Any ethnicity"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "EthnicityCS"
  },
  ProviderSpecialtyCS: {
    startText: "with a provider specialty",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_PROVIDER",
      name: "Any provider specialty"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "ProviderSpecialtyCS"
  },
  PlaceOfServiceCS: {
    startText: "with place of service",
    type: B.DROPDOWN,
    defaultParam: {
      value: "ANY_LOCATION",
      name: "Any location"
    },
    isExclusion: !0,
    subModule: "concept-sets",
    value: "PlaceOfServiceCS"
  },
  CorrelatedCriteria: {
    type: B.GROUP,
    value: "CorrelatedCriteria"
  },
  Group: {
    type: B.GROUP,
    value: "Group"
  },
  default: {
    startText: "default",
    type: B.BOOL,
    value: "Default"
  }
}, Ms = [
  {
    value: ye.LESS_THAN,
    name: "less than"
  },
  {
    value: ye.LESS_OR_EQUAL_TO,
    name: "less or equal to"
  },
  {
    value: ye.EQUAL_TO,
    name: "equal to"
  },
  {
    value: ye.GREATER_THAN,
    name: "greater than"
  },
  {
    value: ye.GREATER_OR_EQUAL_TO,
    name: "greater or equal to"
  },
  {
    value: ye.BETWEEN,
    name: "between"
  },
  {
    value: ye.NOT_BETWEEN,
    name: "not between"
  }
], Vs = [
  {
    value: hn.STARTING_WITH,
    name: "starting with"
  },
  {
    value: hn.CONTAINING,
    name: "containing"
  },
  {
    value: hn.ENDING_WITH,
    name: "ending with"
  },
  {
    value: hn.NOT_STARTING_WITH,
    name: "not starting with"
  },
  {
    value: hn.NOT_CONTAINING,
    name: "not containing"
  },
  {
    value: hn.NOT_ENDING_WITH,
    name: "not ending with"
  }
], Hc = [
  {
    value: Ss.START_DATE,
    name: "start date"
  },
  {
    value: Ss.END_DATE,
    name: "end date"
  }
], Us = [
  {
    value: "START_DATE",
    name: "start date"
  },
  {
    value: "END_DATE",
    name: "end date"
  }
], Dh = [
  {
    value: Ro.END,
    name: "end of continuous observation"
  },
  {
    value: Ro.FIXED,
    name: "fixed duration relative to initial event"
  },
  {
    value: Ro.EXPOSURE,
    name: "end of a continuous drug exposure"
  }
], or = [
  {
    name: "after",
    value: 1
  },
  {
    name: "before",
    value: -1
  }
], vh = [
  {
    name: "all",
    value: tr.ALL
  },
  {
    name: "any",
    value: tr.ANY
  },
  {
    name: "at Least",
    value: tr.AT_LEAST
  },
  {
    name: "at most",
    value: tr.AT_MOST
  }
], Ko = [
  {
    name: "exactly",
    value: 0
  },
  {
    name: "at most",
    value: 1
  },
  {
    name: "at least",
    value: 2
  }
], Zo = [
  {
    name: "standard concept",
    value: Is.STANDARD_CONCEPT
  },
  {
    name: "start date",
    value: Is.START_DATE
  }
], _h = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 2,
    name: "2"
  },
  {
    value: 3,
    name: "3"
  },
  {
    value: 4,
    name: "4"
  },
  {
    value: 5,
    name: "5"
  },
  {
    value: 6,
    name: "6"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 8,
    name: "8"
  },
  {
    value: 9,
    name: "9"
  },
  {
    value: 10,
    name: "10"
  },
  {
    value: 20,
    name: "20"
  },
  {
    value: 50,
    name: "50"
  },
  {
    value: 100,
    name: "100"
  }
];
tr.ALL;
const Nh = {
  CriteriaList: [],
  ObservationWindow: {
    PriorDays: 0,
    PostDays: 0
  },
  PrimaryCriteriaLimit: {
    Type: Wt.FIRST
  }
}, qc = {
  IsDistinct: !1,
  Type: 2,
  Count: 1,
  CountColumn: void 0
}, ar = {
  Start: {
    Coeff: -1
  },
  End: {
    Coeff: 1
  },
  UseIndexEnd: !1,
  UseEventEnd: !1
}, wh = /* @__PURE__ */ new Set([
  D.CONDITION_OCCURRENCE,
  D.DEVICE_EXPOSURE,
  D.DRUG_EXPOSURE,
  D.MEASUREMENT,
  D.OBSERVATION,
  D.PAYER_PLAN_PERIOD,
  D.PROCEDURE_OCCURRENCE,
  D.VISIT,
  D.VISIT_DETAILS
]), Ph = /* @__PURE__ */ new Set([
  D.CONDITION_ERA,
  D.CONDITION_OCCURRENCE,
  D.DEATH,
  D.DEVICE_EXPOSURE,
  D.DOSE_ERA,
  D.DRUG_ERA,
  D.DRUG_EXPOSURE,
  D.LOCATION_REGION,
  D.MEASUREMENT,
  D.OBSERVATION,
  D.OBSERVATION_PERIOD,
  D.PAYER_PLAN_PERIOD,
  D.PROCEDURE_OCCURRENCE,
  D.SPECIMEN,
  D.VISIT,
  D.VISIT_DETAILS
]), Xc = (e) => !1, Jc = (e) => !!(e && wh.has(e)), Qc = (e) => e === D.LOCATION_REGION, Kc = (e) => !!(e && Ph.has(e));
tr.ALL;
const jh = "&filter.metadata.subject=COHORT";
var mn = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_ATTRIBUTE = "ADD_ATTRIBUTE", e.UPDATE_ATTRIBUTE = "UPDATE_ATTRIBUTE", e.REMOVE_ATTRIBUTE = "REMOVE_ATTRIBUTE", e))(mn || {});
const Lh = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case mn.INIT:
      n.isStartHook = !0, n.attributes = t.payload;
      break;
    case mn.ADD_ATTRIBUTE:
      n.attributes[t.payload.id] = t.payload;
      break;
    case mn.UPDATE_ATTRIBUTE:
      n.attributes[t.payload.id].value = t.payload.values;
      break;
    case mn.REMOVE_ATTRIBUTE:
      delete n.attributes[t.payload];
      break;
  }
}), kh = {
  attributes: {},
  isStartHook: !1,
  isLoading: !1
}, Zc = (e, t) => {
  switch (e) {
    case B.BOOL:
      return !0;
    case B.VALUE:
      return {
        Op: t || ye.GREATER_THAN,
        Value: null
      };
    case B.DATE:
      return {
        Op: ye.LESS_THAN,
        Value: null
      };
    case B.TEXT:
      return {
        Op: hn.CONTAINING,
        Text: null
      };
    case B.DROPDOWN:
      return null;
    case B.VOCABULARY:
      return [];
    default:
      return {};
  }
}, Mh = (e) => {
  const [t, n] = xr(
    Lh,
    kh
  ), r = ie(
    (l) => {
      const c = mr[l.value], u = {
        id: l.value,
        name: l.name,
        value: Zc(c.type, c.defaultOp),
        permamentSecondValue: c.permamentSecondValue
      };
      n({
        type: mn.ADD_ATTRIBUTE,
        payload: u
      });
    },
    []
  ), i = ie(
    (l, c) => {
      n({
        type: mn.UPDATE_ATTRIBUTE,
        payload: {
          id: l,
          values: c
        }
      });
    },
    []
  ), o = ie((l) => {
    n({
      type: mn.REMOVE_ATTRIBUTE,
      payload: l
    });
  }, []), s = ie(() => {
    n({
      type: mn.INIT,
      payload: e
    });
  }, []);
  return q(() => {
    e && s();
  }, []), {
    ...t,
    addAttribute: r,
    removeAttribute: o,
    updateAttribute: i
  };
};
var Mt = /* @__PURE__ */ ((e) => (e.GET_COHORTS = "GET_COHORTS", e.SET_COHORTS = "SET_COHORTS", e.REMOVE_COHORT = "REMOVE_COHORT", e.CREATE_COHORT_REQUEST = "CREATE_COHORTS_REQUEST", e.CREATE_COHORT_REQUEST_DONE = "CREATE_COHORTS_REQUEST_DONE", e.CLEAR = "CLEAR", e))(Mt || {});
const Vh = {
  isCreated: !1,
  isUpdate: !1,
  isLoading: !1,
  cohorts: {},
  cohort: null
}, Uh = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case Mt.GET_COHORTS:
      n.cohorts = t.payload;
      break;
    case Mt.CREATE_COHORT_REQUEST:
      n.isCreated = !1, n.isUpdate = !1, n.isLoading = !0;
      break;
    case Mt.CREATE_COHORT_REQUEST_DONE:
      n.isCreated = !0, n.isLoading = !1, n.cohort = t.payload;
      break;
    case Mt.CLEAR:
      n.cohorts = {};
      break;
    case Mt.SET_COHORTS:
      t.payload.multi ? n.cohorts = {
        ...n.cohorts,
        ...t.payload.newItems
      } : n.cohorts = t.payload.newItems;
      break;
    case Mt.REMOVE_COHORT:
      delete n.cohorts[t.payload];
      break;
  }
}), Fs = (e, t = Fe.CREATE_NEW_OBJECT) => `${e}?resolution=${encodeURIComponent(t)}`, Do = {}, Fh = (e) => e.includes("/copy/") ? "copy" : e.includes("/import") ? "import" : "default", Bh = (e) => {
  switch (e) {
    case Fe.COPY:
      return Array.from(/* @__PURE__ */ new Set([e, "COPY"]));
    case Fe.CREATE_NEW_VERSION:
      return Array.from(
        /* @__PURE__ */ new Set([
          "NEW_VERSION",
          e,
          "CREATE_NEW_VERSION",
          "create_new_version",
          "create-new-version"
        ])
      );
    case Fe.CREATE_NEW_OBJECT:
    default:
      return Array.from(
        /* @__PURE__ */ new Set([
          "NEW_OBJECT",
          e,
          "CREATE_NEW_OBJECT",
          "CREATE_NEW",
          "create_new",
          "create-new"
        ])
      );
  }
}, pi = (e, t, n = Fe.CREATE_NEW_OBJECT) => {
  const r = Fh(e), i = Do[r];
  if (i === null)
    return Ie.post(e, t);
  if (typeof i == "string")
    return Ie.post(Fs(e, i), t).catch((l) => {
      var c;
      if (((c = l == null ? void 0 : l.response) == null ? void 0 : c.status) === 400)
        return delete Do[r], pi(e, t, n);
      throw l;
    });
  const o = [
    ...Bh(n),
    void 0
  ], s = (l) => {
    const c = o[l], u = c ? Fs(e, c) : e;
    return Ie.post(u, t).then((p) => (Do[r] = c ?? null, p)).catch((p) => {
      var d;
      if (((d = p == null ? void 0 : p.response) == null ? void 0 : d.status) === 400 && l < o.length - 1)
        return s(l + 1);
      throw p;
    });
  };
  return s(0);
}, so = (e, t) => {
  const n = encodeURIComponent(e), r = t ? `&entityId=${encodeURIComponent(t)}` : "";
  return `name=${n}${r}`;
}, eu = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: r, query: i } = e, o = di(r), s = `/cohortdefinition/list?size=${n || ""}&page=${t || ""}&sort=${o}&${i || ""}`;
  return Ie.get(s);
}, tu = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: r, query: i } = e, o = di(r), s = `/workspace/cohorts/list?size=${n || ""}&page=${t || 0}&sort=${o}&${i || ""}`;
  return Ie.get(s);
}, $h = () => Ie.get("/cohortdefinition/sorts"), Gh = () => Ie.get("/workspace/cohorts/sorts"), nu = (e, t) => {
  if (!e)
    throw new Error("Study must be selected in order to get study cohorts");
  const { pageNumber: n, pageSize: r, sortBy: i, query: o } = t, s = di(i), l = `/studies/${e}/cohorts/list?size=${r || ""}&page=${n || 0}&sort=${s}&${o || ""}`;
  return Ie.get(l);
}, zh = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: r, query: i } = e, o = di(r), s = `/library/cohorts/list?size=${n || ""}&page=${t || 0}&sort=${o}&${i || ""}`;
  return Ie.get(s);
}, Wh = (e) => {
  const t = `/cohortdefinition/filter?${e}`;
  return Ie.get(t);
}, Yh = (e) => {
  const t = `/workspace/cohorts/filter?${e}`;
  return Ie.get(t);
}, Hh = (e, t) => {
  const n = `/studies/${t}/cohorts/filter?${e}`;
  return Ie.get(n);
}, qh = (e) => {
  const t = `/library/cohorts/filter?${e}`;
  return Ie.get(t);
}, Hi = (e) => Ie.get(`/cohortdefinition/${e}?timestanp=${(/* @__PURE__ */ new Date()).toISOString()}`), ru = (e) => Ie.delete(`/cohortdefinition/${e}`), lo = (e, t) => Ie.put(`/cohortdefinition/${e}`, t), Xh = (e) => Ie.post("/cohortdefinition", e), co = (e) => Ie.post("/workspace/cohorts", e), iu = (e, t, n = Fe.COPY) => pi(
  `/workspace/cohorts/copy/${e}`,
  t ? { name: t } : {},
  n
), va = (e, t) => Ie.post(`/studies/${e}/cohorts`, t), Jh = (e, t) => {
  const { pageNumber: n, pageSize: r, sortBy: i, query: o } = t, s = di(i), l = `/cohortdefinition/${e}/usage/list?size=${r || ""}&page=${n || 0}&sort=${s}&${o || ""}`;
  return Ie.get(l);
}, Qh = (e, t) => {
  const n = `/cohortdefinition/${t}/usage/filter?${e}`;
  return Ie.get(n);
}, ou = (e, t, n, r = Fe.COPY) => pi(
  `/studies/${e}/cohorts/copy/${t}`,
  n ? { name: n } : {},
  r
), Kh = (e, t = Fe.CREATE_NEW_OBJECT) => pi("/workspace/cohorts/import", e, t), Zh = (e, t, n = Fe.CREATE_NEW_OBJECT) => pi(
  `/studies/${e}/cohorts/import`,
  t,
  n
), ef = (e, t) => Ie.get(
  `/workspace/cohorts/check-name?${so(e, t)}`
), tf = (e, t, n) => Ie.get(
  `/studies/${e}/cohorts/check-name?${so(
    t,
    n
  )}`
), nf = (e, t) => Ie.get(
  `/workspace/concept-sets/check-name?${so(e, t)}`
), rf = (e, t, n) => Ie.get(
  `/studies/${e}/concept-sets/check-name?${so(
    t,
    n
  )}`
), au = (e, t, n, r) => {
  switch (e) {
    case Ee.STUDY:
      if (!n)
        throw new Error("Study parentId is required for name check.");
      return tf(n, t, r);
    case Ee.WORKSPACE:
    default:
      return ef(t, r);
  }
}, of = (e, t, n, r) => {
  switch (e) {
    case Ee.STUDY:
      if (!n)
        throw new Error("Study parentId is required for name check.");
      return rf(n, t, r);
    case Ee.WORKSPACE:
    default:
      return nf(t, r);
  }
}, af = (e, t) => t !== "new" ? lo(t, e) : co(e), sf = (e, t, n) => t !== "new" ? lo(t, e) : va(n, e), lf = (e) => Ie.get(`/cohortdefinition/${e}/versions?size=10000`), su = (e) => Ie.get(`/cohortdefinition/version/${e}`), lu = (e) => Ie.get(`/conceptset/version/${e}`), cf = (e) => Ie.post("/cohortdefinition/validation", e), uf = (e) => Ie.post("/library/cohort/invites", e), qi = (e, t) => {
  let n = "";
  e && t && (n += `?size=1000000&page=0&${e}=${t}`);
  const r = `/cohortdefinition/metadata-value/list${n}`;
  return Ie.get(r);
}, ea = (e) => Ie.post("/cohortdefinition/metadata-value", e), ta = (e, t) => {
  const n = `/cohortdefinition/metadata-value/${t}`;
  return Ie.put(n, e);
}, Bs = (e) => {
  const t = `/cohortdefinition/metadata-value/${e}`;
  return Ie.delete(t);
}, $s = (e, t) => {
  const n = `/cohortdefinition/metadata-value/${e}/copy`;
  return Ie.post(n, t);
}, df = (e, t, n, r) => Ie.post(`/atlas/${e}/assets/${t}/export?id=${n}&name=${r}`, {}), pf = (e) => Ie.get(`/cohortdefinition/${e}/summary`), hf = (e, t) => Ie.patch(`/cohortdefinition/${e}`, t), ff = (e = "", t) => {
  {
    const n = e.replace(/^&/, ""), r = `/admin/metadata-attribute/list${n ? `?${n}` : ""}`;
    return Ie.get(r);
  }
}, mf = (e) => th.get(
  `https://clinicaltrials.gov/api/v2/studies/${e}`,
  {
    headers: {
      accept: "text/csv"
    }
  }
), Xi = (e) => typeof e == "object" && e !== null, Ef = (e) => {
  if (typeof e == "string" && e.trim())
    return e;
  if (typeof e == "number")
    return String(e);
}, Gs = (e, t) => {
  for (const n of t) {
    const r = Ef(e[n]);
    if (r)
      return r;
  }
}, xf = (e) => {
  if (!Xi(e) || !Xi(e.response))
    return !1;
  const t = e.response.status;
  return t === 400 || t === 404 || t === 405;
}, Cf = (e) => {
  if (typeof e == "string")
    return e;
  if (!Xi(e))
    return null;
  const t = Gs(e, [
    "sql",
    "templateSql",
    "renderedSql",
    "value",
    "content"
  ]);
  return t || Xi(e.result) && Gs(e.result, [
    "sql",
    "templateSql",
    "renderedSql",
    "value"
  ]) || null;
}, gf = async (e, t, n = !1) => {
  const r = t.flatMap((s) => [
    `/cohortdefinition/${e}/export/sql?dialect=${encodeURIComponent(
      s
    )}`,
    `/cohortdefinition/${e}/export/sql/${encodeURIComponent(s)}`,
    `/cohortdefinition/${e}/sql?dialect=${encodeURIComponent(s)}`,
    `/cohortdefinition/${e}/sql/${encodeURIComponent(s)}`
  ]), i = n ? [`/cohortdefinition/${e}/export/sql`, ...r] : [...r, `/cohortdefinition/${e}/export/sql`];
  let o = null;
  for (const s of new Set(i))
    try {
      const l = await Ie.get(s), c = Cf(l);
      if (c)
        return c;
    } catch (l) {
      if (o = l, !xf(l))
        throw l;
    }
  throw o || new Error("SQL export is unavailable for selected dialect");
}, yf = (e) => Ie.get(`/cohortdefinition/${e}/derived-stats`), Tf = (e, t) => {
  switch (e) {
    case Ee.WORKSPACE:
      return {
        fetch: (n) => tu(n),
        create: (n) => co(n)
      };
    case Ee.STUDY:
      return {
        fetch: (n) => nu(t, n),
        create: (n) => va(t, n)
      };
    default:
      return {
        fetch: (n) => eu(n),
        create: (n) => Xh(n)
      };
  }
}, Sf = (e, t, n) => {
  const [r, i] = xr(
    Uh,
    Vh
  ), { fetch: o, create: s } = Tf(e, t), l = async (h, g, C) => {
    i({
      type: Mt.CREATE_COHORT_REQUEST
    });
    try {
      const y = await s({
        name: h,
        description: g,
        expression: C
      });
      i({
        type: Mt.CREATE_COHORT_REQUEST_DONE,
        payload: y
      });
    } catch {
    }
  }, c = async () => {
    try {
      const h = await o({
        pageNumber: 0,
        pageSize: 1e5
      });
    } catch {
    }
  }, u = ie(
    async (h) => {
      try {
        const g = h.map(
          (I) => su(I.versionId).then((O) => ({
            ...O,
            data: {
              ...O.data,
              currentVersionId: I.currentVersionId
            }
          }))
        ), C = await Promise.all(g), y = {};
        return C.forEach((I) => {
          y[I.data.versionId] = {
            value: I.data.id,
            name: I.data.name,
            versionId: I.data.versionId,
            currentVersionId: I.data.currentVersionId
          };
        }), i({
          type: Mt.GET_COHORTS,
          payload: y
        }), y;
      } catch {
      }
    },
    [r.cohorts]
  ), p = ie((h, g) => {
    const C = {};
    h.forEach((y) => {
      C[y.versionId] = {
        value: y.id,
        name: y.name,
        versionId: y.versionId
      };
    }), i({
      type: Mt.SET_COHORTS,
      payload: {
        newItems: C,
        multi: g
      }
    });
  }, []), d = ie(async (h) => {
    i({
      type: Mt.REMOVE_COHORT,
      payload: h
    });
  }, []), f = ie(() => {
    i({
      type: Mt.CLEAR
    });
  }, []);
  return {
    ...r,
    getExistCohort: c,
    createCohortExpression: l,
    getExistCohortsById: u,
    clearCohortData: f,
    setCohortByImport: p,
    removeCohort: d
  };
};
var Tt = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_CRITERIA = "ADD_CRITERIA", e.UPDATE_CRITERIA_ATTRIBUTES = "UPDATE_CRITERIA_ATTRIBUTES", e.UPDATE_CRITERIA_CODESETID = "UPDATE_CRITERIA_CODESETID", e.UPDATE_CRITERIA_EXTEND_OPTIONS = "UPDATE_CRITERIA_EXTEND_OPTIONS", e.UPDATE_CRITERIA_GROUP = "UPDATE_CRITERIA_EXTEND_GROUP", e.REMOVE_CRITERIA = "REMOVE_CRITERIA", e))(Tt || {});
const If = {
  criteries: {},
  isStartHook: !1,
  isLoading: !1
}, Af = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case Tt.INIT:
      n.isStartHook = !0, n.criteries = t.payload;
      break;
    case Tt.ADD_CRITERIA:
      n.criteries[t.payload.id] = t.payload;
      break;
    case Tt.UPDATE_CRITERIA_ATTRIBUTES:
      n.criteries[t.payload.id].attributes = t.payload.values;
      break;
    case Tt.UPDATE_CRITERIA_CODESETID:
      n.criteries[t.payload.id].codesetId = t.payload.value;
      break;
    case Tt.UPDATE_CRITERIA_EXTEND_OPTIONS:
      n.criteries[t.payload.id].extendOptions = t.payload.value;
      break;
    case Tt.UPDATE_CRITERIA_GROUP:
      n.criteries[t.payload.id].group = t.payload.value;
      break;
    case Tt.REMOVE_CRITERIA:
      delete n.criteries[t.payload];
      break;
  }
}), bf = (e, t = {}) => {
  var r;
  if (!t.extend || !((r = ao[e]) != null && r.extend))
    return;
  const n = {
    StartWindow: {
      Start: { ...ar.Start },
      End: { ...ar.End },
      UseIndexEnd: ar.UseIndexEnd,
      UseEventEnd: ar.UseEventEnd
    }
  };
  return t.hideOccurrence || (n.Occurrence = { ...qc }), Kc(e) && Qc(e) && (n.IgnoreObservationPeriod = !0), Jc(e) && Xc(), n;
}, Rf = (e, t = {}) => {
  const [n, r] = xr(
    Af,
    If
  ), i = ie(
    (d) => {
      const f = {
        id: Dn(),
        name: d.id,
        codesetId: void 0,
        attributes: d.predefinedAttribute ? d.predefinedAttribute : {},
        extendOptions: bf(d.id, t),
        group: void 0
      };
      r({
        type: Tt.ADD_CRITERIA,
        payload: f
      });
    },
    [t.extend, t.hideOccurrence]
  ), o = ie(
    (d, f) => {
      r({
        type: Tt.UPDATE_CRITERIA_ATTRIBUTES,
        payload: {
          id: d,
          values: f
        }
      });
    },
    []
  ), s = ie((d, f) => {
    r({
      type: Tt.UPDATE_CRITERIA_CODESETID,
      payload: {
        id: d,
        value: f
      }
    });
  }, []), l = ie(
    (d, f) => {
      r({
        type: Tt.UPDATE_CRITERIA_EXTEND_OPTIONS,
        payload: {
          id: f,
          value: d
        }
      });
    },
    []
  ), c = ie(
    (d, f) => {
      r({
        type: Tt.UPDATE_CRITERIA_GROUP,
        payload: {
          id: d,
          value: f
        }
      });
    },
    []
  ), u = ie((d) => {
    r({
      type: Tt.REMOVE_CRITERIA,
      payload: d
    });
  }, []), p = ie((d) => {
    r({
      type: Tt.INIT,
      payload: d ?? e
    });
  }, []);
  return q(() => {
    e && p();
  }, []), {
    ...n,
    init: p,
    addCriteria: i,
    updateCriteriaAttributes: o,
    updateCriteriaCodeSetId: s,
    removeCriteria: u,
    updateExtendOptionsCriteria: l,
    updateGroupCriteria: c
  };
}, Mr = "Criteria", vo = "CorrelatedCriteria", Of = /* @__PURE__ */ new Set([
  Mr,
  "Occurrence",
  "StartWindow",
  "EndWindow",
  "IgnoreObservationPeriod",
  "RestrictVisit"
]), St = (e) => typeof e == "object" && e !== null && !Array.isArray(e), kn = (e) => e === void 0 ? e : JSON.parse(JSON.stringify(e)), zs = (e, t) => t && St(e[t]) ? t : Object.keys(e).find(
  (n) => !Of.has(n) && St(e[n])
), cu = (e, t) => {
  let n = !1;
  return Array.isArray(t.CriteriaList) && t.CriteriaList.length > 0 && (!Array.isArray(e.CriteriaList) || e.CriteriaList.length === 0 ? (e.CriteriaList = kn(t.CriteriaList), n = !0) : t.CriteriaList.forEach((r, i) => {
    const o = e.CriteriaList[i];
    St(o) && St(r) ? n = _a(
      o,
      r
    ) || n : o === void 0 && (e.CriteriaList[i] = kn(r), n = !0);
  })), Array.isArray(t.DemographicCriteriaList) && t.DemographicCriteriaList.length > 0 && (!Array.isArray(e.DemographicCriteriaList) || e.DemographicCriteriaList.length === 0) && (e.DemographicCriteriaList = kn(
    t.DemographicCriteriaList
  ), n = !0), Array.isArray(t.Groups) && t.Groups.length > 0 && (!Array.isArray(e.Groups) || e.Groups.length === 0 ? (e.Groups = kn(t.Groups), n = !0) : t.Groups.forEach((r, i) => {
    const o = e.Groups[i];
    St(o) && St(r) ? n = cu(o, r) || n : o === void 0 && (e.Groups[i] = kn(r), n = !0);
  })), n;
}, _a = (e, t) => {
  if (St(e[Mr]) && St(t[Mr]))
    return _a(
      e[Mr],
      t[Mr]
    );
  const n = zs(e), r = zs(t, n);
  if (!n || !r)
    return !1;
  const i = e[n], o = t[r];
  if (!St(i) || !St(o))
    return !1;
  const s = o[vo];
  if (!St(s))
    return !1;
  const l = i[vo];
  return St(l) ? cu(
    l,
    s
  ) : (i[vo] = kn(s), !0);
}, Df = (e, t) => {
  var c, u;
  const n = e == null ? void 0 : e.expression, r = (c = t == null ? void 0 : t.PrimaryCriteria) == null ? void 0 : c.CriteriaList, i = (u = n == null ? void 0 : n.PrimaryCriteria) == null ? void 0 : u.CriteriaList;
  if (!St(n) || !Array.isArray(r) || !Array.isArray(i))
    return { cohort: e, changed: !1 };
  const o = kn(e), s = o.expression.PrimaryCriteria.CriteriaList;
  let l = !1;
  return r.forEach((p, d) => {
    const f = s[d];
    St(f) && St(p) && (l = _a(f, p) || l);
  }), l ? { cohort: o, changed: l } : { cohort: e, changed: !1 };
}, vf = "atlas", _f = "Error! Name is already used by another object.", Nf = "Unable to validate name uniqueness. Please try again.", Ur = (e) => typeof e == "object" && e !== null, wf = (e) => {
  if (Ur(e))
    return typeof e.message == "string" ? e.message : void 0;
}, Pf = (e) => {
  if (!(!Ur(e) || !Ur(e.response) || !Ur(e.response.data)))
    return typeof e.response.data.message == "string" ? e.response.data.message : void 0;
}, jf = (e) => typeof e == "boolean" ? e : Ur(e) ? typeof e.available == "boolean" ? e.available : typeof e.isAvailable == "boolean" ? e.isAvailable : typeof e.success == "boolean" ? e.success : typeof e.result == "boolean" ? e.result : typeof e.unique == "boolean" ? e.unique : typeof e.isUnique == "boolean" ? e.isUnique : typeof e.valid == "boolean" ? e.valid : typeof e.isValid == "boolean" ? e.isValid : typeof e.exists == "boolean" ? !e.exists : typeof e.duplicate == "boolean" ? !e.duplicate : typeof e.conflict == "boolean" ? !e.conflict : typeof e.used == "boolean" ? !e.used : !0 : !0, uu = Ze(
  (e) => {
    const {
      onChange: t,
      typeContainer: n,
      parentId: r,
      importMethod: i,
      resolution: o = Fe.CREATE_NEW_OBJECT,
      onResolutionChange: s
    } = e, { enqueueSnackbar: l } = Xn(), c = Z(() => Oh, []), [u, p] = K(!1), [d, f] = K(""), [h, g] = K(""), C = Te(o), y = !!s, I = s || ((V) => {
    }), O = "Fully identical cohort(s) will not be created, instead existing ones will be reused. Cohort(s) with the same name, but different content will create a new version of the existing ones.", S = "New cohort(s) will be created, even if identical cohort(s) exist.", N = o === Fe.CREATE_NEW_OBJECT, { cohort: _, createCohortExpression: R, isLoading: P } = Sf(
      n,
      r
    );
    q(() => {
      _ && _.id && t(_);
    }, [_, t]);
    const U = ie(() => {
      f("");
    }, []);
    q(() => {
      C.current = o, N || U();
    }, [N, U]);
    const M = ie(
      (V) => {
        C.current = V, V !== Fe.CREATE_NEW_OBJECT && U(), I(V);
      },
      [I, U]
    ), w = ie(
      async (V) => {
        p(!0);
        const { expression: L, name: te, description: $ } = V, v = (te == null ? void 0 : te.trim()) || "", J = V.format ?? vf, j = C.current, ee = j === Fe.CREATE_NEW_OBJECT;
        let Q;
        try {
          Q = JSON.parse(L);
        } catch {
          p(!1), l("Cohort Definition is not valid JSON!", {
            variant: "error"
          });
          return;
        }
        const x = "expression" in Q ? Q.expression : Q;
        let Y = x;
        if (J === "atlas") {
          if (!Array.isArray(x.ConceptSets)) {
            p(!1), l("Atlas cohort definition is not valid!", {
              variant: "error"
            });
            return;
          }
          const k = x.ConceptSets.map((b) => {
            const me = b.expression.items.map((ae) => {
              const le = { ...ae };
              return "isExcluded" in le && le.isExcluded && (le.excluded = le.isExcluded, delete le.isExcluded), le.concept.STANDARD_CONCEPT === up.NON_STANDARD && (le.hierarchy = le.includeDescendants, delete le.includeMapped, delete le.includeDescendants), le;
            });
            return {
              ...b,
              expression: {
                items: me
              }
            };
          }), T = /* @__PURE__ */ new Map();
          for (const b of k) {
            const z = b.id, me = b.name, ae = T.get(z) ?? [];
            ae.push(me), T.set(z, ae);
          }
          const re = Array.from(T.entries()).filter(([b, z]) => z.length > 1).map(([b, z]) => ({ id: b, names: z }));
          if (re.length > 0) {
            const b = re.map((z) => `ID ${z.id}: ${z.names.join(", ")}`).join(`
`);
            p(!1), l(
              `Duplicate ConceptSet IDs found:
${b}
Please use unique IDs.`,
              {
                variant: "error"
              }
            );
            return;
          }
          Y = {
            ...x,
            ConceptSets: k
          };
        }
        if (ee)
          try {
            const k = await au(
              n,
              v,
              r
            );
            if (!jf(k)) {
              f(
                wf(k) || _f
              ), p(!1);
              return;
            }
            U();
          } catch (k) {
            f(
              Pf(k) || Nf
            ), p(!1);
            return;
          }
        try {
          if (i) {
            const k = await i(
              {
                name: v,
                description: $,
                expression: Y,
                format: J
              },
              j
            ), { cohort: T, changed: re } = Df(k, Y);
            let b = T;
            if (re && T.id)
              try {
                b = await lo(
                  String(T.id),
                  T
                );
              } catch {
                l(
                  "Cohort imported, but nested criteria could not be restored.",
                  {
                    variant: "error"
                  }
                );
              }
            p(!1), t(b);
          } else
            await R(v, $, Y), p(!1);
        } catch {
          p(!1), l("Cohort is not valid!", {
            variant: "error"
          });
          return;
        }
      },
      [
        R,
        l,
        i,
        t,
        r,
        U,
        n
      ]
    );
    return /* @__PURE__ */ a.jsx(A, { container: !0, children: /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      Cp,
      {
        onSubmit: w,
        codeKey: "expression",
        nameKey: "name",
        editorTitle: "Cohort Definition",
        fields: c,
        isLoading: P || u,
        fileExtension: Xr.JSON,
        submitButtonText: "Import",
        isSubmitDisabled: N && !!d && h.trim().length > 0,
        onFieldValueChange: (V, L) => {
          V === "name" && (g(L), U());
        },
        fieldErrors: {
          name: d
        },
        footerStart: y ? /* @__PURE__ */ a.jsxs(
          W,
          {
            display: "flex",
            alignItems: "center",
            columnGap: 1.5,
            flexWrap: "nowrap",
            sx: { maxWidth: "100%", overflowX: "auto", py: 0.5 },
            children: [
              /* @__PURE__ */ a.jsx(fe, { variant: "caption", sx: { whiteSpace: "nowrap" }, children: "Select conflict resolution method:" }),
              /* @__PURE__ */ a.jsxs(
                W,
                {
                  display: "flex",
                  alignItems: "center",
                  columnGap: 1.5,
                  sx: { whiteSpace: "nowrap" },
                  children: [
                    /* @__PURE__ */ a.jsxs(W, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
                      /* @__PURE__ */ a.jsx(
                        Bi,
                        {
                          checked: o === Fe.CREATE_NEW_VERSION,
                          onChange: () => M(
                            Fe.CREATE_NEW_VERSION
                          ),
                          name: "import-resolution-manual",
                          size: "small",
                          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
                        }
                      ),
                      /* @__PURE__ */ a.jsx(fe, { variant: "caption", children: "Overwrite existing cohorts" }),
                      /* @__PURE__ */ a.jsx(We, { text: O, children: /* @__PURE__ */ a.jsx(
                        ge,
                        {
                          iconName: "info",
                          sx: { fontSize: 12, color: "text.secondary" }
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ a.jsxs(W, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
                      /* @__PURE__ */ a.jsx(
                        Bi,
                        {
                          checked: o === Fe.CREATE_NEW_OBJECT,
                          onChange: () => M(
                            Fe.CREATE_NEW_OBJECT
                          ),
                          name: "import-resolution-manual",
                          size: "small",
                          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
                        }
                      ),
                      /* @__PURE__ */ a.jsx(fe, { variant: "caption", children: "Create new cohorts" }),
                      /* @__PURE__ */ a.jsx(We, { text: S, children: /* @__PURE__ */ a.jsx(
                        ge,
                        {
                          iconName: "info",
                          sx: { fontSize: 12, color: "text.secondary" }
                        }
                      ) })
                    ] })
                  ]
                }
              )
            ]
          }
        ) : null
      }
    ) }) });
  }
), Ji = (e, t) => rh(
  e,
  t,
  eu,
  ru,
  nu,
  tu,
  zh
), na = (e, t) => nh(
  e,
  t,
  Wh,
  Hh,
  Yh,
  qh
), du = (e) => oh(e, {
  getSorting: $h,
  getSortingWorkspace: Gh
}), Kr = (e, t) => {
  switch (e) {
    case Ee.WORKSPACE:
      return (n, r) => co(n);
    case Ee.STUDY:
      return (n, r) => va(t, n);
  }
}, pu = (e, t) => {
  switch (e) {
    case Ee.WORKSPACE:
      return (n, r = Fe.CREATE_NEW_OBJECT) => Kh(n, r);
    case Ee.STUDY:
      return (n, r = Fe.CREATE_NEW_OBJECT) => Zh(t, n, r);
  }
}, Lf = (e, t, n, r) => {
  const i = n === Ee.WORKSPACE ? "/workspace" : `/study-manager/${r}`, o = (() => {
    switch (t) {
      case "ANALYSIS":
        return "analyses";
      case "COHORT":
        return "cohorts";
      case "CONCEPT_SET":
        return "concept-sets";
    }
  })();
  return `${i}/${o}/${e}`;
}, Na = [
  gp({
    id: "typeIcon",
    cell: Ap,
    accessorFn: (e) => e.type || Dc.COHORT
  }),
  yp(),
  vc({
    size: 350
  }),
  Tp(),
  Sp(),
  Ip()
], kf = ({ metaAttributes: e }) => [
  ...Na,
  ...ih(e, !0)
], Mf = [
  {
    header: "",
    accessorKey: "type",
    id: "type",
    cell: Fp,
    size: 40,
    enableResizing: !1,
    meta: {
      columnType: "action"
    }
  },
  vc()
], Vf = (e, t) => ({
  get: (n) => Hi(n),
  delete: (n) => ru(n),
  update: (n, r) => {
    switch (e) {
      case Ee.STUDY:
        return sf(n, r, t);
      case Ee.WORKSPACE:
        return af(n, r);
      case Ee.LIBRARY:
        return hf(r, {
          name: n.name,
          description: n.description
        });
    }
  },
  copy: (n, r, i = Fe.COPY) => {
    switch (e) {
      case Ee.STUDY:
        return ou(t, n, r, i);
      case Ee.WORKSPACE:
        return iu(n, r, i);
    }
  }
}), Uf = (e, t, n) => ah(
  "New Cohort Definition",
  e,
  t,
  n
), Ff = (e, t, n = {}, r, i, o, s, l) => {
  const c = s === Ee.LIBRARY;
  let u = [
    {
      id: "definition",
      title: "Definition",
      value: "",
      end: !0
    },
    {
      id: "conceptSets",
      title: /* @__PURE__ */ a.jsx(
        en,
        {
          title: "Concept Sets",
          count: r.conceptSets || 0,
          status: ue.SUCCESS,
          dense: !0
        }
      ),
      value: "concept-sets"
    }
  ];
  return t !== "new" && (i ? (u = [
    ...u,
    {
      id: "versioning",
      align: "right",
      iconOnly: !0,
      iconName: "reload",
      title: /* @__PURE__ */ a.jsx(
        en,
        {
          title: "Versions",
          count: r.versions || 0,
          status: ue.SUCCESS,
          dense: !0
        }
      ),
      value: "versions"
    },
    {
      id: "meta-attributes",
      align: "right",
      iconOnly: !0,
      iconName: "bookmark",
      title: /* @__PURE__ */ a.jsx(
        en,
        {
          title: "Metadata",
          count: r.metadata || 0,
          status: ue.SUCCESS,
          dense: !0
        }
      ),
      value: "meta-attributes"
    }
  ], l && u.push({
    id: "ai-meta-attributes",
    align: "right",
    iconOnly: !0,
    iconName: "stars",
    title: /* @__PURE__ */ a.jsx(
      en,
      {
        title: "Generative AI",
        count: r["metadata-ai"] || 0,
        status: ue.SUCCESS,
        dense: !0
      }
    ),
    value: "ai-meta-attributes"
  }), c ? u.push({
    id: "statistics",
    align: "right",
    iconOnly: !0,
    iconName: "chart",
    title: /* @__PURE__ */ a.jsx(
      en,
      {
        title: "Utilization Statistics",
        count: r.usedIn || 0,
        status: ue.SUCCESS,
        dense: !0
      }
    ),
    value: "statistics"
  }) : r.usedIn > 0 && u.push({
    id: "usage",
    align: "right",
    iconOnly: !0,
    iconName: "users",
    title: /* @__PURE__ */ a.jsx(
      en,
      {
        title: "Used In",
        count: r.usedIn || 0,
        status: ue.SUCCESS,
        dense: !0
      }
    ),
    value: "usage"
  })) : (u = [
    ...u,
    {
      id: "versioning",
      align: "right",
      iconOnly: !0,
      iconName: "reload",
      title: /* @__PURE__ */ a.jsx(
        en,
        {
          title: "Versions",
          count: r.versions || 0,
          status: ue.SUCCESS,
          dense: !0
        }
      ),
      value: "versions"
    },
    {
      id: "messages",
      align: "right",
      iconOnly: !0,
      iconName: "message",
      title: /* @__PURE__ */ a.jsx(bp, { ...n.messages }),
      value: "messages"
    },
    {
      id: "meta-attributes",
      align: "right",
      iconOnly: !0,
      iconName: "bookmark",
      title: /* @__PURE__ */ a.jsx(
        en,
        {
          title: "Metadata",
          count: r.metadata || 0,
          status: ue.SUCCESS,
          dense: !0
        }
      ),
      value: "meta-attributes"
    }
  ], l && u.push({
    id: "ai-meta-attributes",
    align: "right",
    iconOnly: !0,
    iconName: "stars",
    title: /* @__PURE__ */ a.jsx(
      en,
      {
        title: "Generative AI",
        count: r["metadata-ai"] || 0,
        status: ue.SUCCESS,
        dense: !0
      }
    ),
    value: "ai-meta-attributes"
  }), r.usedIn > 0 && u.push({
    id: "usage",
    align: "right",
    iconOnly: !0,
    iconName: "users",
    title: /* @__PURE__ */ a.jsx(
      en,
      {
        title: "Used In",
        count: r.usedIn || 0,
        status: ue.SUCCESS,
        dense: !0
      }
    ),
    value: "usage"
  }))), u;
}, Bf = {
  getList: lf,
  getCurrent: su
}, $f = (e) => {
  var J, j, ee;
  const {
    returnEntityText: t,
    typeContainer: n,
    parentId: r,
    path: i,
    onChange: o,
    initialData: s,
    multiple: l = !1,
    //isSelect,
    subModules: c,
    withAlias: u,
    containerProps: {
      titleText: p,
      buttonText: d,
      viewMode: f,
      collapsible: h = !1,
      description: g = "",
      defaultState: C = !1,
      classNameContainer: y = "cohort-import-button"
    }
  } = e, I = yr(), { createCols: O } = Rh, { openModal: S, closeModal: N } = je(En), _ = Z(() => pu(n, r), [n, r]), {
    state: R,
    updateList: P,
    refreshVersion: U,
    removeItem: M,
    updateItem: w
  } = ep(s, l, o, u, "versionId", Hi), V = (Q) => {
    switch (n) {
      case Ee.WORKSPACE:
        return `/workspace/cohorts/${Q}?returnPath=${i}&returnEntityText=${t}`;
      case Ee.STUDY:
        return `/study-manager/${r}/cohorts/${Q}?returnPath=${i}&returnEntityText=${t}`;
      case Ee.LIBRARY:
        return `/library/cohorts/${Q}?returnPath=${i}&returnEntityText=${t}`;
    }
  }, L = Z(() => O(
    {
      onEdit: (Q) => {
        I(V(Q));
      },
      onRefresh: U,
      onRemove: M,
      onUpdate: w
    },
    f,
    u,
    Object.values(R).map((Q) => Q.alias || null)
  ), [R, f, u]), te = (Q) => {
    P(Q, N);
  }, $ = (Q) => {
    Q.stopPropagation(), S(
      () => /* @__PURE__ */ a.jsx(
        _c,
        {
          name: "cohorts",
          currentContainer: n,
          parentId: r,
          defaultResolution: Fe.CREATE_NEW_OBJECT,
          hideConflictResolutionMethod: !0,
          hideConflictResolutionControls: !0,
          onChange: te,
          createListMethods: Ji,
          cols: Na,
          createListFiltersMethod: na,
          createMethodCreate: Kr,
          subModules: c,
          analysisMode: !0,
          isSelect: l,
          successMessage: "Cohort(s) successfully imported.",
          atlasEntity: [Ra.COHORT],
          getEntity: Hi,
          manualImport: !0,
          manualImportComponent: /* @__PURE__ */ a.jsx(
            uu,
            {
              typeContainer: n,
              parentId: r,
              importMethod: _,
              fullEntity: !0,
              onChange: te
            }
          )
        }
      ),
      "Import cohort",
      {
        onClose: N,
        closeOnClickOutside: !0
      }
    );
  }, v = sh(Object.values(R), "id");
  return ((J = Object.keys(R)) == null ? void 0 : J.length) === 0 && f ? /* @__PURE__ */ a.jsx(a.Fragment, {}) : /* @__PURE__ */ a.jsxs(
    nr,
    {
      collapsible: h,
      title: p,
      defaultState: h ? C : !0,
      actions: f ? /* @__PURE__ */ a.jsx(a.Fragment, {}) : /* @__PURE__ */ a.jsx(
        Be,
        {
          onClick: $,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          name: `button-${y}`,
          sx: { px: 3 },
          children: d
        }
      ),
      outlined: !0,
      elevated: !0,
      children: [
        /* @__PURE__ */ a.jsx(
          A,
          {
            item: !0,
            xs: 12,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            children: g && /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", children: g })
          }
        ),
        Object.keys(R).length > 0 ? /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(A, { container: !0, children: /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, className: `table-${y}`, children: /* @__PURE__ */ a.jsx(
          Bp,
          {
            columns: L,
            data: v,
            totalElements: (j = Object.keys(R)) == null ? void 0 : j.length,
            pageSize: (ee = Object.keys(R)) == null ? void 0 : ee.length,
            loadingMessage: "",
            enableSorting: l,
            tileView: !0
          }
        ) }) }) }) : /* @__PURE__ */ a.jsx(
          A,
          {
            item: !0,
            xs: 12,
            sx: {
              backgroundColor: "backgroundColor.main",
              textAlign: "center",
              p: 1
            },
            children: /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", color: "borderColor.main", children: "No cohorts" })
          }
        )
      ]
    }
  );
};
function Gf() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Z(
    () => (r) => {
      t.forEach((i) => i(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const uo = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function Tr(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function wa(e) {
  return "nodeType" in e;
}
function Nt(e) {
  var t, n;
  return e ? Tr(e) ? e : wa(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
function Pa(e) {
  const {
    Document: t
  } = Nt(e);
  return e instanceof t;
}
function hi(e) {
  return Tr(e) ? !1 : e instanceof Nt(e).HTMLElement;
}
function hu(e) {
  return e instanceof Nt(e).SVGElement;
}
function Sr(e) {
  return e ? Tr(e) ? e.document : wa(e) ? Pa(e) ? e : hi(e) || hu(e) ? e.ownerDocument : document : document : document;
}
const cn = uo ? Kd : q;
function ja(e) {
  const t = Te(e);
  return cn(() => {
    t.current = e;
  }), ie(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function zf() {
  const e = Te(null), t = ie((r, i) => {
    e.current = setInterval(r, i);
  }, []), n = ie(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, n];
}
function Zr(e, t) {
  t === void 0 && (t = [e]);
  const n = Te(e);
  return cn(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function fi(e, t) {
  const n = Te();
  return Z(
    () => {
      const r = e(n.current);
      return n.current = r, r;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function Qi(e) {
  const t = ja(e), n = Te(null), r = ie(
    (i) => {
      i !== n.current && (t == null || t(i, n.current)), n.current = i;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
function ra(e) {
  const t = Te();
  return q(() => {
    t.current = e;
  }, [e]), t.current;
}
let _o = {};
function mi(e, t) {
  return Z(() => {
    if (t)
      return t;
    const n = _o[e] == null ? 0 : _o[e] + 1;
    return _o[e] = n, e + "-" + n;
  }, [e, t]);
}
function fu(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return r.reduce((o, s) => {
      const l = Object.entries(s);
      for (const [c, u] of l) {
        const p = o[c];
        p != null && (o[c] = p + e * u);
      }
      return o;
    }, {
      ...t
    });
  };
}
const cr = /* @__PURE__ */ fu(1), Ki = /* @__PURE__ */ fu(-1);
function Wf(e) {
  return "clientX" in e && "clientY" in e;
}
function La(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = Nt(e.target);
  return t && e instanceof t;
}
function Yf(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = Nt(e.target);
  return t && e instanceof t;
}
function ia(e) {
  if (Yf(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return Wf(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const ei = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [ei.Translate.toString(e), ei.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
}), Ws = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function Hf(e) {
  return e.matches(Ws) ? e : e.querySelector(Ws);
}
const qf = {
  display: "none"
};
function Xf(e) {
  let {
    id: t,
    value: n
  } = e;
  return Le.createElement("div", {
    id: t,
    style: qf
  }, n);
}
function Jf(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: r = "assertive"
  } = e;
  const i = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return Le.createElement("div", {
    id: t,
    style: i,
    role: "status",
    "aria-live": r,
    "aria-atomic": !0
  }, n);
}
function Qf() {
  const [e, t] = K("");
  return {
    announce: ie((r) => {
      r != null && t(r);
    }, []),
    announcement: e
  };
}
const mu = /* @__PURE__ */ qn(null);
function Kf(e) {
  const t = je(mu);
  q(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function Zf() {
  const [e] = K(() => /* @__PURE__ */ new Set()), t = ie((r) => (e.add(r), () => e.delete(r)), [e]);
  return [ie((r) => {
    let {
      type: i,
      event: o
    } = r;
    e.forEach((s) => {
      var l;
      return (l = s[i]) == null ? void 0 : l.call(s, o);
    });
  }, [e]), t];
}
const em = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, tm = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was moved over droppable area " + n.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was dropped over droppable area " + n.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function nm(e) {
  let {
    announcements: t = tm,
    container: n,
    hiddenTextDescribedById: r,
    screenReaderInstructions: i = em
  } = e;
  const {
    announce: o,
    announcement: s
  } = Qf(), l = mi("DndLiveRegion"), [c, u] = K(!1);
  if (q(() => {
    u(!0);
  }, []), Kf(Z(() => ({
    onDragStart(d) {
      let {
        active: f
      } = d;
      o(t.onDragStart({
        active: f
      }));
    },
    onDragMove(d) {
      let {
        active: f,
        over: h
      } = d;
      t.onDragMove && o(t.onDragMove({
        active: f,
        over: h
      }));
    },
    onDragOver(d) {
      let {
        active: f,
        over: h
      } = d;
      o(t.onDragOver({
        active: f,
        over: h
      }));
    },
    onDragEnd(d) {
      let {
        active: f,
        over: h
      } = d;
      o(t.onDragEnd({
        active: f,
        over: h
      }));
    },
    onDragCancel(d) {
      let {
        active: f,
        over: h
      } = d;
      o(t.onDragCancel({
        active: f,
        over: h
      }));
    }
  }), [o, t])), !c)
    return null;
  const p = Le.createElement(Le.Fragment, null, Le.createElement(Xf, {
    id: r,
    value: i.draggable
  }), Le.createElement(Jf, {
    id: l,
    announcement: s
  }));
  return n ? gh(p, n) : p;
}
var it;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(it || (it = {}));
function Zi() {
}
function rm(e, t) {
  return Z(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function im() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Z(
    () => [...t].filter((r) => r != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const Jt = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function om(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function am(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return n - r;
}
function sm(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return r - n;
}
function lm(e, t) {
  if (!e || e.length === 0)
    return null;
  const [n] = e;
  return n[t];
}
function Ys(e, t, n) {
  return t === void 0 && (t = e.left), n === void 0 && (n = e.top), {
    x: t + e.width * 0.5,
    y: n + e.height * 0.5
  };
}
const cm = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const i = Ys(t, t.left, t.top), o = [];
  for (const s of r) {
    const {
      id: l
    } = s, c = n.get(l);
    if (c) {
      const u = om(Ys(c), i);
      o.push({
        id: l,
        data: {
          droppableContainer: s,
          value: u
        }
      });
    }
  }
  return o.sort(am);
};
function um(e, t) {
  const n = Math.max(t.top, e.top), r = Math.max(t.left, e.left), i = Math.min(t.left + t.width, e.left + e.width), o = Math.min(t.top + t.height, e.top + e.height), s = i - r, l = o - n;
  if (r < i && n < o) {
    const c = t.width * t.height, u = e.width * e.height, p = s * l, d = p / (c + u - p);
    return Number(d.toFixed(4));
  }
  return 0;
}
const dm = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const i = [];
  for (const o of r) {
    const {
      id: s
    } = o, l = n.get(s);
    if (l) {
      const c = um(l, t);
      c > 0 && i.push({
        id: s,
        data: {
          droppableContainer: o,
          value: c
        }
      });
    }
  }
  return i.sort(sm);
};
function pm(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function Eu(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : Jt;
}
function hm(e) {
  return function(n) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      i[o - 1] = arguments[o];
    return i.reduce((s, l) => ({
      ...s,
      top: s.top + e * l.y,
      bottom: s.bottom + e * l.y,
      left: s.left + e * l.x,
      right: s.right + e * l.x
    }), {
      ...n
    });
  };
}
const fm = /* @__PURE__ */ hm(1);
function mm(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function Em(e, t, n) {
  const r = mm(t);
  if (!r)
    return e;
  const {
    scaleX: i,
    scaleY: o,
    x: s,
    y: l
  } = r, c = e.left - s - (1 - i) * parseFloat(n), u = e.top - l - (1 - o) * parseFloat(n.slice(n.indexOf(" ") + 1)), p = i ? e.width / i : e.width, d = o ? e.height / o : e.height;
  return {
    width: p,
    height: d,
    top: u,
    right: c + p,
    bottom: u + d,
    left: c
  };
}
const xm = {
  ignoreTransform: !1
};
function Ir(e, t) {
  t === void 0 && (t = xm);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: u,
      transformOrigin: p
    } = Nt(e).getComputedStyle(e);
    u && (n = Em(n, u, p));
  }
  const {
    top: r,
    left: i,
    width: o,
    height: s,
    bottom: l,
    right: c
  } = n;
  return {
    top: r,
    left: i,
    width: o,
    height: s,
    bottom: l,
    right: c
  };
}
function Hs(e) {
  return Ir(e, {
    ignoreTransform: !0
  });
}
function Cm(e) {
  const t = e.innerWidth, n = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: n,
    width: t,
    height: n
  };
}
function gm(e, t) {
  return t === void 0 && (t = Nt(e).getComputedStyle(e)), t.position === "fixed";
}
function ym(e, t) {
  t === void 0 && (t = Nt(e).getComputedStyle(e));
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((i) => {
    const o = t[i];
    return typeof o == "string" ? n.test(o) : !1;
  });
}
function ka(e, t) {
  const n = [];
  function r(i) {
    if (t != null && n.length >= t || !i)
      return n;
    if (Pa(i) && i.scrollingElement != null && !n.includes(i.scrollingElement))
      return n.push(i.scrollingElement), n;
    if (!hi(i) || hu(i) || n.includes(i))
      return n;
    const o = Nt(e).getComputedStyle(i);
    return i !== e && ym(i, o) && n.push(i), gm(i, o) ? n : r(i.parentNode);
  }
  return e ? r(e) : n;
}
function xu(e) {
  const [t] = ka(e, 1);
  return t ?? null;
}
function No(e) {
  return !uo || !e ? null : Tr(e) ? e : wa(e) ? Pa(e) || e === Sr(e).scrollingElement ? window : hi(e) ? e : null : null;
}
function Cu(e) {
  return Tr(e) ? e.scrollX : e.scrollLeft;
}
function gu(e) {
  return Tr(e) ? e.scrollY : e.scrollTop;
}
function oa(e) {
  return {
    x: Cu(e),
    y: gu(e)
  };
}
var lt;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(lt || (lt = {}));
function yu(e) {
  return !uo || !e ? !1 : e === document.scrollingElement;
}
function Tu(e) {
  const t = {
    x: 0,
    y: 0
  }, n = yu(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, r = {
    x: e.scrollWidth - n.width,
    y: e.scrollHeight - n.height
  }, i = e.scrollTop <= t.y, o = e.scrollLeft <= t.x, s = e.scrollTop >= r.y, l = e.scrollLeft >= r.x;
  return {
    isTop: i,
    isLeft: o,
    isBottom: s,
    isRight: l,
    maxScroll: r,
    minScroll: t
  };
}
const Tm = {
  x: 0.2,
  y: 0.2
};
function Sm(e, t, n, r, i) {
  let {
    top: o,
    left: s,
    right: l,
    bottom: c
  } = n;
  r === void 0 && (r = 10), i === void 0 && (i = Tm);
  const {
    isTop: u,
    isBottom: p,
    isLeft: d,
    isRight: f
  } = Tu(e), h = {
    x: 0,
    y: 0
  }, g = {
    x: 0,
    y: 0
  }, C = {
    height: t.height * i.y,
    width: t.width * i.x
  };
  return !u && o <= t.top + C.height ? (h.y = lt.Backward, g.y = r * Math.abs((t.top + C.height - o) / C.height)) : !p && c >= t.bottom - C.height && (h.y = lt.Forward, g.y = r * Math.abs((t.bottom - C.height - c) / C.height)), !f && l >= t.right - C.width ? (h.x = lt.Forward, g.x = r * Math.abs((t.right - C.width - l) / C.width)) : !d && s <= t.left + C.width && (h.x = lt.Backward, g.x = r * Math.abs((t.left + C.width - s) / C.width)), {
    direction: h,
    speed: g
  };
}
function Im(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: o,
      innerHeight: s
    } = window;
    return {
      top: 0,
      left: 0,
      right: o,
      bottom: s,
      width: o,
      height: s
    };
  }
  const {
    top: t,
    left: n,
    right: r,
    bottom: i
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: r,
    bottom: i,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function Su(e) {
  return e.reduce((t, n) => cr(t, oa(n)), Jt);
}
function Am(e) {
  return e.reduce((t, n) => t + Cu(n), 0);
}
function bm(e) {
  return e.reduce((t, n) => t + gu(n), 0);
}
function Rm(e, t) {
  if (t === void 0 && (t = Ir), !e)
    return;
  const {
    top: n,
    left: r,
    bottom: i,
    right: o
  } = t(e);
  xu(e) && (i <= 0 || o <= 0 || n >= window.innerHeight || r >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const Om = [["x", ["left", "right"], Am], ["y", ["top", "bottom"], bm]];
class Ma {
  constructor(t, n) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const r = ka(n), i = Su(r);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [o, s, l] of Om)
      for (const c of s)
        Object.defineProperty(this, c, {
          get: () => {
            const u = l(r), p = i[o] - u;
            return this.rect[c] + p;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class Fr {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var r;
        return (r = this.target) == null ? void 0 : r.removeEventListener(...n);
      });
    }, this.target = t;
  }
  add(t, n, r) {
    var i;
    (i = this.target) == null || i.addEventListener(t, n, r), this.listeners.push([t, n, r]);
  }
}
function Dm(e) {
  const {
    EventTarget: t
  } = Nt(e);
  return e instanceof t ? e : Sr(e);
}
function wo(e, t) {
  const n = Math.abs(e.x), r = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(n ** 2 + r ** 2) > t : "x" in t && "y" in t ? n > t.x && r > t.y : "x" in t ? n > t.x : "y" in t ? r > t.y : !1;
}
var Gt;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(Gt || (Gt = {}));
function qs(e) {
  e.preventDefault();
}
function vm(e) {
  e.stopPropagation();
}
var ve;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(ve || (ve = {}));
const Iu = {
  start: [ve.Space, ve.Enter],
  cancel: [ve.Esc],
  end: [ve.Space, ve.Enter, ve.Tab]
}, _m = (e, t) => {
  let {
    currentCoordinates: n
  } = t;
  switch (e.code) {
    case ve.Right:
      return {
        ...n,
        x: n.x + 25
      };
    case ve.Left:
      return {
        ...n,
        x: n.x - 25
      };
    case ve.Down:
      return {
        ...n,
        y: n.y + 25
      };
    case ve.Up:
      return {
        ...n,
        y: n.y - 25
      };
  }
};
class Au {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: n
      }
    } = t;
    this.props = t, this.listeners = new Fr(Sr(n)), this.windowListeners = new Fr(Nt(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(Gt.Resize, this.handleCancel), this.windowListeners.add(Gt.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(Gt.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: n
    } = this.props, r = t.node.current;
    r && Rm(r), n(Jt);
  }
  handleKeyDown(t) {
    if (La(t)) {
      const {
        active: n,
        context: r,
        options: i
      } = this.props, {
        keyboardCodes: o = Iu,
        coordinateGetter: s = _m,
        scrollBehavior: l = "smooth"
      } = i, {
        code: c
      } = t;
      if (o.end.includes(c)) {
        this.handleEnd(t);
        return;
      }
      if (o.cancel.includes(c)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: u
      } = r.current, p = u ? {
        x: u.left,
        y: u.top
      } : Jt;
      this.referenceCoordinates || (this.referenceCoordinates = p);
      const d = s(t, {
        active: n,
        context: r.current,
        currentCoordinates: p
      });
      if (d) {
        const f = Ki(d, p), h = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: g
        } = r.current;
        for (const C of g) {
          const y = t.code, {
            isTop: I,
            isRight: O,
            isLeft: S,
            isBottom: N,
            maxScroll: _,
            minScroll: R
          } = Tu(C), P = Im(C), U = {
            x: Math.min(y === ve.Right ? P.right - P.width / 2 : P.right, Math.max(y === ve.Right ? P.left : P.left + P.width / 2, d.x)),
            y: Math.min(y === ve.Down ? P.bottom - P.height / 2 : P.bottom, Math.max(y === ve.Down ? P.top : P.top + P.height / 2, d.y))
          }, M = y === ve.Right && !O || y === ve.Left && !S, w = y === ve.Down && !N || y === ve.Up && !I;
          if (M && U.x !== d.x) {
            const V = C.scrollLeft + f.x, L = y === ve.Right && V <= _.x || y === ve.Left && V >= R.x;
            if (L && !f.y) {
              C.scrollTo({
                left: V,
                behavior: l
              });
              return;
            }
            L ? h.x = C.scrollLeft - V : h.x = y === ve.Right ? C.scrollLeft - _.x : C.scrollLeft - R.x, h.x && C.scrollBy({
              left: -h.x,
              behavior: l
            });
            break;
          } else if (w && U.y !== d.y) {
            const V = C.scrollTop + f.y, L = y === ve.Down && V <= _.y || y === ve.Up && V >= R.y;
            if (L && !f.x) {
              C.scrollTo({
                top: V,
                behavior: l
              });
              return;
            }
            L ? h.y = C.scrollTop - V : h.y = y === ve.Down ? C.scrollTop - _.y : C.scrollTop - R.y, h.y && C.scrollBy({
              top: -h.y,
              behavior: l
            });
            break;
          }
        }
        this.handleMove(t, cr(Ki(d, this.referenceCoordinates), h));
      }
    }
  }
  handleMove(t, n) {
    const {
      onMove: r
    } = this.props;
    t.preventDefault(), r(n);
  }
  handleEnd(t) {
    const {
      onEnd: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  handleCancel(t) {
    const {
      onCancel: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
Au.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, n) => {
    let {
      keyboardCodes: r = Iu,
      onActivation: i
    } = t, {
      active: o
    } = n;
    const {
      code: s
    } = e.nativeEvent;
    if (r.start.includes(s)) {
      const l = o.activatorNode.current;
      return l && e.target !== l ? !1 : (e.preventDefault(), i == null || i({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function Xs(e) {
  return !!(e && "distance" in e);
}
function Js(e) {
  return !!(e && "delay" in e);
}
class Va {
  constructor(t, n, r) {
    var i;
    r === void 0 && (r = Dm(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = n;
    const {
      event: o
    } = t, {
      target: s
    } = o;
    this.props = t, this.events = n, this.document = Sr(s), this.documentListeners = new Fr(this.document), this.listeners = new Fr(r), this.windowListeners = new Fr(Nt(s)), this.initialCoordinates = (i = ia(o)) != null ? i : Jt, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: n,
          bypassActivationConstraint: r
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), t.cancel && this.listeners.add(t.cancel.name, this.handleCancel), this.windowListeners.add(Gt.Resize, this.handleCancel), this.windowListeners.add(Gt.DragStart, qs), this.windowListeners.add(Gt.VisibilityChange, this.handleCancel), this.windowListeners.add(Gt.ContextMenu, qs), this.documentListeners.add(Gt.Keydown, this.handleKeydown), n) {
      if (r != null && r({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (Js(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay), this.handlePending(n);
        return;
      }
      if (Xs(n)) {
        this.handlePending(n);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(t, n) {
    const {
      active: r,
      onPending: i
    } = this.props;
    i(r, t, this.initialCoordinates, n);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: n
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(Gt.Click, vm, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(Gt.SelectionChange, this.removeTextSelection), n(t));
  }
  handleMove(t) {
    var n;
    const {
      activated: r,
      initialCoordinates: i,
      props: o
    } = this, {
      onMove: s,
      options: {
        activationConstraint: l
      }
    } = o;
    if (!i)
      return;
    const c = (n = ia(t)) != null ? n : Jt, u = Ki(i, c);
    if (!r && l) {
      if (Xs(l)) {
        if (l.tolerance != null && wo(u, l.tolerance))
          return this.handleCancel();
        if (wo(u, l.distance))
          return this.handleStart();
      }
      if (Js(l) && wo(u, l.tolerance))
        return this.handleCancel();
      this.handlePending(l, u);
      return;
    }
    t.cancelable && t.preventDefault(), s(c);
  }
  handleEnd() {
    const {
      onAbort: t,
      onEnd: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleCancel() {
    const {
      onAbort: t,
      onCancel: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleKeydown(t) {
    t.code === ve.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const Nm = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class Ua extends Va {
  constructor(t) {
    const {
      event: n
    } = t, r = Sr(n.target);
    super(t, Nm, r);
  }
}
Ua.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return !n.isPrimary || n.button !== 0 ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
const wm = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var aa;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(aa || (aa = {}));
class Pm extends Va {
  constructor(t) {
    super(t, wm, Sr(t.event.target));
  }
}
Pm.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return n.button === aa.RightClick ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
const Po = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class jm extends Va {
  constructor(t) {
    super(t, Po);
  }
  static setup() {
    return window.addEventListener(Po.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(Po.move.name, t);
    };
    function t() {
    }
  }
}
jm.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    const {
      touches: i
    } = n;
    return i.length > 1 ? !1 : (r == null || r({
      event: n
    }), !0);
  }
}];
var Br;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(Br || (Br = {}));
var eo;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(eo || (eo = {}));
function Lm(e) {
  let {
    acceleration: t,
    activator: n = Br.Pointer,
    canScroll: r,
    draggingRect: i,
    enabled: o,
    interval: s = 5,
    order: l = eo.TreeOrder,
    pointerCoordinates: c,
    scrollableAncestors: u,
    scrollableAncestorRects: p,
    delta: d,
    threshold: f
  } = e;
  const h = Mm({
    delta: d,
    disabled: !o
  }), [g, C] = zf(), y = Te({
    x: 0,
    y: 0
  }), I = Te({
    x: 0,
    y: 0
  }), O = Z(() => {
    switch (n) {
      case Br.Pointer:
        return c ? {
          top: c.y,
          bottom: c.y,
          left: c.x,
          right: c.x
        } : null;
      case Br.DraggableRect:
        return i;
    }
  }, [n, i, c]), S = Te(null), N = ie(() => {
    const R = S.current;
    if (!R)
      return;
    const P = y.current.x * I.current.x, U = y.current.y * I.current.y;
    R.scrollBy(P, U);
  }, []), _ = Z(() => l === eo.TreeOrder ? [...u].reverse() : u, [l, u]);
  q(
    () => {
      if (!o || !u.length || !O) {
        C();
        return;
      }
      for (const R of _) {
        if ((r == null ? void 0 : r(R)) === !1)
          continue;
        const P = u.indexOf(R), U = p[P];
        if (!U)
          continue;
        const {
          direction: M,
          speed: w
        } = Sm(R, U, O, t, f);
        for (const V of ["x", "y"])
          h[V][M[V]] || (w[V] = 0, M[V] = 0);
        if (w.x > 0 || w.y > 0) {
          C(), S.current = R, g(N, s), y.current = w, I.current = M;
          return;
        }
      }
      y.current = {
        x: 0,
        y: 0
      }, I.current = {
        x: 0,
        y: 0
      }, C();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      N,
      r,
      C,
      o,
      s,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(O),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(h),
      g,
      u,
      _,
      p,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(f)
    ]
  );
}
const km = {
  x: {
    [lt.Backward]: !1,
    [lt.Forward]: !1
  },
  y: {
    [lt.Backward]: !1,
    [lt.Forward]: !1
  }
};
function Mm(e) {
  let {
    delta: t,
    disabled: n
  } = e;
  const r = ra(t);
  return fi((i) => {
    if (n || !r || !i)
      return km;
    const o = {
      x: Math.sign(t.x - r.x),
      y: Math.sign(t.y - r.y)
    };
    return {
      x: {
        [lt.Backward]: i.x[lt.Backward] || o.x === -1,
        [lt.Forward]: i.x[lt.Forward] || o.x === 1
      },
      y: {
        [lt.Backward]: i.y[lt.Backward] || o.y === -1,
        [lt.Forward]: i.y[lt.Forward] || o.y === 1
      }
    };
  }, [n, t, r]);
}
function Vm(e, t) {
  const n = t != null ? e.get(t) : void 0, r = n ? n.node.current : null;
  return fi((i) => {
    var o;
    return t == null ? null : (o = r ?? i) != null ? o : null;
  }, [r, t]);
}
function Um(e, t) {
  return Z(() => e.reduce((n, r) => {
    const {
      sensor: i
    } = r, o = i.activators.map((s) => ({
      eventName: s.eventName,
      handler: t(s.handler, r)
    }));
    return [...n, ...o];
  }, []), [e, t]);
}
var ti;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(ti || (ti = {}));
var sa;
(function(e) {
  e.Optimized = "optimized";
})(sa || (sa = {}));
const Qs = /* @__PURE__ */ new Map();
function Fm(e, t) {
  let {
    dragging: n,
    dependencies: r,
    config: i
  } = t;
  const [o, s] = K(null), {
    frequency: l,
    measure: c,
    strategy: u
  } = i, p = Te(e), d = y(), f = Zr(d), h = ie(function(I) {
    I === void 0 && (I = []), !f.current && s((O) => O === null ? I : O.concat(I.filter((S) => !O.includes(S))));
  }, [f]), g = Te(null), C = fi((I) => {
    if (d && !n)
      return Qs;
    if (!I || I === Qs || p.current !== e || o != null) {
      const O = /* @__PURE__ */ new Map();
      for (let S of e) {
        if (!S)
          continue;
        if (o && o.length > 0 && !o.includes(S.id) && S.rect.current) {
          O.set(S.id, S.rect.current);
          continue;
        }
        const N = S.node.current, _ = N ? new Ma(c(N), N) : null;
        S.rect.current = _, _ && O.set(S.id, _);
      }
      return O;
    }
    return I;
  }, [e, o, n, d, c]);
  return q(() => {
    p.current = e;
  }, [e]), q(
    () => {
      d || h();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, d]
  ), q(
    () => {
      o && o.length > 0 && s(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(o)]
  ), q(
    () => {
      d || typeof l != "number" || g.current !== null || (g.current = setTimeout(() => {
        h(), g.current = null;
      }, l));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, d, h, ...r]
  ), {
    droppableRects: C,
    measureDroppableContainers: h,
    measuringScheduled: o != null
  };
  function y() {
    switch (u) {
      case ti.Always:
        return !1;
      case ti.BeforeDragging:
        return n;
      default:
        return !n;
    }
  }
}
function bu(e, t) {
  return fi((n) => e ? n || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function Bm(e, t) {
  return bu(e, t);
}
function $m(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = ja(t), i = Z(() => {
    if (n || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: o
    } = window;
    return new o(r);
  }, [r, n]);
  return q(() => () => i == null ? void 0 : i.disconnect(), [i]), i;
}
function po(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = ja(t), i = Z(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: o
      } = window;
      return new o(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return q(() => () => i == null ? void 0 : i.disconnect(), [i]), i;
}
function Gm(e) {
  return new Ma(Ir(e), e);
}
function Ks(e, t, n) {
  t === void 0 && (t = Gm);
  const [r, i] = K(null);
  function o() {
    i((c) => {
      if (!e)
        return null;
      if (e.isConnected === !1) {
        var u;
        return (u = c ?? n) != null ? u : null;
      }
      const p = t(e);
      return JSON.stringify(c) === JSON.stringify(p) ? c : p;
    });
  }
  const s = $m({
    callback(c) {
      if (e)
        for (const u of c) {
          const {
            type: p,
            target: d
          } = u;
          if (p === "childList" && d instanceof HTMLElement && d.contains(e)) {
            o();
            break;
          }
        }
    }
  }), l = po({
    callback: o
  });
  return cn(() => {
    o(), e ? (l == null || l.observe(e), s == null || s.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (l == null || l.disconnect(), s == null || s.disconnect());
  }, [e]), r;
}
function zm(e) {
  const t = bu(e);
  return Eu(e, t);
}
const Zs = [];
function Wm(e) {
  const t = Te(e), n = fi((r) => e ? r && r !== Zs && e && t.current && e.parentNode === t.current.parentNode ? r : ka(e) : Zs, [e]);
  return q(() => {
    t.current = e;
  }, [e]), n;
}
function Ym(e) {
  const [t, n] = K(null), r = Te(e), i = ie((o) => {
    const s = No(o.target);
    s && n((l) => l ? (l.set(s, oa(s)), new Map(l)) : null);
  }, []);
  return q(() => {
    const o = r.current;
    if (e !== o) {
      s(o);
      const l = e.map((c) => {
        const u = No(c);
        return u ? (u.addEventListener("scroll", i, {
          passive: !0
        }), [u, oa(u)]) : null;
      }).filter((c) => c != null);
      n(l.length ? new Map(l) : null), r.current = e;
    }
    return () => {
      s(e), s(o);
    };
    function s(l) {
      l.forEach((c) => {
        const u = No(c);
        u == null || u.removeEventListener("scroll", i);
      });
    }
  }, [i, e]), Z(() => e.length ? t ? Array.from(t.values()).reduce((o, s) => cr(o, s), Jt) : Su(e) : Jt, [e, t]);
}
function el(e, t) {
  t === void 0 && (t = []);
  const n = Te(null);
  return q(
    () => {
      n.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), q(() => {
    const r = e !== Jt;
    r && !n.current && (n.current = e), !r && n.current && (n.current = null);
  }, [e]), n.current ? Ki(e, n.current) : Jt;
}
function Hm(e) {
  q(
    () => {
      if (!uo)
        return;
      const t = e.map((n) => {
        let {
          sensor: r
        } = n;
        return r.setup == null ? void 0 : r.setup();
      });
      return () => {
        for (const n of t)
          n == null || n();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: n
      } = t;
      return n;
    })
  );
}
function qm(e, t) {
  return Z(() => e.reduce((n, r) => {
    let {
      eventName: i,
      handler: o
    } = r;
    return n[i] = (s) => {
      o(s, t);
    }, n;
  }, {}), [e, t]);
}
function Ru(e) {
  return Z(() => e ? Cm(e) : null, [e]);
}
const tl = [];
function Xm(e, t) {
  t === void 0 && (t = Ir);
  const [n] = e, r = Ru(n ? Nt(n) : null), [i, o] = K(tl);
  function s() {
    o(() => e.length ? e.map((c) => yu(c) ? r : new Ma(t(c), c)) : tl);
  }
  const l = po({
    callback: s
  });
  return cn(() => {
    l == null || l.disconnect(), s(), e.forEach((c) => l == null ? void 0 : l.observe(c));
  }, [e]), i;
}
function Jm(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return hi(t) ? t : e;
}
function Qm(e) {
  let {
    measure: t
  } = e;
  const [n, r] = K(null), i = ie((u) => {
    for (const {
      target: p
    } of u)
      if (hi(p)) {
        r((d) => {
          const f = t(p);
          return d ? {
            ...d,
            width: f.width,
            height: f.height
          } : f;
        });
        break;
      }
  }, [t]), o = po({
    callback: i
  }), s = ie((u) => {
    const p = Jm(u);
    o == null || o.disconnect(), p && (o == null || o.observe(p)), r(p ? t(p) : null);
  }, [t, o]), [l, c] = Qi(s);
  return Z(() => ({
    nodeRef: l,
    rect: n,
    setRef: c
  }), [n, l, c]);
}
const Km = [{
  sensor: Ua,
  options: {}
}, {
  sensor: Au,
  options: {}
}], Zm = {
  current: {}
}, Mi = {
  draggable: {
    measure: Hs
  },
  droppable: {
    measure: Hs,
    strategy: ti.WhileDragging,
    frequency: sa.Optimized
  },
  dragOverlay: {
    measure: Ir
  }
};
class $r extends Map {
  get(t) {
    var n;
    return t != null && (n = super.get(t)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: n
      } = t;
      return !n;
    });
  }
  getNodeFor(t) {
    var n, r;
    return (n = (r = this.get(t)) == null ? void 0 : r.node.current) != null ? n : void 0;
  }
}
const eE = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new $r(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: Zi
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: Mi,
  measureDroppableContainers: Zi,
  windowRect: null,
  measuringScheduled: !1
}, tE = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: Zi,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: Zi
}, ho = /* @__PURE__ */ qn(tE), Ou = /* @__PURE__ */ qn(eE);
function nE() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new $r()
    }
  };
}
function rE(e, t) {
  switch (t.type) {
    case it.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case it.DragMove:
      return e.draggable.active == null ? e : {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      };
    case it.DragEnd:
    case it.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case it.RegisterDroppable: {
      const {
        element: n
      } = t, {
        id: r
      } = n, i = new $r(e.droppable.containers);
      return i.set(r, n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    case it.SetDroppableDisabled: {
      const {
        id: n,
        key: r,
        disabled: i
      } = t, o = e.droppable.containers.get(n);
      if (!o || r !== o.key)
        return e;
      const s = new $r(e.droppable.containers);
      return s.set(n, {
        ...o,
        disabled: i
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: s
        }
      };
    }
    case it.UnregisterDroppable: {
      const {
        id: n,
        key: r
      } = t, i = e.droppable.containers.get(n);
      if (!i || r !== i.key)
        return e;
      const o = new $r(e.droppable.containers);
      return o.delete(n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    default:
      return e;
  }
}
function iE(e) {
  let {
    disabled: t
  } = e;
  const {
    active: n,
    activatorEvent: r,
    draggableNodes: i
  } = je(ho), o = ra(r), s = ra(n == null ? void 0 : n.id);
  return q(() => {
    if (!t && !r && o && s != null) {
      if (!La(o) || document.activeElement === o.target)
        return;
      const l = i.get(s);
      if (!l)
        return;
      const {
        activatorNode: c,
        node: u
      } = l;
      if (!c.current && !u.current)
        return;
      requestAnimationFrame(() => {
        for (const p of [c.current, u.current]) {
          if (!p)
            continue;
          const d = Hf(p);
          if (d) {
            d.focus();
            break;
          }
        }
      });
    }
  }, [r, t, i, s, o]), null;
}
function oE(e, t) {
  let {
    transform: n,
    ...r
  } = t;
  return e != null && e.length ? e.reduce((i, o) => o({
    transform: i,
    ...r
  }), n) : n;
}
function aE(e) {
  return Z(
    () => ({
      draggable: {
        ...Mi.draggable,
        ...e == null ? void 0 : e.draggable
      },
      droppable: {
        ...Mi.droppable,
        ...e == null ? void 0 : e.droppable
      },
      dragOverlay: {
        ...Mi.dragOverlay,
        ...e == null ? void 0 : e.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e == null ? void 0 : e.draggable, e == null ? void 0 : e.droppable, e == null ? void 0 : e.dragOverlay]
  );
}
function sE(e) {
  let {
    activeNode: t,
    measure: n,
    initialRect: r,
    config: i = !0
  } = e;
  const o = Te(!1), {
    x: s,
    y: l
  } = typeof i == "boolean" ? {
    x: i,
    y: i
  } : i;
  cn(() => {
    if (!s && !l || !t) {
      o.current = !1;
      return;
    }
    if (o.current || !r)
      return;
    const u = t == null ? void 0 : t.node.current;
    if (!u || u.isConnected === !1)
      return;
    const p = n(u), d = Eu(p, r);
    if (s || (d.x = 0), l || (d.y = 0), o.current = !0, Math.abs(d.x) > 0 || Math.abs(d.y) > 0) {
      const f = xu(u);
      f && f.scrollBy({
        top: d.y,
        left: d.x
      });
    }
  }, [t, s, l, r, n]);
}
const Du = /* @__PURE__ */ qn({
  ...Jt,
  scaleX: 1,
  scaleY: 1
});
var bn;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(bn || (bn = {}));
const lE = /* @__PURE__ */ Ze(function(t) {
  var n, r, i, o;
  let {
    id: s,
    accessibility: l,
    autoScroll: c = !0,
    children: u,
    sensors: p = Km,
    collisionDetection: d = dm,
    measuring: f,
    modifiers: h,
    ...g
  } = t;
  const C = xr(rE, void 0, nE), [y, I] = C, [O, S] = Zf(), [N, _] = K(bn.Uninitialized), R = N === bn.Initialized, {
    draggable: {
      active: P,
      nodes: U,
      translate: M
    },
    droppable: {
      containers: w
    }
  } = y, V = P != null ? U.get(P) : null, L = Te({
    initial: null,
    translated: null
  }), te = Z(() => {
    var nt;
    return P != null ? {
      id: P,
      // It's possible for the active node to unmount while dragging
      data: (nt = V == null ? void 0 : V.data) != null ? nt : Zm,
      rect: L
    } : null;
  }, [P, V]), $ = Te(null), [v, J] = K(null), [j, ee] = K(null), Q = Zr(g, Object.values(g)), x = mi("DndDescribedBy", s), Y = Z(() => w.getEnabled(), [w]), k = aE(f), {
    droppableRects: T,
    measureDroppableContainers: re,
    measuringScheduled: b
  } = Fm(Y, {
    dragging: R,
    dependencies: [M.x, M.y],
    config: k.droppable
  }), z = Vm(U, P), me = Z(() => j ? ia(j) : null, [j]), ae = Dr(), le = Bm(z, k.draggable.measure);
  sE({
    activeNode: P != null ? U.get(P) : null,
    config: ae.layoutShiftCompensation,
    initialRect: le,
    measure: k.draggable.measure
  });
  const de = Ks(z, k.draggable.measure, le), $e = Ks(z ? z.parentElement : null), we = Te({
    activatorEvent: null,
    active: null,
    activeNode: z,
    collisionRect: null,
    collisions: null,
    droppableRects: T,
    draggableNodes: U,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: w,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), At = w.getNodeFor((n = we.current.over) == null ? void 0 : n.id), qe = Qm({
    measure: k.dragOverlay.measure
  }), ot = (r = qe.nodeRef.current) != null ? r : z, ct = R ? (i = qe.rect) != null ? i : de : null, bt = !!(qe.nodeRef.current && qe.rect), Yt = zm(bt ? null : de), ce = Ru(ot ? Nt(ot) : null), ne = Wm(R ? At ?? z : null), Ue = Xm(ne), mt = oE(h, {
    transform: {
      x: M.x - Yt.x,
      y: M.y - Yt.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: j,
    active: te,
    activeNodeRect: de,
    containerNodeRect: $e,
    draggingNodeRect: ct,
    over: we.current.over,
    overlayNodeRect: qe.rect,
    scrollableAncestors: ne,
    scrollableAncestorRects: Ue,
    windowRect: ce
  }), Rt = me ? cr(me, M) : null, et = Ym(ne), tt = el(et), F = el(et, [de]), H = cr(mt, tt), oe = ct ? fm(ct, mt) : null, Ce = te && oe ? d({
    active: te,
    collisionRect: oe,
    droppableRects: T,
    droppableContainers: Y,
    pointerCoordinates: Rt
  }) : null, Oe = lm(Ce, "id"), [Ge, Ft] = K(null), Pt = bt ? mt : cr(mt, F), dn = pm(Pt, (o = Ge == null ? void 0 : Ge.rect) != null ? o : null, de), Ht = Te(null), at = ie(
    (nt, Et) => {
      let {
        sensor: xt,
        options: Kt
      } = Et;
      if ($.current == null)
        return;
      const Ot = U.get($.current);
      if (!Ot)
        return;
      const Ct = nt.nativeEvent, Bt = new xt({
        active: $.current,
        activeNode: Ot,
        event: Ct,
        options: Kt,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: we,
        onAbort(rt) {
          if (!U.get(rt))
            return;
          const {
            onDragAbort: jt
          } = Q.current, gt = {
            id: rt
          };
          jt == null || jt(gt), O({
            type: "onDragAbort",
            event: gt
          });
        },
        onPending(rt, Zt, jt, gt) {
          if (!U.get(rt))
            return;
          const {
            onDragPending: Sn
          } = Q.current, Dt = {
            id: rt,
            constraint: Zt,
            initialCoordinates: jt,
            offset: gt
          };
          Sn == null || Sn(Dt), O({
            type: "onDragPending",
            event: Dt
          });
        },
        onStart(rt) {
          const Zt = $.current;
          if (Zt == null)
            return;
          const jt = U.get(Zt);
          if (!jt)
            return;
          const {
            onDragStart: gt
          } = Q.current, Tn = {
            activatorEvent: Ct,
            active: {
              id: Zt,
              data: jt.data,
              rect: L
            }
          };
          Si(() => {
            gt == null || gt(Tn), _(bn.Initializing), I({
              type: it.DragStart,
              initialCoordinates: rt,
              active: Zt
            }), O({
              type: "onDragStart",
              event: Tn
            }), J(Ht.current), ee(Ct);
          });
        },
        onMove(rt) {
          I({
            type: it.DragMove,
            coordinates: rt
          });
        },
        onEnd: yn(it.DragEnd),
        onCancel: yn(it.DragCancel)
      });
      Ht.current = Bt;
      function yn(rt) {
        return async function() {
          const {
            active: jt,
            collisions: gt,
            over: Tn,
            scrollAdjustedTranslate: Sn
          } = we.current;
          let Dt = null;
          if (jt && Sn) {
            const {
              cancelDrop: In
            } = Q.current;
            Dt = {
              activatorEvent: Ct,
              active: jt,
              collisions: gt,
              delta: Sn,
              over: Tn
            }, rt === it.DragEnd && typeof In == "function" && await Promise.resolve(In(Dt)) && (rt = it.DragCancel);
          }
          $.current = null, Si(() => {
            I({
              type: rt
            }), _(bn.Uninitialized), Ft(null), J(null), ee(null), Ht.current = null;
            const In = rt === it.DragEnd ? "onDragEnd" : "onDragCancel";
            if (Dt) {
              const pn = Q.current[In];
              pn == null || pn(Dt), O({
                type: In,
                event: Dt
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [U]
  ), Qt = ie((nt, Et) => (xt, Kt) => {
    const Ot = xt.nativeEvent, Ct = U.get(Kt);
    if (
      // Another sensor is already instantiating
      $.current !== null || // No active draggable
      !Ct || // Event has already been captured
      Ot.dndKit || Ot.defaultPrevented
    )
      return;
    const Bt = {
      active: Ct
    };
    nt(xt, Et.options, Bt) === !0 && (Ot.dndKit = {
      capturedBy: Et.sensor
    }, $.current = Kt, at(xt, Et));
  }, [U, at]), dt = Um(p, Qt);
  Hm(p), cn(() => {
    de && N === bn.Initializing && _(bn.Initialized);
  }, [de, N]), q(
    () => {
      const {
        onDragMove: nt
      } = Q.current, {
        active: Et,
        activatorEvent: xt,
        collisions: Kt,
        over: Ot
      } = we.current;
      if (!Et || !xt)
        return;
      const Ct = {
        active: Et,
        activatorEvent: xt,
        collisions: Kt,
        delta: {
          x: H.x,
          y: H.y
        },
        over: Ot
      };
      Si(() => {
        nt == null || nt(Ct), O({
          type: "onDragMove",
          event: Ct
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [H.x, H.y]
  ), q(
    () => {
      const {
        active: nt,
        activatorEvent: Et,
        collisions: xt,
        droppableContainers: Kt,
        scrollAdjustedTranslate: Ot
      } = we.current;
      if (!nt || $.current == null || !Et || !Ot)
        return;
      const {
        onDragOver: Ct
      } = Q.current, Bt = Kt.get(Oe), yn = Bt && Bt.rect.current ? {
        id: Bt.id,
        rect: Bt.rect.current,
        data: Bt.data,
        disabled: Bt.disabled
      } : null, rt = {
        active: nt,
        activatorEvent: Et,
        collisions: xt,
        delta: {
          x: Ot.x,
          y: Ot.y
        },
        over: yn
      };
      Si(() => {
        Ft(yn), Ct == null || Ct(rt), O({
          type: "onDragOver",
          event: rt
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Oe]
  ), cn(() => {
    we.current = {
      activatorEvent: j,
      active: te,
      activeNode: z,
      collisionRect: oe,
      collisions: Ce,
      droppableRects: T,
      draggableNodes: U,
      draggingNode: ot,
      draggingNodeRect: ct,
      droppableContainers: w,
      over: Ge,
      scrollableAncestors: ne,
      scrollAdjustedTranslate: H
    }, L.current = {
      initial: ct,
      translated: oe
    };
  }, [te, z, Ce, oe, U, ot, ct, T, w, Ge, ne, H]), Lm({
    ...ae,
    delta: M,
    draggingRect: oe,
    pointerCoordinates: Rt,
    scrollableAncestors: ne,
    scrollableAncestorRects: Ue
  });
  const Ci = Z(() => ({
    active: te,
    activeNode: z,
    activeNodeRect: de,
    activatorEvent: j,
    collisions: Ce,
    containerNodeRect: $e,
    dragOverlay: qe,
    draggableNodes: U,
    droppableContainers: w,
    droppableRects: T,
    over: Ge,
    measureDroppableContainers: re,
    scrollableAncestors: ne,
    scrollableAncestorRects: Ue,
    measuringConfiguration: k,
    measuringScheduled: b,
    windowRect: ce
  }), [te, z, de, j, Ce, $e, qe, U, w, T, Ge, re, ne, Ue, k, b, ce]), Qn = Z(() => ({
    activatorEvent: j,
    activators: dt,
    active: te,
    activeNodeRect: de,
    ariaDescribedById: {
      draggable: x
    },
    dispatch: I,
    draggableNodes: U,
    over: Ge,
    measureDroppableContainers: re
  }), [j, dt, te, de, I, x, U, Ge, re]);
  return Le.createElement(mu.Provider, {
    value: S
  }, Le.createElement(ho.Provider, {
    value: Qn
  }, Le.createElement(Ou.Provider, {
    value: Ci
  }, Le.createElement(Du.Provider, {
    value: dn
  }, u)), Le.createElement(iE, {
    disabled: (l == null ? void 0 : l.restoreFocus) === !1
  })), Le.createElement(nm, {
    ...l,
    hiddenTextDescribedById: x
  }));
  function Dr() {
    const nt = (v == null ? void 0 : v.autoScrollEnabled) === !1, Et = typeof c == "object" ? c.enabled === !1 : c === !1, xt = R && !nt && !Et;
    return typeof c == "object" ? {
      ...c,
      enabled: xt
    } : {
      enabled: xt
    };
  }
}), cE = /* @__PURE__ */ qn(null), nl = "button", uE = "Draggable";
function dE(e) {
  let {
    id: t,
    data: n,
    disabled: r = !1,
    attributes: i
  } = e;
  const o = mi(uE), {
    activators: s,
    activatorEvent: l,
    active: c,
    activeNodeRect: u,
    ariaDescribedById: p,
    draggableNodes: d,
    over: f
  } = je(ho), {
    role: h = nl,
    roleDescription: g = "draggable",
    tabIndex: C = 0
  } = i ?? {}, y = (c == null ? void 0 : c.id) === t, I = je(y ? Du : cE), [O, S] = Qi(), [N, _] = Qi(), R = qm(s, t), P = Zr(n);
  cn(
    () => (d.set(t, {
      id: t,
      key: o,
      node: O,
      activatorNode: N,
      data: P
    }), () => {
      const M = d.get(t);
      M && M.key === o && d.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d, t]
  );
  const U = Z(() => ({
    role: h,
    tabIndex: C,
    "aria-disabled": r,
    "aria-pressed": y && h === nl ? !0 : void 0,
    "aria-roledescription": g,
    "aria-describedby": p.draggable
  }), [r, h, C, y, g, p.draggable]);
  return {
    active: c,
    activatorEvent: l,
    activeNodeRect: u,
    attributes: U,
    isDragging: y,
    listeners: r ? void 0 : R,
    node: O,
    over: f,
    setNodeRef: S,
    setActivatorNodeRef: _,
    transform: I
  };
}
function pE() {
  return je(Ou);
}
const hE = "Droppable", fE = {
  timeout: 25
};
function mE(e) {
  let {
    data: t,
    disabled: n = !1,
    id: r,
    resizeObserverConfig: i
  } = e;
  const o = mi(hE), {
    active: s,
    dispatch: l,
    over: c,
    measureDroppableContainers: u
  } = je(ho), p = Te({
    disabled: n
  }), d = Te(!1), f = Te(null), h = Te(null), {
    disabled: g,
    updateMeasurementsFor: C,
    timeout: y
  } = {
    ...fE,
    ...i
  }, I = Zr(C ?? r), O = ie(
    () => {
      if (!d.current) {
        d.current = !0;
        return;
      }
      h.current != null && clearTimeout(h.current), h.current = setTimeout(() => {
        u(Array.isArray(I.current) ? I.current : [I.current]), h.current = null;
      }, y);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  ), S = po({
    callback: O,
    disabled: g || !s
  }), N = ie((U, M) => {
    S && (M && (S.unobserve(M), d.current = !1), U && S.observe(U));
  }, [S]), [_, R] = Qi(N), P = Zr(t);
  return q(() => {
    !S || !_.current || (S.disconnect(), d.current = !1, S.observe(_.current));
  }, [_, S]), q(
    () => (l({
      type: it.RegisterDroppable,
      element: {
        id: r,
        key: o,
        disabled: n,
        node: _,
        rect: f,
        data: P
      }
    }), () => l({
      type: it.UnregisterDroppable,
      key: o,
      id: r
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  ), q(() => {
    n !== p.current.disabled && (l({
      type: it.SetDroppableDisabled,
      id: r,
      key: o,
      disabled: n
    }), p.current.disabled = n);
  }, [r, o, n, l]), {
    active: s,
    rect: f,
    isOver: (c == null ? void 0 : c.id) === r,
    node: _,
    over: c,
    setNodeRef: R
  };
}
function Fa(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function EE(e, t) {
  return e.reduce((n, r, i) => {
    const o = t.get(r);
    return o && (n[i] = o), n;
  }, Array(e.length));
}
function Ai(e) {
  return e !== null && e >= 0;
}
function xE(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function CE(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const vu = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: r,
    index: i
  } = e;
  const o = Fa(t, r, n), s = t[i], l = o[i];
  return !l || !s ? null : {
    x: l.left - s.left,
    y: l.top - s.top,
    scaleX: l.width / s.width,
    scaleY: l.height / s.height
  };
}, bi = {
  scaleX: 1,
  scaleY: 1
}, gE = (e) => {
  var t;
  let {
    activeIndex: n,
    activeNodeRect: r,
    index: i,
    rects: o,
    overIndex: s
  } = e;
  const l = (t = o[n]) != null ? t : r;
  if (!l)
    return null;
  if (i === n) {
    const u = o[s];
    return u ? {
      x: 0,
      y: n < s ? u.top + u.height - (l.top + l.height) : u.top - l.top,
      ...bi
    } : null;
  }
  const c = yE(o, i, n);
  return i > n && i <= s ? {
    x: 0,
    y: -l.height - c,
    ...bi
  } : i < n && i >= s ? {
    x: 0,
    y: l.height + c,
    ...bi
  } : {
    x: 0,
    y: 0,
    ...bi
  };
};
function yE(e, t, n) {
  const r = e[t], i = e[t - 1], o = e[t + 1];
  return r ? n < t ? i ? r.top - (i.top + i.height) : o ? o.top - (r.top + r.height) : 0 : o ? o.top - (r.top + r.height) : i ? r.top - (i.top + i.height) : 0 : 0;
}
const _u = "Sortable", Nu = /* @__PURE__ */ Le.createContext({
  activeIndex: -1,
  containerId: _u,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: vu,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function TE(e) {
  let {
    children: t,
    id: n,
    items: r,
    strategy: i = vu,
    disabled: o = !1
  } = e;
  const {
    active: s,
    dragOverlay: l,
    droppableRects: c,
    over: u,
    measureDroppableContainers: p
  } = pE(), d = mi(_u, n), f = l.rect !== null, h = Z(() => r.map((R) => typeof R == "object" && "id" in R ? R.id : R), [r]), g = s != null, C = s ? h.indexOf(s.id) : -1, y = u ? h.indexOf(u.id) : -1, I = Te(h), O = !xE(h, I.current), S = y !== -1 && C === -1 || O, N = CE(o);
  cn(() => {
    O && g && p(h);
  }, [O, h, g, p]), q(() => {
    I.current = h;
  }, [h]);
  const _ = Z(
    () => ({
      activeIndex: C,
      containerId: d,
      disabled: N,
      disableTransforms: S,
      items: h,
      overIndex: y,
      useDragOverlay: f,
      sortedRects: EE(h, c),
      strategy: i
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [C, d, N.draggable, N.droppable, S, h, y, c, f, i]
  );
  return Le.createElement(Nu.Provider, {
    value: _
  }, t);
}
const SE = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: r,
    overIndex: i
  } = e;
  return Fa(n, r, i).indexOf(t);
}, IE = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: r,
    index: i,
    items: o,
    newIndex: s,
    previousItems: l,
    previousContainerId: c,
    transition: u
  } = e;
  return !u || !r || l !== o && i === s ? !1 : n ? !0 : s !== i && t === c;
}, AE = {
  duration: 200,
  easing: "ease"
}, wu = "transform", bE = /* @__PURE__ */ ei.Transition.toString({
  property: wu,
  duration: 0,
  easing: "linear"
}), RE = {
  roleDescription: "sortable"
};
function OE(e) {
  let {
    disabled: t,
    index: n,
    node: r,
    rect: i
  } = e;
  const [o, s] = K(null), l = Te(n);
  return cn(() => {
    if (!t && n !== l.current && r.current) {
      const c = i.current;
      if (c) {
        const u = Ir(r.current, {
          ignoreTransform: !0
        }), p = {
          x: c.left - u.left,
          y: c.top - u.top,
          scaleX: c.width / u.width,
          scaleY: c.height / u.height
        };
        (p.x || p.y) && s(p);
      }
    }
    n !== l.current && (l.current = n);
  }, [t, n, r, i]), q(() => {
    o && s(null);
  }, [o]), o;
}
function DE(e) {
  let {
    animateLayoutChanges: t = IE,
    attributes: n,
    disabled: r,
    data: i,
    getNewIndex: o = SE,
    id: s,
    strategy: l,
    resizeObserverConfig: c,
    transition: u = AE
  } = e;
  const {
    items: p,
    containerId: d,
    activeIndex: f,
    disabled: h,
    disableTransforms: g,
    sortedRects: C,
    overIndex: y,
    useDragOverlay: I,
    strategy: O
  } = je(Nu), S = vE(r, h), N = p.indexOf(s), _ = Z(() => ({
    sortable: {
      containerId: d,
      index: N,
      items: p
    },
    ...i
  }), [d, i, N, p]), R = Z(() => p.slice(p.indexOf(s)), [p, s]), {
    rect: P,
    node: U,
    isOver: M,
    setNodeRef: w
  } = mE({
    id: s,
    data: _,
    disabled: S.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: R,
      ...c
    }
  }), {
    active: V,
    activatorEvent: L,
    activeNodeRect: te,
    attributes: $,
    setNodeRef: v,
    listeners: J,
    isDragging: j,
    over: ee,
    setActivatorNodeRef: Q,
    transform: x
  } = dE({
    id: s,
    data: _,
    attributes: {
      ...RE,
      ...n
    },
    disabled: S.draggable
  }), Y = Gf(w, v), k = !!V, T = k && !g && Ai(f) && Ai(y), re = !I && j, b = re && T ? x : null, me = T ? b ?? (l ?? O)({
    rects: C,
    activeNodeRect: te,
    activeIndex: f,
    overIndex: y,
    index: N
  }) : null, ae = Ai(f) && Ai(y) ? o({
    id: s,
    items: p,
    activeIndex: f,
    overIndex: y
  }) : N, le = V == null ? void 0 : V.id, de = Te({
    activeId: le,
    items: p,
    newIndex: ae,
    containerId: d
  }), $e = p !== de.current.items, we = t({
    active: V,
    containerId: d,
    isDragging: j,
    isSorting: k,
    id: s,
    index: N,
    items: p,
    newIndex: de.current.newIndex,
    previousItems: de.current.items,
    previousContainerId: de.current.containerId,
    transition: u,
    wasDragging: de.current.activeId != null
  }), At = OE({
    disabled: !we,
    index: N,
    node: U,
    rect: P
  });
  return q(() => {
    k && de.current.newIndex !== ae && (de.current.newIndex = ae), d !== de.current.containerId && (de.current.containerId = d), p !== de.current.items && (de.current.items = p);
  }, [k, ae, d, p]), q(() => {
    if (le === de.current.activeId)
      return;
    if (le != null && de.current.activeId == null) {
      de.current.activeId = le;
      return;
    }
    const ot = setTimeout(() => {
      de.current.activeId = le;
    }, 50);
    return () => clearTimeout(ot);
  }, [le]), {
    active: V,
    activeIndex: f,
    attributes: $,
    data: _,
    rect: P,
    index: N,
    newIndex: ae,
    items: p,
    isOver: M,
    isSorting: k,
    isDragging: j,
    listeners: J,
    node: U,
    overIndex: y,
    over: ee,
    setNodeRef: Y,
    setActivatorNodeRef: Q,
    setDroppableNodeRef: w,
    setDraggableNodeRef: v,
    transform: At ?? me,
    transition: qe()
  };
  function qe() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      At || // Or to prevent items jumping to back to their "new" position when items change
      $e && de.current.newIndex === N
    )
      return bE;
    if (!(re && !La(L) || !u) && (k || we))
      return ei.Transition.toString({
        ...u,
        property: wu
      });
  }
}
function vE(e, t) {
  var n, r;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e == null ? void 0 : e.draggable) != null ? n : t.draggable,
    droppable: (r = e == null ? void 0 : e.droppable) != null ? r : t.droppable
  };
}
ve.Down, ve.Right, ve.Up, ve.Left;
const _E = ({
  startText: e
}) => /* @__PURE__ */ a.jsx(A, { container: !0, children: /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: e }) }), Pu = pe.div`
  /* background: #ffffff; */
  display: flex;
  font-size: 14px;
  border: 0;
  min-height: 30px;
  justify-content: space-between;
  line-height: 30px;
  // margin-bottom: 10px;
`;
pe(Be)`
  &.button-component {
    padding-top: 0;
    padding-bottom: 0;
  }
  &.button-component-icon {
    padding: 2px;
    min-width: 0;
    height: 20px;
    width: 20px;
    margin-left: 6px;
    /* width: 26px; */
  }
`;
const NE = pe.div`
  display: inline-block;
  margin-right: 6px;
  // margin-bottom: 6px;
`;
pe.div`
  & > *:not(:last-of-type) {
    margin-right: -1px;
  }
  & > *:hover {
    z-index: 2;
  }
`;
const ju = pe("div", {
  shouldForwardProp: (e) => e !== "isGroup"
})`
  align-items: center;
  display: flex;
  border-radius: 2px;
  flex-grow: 1;
  font-size: 14px;
  padding: ${({ isGroup: e }) => e ? "0" : "2px"};

  &:hover {
    background-color: ${({ theme: e, isGroup: t }) => t ? "#ffffff" : e.palette.backgroundColor.light};
  }
`, Lu = pe("div", {
  shouldForwardProp: (e) => e !== "isGroup"
})`
  align-self: flex-start;
  padding-left: 12px;
  line-height: ${({ isGroup: e }) => e ? 30 : 34}px;
`, fo = pe.div``, mo = pe.div`
  margin-left: 5px;
  span {
    margin-right: 5px;
  }
`;
pe.div`
  margin-left: 5px;
  font-size: 14px;
  font-weight: 500;
  padding-top: 1px;
`;
const wE = pe.div`
  font-size: 14px;
  font-weight: 700;
  margin-left: 5px;
  cursor: ${({ existConceptSet: e }) => e ? "pointer" : "default"};
`, ku = Ze(
  (e) => {
    const { id: t, startText: n, range: r, value: i, updateAttribute: o, viewMode: s } = e, [l, c] = K({
      Op: (i == null ? void 0 : i.Op) || ye.LESS_THAN,
      Value: (r ? i == null ? void 0 : i.StartDate : i == null ? void 0 : i.Value) || null,
      Extent: (r ? i == null ? void 0 : i.EndDate : i == null ? void 0 : i.Extent) || null
    }), { Op: u, Value: p, Extent: d } = l;
    return q(() => {
      const f = {
        Op: l.Op,
        Value: l.Value
      };
      (u === ye.BETWEEN || u === ye.NOT_BETWEEN) && (f.Extent = l.Extent), (f.Extent === null || u !== ye.BETWEEN && u !== ye.NOT_BETWEEN) && delete f.Extent, f.Value === null && delete f.Value, r && delete f.Op, Pe(f, i) || o(t, r ? {
        StartDate: p,
        EndDate: d
      } : f);
    }, [l]), /* @__PURE__ */ a.jsxs(A, { container: !0, alignItems: "center", className: "attribute-date", children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, minWidth: s ? 0 : 175, mr: s ? 0 : 1, children: n }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: s ? /* @__PURE__ */ a.jsxs(mo, { children: [
        /* @__PURE__ */ a.jsx("span", { children: ks.find((f) => f.value === u).name }),
        /* @__PURE__ */ a.jsx("span", { children: Ns(p) }),
        (u === ye.BETWEEN || u === ye.NOT_BETWEEN) && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsx("span", { children: "and" }),
          /* @__PURE__ */ a.jsx("span", { children: Ns(d) })
        ] })
      ] }) : /* @__PURE__ */ a.jsx(fo, { children: r ? /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 1, alignItems: "center", children: [
        /* @__PURE__ */ a.jsx(A, { item: !0, children: "starting:" }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
          rr,
          {
            fullWidth: !1,
            value: p,
            format: $t.DATEPICKER_DATE,
            onChange: (f) => {
              c({
                ...l,
                Value: ir(f, $t.ISO_DATE)
              });
            },
            name: "dateAttrPickerStart"
          }
        ) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: "and ending:" }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
          rr,
          {
            fullWidth: !1,
            value: d,
            format: $t.DATEPICKER_DATE,
            onChange: (f) => {
              c({
                ...l,
                Extent: ir(f, $t.ISO_DATE)
              });
            },
            name: "dateAttrPickerEnd"
          }
        ) })
      ] }) : /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 1, alignItems: "center", children: [
        /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
          It,
          {
            className: "",
            fullWidth: !1,
            options: ks,
            value: u,
            placeholder: "Select option...",
            onChange: (f) => c({ ...l, Op: f }),
            name: "dateAttrSelect"
          }
        ) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
          rr,
          {
            fullWidth: !1,
            value: p,
            format: $t.DATEPICKER_DATE,
            onChange: (f) => {
              c({
                ...l,
                Value: ir(f, $t.ISO_DATE)
              });
            },
            name: "dateAttrPicker"
          }
        ) }),
        (u === ye.BETWEEN || u === ye.NOT_BETWEEN) && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsx(A, { item: !0, children: "and" }),
          /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
            rr,
            {
              fullWidth: !1,
              value: d,
              format: $t.DATEPICKER_DATE,
              onChange: (f) => {
                c({
                  ...l,
                  Extent: ir(f, $t.ISO_DATE)
                });
              },
              name: "dateAttrPickerBetween"
            }
          ) })
        ] })
      ] }) }) })
    ] });
  }
), rl = (e, t) => Object.prototype.hasOwnProperty.call(e, t), PE = (e) => {
  if (!e)
    return "none";
  const t = !!(e.referenceId || e.versionId || e.currentVersionId);
  return !t && !e.terminated ? "none" : e.terminated || t && !e.currentVersionId ? "archived" : e.versionId && e.currentVersionId && e.currentVersionId !== e.versionId ? "outdated" : "none";
}, jE = (e) => {
  var t, n;
  return (e == null ? void 0 : e.ordinal) ?? ((t = e == null ? void 0 : e.data) == null ? void 0 : t.versionOrdinal) ?? ((n = e == null ? void 0 : e.data) == null ? void 0 : n.version) ?? (e == null ? void 0 : e.versionOrdinal) ?? (e == null ? void 0 : e.version) ?? null;
}, Nr = ({ label: e, color: t, icon: n }) => {
  const r = {
    warning: {
      backgroundColor: "#fff1dd",
      color: "#f2a53a"
    },
    info: {
      backgroundColor: "#d6eafb",
      color: "#64a7df"
    },
    default: {
      backgroundColor: "#dfdfdf",
      color: "#8f8f8f"
    }
  };
  return /* @__PURE__ */ a.jsxs(
    W,
    {
      display: "inline-flex",
      alignItems: "center",
      px: 1.25,
      height: 26,
      borderRadius: 1,
      sx: {
        ...r[t],
        lineHeight: 1
      },
      children: [
        n,
        /* @__PURE__ */ a.jsx(fe, { component: "span", fontSize: 14, sx: { lineHeight: 1 }, children: e })
      ]
    }
  );
}, il = /* @__PURE__ */ a.jsx(
  W,
  {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    mr: 0.75,
    width: 16,
    height: 16,
    borderRadius: "50%",
    sx: {
      border: "2px solid currentColor"
    },
    children: /* @__PURE__ */ a.jsx(
      ge,
      {
        iconName: "info",
        sx: {
          color: "inherit",
          fontSize: 16,
          "& circle": {
            fill: "transparent",
            fillOpacity: 1
          }
        }
      }
    )
  }
), LE = /* @__PURE__ */ a.jsx(ge, { iconName: "reload", sx: { color: "inherit", fontSize: 16, mr: 0.75 } }), kE = /* @__PURE__ */ a.jsx(pt, { size: 16, sx: { color: "inherit", mr: 0.75 } }), Hn = ({
  conceptSet: e,
  viewMode: t = !1,
  onRefresh: n,
  showRefreshOnHover: r = !0,
  marginLeft: i = 1.5
}) => {
  const o = Z(() => PE(e), [e]), [s, l] = K(null), [c, u] = K(!1), [p, d] = K(!1);
  if (q(() => {
    let S = !0;
    return (o === "outdated" || o === "archived") && ((e == null ? void 0 : e.versionOrdinal) === void 0 || (e == null ? void 0 : e.versionOrdinal) === null) && ((e == null ? void 0 : e.version) === void 0 || (e == null ? void 0 : e.version) === null) && (e != null && e.versionId) && lu(e.versionId).then((N) => {
      const _ = jE(N);
      S && _ !== null && l(_);
    }).catch(() => {
    }), () => {
      S = !1;
    };
  }, [
    e == null ? void 0 : e.version,
    e == null ? void 0 : e.versionId,
    e == null ? void 0 : e.versionOrdinal,
    o
  ]), q(() => {
    p && d(!1);
  }, [e == null ? void 0 : e.id, e == null ? void 0 : e.versionId, e == null ? void 0 : e.currentVersionId]), !e || o === "none" || o === "outdated" && p)
    return null;
  const f = e.versionOrdinal ?? e.version ?? s, h = f != null, g = !!(!t && o === "outdated" && n && e.currentVersionId), C = e.currentVersionOrdinal, y = /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    "Newer version exists",
    C != null ? ` (latest version: ${C})` : "",
    ",",
    /* @__PURE__ */ a.jsx("br", {}),
    " would you like to REFRESH it?"
  ] }), I = (S) => {
    S.preventDefault(), S.stopPropagation();
  }, O = async (S) => {
    if (S.preventDefault(), S.stopPropagation(), !c) {
      u(!0);
      try {
        await (n == null ? void 0 : n(e)), d(!0);
      } finally {
        u(!1);
      }
    }
  };
  return /* @__PURE__ */ a.jsxs(
    W,
    {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      ml: i,
      sx: {
        whiteSpace: "nowrap",
        alignSelf: "center",
        lineHeight: 1
      },
      children: [
        h && /* @__PURE__ */ a.jsxs(
          fe,
          {
            variant: "subtitle1",
            component: "i",
            sx: { mr: 2, fontWeight: 400, whiteSpace: "nowrap" },
            children: [
              "( Version: ",
              f,
              " )"
            ]
          }
        ),
        o === "archived" && /* @__PURE__ */ a.jsx(
          Nr,
          {
            color: "default",
            label: "Archived",
            icon: /* @__PURE__ */ a.jsx(
              ge,
              {
                iconName: "terminated",
                sx: { color: "inherit", fontSize: 16, mr: 0.75 }
              }
            )
          }
        ),
        o === "outdated" && (c ? /* @__PURE__ */ a.jsx(Nr, { color: "info", label: "Refreshing", icon: kE }) : g ? /* @__PURE__ */ a.jsx(We, { text: y, children: /* @__PURE__ */ a.jsxs(
          W,
          {
            role: "button",
            tabIndex: 0,
            onClick: O,
            onKeyDown: (S) => {
              (S.key === "Enter" || S.key === " ") && O(S);
            },
            onMouseDown: I,
            onPointerDown: I,
            onTouchStart: I,
            sx: {
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              lineHeight: 1,
              ...r ? {
                ".refresh-chip": {
                  display: "none"
                },
                "&:hover": {
                  ".outdated-chip": {
                    display: "none"
                  },
                  ".refresh-chip": {
                    display: "inline-flex"
                  }
                }
              } : {}
            },
            children: [
              /* @__PURE__ */ a.jsx(W, { className: "outdated-chip", sx: { display: "inline-flex" }, children: /* @__PURE__ */ a.jsx(
                Nr,
                {
                  color: "warning",
                  label: "Outdated",
                  icon: il
                }
              ) }),
              r && /* @__PURE__ */ a.jsx(W, { className: "refresh-chip", sx: { display: "inline-flex" }, children: /* @__PURE__ */ a.jsx(
                Nr,
                {
                  color: "info",
                  label: "Refresh",
                  icon: LE
                }
              ) })
            ]
          }
        ) }) : /* @__PURE__ */ a.jsx(Nr, { color: "warning", label: "Outdated", icon: il }))
      ]
    }
  );
}, ME = (e) => {
  const {
    startText: t,
    defaultTitle: n,
    updateAttribute: r,
    value: i,
    subModules: o,
    conceptSets: s,
    typeContainer: l,
    parentId: c,
    updateConceptSets: u,
    refreshConceptSetReference: p,
    embeddedReferenceOnly: d,
    viewMode: f,
    isExclusion: h,
    id: g
  } = e, C = d || l === Ee.LIBRARY, y = ($) => typeof $ == "number" ? $ >= 0 : $.trim() !== "" && $ !== "-1", I = ($) => {
    if (!Oo($))
      return typeof $ == "number" ? $ >= 0 ? $ : -1 : C && typeof $ == "string" && $.trim() ? $ : -1;
    const v = $;
    return typeof v.CodesetId == "number" ? v.CodesetId : typeof v.codesetId == "number" ? v.codesetId : C && typeof v.CodesetId == "string" ? v.CodesetId.trim() ? v.CodesetId : -1 : C && typeof v.codesetId == "string" && v.codesetId.trim() ? v.codesetId : -1;
  }, O = ($) => {
    if (!Oo($))
      return !1;
    const v = $;
    return typeof v.isExclusion == "boolean" ? v.isExclusion : typeof v.IsExclusion == "boolean" ? v.IsExclusion : !1;
  }, { openModal: S, closeModal: N } = je(En), [_, R] = K(
    I(i)
  ), [P, U] = K(O(i)), M = Wi(_, s), w = () => {
    S(
      () => /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
        o.concept,
        {
          type: "component",
          name: "view-concept-set-button",
          subModules: o,
          config: {
            conceptSets: s,
            conceptSetId: _
          }
        }
      ) }),
      "View concept set",
      {
        closeOnClickOutside: !0,
        onClose: N,
        width: "1000px"
      }
    );
  };
  q(() => {
    const $ = I(i), v = O(i);
    if (h) {
      if (!y(_)) {
        i !== null && r(g, null);
        return;
      }
      ($ !== _ || v !== P || !Oo(i)) && r(g, {
        CodesetId: _,
        IsExclusion: !!P
      });
    } else
      $ !== _ && r(g, _);
  }, [_, P]);
  const V = () => {
    R(-1);
  }, L = ($, v) => {
    R($.id ?? -1), v && u([...s, $]);
  }, te = () => {
    U(!P);
  };
  return /* @__PURE__ */ a.jsxs(A, { container: !0, alignItems: "center", className: "attribute-dropdown", children: [
    /* @__PURE__ */ a.jsx(A, { item: !0, minWidth: f ? 0 : 175, mr: f ? 0 : 1, children: t }),
    h && !f && /* @__PURE__ */ a.jsx(A, { item: !0, mr: 1, children: /* @__PURE__ */ a.jsx(
      Be,
      {
        onClick: te,
        fullWidth: !1,
        variant: "outlined",
        name: "exclude",
        children: P ? "is not any of" : "is any of"
      }
    ) }),
    /* @__PURE__ */ a.jsx(A, { item: !0, children: f ? /* @__PURE__ */ a.jsxs(W, { display: "flex", alignItems: "center", flexWrap: "nowrap", children: [
      /* @__PURE__ */ a.jsx(
        wE,
        {
          existConceptSet: y(_),
          onClick: y(_) ? w : () => {
          },
          children: y(_) ? M == null ? void 0 : M.name : n
        }
      ),
      /* @__PURE__ */ a.jsx(
        Hn,
        {
          conceptSet: M,
          viewMode: f,
          onRefresh: p
        }
      )
    ] }) : /* @__PURE__ */ a.jsxs(W, { display: "flex", alignItems: "center", flexWrap: "nowrap", children: [
      /* @__PURE__ */ a.jsx(
        o.concept,
        {
          type: "component",
          name: "widget-concept-set-choose-button",
          subModules: o,
          config: {
            conceptSets: s,
            defaultValue: n,
            conceptSetId: _,
            onUpdate: L,
            onClear: V,
            typeContainer: l,
            parentId: c,
            localImport: !0,
            embeddedReferenceOnly: d,
            dense: !1
          }
        }
      ),
      /* @__PURE__ */ a.jsx(
        Hn,
        {
          conceptSet: M,
          viewMode: f,
          onRefresh: p
        }
      )
    ] }) })
  ] });
}, VE = (e) => {
  const {
    updateAttribute: t,
    value: n,
    subModules: r,
    conceptSets: i,
    updateConceptSets: o,
    viewMode: s,
    typeContainer: l,
    parentId: c,
    id: u,
    criteriaName: p,
    conceptSetName: d,
    refreshConceptSetReference: f,
    embeddedReferenceOnly: h
  } = e, g = (C) => {
    t(u, C);
  };
  return /* @__PURE__ */ a.jsx(
    Ar,
    {
      extend: !0,
      subModules: r,
      value: n,
      conceptSets: i,
      updateConceptSets: o,
      updateModel: g,
      viewMode: s,
      typeContainer: l,
      parentId: c,
      attrGroup: !0,
      groupTitleText: `Group criteria of ${p}`,
      hasAction: !s,
      conceptSetName: d,
      refreshConceptSetReference: f,
      embeddedReferenceOnly: h
    }
  );
}, UE = (e) => {
  const { id: t, startText: n, value: r, updateAttribute: i, viewMode: o, defaultOp: s } = e, [l, c] = K({
    Op: (r == null ? void 0 : r.Op) || s || hn.CONTAINING,
    Text: (r == null ? void 0 : r.Text) || null
  }), { Op: u, Text: p } = l;
  return q(() => {
    const d = {
      Op: l.Op,
      Text: l.Text
    };
    d.Text === null && delete d.Text, Pe(d, r) || i(t, d);
  }, [l]), /* @__PURE__ */ a.jsxs(A, { container: !0, alignItems: "center", className: "attribute-text", children: [
    /* @__PURE__ */ a.jsx(A, { item: !0, minWidth: o ? 0 : 175, mr: o ? 0 : 1, children: n }),
    /* @__PURE__ */ a.jsx(A, { item: !0, children: o ? /* @__PURE__ */ a.jsxs(mo, { children: [
      /* @__PURE__ */ a.jsx("span", { children: Vs.find((d) => d.value === u).name }),
      /* @__PURE__ */ a.jsx("span", { children: p })
    ] }) : /* @__PURE__ */ a.jsx(fo, { children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 1, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        It,
        {
          className: "",
          options: Vs,
          value: u,
          placeholder: "Select option...",
          onChange: (d) => c({ ...l, Op: d }),
          fullWidth: !0,
          name: "textAttrSelect"
        }
      ) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        Ye,
        {
          type: "text",
          fullWidth: !0,
          value: p,
          onChange: (d) => c({ ...l, Text: d.target.value }),
          name: "textAttrInput"
        }
      ) })
    ] }) }) })
  ] });
}, Ba = (e) => {
  const {
    id: t,
    startText: n,
    value: r,
    updateAttribute: i,
    viewMode: o,
    endText: s,
    defaultOp: l
  } = e, c = r || {}, [u, p] = K({
    Op: c.Op || l || ye.GREATER_THAN,
    Value: c.Value != null && +c.Value >= 0 ? +c.Value : null,
    Extent: c.Extent != null && +c.Extent >= 0 ? +c.Extent : null
  }), { Op: d, Value: f, Extent: h } = u;
  return q(() => {
    const g = {
      Op: u.Op,
      Value: u.Value != null && +(u == null ? void 0 : u.Value) >= 0 ? +(u == null ? void 0 : u.Value) : null,
      Extent: (u == null ? void 0 : u.Extent) != null && +(u == null ? void 0 : u.Extent) >= 0 ? +(u == null ? void 0 : u.Extent) : null
    };
    (g.Extent === null || d !== ye.BETWEEN && d !== ye.NOT_BETWEEN) && delete g.Extent, g.Value === null && delete g.Value, Pe(g, r) || i(t, g);
  }, [u]), /* @__PURE__ */ a.jsxs(A, { container: !0, alignItems: "center", className: "attribute-value", children: [
    /* @__PURE__ */ a.jsx(A, { item: !0, minWidth: o ? 0 : 175, mr: o ? 0 : 1, children: n }),
    /* @__PURE__ */ a.jsx(A, { item: !0, children: o ? /* @__PURE__ */ a.jsxs(mo, { children: [
      /* @__PURE__ */ a.jsx("span", { children: Ms.find((g) => g.value === d).name }),
      /* @__PURE__ */ a.jsx("span", { children: f }),
      (d === ye.BETWEEN || d === ye.NOT_BETWEEN) && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx("span", { children: "and" }),
        /* @__PURE__ */ a.jsx("span", { children: h }),
        s && /* @__PURE__ */ a.jsx("span", { children: "days" })
      ] })
    ] }) : /* @__PURE__ */ a.jsx(fo, { children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 1, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        It,
        {
          className: "valueAttrSelect",
          options: Ms,
          value: d,
          placeholder: "Select option...",
          onChange: (g) => p({
            ...u,
            Op: g,
            Extent: [
              ye.BETWEEN,
              ye.NOT_BETWEEN
            ].includes(g) ? 1 : null
          }),
          name: "valueAttrSelect",
          id: "valueAttrSelect" + t
        }
      ) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        Ye,
        {
          type: "text",
          value: f,
          onChange: (g) => p({ ...u, Value: g.target.value }),
          name: "valueAttrText",
          id: "valueAttrText" + t,
          className: "valueAttrText"
        }
      ) }),
      (d === ye.BETWEEN || d === ye.NOT_BETWEEN) && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx(A, { item: !0, children: "and" }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
          Ye,
          {
            type: "text",
            value: h,
            onChange: (g) => p({ ...u, Extent: g.target.value }),
            name: "valueAttrExtent",
            id: "valueAttrExtent" + t,
            className: "valueAttrExtent"
          }
        ) })
      ] }),
      s && /* @__PURE__ */ a.jsx(A, { item: !0, children: "days" })
    ] }) }) })
  ] });
}, FE = (e) => {
  const {
    name: t,
    startText: n,
    extend: r,
    domainId: i,
    standardConcept: o,
    value: s,
    updateAttribute: l,
    subModules: c,
    viewMode: u,
    id: p
  } = e, d = s || [], [f, h] = K(
    (r && d.baseValue ? d.baseValue : d) || []
  ), [g, C] = K(
    r ? d[`${p}Exclude`] || !1 : void 0
  );
  q(() => {
    if (r) {
      const S = d.baseValue || d;
      (!Pe(S, f) || g != d[`${p}Exclude`]) && l(p, {
        baseValue: f,
        [`${p}Exclude`]: g
      });
    } else
      Pe(s, f) || l(p, f);
  }, [f, g]);
  const y = () => {
    C(!g);
  }, I = (S) => {
    const N = f.filter(
      (_) => _.CONCEPT_ID !== S.CONCEPT_ID
    );
    h(N);
  }, O = (S) => {
    h((N) => lh(N, S, "CONCEPT_ID"));
  };
  return /* @__PURE__ */ a.jsxs(
    A,
    {
      container: !0,
      spacing: 1,
      alignItems: "center",
      className: "attribute-vocabulary",
      children: [
        /* @__PURE__ */ a.jsx(
          A,
          {
            item: !0,
            minWidth: u ? 0 : 175,
            mr: u ? 0 : 1,
            className: "start-text",
            children: n
          }
        ),
        r && !u && /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
          Be,
          {
            onClick: y,
            fullWidth: !1,
            variant: "outlined",
            name: "exclude",
            children: g ? "is not any of" : "is any of"
          }
        ) }),
        u ? f.map((S, N) => /* @__PURE__ */ a.jsxs(A, { item: !0, fontWeight: "bold", children: [
          S.CONCEPT_NAME,
          N !== f.length - 1 ? ", " : ""
        ] }, S.CONCEPT_ID)) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          f.length > 0 && /* @__PURE__ */ a.jsx(A, { item: !0, children: f.map((S) => /* @__PURE__ */ a.jsx(NE, { children: /* @__PURE__ */ a.jsx(
            $p,
            {
              label: S.CONCEPT_NAME,
              variant: "outlined",
              color: "primary",
              classes: {
                root: "chip",
                outlined: "chip-outlined",
                deleteIcon: "chip-delete-outlined"
              },
              deleteIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "close", sx: { fontSize: 14 } }),
              onDelete: u ? void 0 : () => I(S)
            }
          ) }, S.CONCEPT_ID)) }),
          /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
            c.vocabulary,
            {
              type: "component",
              name: "add-import-concepts-widget",
              subModules: c,
              config: {
                domainId: i,
                standardConcept: o,
                onAddConcepts: O
              }
            }
          ) })
        ] })
      ]
    }
  );
}, BE = (e) => {
  const { id: t, startText: n, value: r, updateAttribute: i, viewMode: o } = e, [s, l] = K({
    EndOffset: (r == null ? void 0 : r.EndOffset) || 0,
    EndWith: (r == null ? void 0 : r.EndWith) || "END_DATE",
    StartOffset: (r == null ? void 0 : r.StartOffset) || 0,
    StartWith: (r == null ? void 0 : r.StartWith) || "START_DATE"
  });
  return q(() => {
    Pe(s, r) || i(t, s);
  }, [s]), /* @__PURE__ */ a.jsxs(A, { container: !0, alignItems: "center", className: "attribute-range", children: [
    /* @__PURE__ */ a.jsx(A, { item: !0, minWidth: o ? 0 : 175, mr: o ? 0 : 1, children: n }),
    /* @__PURE__ */ a.jsx(A, { item: !0, children: o ? /* @__PURE__ */ a.jsx(mo, {}) : /* @__PURE__ */ a.jsx(fo, { children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 1, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, children: "starting with" }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        It,
        {
          className: "StartWith",
          options: Us,
          value: s.StartWith,
          placeholder: "Select option...",
          onChange: (c) => l({ ...s, StartWith: c }),
          name: "StartWith",
          id: "StartWith" + t
        }
      ) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: "+" }),
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 2, children: /* @__PURE__ */ a.jsx(
        Ye,
        {
          type: "text",
          value: s.StartOffset,
          onChange: (c) => l({ ...s, StartOffset: +c.target.value }),
          name: "StartOffset",
          id: "StartOffset" + t,
          className: "valueAttrText"
        }
      ) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: "days" }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: "and" }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: "ending with" }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        It,
        {
          className: "EndWith",
          options: Us,
          value: s.EndWith,
          placeholder: "Select option...",
          onChange: (c) => l({ ...s, EndWith: c }),
          name: "EndWith",
          id: "EndWith" + t
        }
      ) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: "+" }),
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 2, children: /* @__PURE__ */ a.jsx(
        Ye,
        {
          type: "text",
          value: s.EndOffset,
          onChange: (c) => l({ ...s, EndOffset: +c.target.value }),
          name: "EndOffset",
          id: "EndOffset" + t,
          className: "valueAttrText"
        }
      ) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: "days" })
    ] }) }) })
  ] });
}, $E = {
  "Observation period:": [
    "First",
    "PeriodStartDate",
    "PeriodEndDate",
    "AgeAtStart",
    "AgeAtEnd"
  ],
  "Payer plan period:": ["AgeAtStart", "AgeAtEnd"],
  "Observation:": ["VisitType"],
  "Procedure occurrence:": ["VisitType"],
  "Condition Occurrence:": ["VisitType"],
  "Device Exposure:": ["VisitType"],
  "Drug Exposure:": ["VisitType"],
  "Measurement:": ["VisitType"]
}, GE = {
  "Observation:": ["VisitType"],
  "Procedure occurrence:": ["VisitType"],
  "Visit:": [],
  "Condition Occurrence:": ["VisitType"],
  "Device Exposure:": ["VisitType"],
  "Drug Exposure:": ["VisitType"],
  "Measurement:": ["VisitType"]
}, Ri = (e, t) => {
  const n = $E[e];
  return n ? !!n.includes(t) : !1;
}, zE = (e, t) => {
  const n = GE[e];
  return n ? !n.includes(t) : !0;
}, WE = Ze((e) => {
  const {
    attribute: t,
    details: n,
    subModules: r,
    updateAttribute: i,
    conceptSets: o,
    updateConceptSets: s,
    refreshConceptSetReference: l,
    embeddedReferenceOnly: c,
    removeAttribute: u,
    viewMode: p,
    typeContainer: d,
    parentId: f,
    criteriaName: h,
    conceptSetName: g
  } = e, { id: C, name: y, value: I } = t, {
    type: O,
    startText: S,
    domainId: N,
    standardConcept: _,
    extend: R,
    defaultParam: P,
    range: U,
    endText: M,
    altStartText: w,
    defaultOp: V,
    isExclusion: L
  } = n;
  return /* @__PURE__ */ a.jsxs(Pu, { children: [
    /* @__PURE__ */ a.jsxs(
      ju,
      {
        isGroup: n.type === B.GROUP,
        children: [
          n.type === B.BOOL && /* @__PURE__ */ a.jsx(
            _E,
            {
              startText: Ri(h, C) ? w : S
            }
          ),
          n.type === B.RANGE && /* @__PURE__ */ a.jsx(
            BE,
            {
              id: C,
              name: y,
              type: O,
              startText: S,
              value: I,
              subModules: r,
              updateAttribute: i,
              viewMode: p,
              endText: M
            }
          ),
          n.type === B.DATE && /* @__PURE__ */ a.jsx(
            ku,
            {
              id: C,
              name: y,
              type: O,
              startText: Ri(h, C) ? w : S,
              value: I,
              subModules: r,
              updateAttribute: i,
              viewMode: p,
              range: U
            }
          ),
          n.type === B.VALUE && /* @__PURE__ */ a.jsx(
            Ba,
            {
              id: C,
              name: y,
              type: O,
              startText: Ri(h, C) ? w : S,
              value: I,
              subModules: r,
              updateAttribute: i,
              viewMode: p,
              endText: M,
              defaultOp: V
            }
          ),
          n.type === B.TEXT && /* @__PURE__ */ a.jsx(
            UE,
            {
              id: C,
              name: y,
              type: O,
              startText: S,
              value: I,
              subModules: r,
              updateAttribute: i,
              viewMode: p,
              defaultOp: V
            }
          ),
          n.type === B.VOCABULARY && /* @__PURE__ */ a.jsx(
            FE,
            {
              id: C,
              name: y,
              startText: Ri(h, C) ? w : S,
              value: I,
              subModules: r,
              updateAttribute: i,
              domainId: N,
              standardConcept: _,
              viewMode: p,
              extend: R && zE(h, C)
            }
          ),
          n.type === B.DROPDOWN && /* @__PURE__ */ a.jsx(
            ME,
            {
              id: C,
              name: y,
              type: O,
              startText: S,
              value: I,
              subModules: r,
              defaultTitle: P.name,
              updateAttribute: i,
              conceptSets: o,
              updateConceptSets: s,
              refreshConceptSetReference: l,
              embeddedReferenceOnly: c,
              typeContainer: d,
              parentId: f,
              viewMode: p,
              isExclusion: L
            }
          ),
          n.type === B.GROUP && /* @__PURE__ */ a.jsx(
            VE,
            {
              id: C,
              name: y,
              type: O,
              startText: S,
              value: t.value,
              subModules: r,
              updateAttribute: i,
              conceptSets: o,
              updateConceptSets: s,
              refreshConceptSetReference: l,
              typeContainer: d,
              parentId: f,
              viewMode: p,
              criteriaName: h,
              conceptSetName: g,
              embeddedReferenceOnly: c
            }
          )
        ]
      }
    ),
    !p && /* @__PURE__ */ a.jsx(
      Lu,
      {
        isGroup: n.type === B.GROUP,
        children: /* @__PURE__ */ a.jsx(
          Cr,
          {
            size: "small",
            onClick: () => {
              u(C);
            },
            color: "primary",
            iconName: "close",
            noExpand: !0,
            name: "closeCriteriaButton"
          }
        )
      }
    )
  ] });
}), YE = (e, t) => {
  var n;
  switch (e) {
    case B.BOOL:
      return !1;
    case B.DATE:
    case B.VALUE:
      return !t || t.Value === null;
    case B.TEXT:
      return !t || t.Text === null;
    case B.VOCABULARY:
      return !t || t.length === 0 || ((n = t == null ? void 0 : t.baseValue) == null ? void 0 : n.length) === 0;
    case B.DROPDOWN:
      return t === null;
  }
}, HE = (e) => {
  const {
    initialAttributes: t,
    extend: n,
    subModules: r,
    sortBy: i,
    updateModel: o,
    conceptSets: s,
    updateConceptSets: l,
    refreshConceptSetReference: c,
    embeddedReferenceOnly: u,
    viewMode: p,
    addedDropdownAttribute: d,
    typeContainer: f,
    parentId: h,
    criteriaName: g,
    cleanDropdownAttribute: C,
    conceptSetName: y
  } = e, {
    attributes: I,
    isStartHook: O,
    addAttribute: S,
    updateAttribute: N,
    removeAttribute: _
  } = Mh(t);
  return q(() => {
    O && !Pe(I, t) && o(I);
  }, [I]), q(() => {
    d && (S(d), C());
  }, [d]), O ? /* @__PURE__ */ a.jsx(a.Fragment, { children: Object.keys(I).length > 0 && /* @__PURE__ */ a.jsx(
    A,
    {
      item: !0,
      xs: 12,
      sx: {
        borderTop: p && g != "Demographic:" ? "0px dashed" : "1px dashed",
        borderColor: "borderColor.main",
        padding: p ? "0 8px" : 1
      },
      children: /* @__PURE__ */ a.jsx(
        A,
        {
          container: !0,
          spacing: p ? 0 : 0.5,
          className: "cohort-definition-attributes-list",
          children: i == null ? void 0 : i(Object.keys(I)).filter((R) => {
            if (p) {
              const P = I[R], U = mr[P.id];
              return !YE(U.type, P.value);
            } else
              return !0;
          }).map((R) => /* @__PURE__ */ a.jsx(
            A,
            {
              item: !0,
              xs: 12,
              className: "cohort-definition-attributes-item",
              children: /* @__PURE__ */ a.jsx(
                WE,
                {
                  attribute: I[R],
                  details: mr[I[R].id],
                  subModules: r,
                  updateAttribute: N,
                  conceptSets: s,
                  updateConceptSets: l,
                  refreshConceptSetReference: c,
                  embeddedReferenceOnly: u,
                  removeAttribute: _,
                  viewMode: p,
                  typeContainer: f,
                  parentId: h,
                  criteriaName: g,
                  conceptSetName: y
                }
              )
            },
            R
          ))
        }
      )
    }
  ) }) : /* @__PURE__ */ a.jsx(Xt, { children: /* @__PURE__ */ a.jsx(pt, { size: 32 }) });
}, qE = pe.div`
  font-size: 14px;
  margin-right: 8px;
`, XE = pe.div``, Mu = pe.div`
  font-size: 14px;
  font-weight: 700;
  cursor: ${({ existConceptSet: e }) => e ? "pointer" : "default"};
`, JE = pe.div`
  display: flex;
`, $a = ({ sx: e, children: t, className: n, viewMode: r, disableBorder: i, ...o }) => {
  const s = Gp(), l = {
    border: "1px dashed",
    borderColor: "borderColor.main",
    borderRadius: 1,
    transition: "border-color 500ms"
  }, c = {
    border: "1px solid",
    borderColor: "info.main",
    borderRadius: 1,
    transition: "all 500ms",
    boxShadow: "0px 0px 0px 1px " + s.palette.info.main
  }, [u, p] = K(l);
  return /* @__PURE__ */ a.jsx(
    A,
    {
      ...o,
      className: "criteria-content-wrapper " + (n || ""),
      sx: [u, ...Array.isArray(e) ? e : [e]],
      onMouseOver: (d) => {
        d.stopPropagation(), !r && !i && p(c);
      },
      onMouseOut: (d) => {
        d.stopPropagation(), !r && !i && p(l);
      },
      children: t
    }
  );
}, Vu = ({
  viewMode: e,
  onRemove: t,
  iconName: n,
  title: r,
  children: i,
  baseText: o,
  hideRemove: s
}) => /* @__PURE__ */ a.jsx(
  W,
  {
    sx: {
      padding: "6px 8px",
      fontSize: 14,
      // questionable
      bgcolor: o && !r || e ? "transparent" : "backgroundColor.main",
      borderRadius: "inherit"
    },
    className: "criteria-title-wrapper",
    children: /* @__PURE__ */ a.jsxs(A, { container: !0, alignItems: "center", justifyContent: "space-between", children: [
      r && /* @__PURE__ */ a.jsxs(
        A,
        {
          item: !0,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          pr: e ? 0 : 1,
          children: [
            /* @__PURE__ */ a.jsx(
              zp,
              {
                iconName: n,
                sx: { display: "inline-flex", pr: 1, fontSize: 28 }
              }
            ),
            !e && r
          ]
        }
      ),
      o && /* @__PURE__ */ a.jsx(A, { item: !0, display: "flex", alignItems: "center", fontSize: 14, pr: 1, children: o }),
      /* @__PURE__ */ a.jsx(A, { item: !0, flexGrow: 1, children: i }),
      !e && !s && /* @__PURE__ */ a.jsx(A, { item: !0, pl: 1, children: /* @__PURE__ */ a.jsx(
        Cr,
        {
          onClick: t,
          color: "primary",
          iconName: "delete",
          noExpand: !0,
          name: "closeCriteriaButton"
        }
      ) })
    ] })
  }
), ol = Ze((e) => {
  const {
    extend: t,
    criteria: n,
    details: r,
    subModules: i,
    updateCriteriaAttributes: o,
    updateCriteriaCodeSetId: s,
    removeCriteria: l,
    conceptSets: c,
    updateConceptSets: u,
    refreshConceptSetReference: p,
    embeddedReferenceOnly: d,
    typeContainer: f,
    parentId: h,
    viewMode: g,
    attrGroup: C,
    hasAction: y
  } = e, { id: I, codesetId: O } = n, { openModal: S, closeModal: N } = je(En), [_, R] = K(O), [P, U] = K(
    ch(
      n.attributes,
      mr
    )
  ), [M, w] = K(), V = _ != null && _ !== "" && _ !== -1, L = Z(
    () => Wi(_, c),
    [_, c]
  ), te = Z(
    () => L || (V ? {
      id: _,
      name: r.defaultValue,
      expression: { items: [] },
      terminated: !0
    } : void 0),
    [_, r.defaultValue, V, L]
  ), $ = Z(() => Vc(
    r.attributes,
    Yc,
    Object.keys(P)
  ), [r, P]), v = () => {
    R(-1);
  }, J = Z(() => {
    var Y;
    const x = ((Y = Wi(_, c)) == null ? void 0 : Y.name) || r.defaultValue;
    return `${r.baseTextViewMode} ${x}`;
  }, [_, c]), j = (x) => {
    w(x);
  }, ee = (x, Y) => {
    const k = x.id ?? -1;
    R(k), Y && u([...c, x]);
  };
  q(() => {
    O !== _ && R(O);
  }, [O]);
  const Q = () => {
    S(
      () => /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
        i.concept,
        {
          type: "component",
          name: "view-concept-set-button",
          subModules: i,
          config: {
            conceptSets: c,
            conceptSetId: _
          }
        }
      ) }),
      "View concept set",
      {
        closeOnClickOutside: !0,
        onClose: N,
        width: "1000px"
      }
    );
  };
  return q(() => {
    _ !== O && s(I, _);
  }, [_]), q(() => {
    const x = uh(P);
    x && !Pe(x, n.attributes) && o(I, x);
  }, [P]), /* @__PURE__ */ a.jsx(
    A,
    {
      container: !0,
      width: `calc(100% + ${y ? 36 : 0}px)`,
      mb: g && n.name != "Demographic" ? 0 : 1,
      children: /* @__PURE__ */ a.jsxs(
        $a,
        {
          item: !0,
          xs: 12,
          className: "cohort-definition-criteria-item",
          viewMode: n.name != "Demographic" ? g : !1,
          disableBorder: g && n.name === "Demographic",
          sx: g ? n.name != "Demographic" ? {
            border: "none",
            padding: "0px",
            "> .criteria-title-wrapper": {
              padding: "0px 10px"
            }
          } : {} : {},
          children: [
            /* @__PURE__ */ a.jsx(
              Vu,
              {
                viewMode: g,
                iconName: n.name,
                title: !t || !r.extend ? r.titleText : void 0,
                baseText: r.baseText,
                hideRemove: t && n.name != "Demographic",
                onRemove: () => l(n.id),
                children: /* @__PURE__ */ a.jsxs(
                  A,
                  {
                    item: !0,
                    xs: !0,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    lineHeight: "30px",
                    minWidth: 0,
                    children: [
                      g ? /* @__PURE__ */ a.jsxs(
                        W,
                        {
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "nowrap",
                          minWidth: 0,
                          children: [
                            /* @__PURE__ */ a.jsx(
                              Mu,
                              {
                                existConceptSet: V,
                                onClick: L ? Q : () => {
                                },
                                children: V && (L == null ? void 0 : L.name) || r.defaultValue
                              }
                            ),
                            /* @__PURE__ */ a.jsx(
                              Hn,
                              {
                                conceptSet: te,
                                viewMode: g,
                                onRefresh: p
                              }
                            )
                          ]
                        }
                      ) : /* @__PURE__ */ a.jsxs(
                        W,
                        {
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "nowrap",
                          minWidth: 0,
                          children: [
                            /* @__PURE__ */ a.jsx(XE, { children: r.defaultValue && /* @__PURE__ */ a.jsx(
                              i.concept,
                              {
                                type: "component",
                                name: "widget-concept-set-choose-button",
                                subModules: i,
                                config: {
                                  conceptSets: c,
                                  defaultValue: r.defaultValue,
                                  conceptSetId: _,
                                  onUpdate: ee,
                                  onClear: v,
                                  typeContainer: f,
                                  parentId: h,
                                  localImport: !0,
                                  embeddedReferenceOnly: d
                                }
                              }
                            ) }),
                            /* @__PURE__ */ a.jsx(
                              Hn,
                              {
                                conceptSet: te,
                                viewMode: g,
                                onRefresh: p
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ a.jsx(A, { item: !0, children: !g && $.length > 0 && /* @__PURE__ */ a.jsx(
                        Rn,
                        {
                          options: $,
                          onClick: j,
                          variant: "outlined",
                          title: "Attribute",
                          name: "Attribute",
                          closeOnSelect: !0,
                          preventOverflow: !0,
                          startIcon: /* @__PURE__ */ a.jsx(
                            ge,
                            {
                              iconName: "add",
                              sx: { "&.MuiSvgIcon-root": { fontSize: 16 } }
                            }
                          ),
                          endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" })
                        }
                      ) })
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ a.jsx(
              HE,
              {
                initialAttributes: P,
                addedDropdownAttribute: M,
                cleanDropdownAttribute: () => w(void 0),
                subModules: i,
                updateModel: U,
                sortBy: (x) => dh(r.attributesSort, x),
                conceptSets: c,
                updateConceptSets: u,
                refreshConceptSetReference: p,
                embeddedReferenceOnly: d,
                typeContainer: f,
                parentId: h,
                viewMode: g,
                criteriaName: r.titleText,
                conceptSetName: J
              }
            )
          ]
        }
      )
    }
  );
}), st = pe.span`
  // margin: 0 4px;
`, sn = pe.div`
  margin-right: 5px;
  margin-left: 5px;
`, al = pe.label`
  display: flex;
  padding: 0px 6px;
  font-size: 14px;
  white-space: nowrap;
  align-items: center;
  > span {
    margin-right: 10px;
  }
`, QE = pe.div`
  align-self: baseline;
`;
pe.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 10px;
  font-size: 14px;
`;
pe.div`
  padding: 3px;
`;
pe.span`
  margin-left: 7px;
`;
pe.div`
  /* margin-right: 10px; */
`;
const sl = pe.div`
  display: inline-block;
  font-size: 14px;
  /* margin-top: -75px; */
  position: relative;
  top: -7px;
`, KE = pe.div`
  border-radius: 2px;
  padding: 8px;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  /* background-color: ${({ theme: e, isGroup: t }) => e.palette.backgroundColor.dark}; */

  border-radius: 2px;
  padding: ${({ isGroup: e }) => e ? "0" : "4px 10px"};
  font-size: 14px;
  // margin-bottom: 4px;
`, ZE = Ze((e) => {
  const { updateModel: t, type: n, value: r, viewMode: i, first: o } = e, [s, l] = K(r), { IsDistinct: c, Type: u, Count: p, CountColumn: d } = s;
  return q(() => {
    Pe(s, r) || t(s);
  }, [s]), /* @__PURE__ */ a.jsxs(
    A,
    {
      container: !0,
      className: "extend-criteria-occurrence",
      alignItems: "center",
      fontSize: 14,
      spacing: 0.5,
      children: [
        !o && /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(st, { children: n === "ALL" ? "and" : "or" }) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(st, { children: "with" }) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: Ko.find((f) => f.value === u).name }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
          It,
          {
            className: "",
            options: Ko,
            value: u,
            placeholder: "Select criteria type...",
            onChange: (f) => l({ ...s, Type: f }),
            name: "extendCriteriaType"
          }
        ) }) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: p }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
          $i,
          {
            value: p,
            onChange: (f) => l({ ...s, Count: f }),
            options: _h
          }
        ) }) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: c ? /* @__PURE__ */ a.jsx("span", { children: "using distinct" }) : /* @__PURE__ */ a.jsx("span", { children: "using all" }) }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
          Be,
          {
            onClick: () => l({ ...s, IsDistinct: !c }),
            fullWidth: !1,
            variant: "outlined",
            sx: { borderColor: "borderColor.main" },
            name: "isDistinct",
            children: c ? /* @__PURE__ */ a.jsx("span", { children: "using distinct" }) : /* @__PURE__ */ a.jsx("span", { children: "using all" })
          }
        ) }) }),
        c ? /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: Zo.find(
          (f) => f.value === d
        ).name }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
          It,
          {
            className: "",
            options: Zo,
            value: d,
            placeholder: "Select criteria count column...",
            onChange: (f) => l({ ...s, CountColumn: f }),
            fullWidth: !0,
            name: "extendCriteriaCountColumn"
          }
        ) }) }) : /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(st, { children: "occurrences of:" }) })
      ]
    }
  );
}), la = (e) => Object.fromEntries(
  Object.entries(e).filter(([t, n]) => n !== void 0)
), wr = (e) => {
  var n, r, i, o;
  const t = {
    Start: la({
      Coeff: (n = e == null ? void 0 : e.Start) == null ? void 0 : n.Coeff,
      Days: (r = e == null ? void 0 : e.Start) == null ? void 0 : r.Days
    }),
    End: la({
      Coeff: (i = e == null ? void 0 : e.End) == null ? void 0 : i.Coeff,
      Days: (o = e == null ? void 0 : e.End) == null ? void 0 : o.Days
    })
  };
  return (e == null ? void 0 : e.UseEventEnd) !== void 0 && (t.UseEventEnd = e.UseEventEnd), (e == null ? void 0 : e.UseIndexEnd) !== void 0 && (t.UseIndexEnd = e.UseIndexEnd), t;
}, ll = Ze((e) => {
  var f, h, g, C;
  const { updateModel: t, value: n, children: r, viewMode: i } = e, [o, s] = K(
    () => wr(n)
  ), { Start: l, End: c, UseEventEnd: u, UseIndexEnd: p } = o, d = (y, I) => {
    s((O) => {
      const S = wr({
        ...O,
        [y]: la(I)
      });
      return Pe(wr(O), S) ? O : S;
    });
  };
  return q(() => {
    const y = wr(o), I = wr(n);
    Pe(y, I) || t(y);
  }, [o, n, t]), /* @__PURE__ */ a.jsxs(KE, { className: "extend-criteria-start-end-window", children: [
    /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 0.5, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(st, { children: "where" }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: u ? /* @__PURE__ */ a.jsx("span", { children: "event ends" }) : /* @__PURE__ */ a.jsx("span", { children: "event starts" }) }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
        Be,
        {
          onClick: () => s({ ...o, UseEventEnd: !u }),
          fullWidth: !1,
          variant: "outlined",
          name: "useEventEnd",
          sx: { minWidth: 110 },
          children: u ? /* @__PURE__ */ a.jsx("span", { children: "event ends" }) : /* @__PURE__ */ a.jsx("span", { children: "event starts" })
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(st, { children: "between" }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: /* @__PURE__ */ a.jsx("strong", { children: ((f = Ii.find(
        (y) => y.value == `${l.Days}`
      )) == null ? void 0 : f.name) || l.Days }) }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
        $i,
        {
          value: l.Days,
          onChange: (y) => {
            d("Start", {
              ...l,
              Days: y
            });
          },
          options: Ii
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(st, { children: "days" }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: /* @__PURE__ */ a.jsx("strong", { children: (h = or.find((y) => y.value === l.Coeff)) == null ? void 0 : h.name }) }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
        It,
        {
          className: "",
          options: or,
          value: l.Coeff,
          placeholder: "Select option...",
          onChange: (y) => {
            d("Start", { ...l, Coeff: y });
          },
          name: "selectStart"
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(st, { children: "and" }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: /* @__PURE__ */ a.jsx("strong", { children: ((g = Ii.find((y) => y.value == `${c.Days}`)) == null ? void 0 : g.name) || c.Days }) }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
        $i,
        {
          value: c.Days,
          onChange: (y) => {
            d("End", {
              ...c,
              Days: y
            });
          },
          options: Ii
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(st, { children: "days" }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: /* @__PURE__ */ a.jsx("strong", { children: (C = or.find((y) => y.value === c.Coeff)) == null ? void 0 : C.name }) }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
        It,
        {
          className: "",
          options: or,
          value: c.Coeff,
          placeholder: "Select option...",
          onChange: (y) => d("End", { ...c, Coeff: y }),
          name: "selectEnd"
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: i ? /* @__PURE__ */ a.jsx(st, { children: p ? /* @__PURE__ */ a.jsx("span", { children: "index end date" }) : /* @__PURE__ */ a.jsx("span", { children: "index start date" }) }) : /* @__PURE__ */ a.jsx(sn, { children: /* @__PURE__ */ a.jsx(
        Be,
        {
          onClick: () => s({ ...o, UseIndexEnd: !p }),
          fullWidth: !1,
          variant: "outlined",
          name: "indexStartEnd",
          children: p ? /* @__PURE__ */ a.jsx("span", { children: "index end date" }) : /* @__PURE__ */ a.jsx("span", { children: "index start date" })
        }
      ) }) })
    ] }),
    r
  ] });
}), ex = (e, t) => !!(e != null && e.StartWindow) && (t || !!(e != null && e.Occurrence)), tx = Ze((e) => {
  const {
    children: t,
    criteria: n,
    details: r,
    parentConceptSet: i,
    updateExtendOptions: o,
    type: s,
    removeCriteria: l,
    attrGroup: c,
    viewMode: u,
    hiddenParentConcept: p,
    sectionType: d,
    sectionCount: f,
    hasAction: h,
    parentConceptSetName: g,
    hideIgnoreObservationPeriod: C,
    hideOccurrence: y,
    first: I
  } = e, { id: O, extendOptions: S } = n, N = Jc(n.name), _ = !C && Kc(n.name), [R, P] = K({
    Occurrence: (S == null ? void 0 : S.Occurrence) || qc,
    StartWindow: (S == null ? void 0 : S.StartWindow) || ar,
    EndWindow: (S == null ? void 0 : S.EndWindow) || ar,
    IgnoreObservationPeriod: (S == null ? void 0 : S.IgnoreObservationPeriod) ?? (_ ? Qc(n.name) : void 0),
    RestrictVisit: (S == null ? void 0 : S.RestrictVisit) ?? (N ? Xc(n.name) : void 0)
  }), [U, M] = K(
    !!(S != null && S.EndWindow)
  ), w = Te(!0), {
    Occurrence: V,
    StartWindow: L,
    EndWindow: te,
    RestrictVisit: $,
    IgnoreObservationPeriod: v
  } = R;
  q(() => {
    const Q = { ...R }, x = { ...S };
    U || delete Q.EndWindow, (!N || !Q.RestrictVisit) && delete Q.RestrictVisit, (!_ || !Q.IgnoreObservationPeriod) && delete Q.IgnoreObservationPeriod, y && delete Q.Occurrence, !(w.current && (w.current = !1, ex(S, y))) && (Pe(Q, x) || o(Q, O));
  }, [R, U]), q(() => {
    S != null && S.EndWindow && M(!0);
  }, []);
  const J = ie(
    (Q) => {
      P({
        ...R,
        Occurrence: Q
      });
    },
    [R]
  ), j = ie(
    (Q) => {
      P({
        ...R,
        StartWindow: Q
      });
    },
    [R]
  ), ee = ie(
    (Q) => {
      P({
        ...R,
        EndWindow: Q
      });
    },
    [R]
  );
  return /* @__PURE__ */ a.jsxs(
    $a,
    {
      className: "extend-criteria",
      width: `calc(100% + ${h ? "36px" : "0px"})`,
      viewMode: u,
      sx: {
        boxSizing: "border-box",
        "&:not(:last-of-type)": {
          mb: 1
        }
      },
      children: [
        /* @__PURE__ */ a.jsx(
          Vu,
          {
            viewMode: u,
            onRemove: () => l(O),
            iconName: n.name,
            title: r.titleText,
            children: !y && /* @__PURE__ */ a.jsx(
              ZE,
              {
                value: V,
                type: d,
                updateModel: J,
                viewMode: u,
                first: I
              }
            )
          }
        ),
        /* @__PURE__ */ a.jsxs(
          A,
          {
            container: !0,
            p: 1,
            sx: { borderTop: "1px dashed", borderColor: "borderColor.main" },
            children: [
              /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: t }),
              /* @__PURE__ */ a.jsxs(
                A,
                {
                  item: !0,
                  xs: 12,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  children: [
                    /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
                      ll,
                      {
                        typeOfStartEnd: "first",
                        value: L,
                        updateModel: j,
                        viewMode: u
                      }
                    ) }),
                    /* @__PURE__ */ a.jsx(A, { item: !0, children: !U && !u && /* @__PURE__ */ a.jsx(
                      Be,
                      {
                        onClick: () => M(!U),
                        fullWidth: !1,
                        variant: "outlined",
                        startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
                        name: "addConstraint",
                        sx: { mb: 0.5, minWidth: 185 },
                        children: "Additional Constraint"
                      }
                    ) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: U && /* @__PURE__ */ a.jsx(
                ll,
                {
                  typeOfStartEnd: "second",
                  value: te,
                  updateModel: ee,
                  viewMode: u,
                  children: /* @__PURE__ */ a.jsx(QE, { children: !u && /* @__PURE__ */ a.jsx(
                    Cr,
                    {
                      onClick: () => M(!U),
                      color: "primary",
                      iconName: "delete",
                      noExpand: !0,
                      name: "closeButton"
                    }
                  ) })
                }
              ) }),
              /* @__PURE__ */ a.jsxs(
                A,
                {
                  container: !0,
                  sx: (Q) => ({
                    // backgroundColor: theme.palette.backgroundColor.dark,
                    borderRadius: 0.5,
                    padding: "4px 0",
                    fontSize: 14
                  }),
                  children: [
                    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, mb: u ? 0 : 1, children: !p && /* @__PURE__ */ a.jsxs(fe, { px: 1, fontSize: 12, mb: 0.5, color: "textColor.label", children: [
                      "The index date refers to the event from the",
                      " ",
                      g || "Cohort Entry criteria"
                    ] }) }),
                    (N || _) && /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 12, display: "flex", children: [
                      N && /* @__PURE__ */ a.jsx(A, { item: !0, pr: 2, children: u ? /* @__PURE__ */ a.jsx(a.Fragment, { children: $ ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                        /* @__PURE__ */ a.jsx(ge, { iconName: "check", className: "icon-analysis" }),
                        /* @__PURE__ */ a.jsx(sl, { children: "Restrict to the same visit occurrence" })
                      ] }) : /* @__PURE__ */ a.jsx(a.Fragment, {}) }) : /* @__PURE__ */ a.jsxs(al, { children: [
                        /* @__PURE__ */ a.jsx(
                          hr,
                          {
                            disabled: u,
                            name: "Restrict",
                            onChange: () => P((Q) => ({
                              ...Q,
                              RestrictVisit: !Q.RestrictVisit
                            })),
                            checked: !!$,
                            size: "small"
                          }
                        ),
                        "Restrict to the same visit occurrence"
                      ] }) }),
                      _ && /* @__PURE__ */ a.jsx(A, { item: !0, children: u ? /* @__PURE__ */ a.jsx(a.Fragment, { children: v ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                        /* @__PURE__ */ a.jsx(ge, { iconName: "check", className: "icon-analysis" }),
                        /* @__PURE__ */ a.jsx(sl, { children: "Allow events from outside observation period" })
                      ] }) : /* @__PURE__ */ a.jsx(a.Fragment, {}) }) : /* @__PURE__ */ a.jsxs(al, { children: [
                        /* @__PURE__ */ a.jsx(
                          hr,
                          {
                            disabled: u,
                            name: "Ignore",
                            onChange: () => P((Q) => ({
                              ...Q,
                              IgnoreObservationPeriod: !Q.IgnoreObservationPeriod
                            })),
                            size: "small",
                            checked: !!v
                          }
                        ),
                        "Allow events from outside observation period"
                      ] }) })
                    ] })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}), nx = pe("div", {
  shouldForwardProp: (e) => e !== "isGroup"
})`
  align-self: flex-start;
  padding-left: 8px;
  min-width: 30px;
`, rx = (e) => {
  const {
    criteria: t,
    subModules: n,
    removeCriteria: r,
    conceptSets: i,
    updateConceptSets: o,
    refreshConceptSetReference: s,
    embeddedReferenceOnly: l,
    typeContainer: c,
    parentId: u,
    viewMode: p,
    updateModel: d,
    hasAction: f,
    parentConceptSetName: h
  } = e, { id: g } = t, C = (y) => {
    d(t.id, y);
  };
  return /* @__PURE__ */ a.jsx(
    $a,
    {
      className: "criteria-group",
      p: 1,
      sx: {
        boxSizing: "border-box",
        "&:not(:last-of-type)": {
          mb: 1
        }
      },
      children: /* @__PURE__ */ a.jsx(A, { container: !0, children: /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 12, display: "flex", justifyContent: "space-between", children: [
        /* @__PURE__ */ a.jsx(
          Ar,
          {
            extend: !0,
            subModules: n,
            value: t.group,
            updateModel: C,
            viewMode: p,
            typeContainer: c,
            parentId: u,
            conceptSets: i,
            updateConceptSets: o,
            refreshConceptSetReference: s,
            embeddedReferenceOnly: l,
            attrGroup: !0,
            hasAction: f,
            conceptSetName: h
          }
        ),
        !p && /* @__PURE__ */ a.jsx(nx, { children: /* @__PURE__ */ a.jsx(
          Cr,
          {
            onClick: () => {
              r(g);
            },
            color: "primary",
            iconName: "delete",
            noExpand: !0,
            name: "closeCriteriaButton"
          }
        ) })
      ] }) })
    }
  );
};
pe(fe)`
  font-size: 14px;
  font-weight: 700;
  margin-right: 8px;
`;
const ix = pe.div`
  font-size: 14px;
  color: #232323;
  font-weight: 700;
  /* padding-top: 4px; */
`;
pe.div`
  text-align: right;
`;
pe.div`
  font-size: 14px;
  margin-top: 10px;
`;
function ox({ id: e, children: t }) {
  const {
    attributes: n,
    listeners: r,
    setNodeRef: i,
    transform: o,
    transition: s,
    isDragging: l
  } = DE({ id: e }), c = {
    transform: ei.Transform.toString(o),
    transition: s,
    cursor: "grab",
    opacity: l ? 0.6 : 1,
    borderRadius: "8px",
    marginBottom: "8px"
  };
  return /* @__PURE__ */ a.jsx("div", { ref: i, style: c, ...n, ...r, children: t });
}
const Ga = Ze((e) => {
  const {
    titleText: t,
    descriptionText: n,
    initialCriteries: r,
    addTextButton: i,
    optionsDropdown: o,
    updateModel: s,
    viewMode: l,
    extend: c,
    parentConceptSet: u,
    attrGroup: p,
    groupTitleText: d,
    children: f,
    hiddenParentConcept: h,
    count: g,
    sectionType: C,
    sectionCount: y,
    isParentCriteriaAction: I,
    parentCriteriaElement: O,
    clearParentCriteriaElement: S,
    hasAction: N,
    parentConceptSetName: _,
    hideIgnoreObservationPeriod: R,
    hideCriteriaControls: P,
    hideOccurrence: U,
    ...M
  } = e, {
    criteries: w,
    isStartHook: V,
    addCriteria: L,
    init: te,
    updateCriteriaAttributes: $,
    updateCriteriaCodeSetId: v,
    updateExtendOptionsCriteria: J,
    updateGroupCriteria: j,
    removeCriteria: ee
  } = Rf(r, { extend: c, hideOccurrence: U }), Q = Z(() => Object.keys(w), [w]), x = !!(t || d || !P && (f || !l && !I)), Y = im(
    rm(Ua, {
      activationConstraint: {
        distance: 8
      }
    })
  );
  q(() => {
    I && O && (L(O), S());
  }, [O]);
  const k = ie(
    (re) => {
      const { active: b, over: z } = re;
      if (b != null && b.id && (z != null && z.id) && b.id !== z.id) {
        const me = Object.keys(w), ae = me.indexOf(b.id), le = me.indexOf(z.id), de = Fa(me, ae, le), $e = {};
        return de.forEach((we) => {
          $e[we] = w[we];
        }), s($e), te($e), de;
      }
    },
    [w, s]
  );
  q(() => {
    var re;
    (V && !Pe(w, r) || V && !((re = Object.keys(w)) != null && re.length)) && s(w);
  }, [w]);
  const T = ie(
    (re) => {
      const b = w[re], z = ao[b == null ? void 0 : b.name];
      return {
        criteria: b,
        details: z
      };
    },
    [w]
  );
  return V ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    x && /* @__PURE__ */ a.jsxs(
      A,
      {
        container: !0,
        alignItems: "flex-start",
        className: "cohort-definition-criteria-list",
        mb: Object.keys(w).length > 0 && f ? 1 : 0,
        children: [
          /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 9, children: [
            t && /* @__PURE__ */ a.jsx(
              A,
              {
                item: !0,
                xs: 12,
                display: "flex",
                alignItems: "center",
                mb: 1,
                className: "title-text",
                children: /* @__PURE__ */ a.jsx(
                  Jr,
                  {
                    title: t,
                    count: Object.keys(w).length
                  }
                )
              }
            ),
            d && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, className: "group-title-text", children: /* @__PURE__ */ a.jsx(ix, { children: d }) }),
            !P && Object.keys(w).length > 0 && f && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, className: "children-text", children: f })
          ] }),
          /* @__PURE__ */ a.jsx(
            A,
            {
              item: !0,
              xs: 3,
              textAlign: "right",
              className: "cohort-definition-criteria-button",
              children: !P && !l && !I && /* @__PURE__ */ a.jsx(
                Rn,
                {
                  variant: "outlined",
                  options: o,
                  onClick: L,
                  title: i || "",
                  name: i || "",
                  closeOnSelect: !0,
                  preventOverflow: !0,
                  startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
                  endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" })
                }
              )
            }
          )
        ]
      }
    ),
    n && Object.keys(w).length > 0 && /* @__PURE__ */ a.jsx(fe, { fontSize: 12, mb: 1, children: n }),
    /* @__PURE__ */ a.jsx(
      lE,
      {
        sensors: Y,
        collisionDetection: cm,
        onDragEnd: k,
        children: /* @__PURE__ */ a.jsx(
          TE,
          {
            items: Q,
            strategy: gE,
            children: Q.map((re, b) => {
              var me, ae, le;
              const z = T(re);
              return /* @__PURE__ */ a.jsx(ox, { id: re, children: (me = z == null ? void 0 : z.details) != null && me.wrapCriteria ? /* @__PURE__ */ a.jsx(
                rx,
                {
                  ...z,
                  extend: !0,
                  updateModel: j,
                  viewMode: l,
                  removeCriteria: ee,
                  parentConceptSet: u,
                  parentConceptSetName: _,
                  hasAction: !0,
                  ...M
                }
              ) : c && ((ae = z == null ? void 0 : z.details) != null && ae.extend) ? /* @__PURE__ */ a.jsx(
                tx,
                {
                  ...z,
                  parentConceptSet: u,
                  updateExtendOptions: J,
                  removeCriteria: ee,
                  attrGroup: p,
                  viewMode: l,
                  hiddenParentConcept: h,
                  sectionType: C,
                  sectionCount: y,
                  first: b === 0,
                  hasAction: N,
                  parentConceptSetName: _,
                  hideIgnoreObservationPeriod: R,
                  hideOccurrence: U,
                  children: /* @__PURE__ */ a.jsx(
                    ol,
                    {
                      ...z,
                      updateCriteriaAttributes: $,
                      updateCriteriaCodeSetId: v,
                      removeCriteria: ee,
                      viewMode: l,
                      extend: c && ((le = z == null ? void 0 : z.details) == null ? void 0 : le.extend),
                      ...M
                    }
                  )
                }
              ) : /* @__PURE__ */ a.jsx(
                ol,
                {
                  ...z,
                  updateCriteriaAttributes: $,
                  updateCriteriaCodeSetId: v,
                  removeCriteria: ee,
                  viewMode: l,
                  extend: c,
                  attrGroup: p,
                  hasAction: N,
                  ...M
                }
              ) }, re);
            })
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ a.jsx(Xt, { children: /* @__PURE__ */ a.jsx(pt, { size: 32 }) });
}), ax = {
  addCriteriaButton: "Criteria to group",
  subSections: {
    havingFolovingCriteria: {
      startText: "having",
      type: "selectExt",
      options: vh,
      endText: "of the following criteria:"
    }
  },
  optionsForCriteriaButton: [
    D.DEMOGRAPHIC,
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.LOCATION_REGION,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.OBSERVATION_PERIOD,
    D.PAYER_PLAN_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS,
    D.GROUP
  ]
}, sx = pe.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  flex-wrap: wrap;
  margin-right: 4px;
`, lx = pe.div`
  font-size: 12px;
`, cx = pe.div`
  margin: 0 10px;
`, ux = pe.div`
  font-size: 12px;
`, dx = pe.div`
  font-size: 12px;
  margin: 0 5px;
`, Ut = Ze(
  (e) => {
    var p;
    const {
      startText: t,
      children: n,
      endText: r,
      type: i = "select",
      options: o,
      value: s,
      viewMode: l,
      onChange: c
    } = e, u = (d) => {
      c(d);
    };
    return /* @__PURE__ */ a.jsxs(sx, { children: [
      /* @__PURE__ */ a.jsx(lx, { className: "start-text", children: t }),
      l ? /* @__PURE__ */ a.jsx(dx, { children: (p = o.find((d) => d.value == s)) == null ? void 0 : p.name }) : /* @__PURE__ */ a.jsxs(cx, { children: [
        i === "select" && /* @__PURE__ */ a.jsxs(Le.Fragment, { children: [
          /* @__PURE__ */ a.jsx(
            It,
            {
              className: "",
              options: o,
              value: s,
              placeholder: "Select option...",
              onChange: u,
              name: "selectStart"
            }
          ),
          n
        ] }),
        i === "autocomplete" && /* @__PURE__ */ a.jsx(
          $i,
          {
            value: s,
            onChange: (d) => {
              u(d);
            },
            options: o,
            className: "autocompleteValue"
          }
        ),
        i === "selectExt" && /* @__PURE__ */ a.jsxs(Le.Fragment, { children: [
          /* @__PURE__ */ a.jsx(
            It,
            {
              className: "",
              options: o,
              value: s,
              placeholder: "Select option...",
              onChange: u,
              name: "selectEnd"
            }
          ),
          ["AT_LEAST", "AT_MOST"].includes(s) && /* @__PURE__ */ a.jsx(Le.Fragment, { children: n })
        ] })
      ] }),
      /* @__PURE__ */ a.jsx(ux, { className: "end-text", children: r })
    ] });
  }
), px = (e, t) => typeof e == "number" ? e >= 0 : !t || typeof e != "string" ? !1 : e.trim() !== "" && e !== "-1", Ar = (e) => {
  const {
    extend: t,
    value: n,
    title: r,
    subModules: i,
    viewMode: o,
    typeContainer: s,
    parentId: l,
    description: c,
    addTextButton: u,
    updateModel: p,
    groupTitleText: d,
    hiddenParentConcept: f,
    parentCriteriaElement: h,
    clearParentCriteriaElement: g,
    isParentCriteriaAction: C,
    conceptSetName: y,
    hideIgnoreObservationPeriod: I,
    embeddedReferenceOnly: O,
    hasAction: S = !1,
    hideCriteriaControls: N,
    hideOccurrence: _,
    ...R
  } = e, [P, U] = K({
    Type: (n == null ? void 0 : n.Type) || "ALL",
    Count: (n == null ? void 0 : n.Count) || (["ANY", "ALL"].includes(n == null ? void 0 : n.Type) ? void 0 : 0),
    CriteriaList: (n == null ? void 0 : n.CriteriaList) || [],
    DemographicCriteriaList: (n == null ? void 0 : n.DemographicCriteriaList) || [],
    Groups: (n == null ? void 0 : n.Groups) || []
  }), { Type: M, Count: w, CriteriaList: V, DemographicCriteriaList: L, Groups: te } = P, $ = O || s === Ee.LIBRARY, v = (T, re, b) => {
    const z = {};
    return T.forEach((me) => {
      const ae = Dn(), { CodesetId: le, ...de } = me;
      z[ae] = {
        id: ae,
        name: "Demographic",
        codesetId: le,
        attributes: de
      };
    }), re.forEach((me) => {
      const ae = Dn(), { Criteria: le, ...de } = me, $e = Object.keys(le)[0], we = Object.values(le)[0] || {}, { CodesetId: At, codesetId: qe, ...ot } = we;
      z[ae] = {
        id: ae,
        name: $e,
        codesetId: At ?? qe,
        attributes: ot,
        extendOptions: de
      };
    }), b.forEach((me) => {
      const ae = Dn();
      z[ae] = {
        id: ae,
        name: "Group",
        codesetId: void 0,
        attributes: {},
        group: me
      };
    }), z;
  }, J = ie(
    (T) => {
      const re = {
        CriteriaList: [],
        DemographicCriteriaList: [],
        Groups: []
      };
      return Object.keys(T).forEach((b) => {
        const z = T[b];
        switch (z.name) {
          case D.DEMOGRAPHIC:
            re.DemographicCriteriaList.push(
              z.attributes
            );
            break;
          case D.GROUP:
            re.Groups.push(z.group);
            break;
          default:
            re.CriteriaList.push({
              Criteria: {
                [z.name]: z.codesetId !== void 0 && z.codesetId !== null && z.codesetId !== -1 && px(
                  z.codesetId,
                  $
                ) ? {
                  ...z.attributes,
                  CodesetId: z.codesetId
                } : z.attributes
              },
              ...z.extendOptions
            });
        }
      }), re;
    },
    [$]
  ), [j] = K(
    v(
      L,
      V,
      te
    )
  ), { addCriteriaButton: ee, optionsForCriteriaButton: Q, subSections: x } = ax, Y = Z(() => _n(
    Q,
    xn
  ), [Q]), k = (T) => {
    const re = J(T);
    U({
      ...P,
      ...re
    });
  };
  return q(() => {
    let T = {
      Type: P.Type,
      CriteriaList: P.CriteriaList,
      DemographicCriteriaList: P.DemographicCriteriaList,
      Groups: P.Groups
    };
    P.Count >= 0 && P.Type !== "ALL" && (T.Count = P.Count), Pe(T, n) || p(T);
  }, [P]), /* @__PURE__ */ a.jsx(A, { container: !0, className: "criteria-group-container", children: /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
    Ga,
    {
      viewMode: o,
      groupTitleText: d,
      extend: !0,
      subModules: i,
      initialCriteries: j,
      addTextButton: u || ee,
      optionsDropdown: Y,
      updateModel: k,
      typeContainer: s,
      parentId: l,
      titleText: r,
      descriptionText: c,
      hiddenParentConcept: f,
      sectionType: M,
      sectionCount: w,
      parentCriteriaElement: h,
      clearParentCriteriaElement: g,
      isParentCriteriaAction: C,
      embeddedReferenceOnly: O,
      hasAction: S,
      parentConceptSetName: y,
      hideIgnoreObservationPeriod: I,
      hideCriteriaControls: N,
      hideOccurrence: _,
      ...R,
      children: /* @__PURE__ */ a.jsx(A, { container: !0, children: /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: o,
          startText: x.havingFolovingCriteria.startText,
          endText: x.havingFolovingCriteria.endText,
          options: x.havingFolovingCriteria.options,
          type: x.havingFolovingCriteria.type,
          onChange: (T) => {
            U({
              ...P,
              Type: T
            });
          },
          value: P.Type,
          children: /* @__PURE__ */ a.jsx(
            It,
            {
              className: "criteriaSelectNumeric",
              options: [
                {
                  value: 0,
                  name: "0"
                },
                ...V.map((T, re) => ({
                  value: re + 1,
                  name: `${re + 1}`
                }))
              ],
              value: P.Count,
              placeholder: "Select option...",
              onChange: (T) => {
                U({
                  ...P,
                  Count: T
                });
              },
              name: "selectStart"
            }
          )
        }
      ) }) })
    }
  ) }) });
}, hx = pe.div`
  font-size: 16px;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  font-weight: 700;
  /* padding-top: 4px; */
`, fx = pe.div`
  margin-bottom: 8px;
`, cl = [
  {
    id: "dsdsds",
    name: "Gender (M, F)",
    stratas: [
      {
        id: "fjoiewfwo31232",
        name: "Gender (M)",
        description: "--- Gender (M) ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Gender: [
                {
                  CONCEPT_ID: 8507,
                  CONCEPT_NAME: "MALE",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Valid",
                  CONCEPT_CODE: "M",
                  DOMAIN_ID: "Gender",
                  VOCABULARY_ID: "Gender",
                  CONCEPT_CLASS_ID: "Gender",
                  id: null,
                  shortcut: null,
                  created: null,
                  modified: null,
                  actions: null
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjoiewfwo355555",
        name: "Gender (F)",
        description: "--- Gender (F) ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Gender: [
                {
                  CONCEPT_ID: 8532,
                  CONCEPT_NAME: "FEMALE",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Valid",
                  CONCEPT_CODE: "F",
                  DOMAIN_ID: "Gender",
                  VOCABULARY_ID: "Gender",
                  CONCEPT_CLASS_ID: "Gender",
                  id: null,
                  shortcut: null,
                  created: null,
                  modified: null,
                  actions: null
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsdsds456",
    name: "Gender (M)",
    stratas: [
      {
        id: "fjoiewfwo3lk1232",
        name: "Gender (M)",
        description: "--- Gender (M) ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Gender: [
                {
                  CONCEPT_ID: 8507,
                  CONCEPT_NAME: "MALE",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Valid",
                  CONCEPT_CODE: "M",
                  DOMAIN_ID: "Gender",
                  VOCABULARY_ID: "Gender",
                  CONCEPT_CLASS_ID: "Gender",
                  id: null,
                  shortcut: null,
                  created: null,
                  modified: null,
                  actions: null
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsdsdgglos",
    name: "Gender (F)",
    stratas: [
      {
        id: "fjoiewfwo35534gg",
        name: "Gender (F)",
        description: "--- Gender (F) ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Gender: [
                {
                  CONCEPT_ID: 8532,
                  CONCEPT_NAME: "FEMALE",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Valid",
                  CONCEPT_CODE: "F",
                  DOMAIN_ID: "Gender",
                  VOCABULARY_ID: "Gender",
                  CONCEPT_CLASS_ID: "Gender",
                  id: null,
                  shortcut: null,
                  created: null,
                  modified: null,
                  actions: null
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsoioi3333",
    name: "Age Groups #1 (0-10, 11-20, 21-30, 31-40, 41-50, 51-60, 61+)",
    stratas: [
      {
        id: "fjdfdf11",
        name: "Age 0 - 10",
        description: "--- Age 0 - 10 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 0,
                Op: "bt",
                Extent: 10
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf22",
        name: "Age 11 - 20",
        description: "--- Age 11 - 20 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 11,
                Op: "bt",
                Extent: 20
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf33",
        name: "Age 21 - 30",
        description: "--- Age 21 - 30 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 21,
                Op: "bt",
                Extent: 30
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf44",
        name: "Age 31 - 40",
        description: "--- Age 31 - 40 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 31,
                Op: "bt",
                Extent: 40
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf55",
        name: "Age 41 - 50",
        description: "--- Age 41 - 50 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 41,
                Op: "bt",
                Extent: 50
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf66",
        name: "Age 51 - 60",
        description: "--- Age 51 - 60 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 51,
                Op: "bt",
                Extent: 60
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf77",
        name: "Age 61+",
        description: "--- Age 61+ ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 61,
                Op: "gte"
              }
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsdsdgglosiihtht",
    name: "Age Groups #2 (<40, 40+)",
    stratas: [
      {
        id: "fjoiewfwo35534gg",
        name: "Age < 40",
        description: "--- Age < 40 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Op: "lt",
                Value: 40
              }
            }
          ]
        }
      },
      {
        id: "fjoiewfwo35534gg",
        name: "Age 40+",
        description: "--- Age 40+ ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Op: "gte",
                Value: 40
              }
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsds11dgglqwqwqwoshtht",
    name: "Age Groups #3 (<60, 60+)",
    stratas: [
      {
        id: "fjoiewfwo35kk534gg",
        name: "Age < 60",
        description: "--- Age < 60 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Op: "lt",
                Value: 60
              }
            }
          ]
        }
      },
      {
        id: "fjoiewfwo355lolo34gg",
        name: "Age 60+",
        description: "--- Age 60+ ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Op: "gte",
                Value: 60
              }
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsoi98oi3333",
    name: "Age Groups Adolescent (0-1, 1-5, 6-10, 11-18) ",
    stratas: [
      {
        id: "fjdfdf1111",
        name: "Age 0 - 1",
        description: "--- Age 0 - 1 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 0,
                Op: "bt",
                Extent: 1
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf2222",
        name: "Age 1 - 5",
        description: "--- Age 1 - 5 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 1,
                Op: "bt",
                Extent: 5
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf3333",
        name: "Age 6 - 10",
        description: "--- Age 6 - 10 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 6,
                Op: "bt",
                Extent: 10
              }
            }
          ]
        }
      },
      {
        id: "fjdfdf4444",
        name: "Age 11 - 18",
        description: "--- Age 11 - 18 ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Age: {
                Value: 11,
                Op: "bt",
                Extent: 18
              }
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsoi985566344423f",
    name: "Race (U.S. Census Bureau)",
    stratas: [
      {
        id: "fjdfdf22qq",
        name: "White",
        description: "--- White ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8527,
                  CONCEPT_NAME: "White",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "5",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjdfdf11qq",
        name: "Black or African American",
        description: "--- Black or African American ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8516,
                  CONCEPT_NAME: "Black or African American",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "3",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjdfdf55qq",
        name: "American Indian or Alaska Native",
        description: "--- American Indian or Alaska Native ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8657,
                  CONCEPT_NAME: "American Indian or Alaska Native",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "1",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjgg66hh66",
        name: "Asian",
        description: "--- Asian ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8515,
                  CONCEPT_NAME: "Asian",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "2",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fjdfdf33qq",
        name: "Native Hawaiian or Other Pacific Islander",
        description: "--- Native Hawaiian or Other Pacific Islander ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Race: [
                {
                  CONCEPT_ID: 8557,
                  CONCEPT_NAME: "Native Hawaiian or Other Pacific Islander",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "4",
                  DOMAIN_ID: "Race",
                  VOCABULARY_ID: "Race",
                  CONCEPT_CLASS_ID: "Race"
                }
              ]
            }
          ]
        }
      }
    ]
  },
  {
    id: "dsoededrf4444",
    name: "Ethnic Group",
    stratas: [
      {
        id: "fj34340011",
        name: "Hispanic or Latino",
        description: "--- Hispanic or Latino ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Ethnicity: [
                {
                  CONCEPT_ID: 38003563,
                  CONCEPT_NAME: "Hispanic or Latino",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "Hispanic",
                  DOMAIN_ID: "Ethnicity",
                  VOCABULARY_ID: "Ethnicity",
                  CONCEPT_CLASS_ID: "Ethnicity"
                }
              ]
            }
          ]
        }
      },
      {
        id: "fj34340551",
        name: "Not Hispanic or Latino",
        description: "--- Not Hispanic or Latino ---",
        expression: {
          Type: "ALL",
          CriteriaList: [],
          DemographicCriteriaList: [
            {
              Ethnicity: [
                {
                  CONCEPT_ID: 38003564,
                  CONCEPT_NAME: "Not Hispanic or Latino",
                  STANDARD_CONCEPT: "S",
                  STANDARD_CONCEPT_CAPTION: "Standard",
                  INVALID_REASON: null,
                  INVALID_REASON_CAPTION: "Unknown",
                  CONCEPT_CODE: "Not Hispanic",
                  DOMAIN_ID: "Ethnicity",
                  VOCABULARY_ID: "Ethnicity",
                  CONCEPT_CLASS_ID: "Ethnicity"
                }
              ]
            }
          ]
        }
      }
    ]
  }
];
pe.div`
  font-size: 16px;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  font-weight: 700;
  padding-top: 4px;
`;
pe.div`
  display: block;
  text-align: right;
`;
pe(Be)`
  border-radius: 4px;
  font-size: 14px;
  text-transform: initial;
  padding: 1px 15px;
`;
pe.div`
  margin-bottom: 20px;
`;
const ul = pe(gr)`
  padding: 10px;
`, Uu = (e) => {
  const { subModules: t, typeContainer: n, parentId: r, onChange: i, onClose: o } = e, [s, l] = K(null), [c, u] = K(!1), p = () => {
    i(s.stratas);
  };
  return /* @__PURE__ */ a.jsx(gr, { children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(ze, { name: "criteria", textLabel: "Criteria", required: !0, children: /* @__PURE__ */ a.jsx(
      Gi,
      {
        className: "",
        name: "criteria",
        id: "criteria",
        options: cl.map((d) => ({
          name: d.name,
          value: d.id
        })),
        value: s == null ? void 0 : s.name,
        placeholder: "Select criteria...",
        fullWidth: !0,
        isOptionEqualToValue: (d, f) => d.value === f.value,
        onChange: (d, f) => {
          u(!0), setTimeout(() => {
            u(!1);
          }, 300);
          const h = cl.find(
            (g) => g.id === f.value
          );
          l(h);
        },
        getOptionLabel: (d) => d.name
      }
    ) }) }),
    s && s.stratas.length > 0 && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ a.jsxs(oo, { children: [
      /* @__PURE__ */ a.jsx(
        Be,
        {
          variant: "outlined",
          onClick: o,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "deactivate" }),
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ a.jsx(
        Be,
        {
          onClick: p,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "submit" }),
          name: "save",
          children: "Choose"
        }
      )
    ] }) }),
    s && s.stratas.length > 0 && s.stratas.map((d, f) => /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
      A,
      {
        item: !0,
        xs: 12,
        className: "cohort-definition-inclusion-criteria-data",
        children: /* @__PURE__ */ a.jsx(
          Oa,
          {
            index: f,
            item: d,
            viewMode: !0,
            defaultState: !0,
            updateSection: () => {
            },
            copySection: () => {
            },
            removeSection: () => {
            },
            children: /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 12, children: [
              !c && /* @__PURE__ */ a.jsx(ul, { children: /* @__PURE__ */ a.jsx(
                Ar,
                {
                  extend: !0,
                  subModules: t,
                  value: d.expression,
                  updateModel: (h) => {
                  },
                  viewMode: !0,
                  typeContainer: n,
                  parentId: r,
                  groupTitleText: `Group criteria for ${d.name}`,
                  conceptSets: [],
                  updateConceptSets: (h) => {
                  },
                  hasAction: !1
                }
              ) }),
              c && /* @__PURE__ */ a.jsx(ul, { children: /* @__PURE__ */ a.jsx(Xt, { children: /* @__PURE__ */ a.jsx(pt, { size: 32 }) }) })
            ] })
          },
          f
        )
      }
    ) }))
  ] }) });
}, Gr = (e) => typeof e == "object" && e !== null, Fu = (e) => {
  if (Gr(e))
    return typeof e.message == "string" ? e.message : void 0;
}, Bu = (e, t) => {
  const n = Gr(e) && Gr(e.response) && Gr(e.response.data) && typeof e.response.data.message == "string" ? e.response.data.message : void 0;
  return n || t;
}, $u = (e) => typeof e == "boolean" ? e : Gr(e) ? typeof e.available == "boolean" ? e.available : typeof e.isAvailable == "boolean" ? e.isAvailable : typeof e.success == "boolean" ? e.success : typeof e.result == "boolean" ? e.result : typeof e.unique == "boolean" ? e.unique : typeof e.isUnique == "boolean" ? e.isUnique : typeof e.valid == "boolean" ? e.valid : typeof e.isValid == "boolean" ? e.isValid : typeof e.exists == "boolean" ? !e.exists : typeof e.duplicate == "boolean" ? !e.duplicate : typeof e.conflict == "boolean" ? !e.conflict : typeof e.used == "boolean" ? !e.used : !0 : !0, ur = async (e, t, n, r) => {
  const i = t == null ? void 0 : t.trim();
  if (!i)
    return {
      isValid: !1,
      message: "Name is required."
    };
  try {
    const o = await au(
      e,
      i,
      n,
      r
    ), s = $u(o);
    return {
      isValid: s,
      message: (s ? void 0 : Fu(o)) || (s ? void 0 : "Error! Name is already used by another object.")
    };
  } catch (o) {
    return {
      isValid: !1,
      message: Bu(
        o,
        "Unable to validate name uniqueness. Please try again."
      )
    };
  }
}, mx = async (e, t, n, r) => {
  const i = t == null ? void 0 : t.trim();
  if (!i)
    return {
      isValid: !1,
      message: "Name is required."
    };
  try {
    const o = await of(
      e,
      i,
      n,
      r
    ), s = $u(o);
    return {
      isValid: s,
      message: (s ? void 0 : Fu(o)) || (s ? void 0 : "Error! Name is already used by another object.")
    };
  } catch (o) {
    return {
      isValid: !1,
      message: Bu(
        o,
        "Unable to validate name uniqueness. Please try again."
      )
    };
  }
}, Gu = Ze((e) => {
  const { parentId: t, typeContainer: n, afterCreate: r, onCancel: i, createMethod: o } = e, [s, l] = K(!1), [c, u] = K(""), [p, d] = K({
    name: "",
    description: "",
    studyId: t
  }), f = ie(async () => {
    l(!0);
    const h = await ur(n, p.name, t);
    if (!h.isValid) {
      l(!1), u(h.message || "");
      return;
    }
    u(""), o(p).then((g) => {
      l(!1), r == null || r(g);
    });
  }, [t, p, o, n]);
  return /* @__PURE__ */ a.jsx(A, { container: !0, p: 2, children: /* @__PURE__ */ a.jsx(gr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(ze, { name: "name", textLabel: "Name", required: !0, children: [
      /* @__PURE__ */ a.jsx(
        Ye,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          value: p.name,
          placeholder: "Enter name",
          onChange: (h) => {
            u(""), d({ ...p, name: h.target.value });
          },
          fullWidth: !0
        }
      ),
      c && /* @__PURE__ */ a.jsx(fe, { color: "error.main", variant: "caption", children: c })
    ] }) }),
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(ze, { name: "description", textLabel: "Description", children: /* @__PURE__ */ a.jsx(
      Ye,
      {
        id: "description",
        name: "description",
        type: "text",
        size: "medium",
        value: p.description,
        placeholder: "Enter description",
        onChange: (h) => d({ ...p, description: h.target.value }),
        fullWidth: !0,
        multiline: !0,
        minRows: 2,
        maxRows: 10
      }
    ) }) }),
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(oo, { children: [
      /* @__PURE__ */ a.jsx(
        Be,
        {
          variant: "outlined",
          disabled: s,
          onClick: i,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ a.jsx(
        Be,
        {
          disabled: s || fn(p.name),
          onClick: f,
          variant: "contained",
          color: "success",
          startIcon: s ? /* @__PURE__ */ a.jsx(pt, { size: 16 }) : /* @__PURE__ */ a.jsx(ge, { iconName: "submit" }),
          name: "save",
          children: "Save"
        }
      )
    ] }) })
  ] }) }) });
}), Ex = Fe.CREATE_NEW_OBJECT, dl = Fe.CREATE_NEW_VERSION, xx = "Fully identical concept sets will not be created, instead existing ones will be re-used. Concept sets with the same name will create a new version of the existing ones and Cohort design will reference these newly created versions. Previously created concept-sets, which are not used anywhere else will be deleted(archived).", Cx = "New Concept Set(s) will be created, even if identical Concept Set(s) exist.", Pr = (e) => e.trim().replace(/^['"]|['"]$/g, "").replace(/^\[+/, "").replace(/\]+$/, "").trim(), ca = (e) => {
  if (Array.isArray(e))
    return e.map((t) => Pr(String(t))).filter(Boolean);
  if (typeof e == "string") {
    const t = e.trim();
    if (!t) return [];
    try {
      const n = JSON.parse(t);
      if (Array.isArray(n))
        return n.map((r) => Pr(String(r))).filter(Boolean);
    } catch {
    }
    if (t.startsWith("[") && t.endsWith("]")) {
      const n = t.slice(1, -1).trim();
      return n ? n.split(",").map(Pr).filter(Boolean) : [];
    }
    return t.includes(",") ? t.split(",").map(Pr).filter(Boolean) : [Pr(t)].filter(Boolean);
  }
  return [];
}, gx = (e) => {
  if (!e) return {};
  if (typeof e == "string") {
    try {
      const t = JSON.parse(e);
      if (t && typeof t == "object" && !Array.isArray(t))
        return t;
    } catch {
      return { Description: e };
    }
    return { Description: e };
  }
  return e;
}, pl = (e, t) => ca(e).map((n) => ({
  name: (t == null ? void 0 : t.get(n)) ?? n,
  value: n
})), hl = (e) => typeof e == "string" ? e : e.name, fl = (e) => {
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    if (t === "true")
      return !0;
    if (t === "false")
      return !1;
  }
}, Oi = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim() !== "") {
    const t = Number(e);
    if (Number.isFinite(t))
      return t;
  }
}, Wn = (e, t) => {
  var i;
  const n = t.map((o) => o.toLowerCase()), r = e == null ? void 0 : e.find((o) => {
    var l, c;
    const s = (c = (l = o.attribute) == null ? void 0 : l.name) == null ? void 0 : c.toLowerCase();
    return s ? n.includes(s) : !1;
  });
  return ((i = r == null ? void 0 : r.value) == null ? void 0 : i.trim()) || "";
}, yx = (e) => {
  const [t = "", n = ""] = e.split("#");
  return { aiJobId: t.trim(), clinicalTrials: n.trim() };
}, Tx = (e, t) => {
  const n = Oi(e["Search precision"]) ?? Oi(
    Wn(t, [
      "Search precision",
      "ai-search-precision"
    ])
  );
  if (n !== void 0 && n >= 0 && n < zi.length)
    return n;
  const r = fl(e["~ai_skip_vector_search"]) ?? fl(
    Wn(t, [
      "~ai_skip_vector_search",
      "ai_skip_vector_search",
      "ai-skip-vector-search"
    ])
  ), i = Oi(e["~vector_search_result_limit"]) ?? Oi(
    Wn(t, [
      "~vector_search_result_limit",
      "vector_search_result_limit",
      "ai-vector-search-result-limit"
    ])
  ), o = zi.findIndex(
    (s) => s.skipVectorSearch === r && s.vectorSearchResultLimit === i
  );
  return o >= 0 ? o : 0;
}, Sx = (e, t) => {
  var i;
  if ((i = e["NCT number"]) != null && i.trim())
    return e["NCT number"].trim();
  const n = Wn(t, [
    "NCT number",
    "ai-clinical-trials-id"
  ]);
  if (n)
    return n;
  const r = Wn(t, ["ai-job-id"]);
  return yx(r).clinicalTrials;
}, Ix = (e) => {
  var n, r, i, o, s;
  var t = (((n = e.eligibilityModule) == null ? void 0 : n.eligibilityCriteria) || "").replace(/\\/g, "");
  return t != "" && !t.toLowerCase().includes("inclusion criteria") && (t = `Inclusion criteria:

` + t), `Entry events:

${(i = (r = e.conditionsModule) == null ? void 0 : r.conditions) == null ? void 0 : i.map((l) => `* ${l}
`).join("")}${((s = (o = e.armsInterventionsModule) == null ? void 0 : o.interventions) == null ? void 0 : s.map((l) => `* ${l.name}
`).join("")) || ""}
${t}
  `;
}, zu = Ze(
  ({
    parentId: e,
    typeContainer: t,
    afterCreate: n,
    onCancel: r,
    onGenerateStart: i,
    onGenerateError: o,
    createMethod: s,
    entity: l,
    prompt: c,
    attributes: u
  }) => {
    var qe, ot, ct, bt, Yt;
    const { enqueueSnackbar: p } = Xn(), d = !!l, [f, h] = K(!1), [g, C] = K(""), [y, I] = K(!1), O = Te(0), S = Te(!1), [N, _] = K(dl), [R, P] = K(!1), U = Zd(), M = gx(c), w = ca(M.Vocabulary).length > 0 ? M.Vocabulary : Wn(u, [
      "Vocabulary",
      "ai-vocabularies"
    ]), V = ca(M["Standard concept"]).length > 0 ? M["Standard concept"] : Wn(u, [
      "Standard concept",
      "ai-standard-concepts"
    ]), [L, te] = K(
      Sx(M, u)
    ), [$, v] = K({
      text: M.Description || "",
      cohort_name: (l == null ? void 0 : l.name) || "",
      model_id: "",
      vocabulary: pl(w),
      standard_concept: pl(
        V,
        new Map(
          Array.from(dp, ([ce, ne]) => [
            ce,
            ne.caption
          ])
        )
      ),
      search_precision: Tx(M, u)
    }), { settings: J } = Da(
      (ce) => ce.user.data
    ), j = tp(s, e, l, "cohortdefinition"), { options: ee, status: Q } = np(), { options: x, status: Y } = rp(), k = ie(
      async (ce, ne) => {
        const [Ue, mt] = await Promise.all([
          ff(jh),
          qi(
            "filter.metadata.value.subject.id",
            ce
          )
        ]), Rt = Ue.content.find(
          (H) => H.name === "ai-prompt"
        );
        if (!Rt)
          return;
        const et = mt.content.find(
          (H) => {
            var oe;
            return ((oe = H.attribute) == null ? void 0 : oe.name) === "ai-prompt";
          }
        ), tt = JSON.stringify({
          Description: ne.description,
          Vocabulary: ne.vocabulary,
          "Standard concept": ne.standardConcept,
          "Search precision": ne.searchPrecision,
          "~ai_skip_vector_search": ne.skipVectorSearch,
          "~vector_search_result_limit": ne.vectorSearchResultLimit,
          "NCT number": ne.clinicalTrialsId,
          "Conflict resolution": ne.conflictResolution
        }), F = {
          attribute: { id: Rt.id },
          dataSourceId: ce,
          value: tt
        };
        if (et != null && et.id) {
          await ta(F, et.id);
          return;
        }
        await ea(F);
      },
      []
    ), T = ie(
      ({
        target: { name: ce, value: ne }
      }) => {
        v((Ue) => ({ ...Ue, [ce]: ne }));
      },
      []
    ), re = ie(
      (ce, ne) => {
        v((Ue) => ({ ...Ue, [ce]: ne }));
      },
      []
    ), b = ie(async () => {
      var ce;
      if (L)
        try {
          const ne = await mf(L);
          (ce = ne == null ? void 0 : ne.data) != null && ce.protocolSection && v((Ue) => ({
            ...Ue,
            text: Ix(ne.data.protocolSection)
          }));
        } catch (ne) {
          p({
            message: "Error fetching clinical trial data",
            variant: "error"
          }), console.error("Error:", ne);
        }
    }, [L]), z = ie(
      async (ce) => {
        if (!(f || fn($.cohort_name) || fn($.text))) {
          h(!0);
          try {
            if (!d) {
              const tt = await ur(
                t,
                $.cohort_name,
                e
              );
              if (!tt.isValid) {
                C(tt.message || ""), h(!1);
                return;
              }
            }
            C(""), i ? i() : p({
              message: d ? "Cohort regenerate in progress..." : "Cohort generate in progress...",
              variant: "success"
            });
            const ne = zi[$.search_precision] ?? zi[0], Ue = $.vocabulary.map((tt) => tt.value), mt = $.standard_concept.map(
              (tt) => tt.value
            );
            let Rt = !1;
            const et = await j.generate(
              {
                title: $.cohort_name,
                description: $.text,
                clinicalTrialsId: L,
                ...Ue.length ? { vocabulary: Ue } : {},
                ...mt.length ? { standardConcept: mt } : {},
                conflictResolution: ce,
                skipVectorSearch: ne.skipVectorSearch,
                vectorSearchResultLimit: ne.vectorSearchResultLimit
              },
              (tt) => {
                Rt = !0, n == null || n(tt);
              }
            );
            try {
              await k(et.id, {
                description: $.text,
                vocabulary: Ue,
                standardConcept: mt,
                searchPrecision: $.search_precision,
                skipVectorSearch: ne.skipVectorSearch,
                vectorSearchResultLimit: ne.vectorSearchResultLimit,
                clinicalTrialsId: L,
                conflictResolution: ce
              });
            } catch (tt) {
              console.error("Error updating ai-prompt metadata:", tt);
            }
            Rt || n == null || n(et);
          } catch (ne) {
            o == null || o(), p({ message: "Cohort not created", variant: "error" }), console.error("Error:", ne);
          } finally {
            h(!1);
          }
        }
      },
      [
        $,
        f,
        j,
        n,
        L,
        p,
        d,
        k,
        t,
        e,
        i,
        o
      ]
    ), me = ie(() => {
      _(dl), I(!0);
    }, []), ae = ie(() => {
      I(!1), S.current = !1, bo("dialog") >= O.current && window.history.back();
    }, []);
    q(() => {
      if (y && !S.current) {
        const ce = bo("dialog") + 1;
        O.current = ce, ip("dialog", ce);
      }
      S.current = y;
    }, [y]), q(() => {
      const ce = (ne) => {
        y && bo("dialog", ne.state) < O.current && I(!1);
      };
      return window.addEventListener("popstate", ce), () => {
        window.removeEventListener("popstate", ce);
      };
    }, [y]);
    const le = ie(async () => {
      ae(), await z(N);
    }, [ae, N, z]), de = ie(() => {
      if (d) {
        me();
        return;
      }
      z(Ex);
    }, [d, me, z]);
    q(() => {
      if (Q === ue.SUCCESS) {
        const ce = ee.find((ne) => ne.isDefault);
        v((ne) => ({ ...ne, model_id: ce == null ? void 0 : ce.value }));
      }
    }, [Q]);
    const [$e, we] = Wp(), At = Math.round((we - 420) / 28);
    return [ue.INITIAL, ue.IN_PROGRESS].includes(Q) || [ue.INITIAL, ue.IN_PROGRESS].includes(Y) ? /* @__PURE__ */ a.jsx(Xt, { children: /* @__PURE__ */ a.jsx(pt, {}) }) : /* @__PURE__ */ a.jsxs(A, { container: !0, p: 2, children: [
      /* @__PURE__ */ a.jsx(gr, { elevated: !0, outlined: !0, children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 2, p: 2, children: [
        /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(ze, { name: "name", textLabel: "Name", required: !0, children: [
          /* @__PURE__ */ a.jsx(
            Ye,
            {
              id: "name",
              name: "cohort_name",
              type: "text",
              size: "medium",
              value: $.cohort_name,
              disabled: !!l,
              placeholder: "Enter name",
              onChange: (ce) => {
                C(""), T(ce);
              },
              fullWidth: !0
            }
          ),
          g && /* @__PURE__ */ a.jsx(fe, { color: "error.main", variant: "caption", children: g })
        ] }) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(ze, { name: "description", textLabel: "Description", required: !0, children: /* @__PURE__ */ a.jsx(
          Ye,
          {
            id: "description",
            name: "text",
            type: "text",
            size: "medium",
            value: $.text,
            placeholder: "Enter description",
            onChange: T,
            fullWidth: !0,
            multiline: !0,
            minRows: 6,
            maxRows: At ?? 20
          }
        ) }) }),
        ((qe = J == null ? void 0 : J.services) == null ? void 0 : qe["clinical-trials"]) && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
          ze,
          {
            name: "lookup",
            textLabel: "Look up in ClinicalTrials.gov",
            children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 2, children: [
              /* @__PURE__ */ a.jsx(A, { item: !0, xs: 9, children: /* @__PURE__ */ a.jsx(
                Ye,
                {
                  id: "nct",
                  name: "nct",
                  type: "text",
                  size: "medium",
                  value: L,
                  placeholder: "*NCT*",
                  fullWidth: !0,
                  onChange: (ce) => {
                    var ne;
                    te((ne = ce.target.value) == null ? void 0 : ne.trim());
                  }
                }
              ) }),
              /* @__PURE__ */ a.jsx(A, { item: !0, xs: 3, children: /* @__PURE__ */ a.jsx(
                Be,
                {
                  variant: "contained",
                  color: "primary",
                  fullWidth: !0,
                  onClick: b,
                  children: "Find"
                }
              ) })
            ] })
          }
        ) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, mt: 2, children: /* @__PURE__ */ a.jsxs(W, { children: [
          /* @__PURE__ */ a.jsxs(
            W,
            {
              component: "button",
              type: "button",
              onClick: () => P((ce) => !ce),
              "aria-expanded": R,
              "aria-controls": U,
              sx: {
                p: 0,
                m: 0,
                border: 0,
                background: "transparent",
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                color: "textColor.main",
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 700,
                lineHeight: "20px",
                "&:focus-visible": {
                  outline: "2px solid",
                  outlineColor: "primary.main",
                  outlineOffset: 2
                }
              },
              children: [
                "Concept Set options",
                /* @__PURE__ */ a.jsx(
                  ge,
                  {
                    iconName: "chevronFilled",
                    sx: {
                      fontSize: 8,
                      color: "#7B8599",
                      transform: R ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease"
                    }
                  }
                )
              ]
            }
          ),
          R && /* @__PURE__ */ a.jsxs(
            A,
            {
              container: !0,
              spacing: 2,
              id: U,
              sx: { pt: "16px" },
              children: [
                /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ a.jsx(
                  ze,
                  {
                    name: "standard_concept",
                    textLabel: "Standard Concept",
                    children: /* @__PURE__ */ a.jsx(
                      Gi,
                      {
                        id: "standard_concept",
                        name: "standard_concept",
                        options: ((ot = x == null ? void 0 : x.standard_concepts) == null ? void 0 : ot.filter(
                          (ce) => {
                            var ne;
                            return !((ne = $.standard_concept) != null && ne.some(
                              (Ue) => Ue.value === ce.value
                            ));
                          }
                        )) || [],
                        value: $.standard_concept,
                        placeholder: (ct = $.standard_concept) != null && ct.length ? "" : "Any",
                        multiple: !0,
                        onChange: (ce, ne) => {
                          re("standard_concept", ne);
                        },
                        fullWidth: !0,
                        isOptionEqualToValue: (ce, ne) => ce.value === ne,
                        getOptionLabel: hl
                      }
                    )
                  }
                ) }),
                /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ a.jsx(ze, { name: "vocabulary", textLabel: "Vocabulary", children: /* @__PURE__ */ a.jsx(
                  Gi,
                  {
                    id: "vocabulary",
                    name: "vocabulary",
                    options: ((bt = x == null ? void 0 : x.vocabularies) == null ? void 0 : bt.filter(
                      (ce) => {
                        var ne;
                        return !((ne = $.vocabulary) != null && ne.some(
                          (Ue) => Ue.value === ce.value
                        ));
                      }
                    )) || [],
                    value: $.vocabulary,
                    multiple: !0,
                    placeholder: (Yt = $.vocabulary) != null && Yt.length ? "" : "Any",
                    onChange: (ce, ne) => {
                      re("vocabulary", ne);
                    },
                    fullWidth: !0,
                    isOptionEqualToValue: (ce, ne) => ce.value === ne,
                    getOptionLabel: hl
                  }
                ) }) }),
                /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ a.jsx(
                  ze,
                  {
                    name: "search_precision",
                    textLabel: "Search Precision",
                    children: /* @__PURE__ */ a.jsx(
                      Yp,
                      {
                        value: $.search_precision,
                        onChange: (ce) => re("search_precision", ce),
                        disabled: f
                      }
                    )
                  }
                ) })
              ]
            }
          )
        ] }) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(oo, { children: [
          /* @__PURE__ */ a.jsx(
            Be,
            {
              variant: "outlined",
              disabled: f,
              onClick: r,
              startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "deactivate" }),
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ a.jsx(
            Be,
            {
              disabled: f || fn($.cohort_name) || fn($.text),
              onClick: de,
              variant: "contained",
              color: "success",
              startIcon: f ? /* @__PURE__ */ a.jsx(pt, { size: 16 }) : /* @__PURE__ */ a.jsx(ge, { iconName: "stars" }),
              children: d ? "Regenerate" : "Generate"
            }
          )
        ] }) })
      ] }) }),
      /* @__PURE__ */ a.jsxs(
        Hp,
        {
          open: y,
          onClose: ae,
          maxWidth: "sm",
          fullWidth: !0,
          children: [
            /* @__PURE__ */ a.jsx(qp, { children: "Confirm duplicate concept-set handling:" }),
            /* @__PURE__ */ a.jsxs(Xp, { children: [
              /* @__PURE__ */ a.jsx(fe, { variant: "body2", color: "text.secondary", sx: { mb: 1.5 }, children: "In case AI generates concept sets that already exist in current Workspace or Study, would you like to" }),
              /* @__PURE__ */ a.jsxs(W, { display: "flex", flexDirection: "column", rowGap: 1, children: [
                /* @__PURE__ */ a.jsxs(W, { display: "flex", alignItems: "center", columnGap: 0.5, children: [
                  /* @__PURE__ */ a.jsx(
                    Bi,
                    {
                      checked: N === "NEW_VERSION",
                      onChange: () => _("NEW_VERSION"),
                      name: "generate-conflict-resolution-dialog",
                      size: "small"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", children: "OVERWRITE existing Concept Set(s) where possible (recommended)" }),
                  /* @__PURE__ */ a.jsx(We, { text: xx, children: /* @__PURE__ */ a.jsx(
                    ge,
                    {
                      iconName: "info",
                      sx: { fontSize: 14, color: "text.secondary" }
                    }
                  ) })
                ] }),
                /* @__PURE__ */ a.jsxs(W, { display: "flex", alignItems: "center", columnGap: 0.5, children: [
                  /* @__PURE__ */ a.jsx(
                    Bi,
                    {
                      checked: N === "NEW_OBJECT",
                      onChange: () => _("NEW_OBJECT"),
                      name: "generate-conflict-resolution-dialog",
                      size: "small"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", children: "Create NEW Concept Set(s)" }),
                  /* @__PURE__ */ a.jsx(We, { text: Cx, children: /* @__PURE__ */ a.jsx(
                    ge,
                    {
                      iconName: "info",
                      sx: { fontSize: 14, color: "text.secondary" }
                    }
                  ) })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ a.jsxs(Jp, { children: [
              /* @__PURE__ */ a.jsx(
                Be,
                {
                  variant: "outlined",
                  color: "darkGrey",
                  disabled: f,
                  onClick: ae,
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ a.jsx(
                Be,
                {
                  variant: "contained",
                  color: "success",
                  disabled: f,
                  onClick: () => {
                    le();
                  },
                  children: d ? "Regenerate" : "Generate"
                }
              )
            ] })
          ]
        }
      )
    ] });
  }
), Ax = ({ viewMode: e }) => {
  const t = yr(), n = zc(), { openModal: r, closeModal: i } = je(En), [o, s] = K(), [l, c] = K(!1), { enqueueSnackbar: u } = Xn(), p = je(
    gn
  ), d = Z(() => p == null ? void 0 : p.config, []), f = Da(
    (N) => N.user
  ), h = Z(() => {
    var N;
    return (N = f.data.moduleIds) == null ? void 0 : N.includes("ai");
  }, [f]), g = Z(() => Kr(d.typeContainer, d.parentId), [d.typeContainer, d.parentId]), C = Z(() => pu(d.typeContainer, d.parentId), [d.typeContainer, d.parentId]), y = () => {
    n(yh(d.typeContainer, d.parentId));
  }, I = () => {
    r(
      () => /* @__PURE__ */ a.jsx(
        Gu,
        {
          parentId: d.parentId,
          typeContainer: d.typeContainer,
          createMethod: g,
          onCancel: i,
          afterCreate: (N) => {
            t(N.id), i(), y();
          }
        }
      ),
      "Add cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  }, O = () => {
    r(
      () => /* @__PURE__ */ a.jsx(
        zu,
        {
          parentId: d.parentId,
          typeContainer: d.typeContainer,
          createMethod: g,
          onCancel: i,
          onGenerateStart: () => {
            i(), u({
              message: "Cohort generate in progress...",
              variant: "success"
            }), c(!0);
          },
          onGenerateError: () => {
            c(!1);
          },
          afterCreate: (N) => {
            t(`${N.id}`, {
              state: { aiGenerateRequested: !0 }
            }), y();
          }
        }
      ),
      "Generate Cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  }, S = () => {
    r(
      () => /* @__PURE__ */ a.jsx(
        _c,
        {
          name: "cohorts",
          currentContainer: d.typeContainer,
          parentId: d.parentId,
          onChange: async () => {
            s(Dn()), i();
          },
          createListMethods: Ji,
          cols: Na,
          createListFiltersMethod: na,
          createMethodCreate: Kr,
          subModules: p.subModules,
          isSelect: !0,
          hideConflictResolutionMethod: !0,
          hideConflictResolutionControls: !0,
          successMessage: "Cohort(s) successfully imported.",
          atlasEntity: [Ra.COHORT],
          manualImport: !0,
          manualImportComponent: /* @__PURE__ */ a.jsx(
            uu,
            {
              typeContainer: d.typeContainer,
              parentId: d.parentId,
              importMethod: C,
              fullEntity: !0,
              onChange: (N) => {
                t(N.id), i(), y();
              }
            }
          )
        }
      ),
      "Import cohort",
      {
        onClose: i,
        closeOnClickOutside: !0
      }
    );
  };
  return l ? /* @__PURE__ */ a.jsx(Xt, { background: "/images/back.png", children: /* @__PURE__ */ a.jsx(jc, {}) }) : /* @__PURE__ */ a.jsx(
    Nc,
    {
      reloadId: o,
      isImport: !0,
      onImport: S,
      onCreate: I,
      onGenerate: h && O,
      moduleConfig: p,
      viewMode: e,
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading cohorts...",
        addButtonTitle: "Add cohort",
        tableTitle: "Cohorts",
        moduleDescription: "Cohort is a set of persons who satisfy one or more inclusion and/or exclusion criteria for a duration of time.",
        importButtonTitle: "Import",
        listInitialSort: { id: "modified.timestamp", desc: !0 },
        createCrudMethod: Ji,
        createFiltersPanel: na,
        createSortingMethod: du,
        getCols: kf,
        metadataFilter: "&filter.metadata.subject=COHORT",
        extendedSearchEnabled: !1
      },
      variant: "description",
      allowDelete: !0
    }
  );
};
function bx(e, t, n) {
  var r = this, i = Te(null), o = Te(0), s = Te(null), l = Te([]), c = Te(), u = Te(), p = Te(e), d = Te(!0);
  q(function() {
    p.current = e;
  }, [e]);
  var f = !t && t !== 0 && typeof window < "u";
  if (typeof e != "function") throw new TypeError("Expected a function");
  t = +t || 0;
  var h = !!(n = n || {}).leading, g = !("trailing" in n) || !!n.trailing, C = "maxWait" in n, y = C ? Math.max(+n.maxWait || 0, t) : null;
  q(function() {
    return d.current = !0, function() {
      d.current = !1;
    };
  }, []);
  var I = Z(function() {
    var O = function(U) {
      var M = l.current, w = c.current;
      return l.current = c.current = null, o.current = U, u.current = p.current.apply(w, M);
    }, S = function(U, M) {
      f && cancelAnimationFrame(s.current), s.current = f ? requestAnimationFrame(U) : setTimeout(U, M);
    }, N = function(U) {
      if (!d.current) return !1;
      var M = U - i.current;
      return !i.current || M >= t || M < 0 || C && U - o.current >= y;
    }, _ = function(U) {
      return s.current = null, g && l.current ? O(U) : (l.current = c.current = null, u.current);
    }, R = function U() {
      var M = Date.now();
      if (N(M)) return _(M);
      if (d.current) {
        var w = t - (M - i.current), V = C ? Math.min(w, y - (M - o.current)) : w;
        S(U, V);
      }
    }, P = function() {
      var U = Date.now(), M = N(U);
      if (l.current = [].slice.call(arguments), c.current = r, i.current = U, M) {
        if (!s.current && d.current) return o.current = i.current, S(R, t), h ? O(i.current) : u.current;
        if (C) return S(R, t), O(i.current);
      }
      return s.current || S(R, t), u.current;
    };
    return P.cancel = function() {
      s.current && (f ? cancelAnimationFrame(s.current) : clearTimeout(s.current)), o.current = 0, l.current = i.current = c.current = s.current = null;
    }, P.isPending = function() {
      return !!s.current;
    }, P.flush = function() {
      return s.current ? _(Date.now()) : u.current;
    }, P;
  }, [h, C, t, y, g, f]);
  return I;
}
function Rx(e, t) {
  return e === t;
}
function ml(e) {
  return typeof e == "function" ? function() {
    return e;
  } : e;
}
function Ox(e, t, n) {
  var r, i, o = Rx, s = (r = K(ml(e)), i = r[1], [r[0], ie(function(d) {
    return i(ml(d));
  }, [])]), l = s[0], c = s[1], u = bx(ie(function(d) {
    return c(d);
  }, [c]), t, n), p = Te(e);
  return o(p.current, e) || (u(e), p.current = e), [l, u];
}
var rn = /* @__PURE__ */ ((e) => (e.SET_DEFINITION_RELOAD = "SET_DEFINITION_RELOAD", e.SET_DEFINITION = "SET_DEFINITION", e.SET_AI_ATTRIBUTES = "SET_AI_ATTRIBUTES", e.START_GENERATION = "START_GENERATION", e.UPDATE_DEFINITION = "UPDATE_DEFINITION", e.UPDATE_DEFINITION_BASE = "UPDATE_DEFINITION_BASE", e.CLEAR_DEFINITION = "CLEAR_DEFINITION", e.GET_SUMMARY = "GET_SUMMARY", e.SET_AI_RESULTS = "SET_AI_RESULTS", e.FINISH_GENERATION = "FINISH_GENERATION", e.INIT_DEFINITION = "INIT_DEFINITION", e))(rn || {});
const Dx = {
  definition: null,
  definitionStatus: ue.INITIAL,
  definitionError: null,
  summary: {
    metadata: 0,
    versions: 0
  },
  aiAttrbutes: [],
  aiGenerate: !1,
  aiJobId: null,
  aiStatus: null,
  aiOutput: null,
  aiValues: null,
  aiCompleteTimestamp: null,
  aiCompleteGeneration: !0,
  aiGenerationPending: !1,
  clinicalTrials: null,
  isAiCohort: !1
}, vx = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case "SET_DEFINITION_RELOAD": {
      n.definitionStatus = ue.IN_PROGRESS;
      break;
    }
    case "SET_DEFINITION":
      n.definitionStatus = ue.SUCCESS, n.definition = t.payload;
      break;
    case "UPDATE_DEFINITION":
      n.definition && (n.definition.expression[t.payload.prop] = t.payload.value);
      break;
    case "UPDATE_DEFINITION_BASE":
      n.definition && (n.definition = {
        ...n.definition,
        ...t.payload
      });
      break;
    case "INIT_DEFINITION":
      n.definitionStatus = ue.SUCCESS, n.definition = t.payload.definition, n.summary = t.payload.summary, n.aiValues = t.payload.aiMetadata.aiValues, t.payload.aiMetadata.aiGenerate && (n.aiGenerationPending = !1), n.aiGenerate = t.payload.aiMetadata.aiGenerate || n.aiGenerationPending, n.isAiCohort = t.payload.aiMetadata.isAiCohort;
      break;
    case "GET_SUMMARY":
      n.summary = t.payload;
      break;
    case "SET_AI_ATTRIBUTES":
      if (n.aiValues = t.payload.aiValues, n.isAiCohort = t.payload.isAiCohort, t.payload.terminalAiStatus) {
        n.aiGenerate = !1, n.aiGenerationPending = !1;
        break;
      }
      t.payload.aiGenerate && (n.aiGenerationPending = !1), n.aiGenerate = t.payload.aiGenerate || n.aiGenerationPending;
      break;
    case "START_GENERATION":
      n.aiGenerate = !0, n.aiGenerationPending = !0;
      break;
    case "CLEAR_DEFINITION":
      t.payload.forEach((r) => {
        delete n.definition.expression[r];
      });
      break;
  }
}), El = {
  PrimaryCriteria: {
    CriteriaList: [],
    ObservationWindow: {
      PriorDays: 0,
      PostDays: 0
    },
    PrimaryCriteriaLimit: {
      Type: Wt.FIRST
    }
  },
  QualifiedLimit: {
    Type: Wt.FIRST
  },
  ExpressionLimit: {
    Type: Wt.FIRST
  },
  InclusionRules: [],
  CensoringCriteria: [],
  CollapseSettings: {
    CollapseType: pp.ERA,
    EraPad: 0
  },
  CensorWindow: {},
  ConceptSets: []
}, _x = (e) => e == null ? !1 : typeof e == "string" ? e.trim().length > 0 : !0;
function Nx(e) {
  var r;
  const t = (r = e == null ? void 0 : e.expression) == null ? void 0 : r.ConceptSets;
  if (!t) return e;
  const n = t.map((i) => {
    const { isNewImport: o, uuid: s, expression: l, ...c } = i, u = { ...c }, p = _x(s);
    return o === !0 && p ? u.uuid = s : (p && (u.uuid = s), l !== void 0 && (u.expression = l)), u;
  });
  return {
    ...e,
    expression: {
      ...e.expression,
      ConceptSets: n
    }
  };
}
function ni(e) {
  if (!e || typeof e != "object") return e;
  let t = {};
  for (let n in e) {
    let r = e[n];
    if (r !== void 0)
      if (typeof r == "object" && r !== null) {
        let i = Object.keys(r), o = { ...r };
        for (let s of i)
          if (s.endsWith("Exclude")) {
            let l = s.replace("Exclude", "");
            (o[s] === !1 || !i.includes(l)) && delete o[s];
          }
        t[n] = ni(o);
      } else
        t[n] = r;
  }
  return t;
}
function za(e) {
  return Array.isArray(e) ? e.map((t) => {
    if (typeof t != "object" || t === null) return t;
    let n = ni(t);
    return n.CorrelatedCriteria && typeof n.CorrelatedCriteria == "object" && Array.isArray(n.CorrelatedCriteria.CriteriaList) && (n.CorrelatedCriteria.CriteriaList = za(
      n.CorrelatedCriteria.CriteriaList
    )), n.Criteria && typeof n.Criteria == "object" && (n.Criteria = ni(n.Criteria)), n;
  }) : e;
}
function wx(e) {
  return Array.isArray(e) ? e.map((t) => {
    if (typeof t != "object" || t === null) return t;
    let n = ni(t);
    return n.expression && n.expression.CriteriaList && (n.expression.CriteriaList = za(
      n.expression.CriteriaList
    )), n;
  }) : e;
}
function Px(e, t) {
  return {
    ...e,
    expression: {
      items: Object.values(t || {}).map((n) => {
        const { id: r, ...i } = n, o = n.excluded ?? n.isExcluded;
        return {
          ...i,
          concept: null,
          isExcluded: o,
          excluded: o,
          hierarchy: n.hierarchy,
          includeDescendants: n.includeDescendants,
          includeMapped: n.includeMapped
        };
      })
    }
  };
}
function Di(e) {
  if (!e || typeof e != "object") return e;
  let t = ni(e);
  return t.PrimaryCriteria && Array.isArray(t.PrimaryCriteria.CriteriaList) && (t.PrimaryCriteria.CriteriaList = za(
    t.PrimaryCriteria.CriteriaList
  )), t.InclusionRules && Array.isArray(t.InclusionRules) && (t.InclusionRules = wx(
    t.InclusionRules
  )), t.ConceptSets && (t.ConceptSets = (Array.isArray(t.ConceptSets) ? t.ConceptSets : Object.values(t.ConceptSets)).map((n) => {
    var r;
    if (typeof n == "object" && n !== null) {
      const { uuid: i, ...o } = n;
      return Px(o, (r = n.expression) == null ? void 0 : r.items);
    }
    return n;
  })), t;
}
function ua(e) {
  return Array.isArray(e) ? e.map((t) => ua(t)) : !e || typeof e != "object" ? e : Object.entries(e).reduce((t, [n, r]) => (r !== void 0 && (t[n] = ua(r)), t), {});
}
function jx(e) {
  const [t = "", n = ""] = e.split("#");
  return { aiJobId: t.trim(), clinicalTrials: n.trim() };
}
const Wu = /^\s*(?:#{1,6}\s*)?(?:\d+[.)]\s*)?(?:Sources|Resources|References)(?:\s*(?:and|\/)\s*(?:Sources|Resources|References))*\s*:?\s*$/i, Yu = /^(?:[-*\u2022]|\d+[.)])/;
function Hu(e) {
  const t = e.split(`
`), n = t.findIndex(
    (o) => Wu.test(o.trim())
  );
  if (n === -1)
    return e;
  let r = !1, i = n + 1;
  for (; i < t.length && (Yu.test(t[i].trim()) || t[i].trim() === ""); ) {
    const o = t[i].trim(), s = o.match(/https?:\/\/[^\s)]+/);
    if (s && !o.includes("](")) {
      const l = s[0], u = o.replace(/^(?:[-*\u2022]|\d+[.)])\s*/, "").replace(l, "").trim().replace(/[:\-.]+$/, "") || l;
      t[i] = `- [${u}](${l})`, r = !0;
    }
    i++;
  }
  return r ? t.join(`
`) : e;
}
function Lx(e, t) {
  const n = `https://clinicaltrials.gov/study/${t}`, r = Hu(e), i = r.split(`
`), o = i.findIndex(
    (l) => Wu.test(l.trim())
  );
  if (o === -1)
    return t ? `${r.trim()}

## Sources:
- [ClinicalTrials.gov reference: ${n}](${n})` : r;
  let s = o + 1;
  for (; s < i.length && (Yu.test(i[s].trim()) || i[s].trim() === ""); )
    s++;
  return t && (i.some((c) => c.includes(n)) || i.splice(
    s,
    0,
    `- [ClinicalTrials.gov reference: ${n}](${n})`
  )), i.join(`
`);
}
function kx(e) {
  var r, i;
  const t = ((r = e.find(
    (o) => {
      var s;
      return ((s = o.attribute) == null ? void 0 : s.name) === "ai-clinical-trials-id";
    }
  )) == null ? void 0 : r.value) || "";
  if (t)
    return t.trim();
  const n = ((i = e.find((o) => {
    var s;
    return ((s = o.attribute) == null ? void 0 : s.name) === "ai-job-id";
  })) == null ? void 0 : i.value) || "";
  return jx(n).clinicalTrials;
}
function Mx(e) {
  const t = kx(e);
  let n = !1;
  const r = e.map((i) => {
    var c;
    if (((c = i.attribute) == null ? void 0 : c.name) !== "ai-reasoning")
      return i;
    const o = i.value ?? "", s = Hu(o), l = t ? Lx(s, t) : s;
    return l !== o ? (n = !0, {
      ...i,
      value: l
    }) : i;
  });
  return n ? r : e;
}
const Vx = (e, t, n) => {
  const r = op(
    e,
    t,
    n
  ), [i, o] = xr(
    vx,
    Dx
  ), s = ie(
    async (O = !1) => {
      try {
        const S = await pf(t);
        if (O)
          return S;
        o({
          type: rn.GET_SUMMARY,
          payload: S
        });
      } catch {
        return {
          metadata: 0,
          versions: 0
        };
      }
    },
    [t]
  ), l = async (O) => {
    await r.getEntity(), await c(!1, O);
  }, c = async (O = !1, S) => {
    var N;
    try {
      const _ = await qi(
        "filter.metadata.value.subject.id",
        t
      ), R = _.content.find(Uc), P = Mx(_.content), U = (N = _.content.find(ph)) == null ? void 0 : N.value, M = (R == null ? void 0 : R.value) === "Yes" && ["IN_PROGRESS", "QUEUED"].includes(U || ""), w = {
        aiValues: P,
        // Terminal AI events are authoritative even if metadata is briefly stale.
        aiGenerate: S ? !1 : M,
        terminalAiStatus: S,
        isAiCohort: (R == null ? void 0 : R.value) === "Yes"
      };
      if (O)
        return w;
      o({
        type: rn.SET_AI_ATTRIBUTES,
        payload: w
      });
    } catch {
      return null;
    }
  }, u = ie(() => {
    if (i.definitionStatus != ue.SUCCESS)
      return;
    const O = Di(r.draft.expression), S = Di(i.definition.expression);
    return Pe(O, S);
  }, [
    r.draft,
    i.definition,
    r.status,
    i.definitionStatus
  ]), p = Z(() => {
    var N, _;
    if (r.status !== ue.SUCCESS || i.definitionStatus !== ue.SUCCESS || !((N = r.draft) != null && N.expression) && Pe((_ = i.definition) == null ? void 0 : _.expression, El))
      return !0;
    const O = Di(r.draft.expression), S = Di(i.definition.expression);
    return !!(Pe(O, S) && Pe(r.draft.name, i.definition.name) && Pe(r.draft.description, i.definition.description));
  }, [
    r.draft,
    i.definition,
    r.status,
    i.definitionStatus
  ]), d = ie(
    (O, S, N = !1) => {
      const _ = {
        ...O,
        expression: {
          ...El,
          ...O.expression
        },
        ...S && {
          name: S.name,
          description: S.description
        }
      };
      if (N)
        return _;
      o({
        type: rn.SET_DEFINITION,
        payload: _
      });
    },
    []
  ), f = ie(
    (O, S) => {
      var _;
      const N = (_ = i.definition) == null ? void 0 : _.expression;
      Pe(N == null ? void 0 : N[O], S) || o({
        type: rn.UPDATE_DEFINITION,
        payload: {
          prop: O,
          value: S
        }
      });
    },
    [i.definition]
  ), h = ie(
    (O) => {
      o({
        type: rn.UPDATE_DEFINITION_BASE,
        payload: O
      });
    },
    []
  ), g = ie(
    (O) => {
      o({
        type: rn.CLEAR_DEFINITION,
        payload: O
      });
    },
    [i.definition]
  ), C = ie(
    async (O) => {
      var _, R;
      const S = {
        ...i.definition,
        expression: ua((_ = i.definition) == null ? void 0 : _.expression)
      }, N = Nx(S);
      try {
        await r.updateEntity({
          ...N,
          name: O.name,
          description: O.description ?? ((R = i.definition) == null ? void 0 : R.description)
        }), await s();
      } catch (P) {
        console.error(P);
      }
    },
    [i.definition, r.updateEntity]
  ), y = ie(() => {
    o({
      type: rn.START_GENERATION
    });
  }, []), I = async (O) => {
    o({ type: rn.SET_DEFINITION_RELOAD });
    const S = await s(!0), N = await c(!0), _ = d(O, void 0, !0);
    o({
      type: rn.INIT_DEFINITION,
      payload: {
        summary: S,
        aiMetadata: N,
        definition: _
      }
    });
  };
  return q(() => {
    var O, S, N, _;
    if (r.status === ue.SUCCESS) {
      const R = u(), P = (O = r.draft) == null ? void 0 : O.versionId, U = (S = i.definition) == null ? void 0 : S.versionId, M = (N = r.draft) == null ? void 0 : N.designVersionId, w = (_ = i.definition) == null ? void 0 : _.designVersionId;
      if (R && !(P !== U || M !== w)) {
        (async () => (await c(), await s()))();
        return;
      }
      I(r.draft);
    }
  }, [r.status, r.draft]), {
    ...i,
    ...r,
    updateDefinition: f,
    updateDefinitionBase: h,
    saveDefinition: C,
    setDefinition: d,
    isEqual: p,
    clearDefinition: g,
    getCountsSummary: s,
    refetchEntity: l,
    startGeneration: y
  };
}, Ux = Ze((e) => {
  const {
    messages: t,
    setFilters: n,
    filter: r,
    filters: i,
    isLoading: o,
    fixEntity: s,
    fixEntityAvailability: l
  } = e;
  return /* @__PURE__ */ a.jsx(
    Rp,
    {
      messages: t,
      setFilters: n,
      filters: i,
      filter: r,
      isLoading: o,
      fixEntity: s,
      fixEntityAvailability: l,
      loadingMessage: "Loading Cohort Messages"
    }
  );
});
var ri = /* @__PURE__ */ ((e) => (e.CONCEPT_SET_ID = "conceptSetId", e.RULE_NAME = "ruleName", e))(ri || {});
function Fx(e, t, n) {
  var r;
  if (e.type === Fi.CONCEPT_SET && e.hasOwnProperty(ri.CONCEPT_SET_ID)) {
    const i = (t == null ? void 0 : t.ConceptSets) || [];
    if (i.find((s) => s.id === e.conceptSetId)) {
      const s = i.filter((l) => l.id !== e.conceptSetId);
      n("ConceptSets", s);
    }
  }
  if (e.type === Fi.INCOMPLETE_RULE && e.hasOwnProperty(ri.RULE_NAME)) {
    const i = ((r = t == null ? void 0 : t.definition) == null ? void 0 : r.InclusionRules) || [];
    if (i.find((s) => s.name === e.ruleName)) {
      const s = {
        ...t == null ? void 0 : t.definition,
        InclusionRules: i.filter(
          (l) => l.name !== e.ruleName
        )
      };
      n("InclusionRules", s);
    }
  }
}
function Bx(e) {
  return e.type === Fi.CONCEPT_SET && e.hasOwnProperty(ri.CONCEPT_SET_ID) || e.type === Fi.INCOMPLETE_RULE && e.hasOwnProperty(ri.RULE_NAME);
}
const $x = Ze((e) => {
  const { data: t } = e, { exportCohort: n, getExportCohort: r } = ap(
    ki.COHORT,
    null,
    t
  ), i = Z(
    () => n == null ? void 0 : n.expression,
    [n]
  ), o = Z(() => n == null ? void 0 : n.name, [n == null ? void 0 : n.name]), s = Z(
    () => Fc(Xr.JSON),
    []
  );
  return q(() => {
    t && r(t, "circe");
  }, [t]), /* @__PURE__ */ a.jsx(A, { container: !0, p: 2, children: /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: i ? /* @__PURE__ */ a.jsx(
    wc,
    {
      data: i,
      fileName: o,
      language: s,
      readOnly: !0,
      fileExtension: Xr.JSON
    }
  ) : /* @__PURE__ */ a.jsx(Xt, { children: /* @__PURE__ */ a.jsx(pt, { size: 32 }) }) }) });
}), vi = [
  {
    value: "template-ohdsi",
    name: "Template OHDSI.SQL",
    requests: ["template", "ohdsi", "generic"]
  },
  {
    value: "mssql-server",
    name: "MSSQL Server",
    requests: ["sql server", "sql_server", "mssql", "ms_sql_server"]
  },
  {
    value: "ms-aps",
    name: "MS APS",
    requests: ["pdw", "aps", "sql_server_pdw"]
  },
  {
    value: "oracle",
    name: "Oracle",
    requests: ["oracle"]
  },
  {
    value: "postgresql",
    name: "PostgreSQL",
    requests: ["postgresql", "postgres"]
  },
  {
    value: "redshift",
    name: "Amazon Red Shift",
    requests: ["redshift"]
  },
  {
    value: "impala",
    name: "Impala",
    requests: ["impala"]
  },
  {
    value: "netezza",
    name: "Netezza",
    requests: ["netezza"]
  },
  {
    value: "bigquery",
    name: "Big Query",
    requests: ["bigquery", "google_bigquery"]
  },
  {
    value: "hive",
    name: "Apache Hive",
    requests: ["hive", "apache_hive"]
  },
  {
    value: "spark",
    name: "Spark",
    requests: ["spark"]
  },
  {
    value: "snowflake",
    name: "Snowflake",
    requests: ["snowflake"]
  },
  {
    value: "azure-synapse",
    name: "Azure Synapse",
    requests: ["synapse"]
  },
  {
    value: "iris",
    name: "InterSystems IRIS",
    requests: ["iris"]
  }
], Gx = "-- SQL template is unavailable for selected database dialect", xl = {
  tempDatabaseSchema: "@temp_database_schema",
  vocabularyDatabaseSchema: "@vocabulary_database_schema",
  cdmDatabaseSchema: "@cdm_database_schema",
  targetDatabaseSchema: "@target_database_schema",
  targetCohortTable: "@target_cohort_table",
  targetCohortId: "@target_cohort_id"
}, jo = (e) => typeof e == "object" && e !== null, zx = (e) => {
  if (!jo(e) || !jo(e.response))
    return "Failed to load SQL export";
  const t = e.response.data;
  return jo(t) && typeof t.message == "string" && t.message.trim() ? t.message : "Failed to load SQL export";
}, Wx = (e) => ({
  tempDatabaseSchema: "",
  vocabularyDatabaseSchema: "",
  cdmDatabaseSchema: "",
  targetDatabaseSchema: "",
  targetCohortTable: "",
  targetCohortId: e || ""
}), Yx = (e, t) => Object.keys(xl).reduce(
  (n, r) => {
    const i = xl[r], o = t[r].trim();
    return o ? n.split(i).join(o) : n;
  },
  e
), Hx = Ze(
  ({ cohortId: e, cohortName: t, cohortShortcut: n }) => {
    const [r, i] = K("template-ohdsi"), [o, s] = K(""), [l, c] = K(ue.INITIAL), [u, p] = K(""), [d, f] = K(!1), [h, g] = K(
      () => Wx(n)
    ), C = Z(
      () => vi.find((S) => S.value === r) || vi[0],
      [r]
    ), y = Z(
      () => Fc(Xr.SQL),
      []
    ), I = Z(() => {
      const S = o || Gx;
      return d ? Yx(S, h) : S;
    }, [o, d, h]);
    q(() => {
      let S = !0;
      return c(ue.IN_PROGRESS), p(""), gf(
        e,
        C.requests,
        r === "template-ohdsi"
      ).then((N) => {
        S && (s(N), c(ue.SUCCESS));
      }).catch((N) => {
        if (!S)
          return;
        const _ = zx(N);
        p(_), s(""), c(ue.ERROR);
      }), () => {
        S = !1;
      };
    }, [e, C]);
    const O = (S, N) => {
      g((_) => ({
        ..._,
        [S]: N
      }));
    };
    return /* @__PURE__ */ a.jsxs(A, { container: !0, p: 2, spacing: 2, children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, md: 8, children: /* @__PURE__ */ a.jsx(
        ze,
        {
          name: "databaseDialect",
          textLabel: "Database dialect",
          required: !0,
          children: /* @__PURE__ */ a.jsx(
            It,
            {
              id: "databaseDialect",
              name: "databaseDialect",
              options: vi,
              value: r,
              onChange: (S) => {
                var _;
                if (typeof S != "string")
                  return;
                const N = (_ = vi.find(
                  (R) => R.value === S
                )) == null ? void 0 : _.value;
                N && i(N);
              },
              fullWidth: !0
            }
          )
        }
      ) }),
      /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 12, md: 8, children: [
        l === ue.IN_PROGRESS && /* @__PURE__ */ a.jsx(Xt, { children: /* @__PURE__ */ a.jsx(pt, { size: 32 }) }),
        l !== ue.IN_PROGRESS && /* @__PURE__ */ a.jsx(
          wc,
          {
            data: I,
            fileName: `${t}-${C.value}`,
            language: y,
            readOnly: !0,
            fileExtension: Xr.SQL
          },
          `${C.value}-${d ? "substituted" : "template"}`
        ),
        u && /* @__PURE__ */ a.jsx(
          fe,
          {
            variant: "body2",
            color: "error",
            mt: 1,
            className: "cohort-sql-export-error",
            children: u
          }
        )
      ] }),
      /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 12, md: 4, children: [
        /* @__PURE__ */ a.jsx(
          fe,
          {
            component: "div",
            sx: {
              color: (S) => {
                var N, _;
                return (_ = (N = S.palette) == null ? void 0 : N.textColor) == null ? void 0 : _.header;
              },
              fontSize: 13,
              fontWeight: 700,
              mb: 1.25
            },
            children: "Parameter substitution"
          }
        ),
        /* @__PURE__ */ a.jsxs(A, { container: !0, rowGap: 1.25, children: [
          /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            ze,
            {
              name: "tempDatabaseSchema",
              textLabel: "temp_database_schema",
              children: /* @__PURE__ */ a.jsx(
                Ye,
                {
                  id: "tempDatabaseSchema",
                  name: "tempDatabaseSchema",
                  value: h.tempDatabaseSchema,
                  onChange: (S) => O("tempDatabaseSchema", S.target.value),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            ze,
            {
              name: "vocabularyDatabaseSchema",
              textLabel: "vocabulary_database_schema",
              children: /* @__PURE__ */ a.jsx(
                Ye,
                {
                  id: "vocabularyDatabaseSchema",
                  name: "vocabularyDatabaseSchema",
                  value: h.vocabularyDatabaseSchema,
                  onChange: (S) => O(
                    "vocabularyDatabaseSchema",
                    S.target.value
                  ),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            ze,
            {
              name: "cdmDatabaseSchema",
              textLabel: "cdm_database_schema",
              children: /* @__PURE__ */ a.jsx(
                Ye,
                {
                  id: "cdmDatabaseSchema",
                  name: "cdmDatabaseSchema",
                  value: h.cdmDatabaseSchema,
                  onChange: (S) => O("cdmDatabaseSchema", S.target.value),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            ze,
            {
              name: "targetDatabaseSchema",
              textLabel: "target_database_schema",
              children: /* @__PURE__ */ a.jsx(
                Ye,
                {
                  id: "targetDatabaseSchema",
                  name: "targetDatabaseSchema",
                  value: h.targetDatabaseSchema,
                  onChange: (S) => O("targetDatabaseSchema", S.target.value),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            ze,
            {
              name: "targetCohortTable",
              textLabel: "target_cohort_table",
              children: /* @__PURE__ */ a.jsx(
                Ye,
                {
                  id: "targetCohortTable",
                  name: "targetCohortTable",
                  value: h.targetCohortTable,
                  onChange: (S) => O("targetCohortTable", S.target.value),
                  fullWidth: !0
                }
              )
            }
          ) }),
          /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(ze, { name: "targetCohortId", textLabel: "target_cohort_id", children: /* @__PURE__ */ a.jsx(
            Ye,
            {
              id: "targetCohortId",
              name: "targetCohortId",
              value: h.targetCohortId,
              onChange: (S) => O("targetCohortId", S.target.value),
              fullWidth: !0
            }
          ) }) }),
          /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(A, { container: !0, alignItems: "center", columnGap: 1.25, children: [
            /* @__PURE__ */ a.jsx(
              hr,
              {
                checked: d,
                onChange: (S) => f(S.target.checked)
              }
            ),
            /* @__PURE__ */ a.jsx(fe, { variant: "body2", children: "Apply parameter substitution" })
          ] }) })
        ] })
      ] })
    ] });
  }
), Lo = {
  title: "Event persistence",
  textControlTextSections: {
    eventsPersistence: {
      startText: "Event will persist until:",
      options: Dh,
      endText: ""
    }
  },
  persistentTypes: {
    FIXED: {
      title: "Fixed Duration Persistence:",
      description: "The event end date is derived from adding a number of days to the event's start or end date. If an offset is added to the event's start date, all cohort episodes will have the same fixed duration (subject to further censoring). If an offset is added to the event's end date, persons in the cohort may have varying cohort duration times due to the varying event durations (such as eras of persistent drug exposure or visit length of stay). This event persistence assures that the cohort end date will be no greater than the selected index event date, plus the days offset.",
      dateEdge: {
        startText: "Event date to offset from:",
        control: "select",
        options: Hc,
        endText: ""
      },
      numberOfDays: {
        startText: "Number of days offset:",
        control: "select",
        type: "autocomplete",
        options: zn,
        endText: "days"
      }
    },
    EXPOSURE: {
      title: "Continuous Exposure Persistence:",
      description: "Specify a concept set that contains one or more drugs. A drug era will be derived from all drug exposure events for any of the drugs within the concept set, using the specified persistence window as a maximum allowable gap in days between successive exposure events and adding a specified surveillance window to the final exposure event. If no exposure event end date is provided, then an exposure event end date is inferred to be event start date + days supply in cases when days supply is available or event start date + 1 day otherwise. This event persistence assures that the cohort end date will be no greater than the drug era end date.",
      selectDrugConcept: {
        startText: "Concept set containing the drug(s) of interest:",
        defaultTitle: "Select drug concept set",
        endText: ""
      },
      numberOfDaysPersistenceWindow: {
        startText: "Persistence window: allow for a maximum of",
        control: "select",
        type: "autocomplete",
        options: zn,
        endText: "days between exposure records when inferring the era of persistence exposure"
      },
      numberOfDaysSurveillance: {
        startText: "Surveillance window: add",
        control: "select",
        type: "autocomplete",
        options: zn,
        endText: "days to the end of the era of persistence exposure as an additional period of surveillance prior to cohort exit."
      },
      numberOfDaysForce: {
        preChooseText: "Use days supply and exposure end date for exposure duration.",
        startText: "Force drug exposure days supply to: ",
        control: "select",
        type: "autocomplete",
        options: zn,
        endText: "days"
      }
    }
  }
}, qx = (e) => {
  var u, p;
  const { data: t, update: n, initValues: r, viewMode: i = !1 } = e, [o, s] = K({
    DateField: ((u = r == null ? void 0 : r.DateOffset) == null ? void 0 : u.DateField) || "StartDate",
    Offset: ((p = r == null ? void 0 : r.DateOffset) == null ? void 0 : p.Offset) || 0
  }), { DateField: l, Offset: c } = o;
  return q(() => {
    Pe(r, o) || n && n({
      DateOffset: o
    });
  }, [o]), /* @__PURE__ */ a.jsxs(Le.Fragment, { children: [
    /* @__PURE__ */ a.jsx(W, { component: "h4", mt: 1, children: t.title }),
    /* @__PURE__ */ a.jsx(W, { component: "p", sx: { fontSize: 12 }, children: t.description }),
    /* @__PURE__ */ a.jsxs(W, { component: "ul", pl: 4, my: 1, children: [
      /* @__PURE__ */ a.jsx(W, { component: "li", mb: 1, children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: i,
          startText: t.dateEdge.startText,
          endText: t.dateEdge.endText,
          onChange: (d) => s({ ...o, DateField: d }),
          options: t.dateEdge.options,
          value: l
        }
      ) }),
      /* @__PURE__ */ a.jsx(W, { component: "li", children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: i,
          startText: t.numberOfDays.startText,
          type: t.numberOfDays.type,
          endText: t.numberOfDays.endText,
          onChange: (d) => s({ ...o, Offset: d }),
          options: t.numberOfDays.options,
          value: c
        }
      ) })
    ] })
  ] });
}, Xx = (e) => {
  var L, te, $, v, J, j, ee, Q, x, Y;
  const { data: t, update: n, initValues: r, viewMode: i = !1 } = e, [o, s] = K({
    DrugCodesetId: ((L = r == null ? void 0 : r.CustomEra) == null ? void 0 : L.DrugCodesetId) || -1,
    GapDays: ((te = r == null ? void 0 : r.CustomEra) == null ? void 0 : te.GapDays) || 0,
    Offset: (($ = r == null ? void 0 : r.CustomEra) == null ? void 0 : $.Offset) || 0,
    DaysSupplyOverride: ((v = r == null ? void 0 : r.CustomEra) == null ? void 0 : v.DaysSupplyOverride) || void 0
  }), { openModal: l, closeModal: c } = je(En), [u, p] = K(
    ((J = r == null ? void 0 : r.CustomEra) == null ? void 0 : J.DrugCodesetId) || -1
  ), { GapDays: d, Offset: f, DaysSupplyOverride: h } = o, [g, C] = K(
    !!((j = r == null ? void 0 : r.CustomEra) != null && j.DaysSupplyOverride)
  ), y = je(
    Or
  ), { subModules: I, config: O } = je(
    gn
  ), { conceptSets: S, updateConceptSets: N, refreshConceptSetReference: _ } = Z(() => y, [y]), R = Wi(u, S), { typeContainer: P, parentId: U } = O;
  q(() => {
    let k = {
      GapDays: o.GapDays,
      Offset: o.Offset
    };
    o.DrugCodesetId && o.DrugCodesetId >= 0 && (k.DrugCodesetId = o.DrugCodesetId), g && (k.DaysSupplyOverride = o.DaysSupplyOverride), Pe(k, r) || n && n({
      CustomEra: k
    });
  }, [o]);
  const M = () => {
    l(
      () => /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
        I.concept,
        {
          type: "component",
          name: "view-concept-set-button",
          subModules: I,
          config: {
            conceptSets: S,
            conceptSetId: u
          }
        }
      ) }),
      "View concept set",
      {
        closeOnClickOutside: !0,
        onClose: c,
        width: "1000px"
      }
    );
  }, w = () => {
    p(-1), s({
      ...o,
      DrugCodesetId: -1
    });
  }, V = (k, T) => {
    p(k.id), s({
      ...o,
      DrugCodesetId: k.id
    }), T && N([...S, k]);
  };
  return /* @__PURE__ */ a.jsxs(Le.Fragment, { children: [
    /* @__PURE__ */ a.jsx("h4", { children: t.title }),
    /* @__PURE__ */ a.jsx("p", { children: t.description }),
    /* @__PURE__ */ a.jsxs(JE, { children: [
      /* @__PURE__ */ a.jsx(qE, { children: (ee = t == null ? void 0 : t.selectDrugConcept) == null ? void 0 : ee.startText }),
      i ? /* @__PURE__ */ a.jsxs(W, { display: "flex", alignItems: "center", flexWrap: "nowrap", children: [
        /* @__PURE__ */ a.jsx(
          Mu,
          {
            existConceptSet: u && u >= 0,
            onClick: u && u >= 0 ? M : () => {
            },
            children: u && u >= 0 ? R == null ? void 0 : R.name : (Q = t == null ? void 0 : t.selectDrugConcept) == null ? void 0 : Q.defaultTitle
          }
        ),
        /* @__PURE__ */ a.jsx(
          Hn,
          {
            conceptSet: R,
            viewMode: i,
            onRefresh: _
          }
        )
      ] }) : /* @__PURE__ */ a.jsxs(W, { display: "flex", alignItems: "center", flexWrap: "nowrap", children: [
        /* @__PURE__ */ a.jsx(
          I.concept,
          {
            type: "component",
            name: "widget-concept-set-choose-button",
            subModules: I,
            config: {
              conceptSets: S,
              defaultValue: (x = t == null ? void 0 : t.selectDrugConcept) == null ? void 0 : x.defaultTitle,
              conceptSetId: u,
              onUpdate: V,
              onClear: w,
              typeContainer: P,
              parentId: U,
              localImport: !0
            }
          }
        ),
        /* @__PURE__ */ a.jsx(
          Hn,
          {
            conceptSet: R,
            viewMode: i,
            onRefresh: _
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a.jsxs("ul", { children: [
      /* @__PURE__ */ a.jsx("li", { children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: i,
          startText: t.numberOfDaysPersistenceWindow.startText,
          type: t.numberOfDaysPersistenceWindow.type,
          endText: t.numberOfDaysPersistenceWindow.endText,
          onChange: (k) => s({ ...o, GapDays: k }),
          options: t.numberOfDaysPersistenceWindow.options,
          value: d
        }
      ) }),
      /* @__PURE__ */ a.jsx("li", { children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: i,
          startText: t.numberOfDaysSurveillance.startText,
          type: t.numberOfDaysSurveillance.type,
          endText: t.numberOfDaysSurveillance.endText,
          onChange: (k) => s({ ...o, Offset: k }),
          options: t.numberOfDaysSurveillance.options,
          value: f
        }
      ) }),
      /* @__PURE__ */ a.jsx("li", { children: g ? /* @__PURE__ */ a.jsxs(W, { display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ a.jsx(
          Ut,
          {
            viewMode: i,
            startText: t.numberOfDaysForce.startText,
            endText: t.numberOfDaysForce.endText,
            type: t.numberOfDaysForce.type,
            onChange: (k) => {
              s({ ...o, DaysSupplyOverride: k });
            },
            options: t.numberOfDaysForce.options,
            value: h
          }
        ),
        !i && /* @__PURE__ */ a.jsx(
          Be,
          {
            onClick: () => {
              C(!1);
            },
            fullWidth: !1,
            variant: "text",
            name: "closeExposureDays",
            size: "small",
            children: "Close"
          }
        )
      ] }) : /* @__PURE__ */ a.jsx(Le.Fragment, { children: /* @__PURE__ */ a.jsxs(W, { fontSize: 12, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ a.jsx("div", { children: (Y = t == null ? void 0 : t.numberOfDaysForce) == null ? void 0 : Y.preChooseText }),
        !i && /* @__PURE__ */ a.jsx(
          Be,
          {
            onClick: () => {
              C(!0);
            },
            fullWidth: !1,
            variant: "text",
            name: "changeExposureDays",
            size: "small",
            children: "change"
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ a.jsx("p", {})
  ] });
}, Jx = pe.div`
  color: ${({ theme: e }) => {
  var t, n;
  return (n = (t = e.palette) == null ? void 0 : t.textColor) == null ? void 0 : n.primary;
}};
  font-weight: 700;
  font-size: 14px;
`, Qx = pe.div`
  margin-bottom: 10px;
  border-bottom: 1px solid #d6d4d4;
  padding-bottom: 15px;
`, Kx = pe.div`
  margin-top: 5px;
  h4 {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  p {
    font-size: 14px;
    margin: 0;
  }
`;
pe.div`
  font-size: 14px;
  padding-bottom: 4px;
  font-weight: 700;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  margin-left: 5px;
`;
const Zx = ({
  data: e,
  update: t,
  clear: n,
  viewMode: r = !1
}) => {
  const [i, o] = K("END");
  q(() => {
    e != null && e.DateOffset && o("FIXED"), e != null && e.CustomEra && o("EXPOSURE");
  }, []);
  const { title: s, textControlTextSections: l } = Lo, { eventsPersistence: c } = l;
  return /* @__PURE__ */ a.jsx(Qx, { className: "cohort-definition-event-persistance", children: /* @__PURE__ */ a.jsxs(A, { container: !0, children: [
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(Jx, { children: s }) }),
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(Kx, { children: [
      /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: r,
          startText: c.startText,
          endText: c.endText,
          onChange: (u) => {
            u === "END" && n(), o(u);
          },
          options: c.options,
          value: i
        }
      ),
      i === "FIXED" && /* @__PURE__ */ a.jsx(
        qx,
        {
          update: t,
          initValues: e,
          data: Lo.persistentTypes[i],
          viewMode: r
        }
      ),
      i === "EXPOSURE" && /* @__PURE__ */ a.jsx(
        Xx,
        {
          update: t,
          initValues: e,
          data: Lo.persistentTypes[i],
          viewMode: r
        }
      )
    ] }) })
  ] }) });
}, eC = {
  title: "Censoring events",
  addCriteriaButton: "Add censoring event",
  description: "Exit Cohort based on the following criteria:",
  optionsForCriteriaButton: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PAYER_PLAN_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ]
}, tC = Ze(
  (e) => {
    const { data: t, update: n, clear: r, viewMode: i = !1 } = e, o = je(
      Or
    ), { subModules: s, config: l } = je(
      gn
    ), [c, u] = K(
      Bc(t)
    ), { typeContainer: p, parentId: d } = l, { addCriteriaButton: f, title: h, description: g, optionsForCriteriaButton: C } = eC, y = Z(() => _n(
      C,
      xn
    ), [C]), I = (O) => {
      u(O);
    };
    return q(() => {
      const O = $c(c);
      Pe(t, O) || n(O);
    }, [c]), /* @__PURE__ */ a.jsx(A, { container: !0, className: "cohort-definition-censoring-events", children: /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      Ga,
      {
        viewMode: i,
        extend: !1,
        subModules: s,
        initialCriteries: c,
        addTextButton: f,
        optionsDropdown: y,
        updateModel: I,
        typeContainer: p,
        parentId: d,
        titleText: h,
        descriptionText: g,
        ...o
      }
    ) }) });
  }
), nC = {
  textControlTextSections: {
    numberOfDays: {
      startText: "Specify era collapse gap size:",
      options: zn,
      type: "autocomplete",
      endText: "days"
    }
  },
  leftRightCensor: {
    leftSensorText: "Left censor cohort start dates to",
    rightSensorText: "Right censor cohort end dates to"
  }
}, rC = ({
  dataAddition: e,
  updateAddition: t,
  viewMode: n
}) => {
  const [r, i] = K({
    CollapseType: e.CollapseSettings.CollapseType,
    EraPad: e.CollapseSettings.EraPad
  }), [o, s] = K({
    StartDate: e.CensorWindow.StartDate,
    EndDate: e.CensorWindow.EndDate
  }), { EraPad: l } = r, { StartDate: c, EndDate: u } = o, { textControlTextSections: p, leftRightCensor: d } = nC, { numberOfDays: f } = p;
  return q(() => {
    Pe(r, e.CollapseSettings) || t(r, As.CollapseSettings);
  }, [r]), q(() => {
    const h = hh(o, fh);
    Pe(h, e.CensorWindow) || (h ? (h.StartDate || delete h.StartDate, h.EndDate || delete h.EndDate, t(h, As.CensorWindow)) : t({}, "CensorWindow"));
  }, [o]), /* @__PURE__ */ a.jsxs(A, { container: !0, flexWrap: "nowrap", children: [
    /* @__PURE__ */ a.jsxs(A, { container: !0, columnSpacing: 3, rowSpacing: 1, flexWrap: "wrap", children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        Ut,
        {
          viewMode: n,
          startText: f.startText,
          endText: f.endText,
          type: f.type,
          onChange: (h) => {
            i({
              ...r,
              EraPad: h
            });
          },
          options: f.options,
          value: l
        }
      ) }),
      /* @__PURE__ */ a.jsxs(
        A,
        {
          item: !0,
          display: "flex",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          alignItems: "center",
          children: [
            /* @__PURE__ */ a.jsxs(A, { item: !0, mr: 1, fontSize: 12, children: [
              d.leftSensorText,
              ":"
            ] }),
            /* @__PURE__ */ a.jsx(A, { item: !0, children: n ? /* @__PURE__ */ a.jsx(
              W,
              {
                component: "span",
                sx: {
                  position: "relative",
                  top: "8px"
                },
                children: c
              }
            ) : /* @__PURE__ */ a.jsx(
              rr,
              {
                value: c,
                format: $t.DATEPICKER_DATE,
                onChange: (h) => s({
                  ...o,
                  StartDate: ir(h, $t.ISO_DATE)
                }),
                name: "cohortEraStartDate"
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ a.jsxs(
        A,
        {
          item: !0,
          display: "flex",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          alignItems: "center",
          children: [
            /* @__PURE__ */ a.jsxs(A, { item: !0, mr: 1, fontSize: 12, children: [
              d.rightSensorText,
              ":"
            ] }),
            /* @__PURE__ */ a.jsx(A, { item: !0, children: n ? /* @__PURE__ */ a.jsx(
              W,
              {
                component: "span",
                sx: {
                  position: "relative",
                  top: "8px"
                },
                children: u
              }
            ) : /* @__PURE__ */ a.jsx(
              rr,
              {
                fullWidth: !1,
                value: u,
                format: $t.DATEPICKER_DATE,
                onChange: (h) => {
                  s({
                    ...o,
                    EndDate: ir(h, $t.ISO_DATE)
                  });
                },
                name: "cohortEraEndDate"
              }
            ) })
          ]
        }
      )
    ] }),
    !n && /* @__PURE__ */ a.jsx(
      A,
      {
        item: !0,
        minWidth: 150,
        textAlign: "right",
        sx: { "button .MuiTypography-root": { fontSize: "14px" } },
        children: /* @__PURE__ */ a.jsx(
          Cr,
          {
            iconName: "delete",
            onClick: () => {
              s({
                ...o,
                StartDate: null,
                EndDate: null
              });
            },
            color: "primary",
            title: "Clear censors",
            noCollapse: !0
          }
        )
      }
    )
  ] });
}, iC = (e, t, n, r) => (i, o, s = Fe.COPY) => {
  switch (e) {
    case Ee.STUDY:
      return ou(t, i, o, s);
    case Ee.WORKSPACE:
      return iu(i, o, s);
    case "ATLAS":
      return df(n, r, i, o);
  }
}, oC = (e) => {
  const { id: t, typeContainer: n, parentId: r } = e, i = yr(), o = je(
    gn
  );
  return /* @__PURE__ */ a.jsx(
    Nc,
    {
      isImport: !1,
      isEnableMetadata: !0,
      moduleConfig: o,
      uniqName: "Usage",
      onRowClick: (s) => {
        const l = Lf(
          s.original.id,
          s.original.supertype,
          n,
          r
        );
        i(l);
      },
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading Usage Cohorts...",
        tableTitle: "Used In",
        moduleDescription: "",
        listInitialSort: { id: "modified.timestamp", desc: !0 },
        addButtonTitle: null,
        createCrudMethod: () => ({
          fetch: (s, l, c, u) => Jh(t, {
            pageNumber: s,
            pageSize: l,
            sortBy: c,
            query: u
          })
        }),
        createFiltersPanel: () => ({
          getFilters: (s) => Qh(s, t),
          formatFilters: mh
        }),
        createSortingMethod: du,
        cols: Mf
      },
      variant: "no-header",
      dense: !0
    }
  );
}, aC = ({}) => {
  const { id: e } = kc(), { status: t, state: n } = sp(yf, e), r = Eh(n);
  return /* @__PURE__ */ a.jsx(Op, { board: r == null ? void 0 : r.board, status: t, list: r == null ? void 0 : r.list });
}, Mn = -730, Vn = 730, sC = [-365, -180, -90, -30, 0, 30, 90, 180, 365], lC = {
  default: "S1 Default",
  single: "S2.1 Single",
  multiple: "S2.2 Multiple",
  nested: "S2.3 Nested",
  dual_index: "S2.4 Dual Idx",
  calendar: "S2.5.2 Calendar",
  ppp: "S2.8 PPP",
  obs_period: "S4.4 Obs Period",
  eras: "S4.5 Eras",
  groups: "S4.6 Groups",
  unsupported: "Unsupported"
}, cC = {
  obs_end: "5.1 Obs End",
  start_plus_x: "5.2 Start+Xd",
  end_plus_x: "5.2 End+Xd",
  drug_persist: "5.3 Drug Persist.",
  censoring: "5.4 Censoring",
  unsupported: "Unsupported"
}, Wa = {
  condition: "#E8683A",
  drug: "#3A8FE8",
  device: "#0EA5E9",
  measurement: "#8B5EC8",
  observation: "#C9A83A",
  procedure: "#2EAA6F",
  visit: "#E85BA0",
  demographic: "#94A3B8",
  death: "#111111",
  payer: "#7C3AED",
  other: "#8C8C8C"
}, qu = "#D97706", uC = "#059669", jr = "#DC2626", dC = "#7C3AED", pC = {
  default: "No entry criteria detected. Timeline is rendered with baseline observation and exit markers only.",
  single: "Single primary clinical index event detected.",
  multiple: "Multiple primary index criteria detected.",
  nested: "Nested group criteria detected in entry/inclusion logic.",
  dual_index: "Multi-level nested criteria detected and shown as a dual-index visual state.",
  calendar: "Calendar date constraints detected in criteria attributes.",
  ppp: "Payer Plan Period is used as index criterion.",
  obs_period: "Observation Period criteria are present in cohort logic.",
  eras: "Cohort era collapse/censor window settings are configured.",
  groups: "Group logic (ALL/ANY/AT_LEAST/AT_MOST) is present.",
  unsupported: "Cohort structure is partially unsupported for strict scenario mapping. Baseline timeline is rendered."
}, Cl = {
  obs_end: "Cohort exit is based on observation end.",
  start_plus_x: "Cohort exit uses fixed offset: start date + X days.",
  end_plus_x: "Cohort exit uses fixed offset: end date + X days.",
  drug_persist: "Cohort exit is based on continuous drug persistence (custom era settings).",
  censoring: "Cohort exit includes censoring criteria in addition to observation end.",
  unsupported: "End strategy is not one of supported v1 mappings. Timeline uses observation-end fallback marker."
}, Xu = {
  condition: "Condition",
  drug: "Drug",
  device: "Device",
  measurement: "Measurement",
  observation: "Observation",
  procedure: "Procedure",
  visit: "Visit",
  demographic: "Demographic",
  death: "Death",
  payer: "Payer",
  other: "Other"
}, hC = xn.reduce(
  (e, t) => (e[t.id] = t.name, e),
  {}
);
function Ke(e) {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim() !== "") {
    const t = Number(e);
    return Number.isFinite(t) ? t : null;
  }
  return null;
}
function ut(e) {
  return Math.min(Vn, Math.max(Mn, e));
}
function ii(e) {
  if (!e || typeof e != "object")
    return null;
  const t = e, n = Object.keys(t)[0];
  if (!n)
    return null;
  const r = t[n];
  return {
    type: n,
    payload: ht(r) ? r : {}
  };
}
function Cn(e) {
  return e.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/[_-]/g, " ").replace(/\s+/g, " ").trim().replace(/\b\w/g, (t) => t.toUpperCase());
}
function sr(e) {
  return `${e >= 0 ? "+" : ""}${e}d`;
}
function gl(e) {
  return typeof e != "string" || e.trim() === "" ? "start date" : Cn(e).toLowerCase();
}
const Ju = /* @__PURE__ */ new Set(["CodesetId", "CorrelatedCriteria"]), fC = /* @__PURE__ */ new Set([
  "CONCEPT_ID",
  "VOCABULARY_ID",
  "RECORD_COUNT",
  "DESCENDANT_RECORD_COUNT",
  "DOMAIN_ID",
  "CONCEPT_CLASS_ID",
  "STANDARD_CONCEPT",
  "INVALID_REASON",
  "CONCEPT_CODE",
  "baseValue"
]), mC = {
  DateAdjustment: "Date adjustment",
  OccurrenceStartDate: "Occurrence start date",
  OccurrenceEndDate: "Occurrence end date",
  StartDate: "Start date",
  EndDate: "End date",
  EraStartDate: "Era start date",
  EraEndDate: "Era end date",
  EraLength: "Era length",
  PeriodStartDate: "Period start date",
  PeriodEndDate: "Period end date",
  PeriodLength: "Period length",
  Age: "Age",
  AgeAtStart: "Age at start",
  AgeAtEnd: "Age at end",
  Gender: "Gender",
  GenderCS: "Gender",
  Race: "Race",
  RaceCS: "Race",
  Ethnicity: "Ethnicity",
  EthnicityCS: "Ethnicity",
  ConditionStatus: "Condition status",
  ConditionStatusCS: "Condition status",
  ConditionTypeCS: "Condition type",
  DeathTypeCS: "Death type",
  DeviceTypeCS: "Device type",
  DoseUnitCS: "Dose unit",
  DrugTypeCS: "Drug type",
  MeasurementTypeCS: "Measurement type",
  ObservationTypeCS: "Observation type",
  OperatorCS: "Operator",
  PeriodTypeCS: "Period type",
  ProcedureTypeCS: "Procedure type",
  ModifierCS: "Modifier",
  QualifierCS: "Qualifier",
  RouteConceptCS: "Route",
  SpecimenTypeCS: "Specimen type",
  UnitCS: "Unit",
  ValueAsConceptCS: "Value as concept",
  VisitTypeCS: "Visit type",
  AnatomicSiteCS: "Anatomic site",
  DiseaseStatusCS: "Disease status",
  ProviderSpecialtyCS: "Provider specialty",
  PlaceOfServiceCS: "Place of service",
  StopReason: "Stop reason",
  PayerConcept: "Payer concept",
  PayerSourceConcept: "Payer source concept"
}, EC = {
  STARTING_WITH: "starting with",
  CONTAINING: "containing",
  ENDING_WITH: "ending with",
  NOT_STARTING_WITH: "not starting with",
  NOT_CONTAINING: "not containing",
  NOT_ENDING_WITH: "not ending with",
  lt: "less than",
  lte: "less or equal to",
  eq: "equal to",
  gt: "greater than",
  gte: "greater or equal to",
  bt: "between",
  "!bt": "not between",
  LESS_THAN: "less than",
  LESS_OR_EQUAL_TO: "less or equal to",
  EQUAL_TO: "equal to",
  GREATER_THAN: "greater than",
  GREATER_OR_EQUAL_TO: "greater or equal to",
  BETWEEN: "between",
  NOT_BETWEEN: "not between"
};
function ht(e) {
  return !!e && typeof e == "object" && !Array.isArray(e);
}
function Qe(e) {
  return ht(e) ? e : {};
}
function oi(e) {
  return Array.isArray(e) ? e : [];
}
function xC(e) {
  return typeof e != "string" || e.trim() === "" ? "" : EC[e] || Cn(e).toLowerCase();
}
function CC(e) {
  return typeof e != "string" ? !1 : e === "BETWEEN" || e === "NOT_BETWEEN" || e === "bt" || e === "!bt";
}
function gC(e) {
  return e === e.toUpperCase() ? Cn(e.toLowerCase()) : e;
}
function Vr(e) {
  return Array.isArray(e) ? e.flatMap((t) => Vr(t)) : ht(e) ? typeof e.CONCEPT_NAME == "string" && e.CONCEPT_NAME.trim() !== "" ? [gC(e.CONCEPT_NAME.trim())] : ht(e.concept) ? Vr(e.concept) : Array.isArray(e.baseValue) ? Vr(e.baseValue) : Array.isArray(e.items) ? Vr(e.items) : [] : [];
}
function ai(e, t) {
  if (Array.isArray(e))
    return e.map((c) => ai(c, t)).filter(Boolean).join("; ");
  if (e == null)
    return "";
  if (typeof e == "string" || typeof e == "number") {
    const c = t ? ` ${t}` : "";
    return `${e}${c}`;
  }
  if (!ht(e))
    return String(e);
  const n = Vr(e);
  if (n.length > 0)
    return Array.from(new Set(n)).join(", ");
  const r = xC(e.Op), i = e.Value !== void 0 && e.Value !== null && e.Value !== "", o = e.Extent !== void 0 && e.Extent !== null && e.Extent !== "", s = e.Text !== void 0 && e.Text !== null && e.Text !== "";
  if (e.StartDate || e.EndDate)
    return e.StartDate && e.EndDate ? `between ${e.StartDate} and ${e.EndDate}` : e.StartDate ? `starting ${e.StartDate}` : `ending ${e.EndDate}`;
  if (r && (i || o)) {
    const c = t ? ` ${t}` : "";
    return CC(e.Op) && o ? `${r} ${e.Value} and ${e.Extent}${c}` : i ? `${r} ${e.Value}${c}` : r;
  }
  return r && s ? `${r} ${e.Text}` : s ? String(e.Text) : typeof e.CodesetId < "u" ? `codeset ${e.CodesetId}` : Object.entries(e).filter(([c]) => !(Ju.has(c) || fC.has(c) || c.endsWith("Exclude"))).map(([c, u]) => {
    const p = ai(u);
    return p ? `${Cn(c)} ${p}` : "";
  }).filter(Boolean).join(", ");
}
function yC(e) {
  if (!ht(e))
    return ai(e);
  const t = Ke(e.StartOffset) ?? 0, n = Ke(e.EndOffset) ?? 0, r = gl(e.StartWith), i = gl(e.EndWith || "END_DATE");
  return `starting with ${r} ${sr(
    t
  )} and ending with ${i} ${sr(n)}`;
}
function Qu(e, t, n) {
  if (Ju.has(e) || t == null || t === "")
    return null;
  const r = mC[e] || Cn(e);
  if (e === "DateAdjustment")
    return `${r}: ${yC(t)}`;
  if (typeof t == "number") {
    const o = si(n, t);
    if (o)
      return `${r}: ${o}`;
  }
  if (ht(t) && typeof t.CodesetId < "u") {
    const o = si(
      n,
      Ke(t.CodesetId)
    );
    if (o)
      return `${r}: ${o}`;
  }
  const i = ai(
    t,
    e === "PeriodLength" ? "days" : void 0
  );
  return i ? `${r}: ${i}` : null;
}
function TC(e) {
  const t = e.replace(": greater or equal to ", " >= ").replace(": greater than ", " > ").replace(": less or equal to ", " <= ").replace(": less than ", " < ").replace(": equal to ", " = ").replace(": between ", " between "), n = t.match(/^Gender:\s*(.+)$/i);
  return n ? `${n[1]} gender` : t;
}
function SC(e, t) {
  const n = Object.entries(e || {}).map(([r, i]) => Qu(r, i, t)).filter(Boolean);
  if (n.length === 0) {
    const r = Object.keys(e || {});
    return r.length > 0 ? r.map((i) => Cn(i)).join(", ") : "Demographic criteria";
  }
  return n.map(TC).join(", ");
}
function Eo(e, t) {
  return !e || typeof e != "object" ? [] : Object.entries(e).map(([n, r]) => Qu(n, r, t)).filter(Boolean);
}
function Ya(e) {
  return hC[e] || Cn(e);
}
function IC(e) {
  return e === D.CONDITION_OCCURRENCE ? "CONDITION" : e === D.CONDITION_ERA ? "CONDITION ERA" : Ya(e);
}
function AC(e) {
  switch (e) {
    case D.CONDITION_ERA:
    case D.CONDITION_OCCURRENCE:
      return "condition";
    case D.DRUG_ERA:
    case D.DRUG_EXPOSURE:
    case D.DOSE_ERA:
      return "drug";
    case D.DEVICE_EXPOSURE:
      return "device";
    case D.MEASUREMENT:
      return "measurement";
    case D.OBSERVATION:
    case D.OBSERVATION_PERIOD:
      return "observation";
    case D.PROCEDURE_OCCURRENCE:
    case D.SPECIMEN:
      return "procedure";
    case D.VISIT:
    case D.VISIT_DETAILS:
      return "visit";
    case D.PAYER_PLAN_PERIOD:
      return "payer";
    case D.DEMOGRAPHIC:
      return "demographic";
    case D.DEATH:
      return "death";
    default:
      return "other";
  }
}
function bC(e) {
  return e === D.CONDITION_ERA || e === D.DRUG_ERA || e === D.DOSE_ERA;
}
function RC(e) {
  if (typeof e == "number")
    return `${e}d`;
  if (!ht(e))
    return "";
  const t = String(e.Op || "").toUpperCase(), n = Ke(e.Value), r = Ke(e.Extent);
  if ((t === "BETWEEN" || t === "BT" || t === "!BT" || t === "NOT_BETWEEN") && n !== null && r !== null) {
    const o = Math.min(n, r), s = Math.max(n, r);
    return `${t === "!BT" || t === "NOT_BETWEEN" ? "!" : ""}${o}-${s}d`;
  }
  if (n === null)
    return "";
  switch (t) {
    case "EQUAL_TO":
    case "EQ":
      return `=${n}d`;
    case "GREATER_THAN":
    case "GT":
      return `>${n}d`;
    case "GREATER_OR_EQUAL_TO":
    case "GTE":
      return `>=${n}d`;
    case "LESS_THAN":
    case "LT":
      return `<${n}d`;
    case "LESS_OR_EQUAL_TO":
    case "LTE":
      return `<=${n}d`;
    default:
      return `${n}d`;
  }
}
function OC(e) {
  const t = e == null ? void 0 : e.EraLength;
  if (!t || typeof t != "object")
    return;
  const n = RC(t);
  return n || ai(t, "days") || void 0;
}
function si(e, t) {
  if (!Number.isFinite(t) || t < 0)
    return null;
  const r = oi(e == null ? void 0 : e.ConceptSets).find(
    (i) => {
      var o;
      return Number((o = Qe(i)) == null ? void 0 : o.id) === Number(t);
    }
  );
  return typeof (r == null ? void 0 : r.name) == "string" && r.name.trim() !== "" ? r.name : null;
}
function yl(e) {
  const t = ht(e) ? e : {}, n = Ke(t.Days), r = Ke(t.Coeff);
  return n === null ? null : n * (r === -1 ? -1 : 1);
}
function da(e) {
  const t = Qe(e);
  if (!t)
    return {
      startDay: Mn,
      endDay: Vn,
      openStart: !0,
      openEnd: !0
    };
  const n = yl(t.Start), r = yl(t.End);
  if (n === null && r === null)
    return {
      startDay: Mn,
      endDay: Vn,
      openStart: !0,
      openEnd: !0
    };
  const i = n !== null, o = r !== null;
  let s = i ? n : Mn, l = o ? r : Vn;
  i && o && (s = Math.min(n, r), l = Math.max(n, r));
  const c = !i || s <= Mn, u = !o || l >= Vn;
  return {
    startDay: c ? Mn : ut(s),
    endDay: u ? Vn : ut(l),
    openStart: c,
    openEnd: u
  };
}
function Ku(e) {
  const t = Qe(e);
  return da(t.StartWindow);
}
function xo(e, t, n, r) {
  const i = n ? "all days before" : `${e}d`, o = r ? "all days after" : `${t >= 0 ? "+" : ""}${t}d`;
  return `${i} to ${o}`;
}
function Ha(e) {
  if (typeof e == "number") {
    if (e === 0)
      return "exactly";
    if (e === 1)
      return "at most";
    if (e === 2)
      return "at least";
  }
  if (typeof e == "string") {
    const t = e.trim().toUpperCase();
    if (t === "0")
      return "exactly";
    if (t === "1")
      return "at most";
    if (t === "2")
      return "at least";
    if (t === "EXACTLY")
      return "exactly";
    if (t === "AT_MOST")
      return "at most";
    if (t === "AT_LEAST")
      return "at least";
  }
  return "";
}
function DC(e) {
  if (!ht(e))
    return !1;
  const t = Ha(e.Type), n = Ke(e.Count);
  return t === "exactly" && n === 0;
}
function pa(e) {
  return Array.isArray(e) ? e.some((t) => pa(t)) : ht(e) ? Object.entries(e).some(([t, n]) => t.endsWith("Exclude") && n ? !0 : pa(n)) : !1;
}
function vC(e, t) {
  if (!e && !t)
    return "";
  const n = [];
  if (t && On[t] ? n.push(`Group rule: ${On[t]}`) : t && t !== "ALL" && n.push(`Group rule: ${t}`), e) {
    const r = Qe(e), i = Ke(r.Count), o = Ha(r.Type) || (r.Type ? On[String(r.Type)] : null);
    o && i !== null ? n.push(`Occurrence: ${o} ${i} (x${i})`) : o && n.push(`Occurrence: ${o}`);
  }
  return n.join(" | ");
}
function Zu(e) {
  const {
    id: t,
    expression: n,
    criteriaType: r,
    payload: i,
    extendCriteria: o,
    nestedDepth: s,
    groupType: l,
    exclusion: c = !1,
    isNested: u = !1,
    kind: p = "criteria",
    sourceJson: d
  } = e, f = AC(r), h = si(
    n,
    Ke(i == null ? void 0 : i.CodesetId)
  ), g = Ku(o), C = vC(
    o == null ? void 0 : o.Occurrence,
    l
  ), y = Ya(r), I = IC(r), O = h || y, S = Eo(i, n), N = bC(r) ? OC(i) : void 0, _ = [
    c ? "EXCLUSION criterion." : "",
    h ? `${Cn(y)} of ${h}` : "",
    `Window: ${xo(
      g.startDay,
      g.endDay,
      g.openStart,
      g.openEnd
    )}`,
    C || "",
    ...S,
    u ? "Nested group criterion." : ""
  ].filter(Boolean).join(`
`);
  return {
    id: t,
    label: O,
    domain: f,
    criteriaBadge: I,
    tooltipTitle: y,
    startDay: g.startDay,
    endDay: g.endDay,
    nestedDepth: s,
    openStart: g.openStart,
    openEnd: g.openEnd,
    exclusion: c,
    isNested: u,
    occurrenceText: C || void 0,
    eraText: N,
    tooltip: _,
    kind: p,
    sourceJson: d
  };
}
function _C(e, t, n, r) {
  return !Array.isArray(e) || e.length === 0 ? [] : e.map((i, o) => {
    const s = Qe(i), l = SC(s, r), c = Eo(s, r);
    return {
      id: `${t}-demographic-${n}-${o}`,
      label: l,
      domain: "demographic",
      criteriaBadge: "Demographic",
      tooltipTitle: "Demographic",
      startDay: 0,
      endDay: 0,
      nestedDepth: n,
      openStart: !1,
      openEnd: !1,
      exclusion: !1,
      isNested: n > 0,
      tooltip: c.filter(Boolean).join(`
`),
      kind: "demographic",
      sourceJson: i
    };
  });
}
function zr(e, t, n, r) {
  const i = [], o = /* @__PURE__ */ new Set();
  let s = r, l = !1;
  const c = [];
  i.push(
    ..._C(
      e == null ? void 0 : e.DemographicCriteriaList,
      n,
      r,
      t
    )
  ), (Array.isArray(e == null ? void 0 : e.CriteriaList) ? e.CriteriaList : []).forEach((f, h) => {
    var I;
    const g = ii(f == null ? void 0 : f.Criteria);
    if (!g)
      return;
    const C = DC(f == null ? void 0 : f.Occurrence) || pa(g.payload);
    o.add(g.type), g.type === D.OBSERVATION_PERIOD && c.push({
      startWindow: da(f == null ? void 0 : f.StartWindow),
      endWindow: f != null && f.EndWindow ? da(f.EndWindow) : void 0
    }), i.push(
      Zu({
        id: `${n}-criteria-${r}-${h}`,
        expression: t,
        criteriaType: g.type,
        payload: g.payload,
        extendCriteria: f,
        nestedDepth: r,
        groupType: typeof (e == null ? void 0 : e.Type) == "string" ? e.Type : void 0,
        exclusion: C,
        isNested: r > 0,
        sourceJson: f
      })
    );
    const y = (I = g.payload) == null ? void 0 : I.CorrelatedCriteria;
    if (ht(y)) {
      const O = zr(
        y,
        t,
        `${n}-correlated-${h}`,
        r + 1
      );
      O.rows.forEach((S) => i.push(S)), O.criteriaTypes.forEach((S) => o.add(S)), O.observationPeriodWindows.forEach(
        (S) => c.push(S)
      ), l = l || O.hasGroups, s = Math.max(s, O.maxNestedDepth);
    }
  });
  const p = Array.isArray(e == null ? void 0 : e.Groups) ? e.Groups : [];
  p.length > 0 && (l = !0), p.forEach((f, h) => {
    const g = zr(
      f,
      t,
      `${n}-group-${h}`,
      r + 1
    );
    g.rows.forEach((C) => i.push(C)), g.criteriaTypes.forEach((C) => o.add(C)), g.observationPeriodWindows.forEach(
      (C) => c.push(C)
    ), l = l || g.hasGroups || !0, s = Math.max(s, g.maxNestedDepth);
  }), e != null && e.Type && (e == null ? void 0 : e.Type) !== "ALL" && (l = !0);
  const d = (Array.isArray(e == null ? void 0 : e.CriteriaList) ? e.CriteriaList.length : 0) + (Array.isArray(e == null ? void 0 : e.DemographicCriteriaList) ? e.DemographicCriteriaList.length : 0);
  return r > 0 && (e == null ? void 0 : e.Type) === "ALL" && d > 1 && (l = !0), {
    rows: i,
    criteriaTypes: o,
    hasGroups: l,
    maxNestedDepth: s,
    observationPeriodWindows: c
  };
}
function Tl(e) {
  return [
    e.startDay,
    e.endDay,
    e.openStart ? 1 : 0,
    e.openEnd ? 1 : 0
  ].join("|");
}
function NC(e) {
  const n = e.indexOf("-criteria-");
  return n <= 0 ? "" : e.slice(0, n);
}
function ed(e) {
  const { groupLabel: t, rows: n, sharedWindow: r } = e, i = [
    "Criteria group with shared timeline window.",
    `Group: ${t}`,
    `Shared window: ${r}`,
    `Elements: ${n.length}`,
    ""
  ];
  return n.forEach((o, s) => {
    const l = o.criteriaBadge || Xu[o.domain] || Cn(o.domain), c = (o.tooltip || o.label).split(`
`).map((u) => u.trim()).filter(Boolean);
    i.push(`${s + 1}. ${o.label} (${l})`), c.forEach((u) => i.push(u)), i.push("");
  }), i.join(`
`).trim();
}
function ko(e) {
  const { rows: t, groupId: n, groupName: r } = e;
  if (t.length === 0)
    return t;
  const i = t.filter((l) => l.kind === "criteria");
  if (i.length < 2)
    return t;
  const o = i.reduce(
    (l, c) => {
      const u = NC(c.id);
      return !u || !u.startsWith(n) || (l[u] || (l[u] = []), l[u].push(c)), l;
    },
    {}
  ), s = /* @__PURE__ */ new Map();
  return Object.entries(o).forEach(([l, c]) => {
    if (c.length < 2)
      return;
    const u = Tl(c[0]);
    if (!c.every(
      (y) => Tl(y) === u
    ))
      return;
    const d = c[0], f = l === n && typeof r == "string" && r.trim() !== "" ? r.trim() : "Criteria group", h = `GROUP - ${f}`, g = new Set(c.map((y) => y.id)), C = {
      id: `grouped-${l}`,
      label: h,
      domain: "other",
      criteriaBadge: "Group",
      tooltipTitle: "GROUP",
      groupedInclusion: !0,
      startDay: d.startDay,
      endDay: d.endDay,
      openStart: d.openStart,
      openEnd: d.openEnd,
      exclusion: c.some((y) => y.exclusion),
      isNested: c.some((y) => y.isNested),
      nestedDepth: Math.min(...c.map((y) => y.nestedDepth || 0)),
      tooltip: ed({
        groupLabel: f,
        rows: c,
        sharedWindow: xo(
          d.startDay,
          d.endDay,
          d.openStart,
          d.openEnd
        )
      }),
      kind: "criteria",
      sourceJson: c.map((y) => y.sourceJson).filter((y) => y !== void 0)
    };
    c.forEach((y) => {
      s.set(y.id, {
        collapsed: C,
        hiddenIds: g,
        firstId: c[0].id
      });
    });
  }), s.size === 0 ? t : t.reduce((l, c) => {
    const u = s.get(c.id);
    return u ? (c.id === u.firstId && l.push(u.collapsed), l) : (l.push(c), l);
  }, []);
}
function Sl(e) {
  const { rows: t, groupName: n, fallbackGroupName: r = "Criteria group" } = e;
  if (t.length === 0)
    return t;
  const i = typeof n == "string" && n.trim() !== "" ? n.trim() : r;
  if (t.length === 1)
    return [
      {
        ...t[0],
        label: typeof n == "string" && n.trim() !== "" ? n.trim() : t[0].label
      }
    ];
  const o = Math.min(...t.map((u) => u.startDay)), s = Math.max(...t.map((u) => u.endDay)), l = t.some((u) => u.openStart), c = t.some((u) => u.openEnd);
  return [
    {
      id: `display-group-${t[0].id}`,
      label: `GROUP - ${i}`,
      domain: "other",
      criteriaBadge: "Group",
      tooltipTitle: "GROUP",
      groupedInclusion: !0,
      startDay: o,
      endDay: s,
      openStart: l,
      openEnd: c,
      exclusion: t.some((u) => u.exclusion),
      isNested: t.some((u) => u.isNested),
      nestedDepth: Math.min(...t.map((u) => u.nestedDepth || 0)),
      tooltip: ed({
        groupLabel: i,
        rows: t,
        sharedWindow: xo(o, s, l, c)
      }),
      kind: "criteria",
      sourceJson: t.map((u) => u.sourceJson).filter((u) => u !== void 0)
    }
  ];
}
function td(e) {
  return typeof e == "string" ? /^\d{4}-\d{2}-\d{2}/.test(e) : !e || typeof e != "object" ? !1 : Object.values(e).some((t) => td(t));
}
function wC(e) {
  const t = Qe(e == null ? void 0 : e.PrimaryCriteria);
  return oi(t.CriteriaList).map((r) => ii(r)).filter(Boolean);
}
function nd(e) {
  const t = Qe(e);
  return ii(t == null ? void 0 : t.Criteria) || ii(e);
}
function rd(e, t, n) {
  const r = si(
    n,
    Ke(t == null ? void 0 : t.CodesetId)
  ), i = Ya(e);
  return r ? `${i} of ${r}` : i;
}
function PC(e) {
  return typeof e != "string" || e.trim() === "" ? null : `Group rule: ${On[e] || e}`;
}
function jC(e) {
  if (!ht(e))
    return { prefix: "", countSuffix: "" };
  const t = Ke(e.Count), n = Ha(e.Type) || (e.Type ? On[String(e.Type)] : "");
  return {
    prefix: n && t !== null ? `${n} ${t} ` : n || "",
    countSuffix: t !== null ? ` (x${t})` : ""
  };
}
function LC(e) {
  var f, h;
  const { entry: t, expression: n, depth: r } = e, i = nd(t);
  if (!i)
    return [];
  const o = "  ".repeat(r), { prefix: s, countSuffix: l } = jC(
    (f = Qe(t)) == null ? void 0 : f.Occurrence
  ), c = rd(
    i.type,
    i.payload,
    n
  ), u = Ku(t), p = [
    `${o}* ${s}${c}${l}`,
    ...Eo(i.payload, n).map(
      (g) => `${o}  ${g}`
    ),
    `${o}  Window: ${xo(
      u.startDay,
      u.endDay,
      u.openStart,
      u.openEnd
    )}`
  ], d = (h = i.payload) == null ? void 0 : h.CorrelatedCriteria;
  return ht(d) && p.push(
    ...qa({
      group: d,
      expression: n,
      depth: r + 1
    })
  ), p;
}
function qa(e) {
  const { group: t, expression: n, depth: r } = e, i = "  ".repeat(r), o = [], s = PC(t == null ? void 0 : t.Type);
  return s && o.push(`${i}${s}`), oi(t == null ? void 0 : t.CriteriaList).forEach((l) => {
    o.push(
      ...LC({
        entry: l,
        expression: n,
        depth: r
      })
    );
  }), oi(t == null ? void 0 : t.Groups).forEach((l) => {
    o.push(
      ...qa({
        group: Qe(l),
        expression: n,
        depth: r + 1
      })
    );
  }), o;
}
function kC(e, t) {
  const n = t.flatMap((r) => {
    var l;
    const i = nd(r);
    if (!i)
      return [];
    const o = [
      `* ${rd(i.type, i.payload, e)}`,
      ...Eo(i.payload, e).map(
        (c) => `  ${c}`
      )
    ], s = (l = i.payload) == null ? void 0 : l.CorrelatedCriteria;
    return ht(s) && o.push(
      ...qa({
        group: s,
        expression: e,
        depth: 1
      })
    ), o;
  });
  return n.length > 0 ? n.join(`
`) : "No index event configured.";
}
function MC(e, t) {
  const n = [
    "default",
    "single",
    "multiple",
    "nested",
    "dual_index",
    "calendar",
    "ppp",
    "obs_period",
    "eras",
    "groups"
  ], r = {
    default: "Requires no primary criteria.",
    single: "Requires exactly one primary index criterion.",
    multiple: "Requires two or more primary index criteria.",
    nested: "Requires nested group criteria.",
    dual_index: "Requires multi-level nested criteria.",
    calendar: "Requires explicit calendar date constraints.",
    ppp: "Requires Payer Plan Period as index criterion.",
    obs_period: "Requires Observation Period criterion.",
    eras: "Requires cohort era settings (EraPad or CensorWindow).",
    groups: "Requires non-trivial group logic.",
    unsupported: "Scenario is unsupported."
  }, i = (o) => {
    switch (o) {
      case "default":
        return t.hasPrimary ? r.default : "";
      case "single":
        return !t.hasPrimary || t.hasMultiplePrimary ? r.single : "";
      case "multiple":
        return t.hasMultiplePrimary ? "" : r.multiple;
      case "nested":
        return t.hasNested ? "" : r.nested;
      case "dual_index":
        return t.hasDualIndex ? "" : r.dual_index;
      case "calendar":
        return t.hasCalendarDates ? "" : r.calendar;
      case "ppp":
        return t.hasPayerPlanPeriod ? "" : r.ppp;
      case "obs_period":
        return t.hasObservationPeriodCriteria ? "" : r.obs_period;
      case "eras":
        return t.hasEras ? "" : r.eras;
      case "groups":
        return t.hasGroups ? "" : r.groups;
      default:
        return r.unsupported;
    }
  };
  return n.map((o) => {
    const s = o !== e;
    return {
      id: o,
      label: lC[o],
      active: o === e,
      disabled: s,
      disabledReason: s ? i(o) : ""
    };
  });
}
function VC(e, t) {
  if (!e.hasPrimary)
    return "default";
  const n = [];
  return e.hasDualIndex && n.push("dual_index"), e.hasEras && n.push("eras"), e.hasGroups && n.push("groups"), e.hasNested && n.push("nested"), e.hasObservationPeriodCriteria && n.push("obs_period"), e.hasPayerPlanPeriod && n.push("ppp"), e.hasCalendarDates && n.push("calendar"), e.hasMultiplePrimary && n.push("multiple"), n.length > 1 && t.push(
    `Multiple scenario signals detected (${n.join(
      ", "
    )}). Highest-priority state is selected for active tab.`
  ), n.length > 0 ? n[0] : "single";
}
function UC(e, t) {
  const n = e[0];
  if (!n || n.openStart && n.openEnd)
    return ut(t + 120);
  if (n.startDay === n.endDay)
    return ut(Math.max(t + 15, n.startDay));
  const r = n.openStart ? t + 30 : n.startDay, i = n.openEnd ? t + 120 : n.endDay, o = Math.round((r + i) / 2);
  return ut(Math.max(t + 15, o));
}
function FC(e, t, n, r, i, o) {
  var u;
  if (t) {
    const p = UC(
      r,
      i
    ), d = n ? "Death Censoring Event" : "Censoring Event", f = ((u = r[0]) == null ? void 0 : u.label) || "Configured censoring rule";
    return {
      active: "censoring",
      markerDay: ut(i),
      markerColor: jr,
      secondaryMarkerDay: p,
      secondaryMarkerLabel: d,
      secondaryMarkerColor: n ? Wa.death : "#475569",
      secondaryMarkerTooltip: n ? `${f} triggers additional cohort exit after observation end.` : `${f} triggers additional cohort exit after observation end.`,
      tooltip: "Cohort exit occurs at observation end or at a censoring event (for example, death), whichever applies first."
    };
  }
  const s = Qe(e == null ? void 0 : e.EndStrategy);
  if (!s || Object.keys(s).length === 0)
    return {
      active: "obs_end",
      markerDay: ut(i),
      markerColor: jr
    };
  const l = Qe(s == null ? void 0 : s.CustomEra);
  if (Object.keys(l).length > 0) {
    const p = Ke(l.GapDays) ?? 0, d = Ke(l.Offset) ?? 0, f = Ke(l.DaysSupplyOverride), h = si(e, Ke(l.DrugCodesetId)) || "selected drug concept", g = ut(Math.max(0, i)), C = ut(g + d), y = Math.abs(d), I = [
      `Continuous exposure persistence for ${h}.`,
      `Persistence window: ${p} days between exposure records.`,
      `Cohort exit is ${sr(d)} after drug_exposure_end.`,
      f !== null ? `Days supply override: ${f} days.` : ""
    ].filter(Boolean), O = [
      `Drug exposure end for ${h}.`,
      `Persistence window: ${p} days between exposure records.`,
      `Cohort exit offset: ${sr(d)}.`,
      f !== null ? `Days supply override: ${f} days.` : ""
    ].filter(Boolean);
    return {
      active: "drug_persist",
      markerDay: C,
      markerColor: dC,
      secondaryMarkerDay: g,
      secondaryMarkerLabel: "Drug Exposure End",
      secondaryMarkerColor: "#334155",
      secondaryMarkerTooltip: O.join(`
`),
      markerSpan: {
        startDay: g,
        endDay: C,
        label: `surveillance=${y}d`
      },
      tooltip: I.join(`
`)
    };
  }
  const c = Qe(s == null ? void 0 : s.DateOffset);
  if (Object.keys(c).length > 0) {
    const p = Ke(c.Offset) ?? 0, d = String(c.DateField || "").toLowerCase();
    if (d.includes("start")) {
      const f = sr(p), h = `${p >= 0 ? "+" : ""}${p}`;
      return {
        active: "start_plus_x",
        markerDay: ut(p),
        markerColor: jr,
        activeLabelOverride: `5.2 Start${f}`,
        descriptionOverride: `Cohort exit uses fixed offset: start date ${h} days.`,
        tooltip: `Cohort exit uses fixed offset: start date ${h} days.`
      };
    }
    if (d.includes("end")) {
      const f = sr(p), h = `${p >= 0 ? "+" : ""}${p}`;
      return {
        active: "end_plus_x",
        markerDay: ut(i + p),
        markerColor: jr,
        activeLabelOverride: `5.2 End${f}`,
        descriptionOverride: `Cohort exit uses fixed offset: end date ${h} days.`,
        tooltip: `Cohort exit uses fixed offset: end date ${h} days.`
      };
    }
    o.push(
      `DateOffset end strategy (${c.DateField} + ${p}d) is not covered by v1 named tabs.`
    );
  } else
    o.push("EndStrategy shape is not recognized for v1 mapping.");
  return {
    active: "unsupported",
    markerDay: ut(i),
    markerColor: jr
  };
}
function BC(e, t, n) {
  const r = [
    "obs_end",
    "start_plus_x",
    "end_plus_x",
    "drug_persist",
    "censoring"
  ], i = {
    obs_end: "Active only when exit is observation-end based.",
    start_plus_x: "Active only for DateOffset(StartDate, +Xd).",
    end_plus_x: "Active only for DateOffset(EndDate, +Xd).",
    drug_persist: "Active only for CustomEra persistence exit.",
    censoring: "Active only when censoring criteria are configured.",
    unsupported: "Unsupported exit strategy."
  };
  return r.map((o) => {
    const s = o !== e;
    return {
      id: o,
      label: o === e && n ? n : cC[o],
      active: o === e,
      disabled: s,
      disabledReason: s ? o === "censoring" && !t.hasCensoring ? i.censoring : i[o] : ""
    };
  });
}
function $C(e) {
  const t = [
    "condition",
    "drug",
    "device",
    "measurement",
    "observation",
    "procedure",
    "visit",
    "payer",
    "demographic",
    "death",
    "other"
  ], n = new Set(e.map((r) => r.domain));
  return t.filter((r) => n.has(r)).map((r) => ({
    domain: r,
    label: Xu[r],
    color: Wa[r]
  }));
}
function Il(e) {
  if (!e)
    return [];
  const t = [];
  return e.openStart || t.push(e.startDay), e.openEnd || t.push(e.endDay), t;
}
function GC(e) {
  const { defaultStartDay: t, defaultEndDay: n, observationPeriodWindows: r, warnings: i } = e;
  if (r.length === 0)
    return {
      startDay: t,
      endDay: n
    };
  const o = r.flatMap((c) => [
    ...Il(c.startWindow),
    ...Il(c.endWindow)
  ]);
  let s = o.length > 0 ? ut(Math.min(...o)) : t, l = o.length > 0 ? ut(Math.max(...o)) : n;
  if (s > l) {
    i.push(
      `Observation Period boundaries were inverted (${s}d..${l}d). They were normalized for timeline display.`
    );
    const c = Math.min(s, l), u = Math.max(s, l);
    s = c, l = u;
  }
  return {
    startDay: s,
    endDay: l
  };
}
const zC = [
  "Timeline line appears in all scenario states.",
  "Labels use short criterion names with domain badges.",
  "Demographics are shown as index-aligned markers.",
  "Observation end and cohort exit labels stack when coinciding.",
  "Primary index criteria and nested index criteria are summarized in the Index tooltip.",
  "Nested inclusion criteria are rendered in regular inclusion rows in timeline.",
  "Exit tooltip expresses the active exit formula."
];
function WC(e) {
  const t = Qe(e == null ? void 0 : e.expression), n = [], r = wC(t), i = r.reduce(
    (k, T, re) => {
      var ae;
      const b = (ae = T == null ? void 0 : T.payload) == null ? void 0 : ae.CorrelatedCriteria;
      if (!ht(b))
        return k;
      const z = zr(
        b,
        t,
        `primary-correlated-${re}`,
        1
      );
      return ko({
        rows: z.rows,
        groupId: `primary-correlated-${re}`
      }).forEach((le) => k.rows.push(le)), z.criteriaTypes.forEach((le) => k.criteriaTypes.add(le)), z.observationPeriodWindows.forEach(
        (le) => k.observationPeriodWindows.push(le)
      ), k.hasGroups = k.hasGroups || z.hasGroups, k.maxNestedDepth = Math.max(
        k.maxNestedDepth,
        z.maxNestedDepth
      ), k;
    },
    {
      rows: [],
      criteriaTypes: /* @__PURE__ */ new Set(),
      hasGroups: !1,
      maxNestedDepth: 0,
      observationPeriodWindows: []
    }
  ), o = zr(
    Qe(t == null ? void 0 : t.AdditionalCriteria),
    t,
    "additional",
    0
  ), s = ko({
    rows: o.rows,
    groupId: "additional"
  }), l = {
    ...o,
    rows: Sl({
      rows: s,
      fallbackGroupName: "Restrict initial events"
    })
  }, u = (Array.isArray(t == null ? void 0 : t.InclusionRules) ? t.InclusionRules : []).reduce(
    (k, T, re) => {
      const b = zr(
        Qe(T == null ? void 0 : T.expression),
        t,
        `inclusion-${re}`,
        0
      ), z = ko({
        rows: b.rows,
        groupId: `inclusion-${re}`,
        groupName: T == null ? void 0 : T.name
      });
      return Sl({
        rows: z,
        groupName: T == null ? void 0 : T.name
      }).forEach((me) => k.rows.push(me)), b.criteriaTypes.forEach((me) => k.criteriaTypes.add(me)), b.observationPeriodWindows.forEach(
        (me) => k.observationPeriodWindows.push(me)
      ), k.hasGroups = k.hasGroups || b.hasGroups, k.maxNestedDepth = Math.max(
        k.maxNestedDepth,
        b.maxNestedDepth
      ), k;
    },
    {
      rows: [],
      criteriaTypes: /* @__PURE__ */ new Set(),
      hasGroups: !1,
      maxNestedDepth: 0,
      observationPeriodWindows: []
    }
  ), p = Array.isArray(t == null ? void 0 : t.CensoringCriteria) ? t.CensoringCriteria : [], d = [], f = /* @__PURE__ */ new Set();
  p.forEach((k, T) => {
    const re = ii(k);
    re && (f.add(re.type), d.push(
      Zu({
        id: `censoring-${T}`,
        expression: t,
        criteriaType: re.type,
        payload: re.payload,
        nestedDepth: 0,
        exclusion: !0,
        isNested: !1,
        kind: "censoring",
        sourceJson: k
      })
    ));
  });
  const h = [
    ...l.rows,
    ...u.rows,
    ...d
  ], g = [
    ...h.filter((k) => k.domain !== "death"),
    ...h.filter((k) => k.domain === "death")
  ], C = /* @__PURE__ */ new Set();
  r.forEach((k) => C.add(k.type)), i.criteriaTypes.forEach((k) => C.add(k)), o.criteriaTypes.forEach((k) => C.add(k)), u.criteriaTypes.forEach((k) => C.add(k)), f.forEach((k) => C.add(k));
  const y = i.criteriaTypes.size > 0, I = Math.max(
    o.maxNestedDepth,
    u.maxNestedDepth
  ), O = {
    hasPrimary: r.length > 0,
    hasMultiplePrimary: r.length > 1,
    hasNested: y || I >= 1,
    hasDualIndex: i.maxNestedDepth >= 2 || I >= 2,
    hasCalendarDates: r.some((k) => td(k.payload)),
    hasPayerPlanPeriod: r.some(
      (k) => k.type === D.PAYER_PLAN_PERIOD
    ),
    hasObservationPeriodCriteria: C.has(
      D.OBSERVATION_PERIOD
    ),
    hasEras: C.has(D.CONDITION_ERA) || C.has(D.DRUG_ERA) || C.has(D.DOSE_ERA) || (Ke(Qe(t == null ? void 0 : t.CollapseSettings).EraPad) ?? 0) > 0 || !!Qe(t == null ? void 0 : t.CensorWindow).StartDate || !!Qe(t == null ? void 0 : t.CensorWindow).EndDate,
    hasGroups: l.hasGroups || u.hasGroups,
    hasCensoring: d.length > 0
  }, S = d.some((k) => k.domain === "death"), N = VC(O, n), _ = Qe(t == null ? void 0 : t.PrimaryCriteria), R = Qe(_ == null ? void 0 : _.ObservationWindow), P = Ke(R == null ? void 0 : R.PriorDays), U = Ke(R == null ? void 0 : R.PostDays), M = ut(-1 * (P ?? 0)), w = ut(U ?? 0), V = [
    ...i.observationPeriodWindows,
    ...o.observationPeriodWindows,
    ...u.observationPeriodWindows
  ], L = GC({
    defaultStartDay: M,
    defaultEndDay: w,
    observationPeriodWindows: V,
    warnings: n
  }), te = L.startDay, $ = L.endDay, v = FC(
    t,
    O.hasCensoring,
    S,
    d,
    $,
    n
  ), J = BC(
    v.active,
    O,
    v.activeLabelOverride
  ), j = oi(_.CriteriaList), ee = kC(
    t,
    j
  ), Q = O.hasPrimary ? [
    {
      id: "index-primary",
      day: 0,
      label: "Index",
      color: qu,
      variant: "diamond",
      tooltip: ee,
      sourceJson: r.length === 1 ? j[0] : j
    }
  ] : [];
  N === "default" && g.length === 0 && n.push(
    "No criteria rows available; displaying baseline timeline only."
  );
  const x = MC(N, O), Y = $C(g);
  return {
    title: (e == null ? void 0 : e.name) || "Cohort Criteria Timeline",
    scenario: {
      active: N,
      tabs: x,
      description: pC[N]
    },
    exit: {
      active: v.active,
      tabs: J,
      description: v.descriptionOverride || Cl[v.active],
      tooltip: v.tooltip || v.descriptionOverride || Cl[v.active],
      markerDay: v.markerDay,
      markerColor: v.markerColor,
      secondaryMarkerDay: v.secondaryMarkerDay,
      secondaryMarkerLabel: v.secondaryMarkerLabel,
      secondaryMarkerColor: v.secondaryMarkerColor,
      secondaryMarkerTooltip: v.secondaryMarkerTooltip,
      markerSpan: v.markerSpan
    },
    index: {
      label: "Index Event",
      tooltip: ee,
      markers: Q
    },
    observation: {
      startDay: te,
      endDay: $
    },
    axis: {
      minDay: Mn,
      maxDay: Vn,
      ticks: sC
    },
    rows: g,
    domainLegend: Y,
    warnings: n,
    notes: zC
  };
}
const vn = {
  domains: Wa,
  index: qu,
  secondaryIndex: uC
}, to = 250, kt = 26, Un = 10, YC = 6, Al = 15, HC = 8, Mo = "#4f5d7a", bl = 2, Zn = 18, qC = kt * 2 + Un * 4, XC = 25, JC = 10, Vo = 3, QC = 1.2, KC = vn.domains.other, ZC = 2e3, Rl = {
  width: 38,
  height: 38,
  p: 0,
  border: "1px solid #D8DEE9",
  borderRadius: "6px",
  backgroundColor: "#FFFFFF",
  color: "#1F2A44",
  boxShadow: "0 1px 2px rgba(31, 42, 68, 0.08)",
  "&:hover": {
    backgroundColor: "#f8fafc",
    borderColor: "#c8d0dc"
  },
  "&.Mui-disabled": {
    backgroundColor: "#FFFFFF",
    borderColor: "#E5E7EB",
    color: "#A0A8B8"
  }
}, tn = {
  [`& .${vs.tooltip}`]: {
    backgroundColor: Mo,
    borderRadius: "12px",
    border: "1px solid rgba(148, 163, 184, 0.35)",
    boxShadow: "0 12px 32px rgba(2, 6, 23, 0.35)",
    p: 1.5,
    maxWidth: "430px",
    fontFamily: '"IBM Plex Sans", "Segoe UI", sans-serif'
  },
  [`& .${vs.arrow}`]: {
    color: Mo,
    "&::before": {
      backgroundColor: Mo,
      border: "1px solid rgba(148, 163, 184, 0.35)",
      boxShadow: "none"
    }
  }
};
function eg(e) {
  return JSON.stringify(e, null, 2);
}
function Er(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function id(e) {
  return Array.isArray(e) ? e : Er(e) ? Object.values(e) : [];
}
function tg(e) {
  return Er(e) ? e.STANDARD_CONCEPT === "N" || e.standardConcept === "N" : !1;
}
function ng(e) {
  if (!Er(e))
    return {};
  const t = { ...e }, n = t.excluded, r = t.hierarchy;
  delete t.excluded, delete t.hierarchy, delete t.id;
  const i = t.concept, o = typeof t.isExcluded == "boolean" ? t.isExcluded : n, s = {
    ...t,
    ...typeof o == "boolean" ? { isExcluded: o } : {}
  };
  if (tg(i)) {
    const l = typeof r == "boolean" ? r : t.includeDescendants;
    typeof l == "boolean" && (s.includeDescendants = l);
  }
  return delete s.excluded, delete s.id, s;
}
function rg(e) {
  if (!Er(e))
    return {};
  const t = { ...e }, n = t.expression;
  delete t.currentVersionId, delete t.currentVersionOrdinal, delete t.externalId, delete t.referenceId, delete t.terminated, delete t.uuid, delete t.version, delete t.versionId, delete t.versionOrdinal;
  const r = Er(n) ? n : {};
  return {
    ...t,
    expression: {
      ...r,
      items: id(r.items).map(ng)
    }
  };
}
function ig(e) {
  const t = e == null ? void 0 : e.expression;
  return Er(t) ? {
    ...t,
    ConceptSets: id(t.ConceptSets).map(rg)
  } : t ?? null;
}
function ha(e) {
  const { copyKey: t, data: n, copiedKey: r, onCopy: i, tooltip: o = "Copy JSON" } = e, s = r === t;
  return /* @__PURE__ */ a.jsx(We, { text: o, width: 120, children: /* @__PURE__ */ a.jsx(
    Qr,
    {
      size: "small",
      onClick: (l) => {
        l.stopPropagation(), i(t, n);
      },
      sx: {
        width: 24,
        height: 24,
        p: 0.25,
        color: s ? "#059669" : "#64748b",
        "&:hover": {
          backgroundColor: "#e2e8f0",
          color: "#0f172a"
        }
      },
      name: t,
      children: /* @__PURE__ */ a.jsx(
        We,
        {
          text: s ? "JSON copied to clipboard!" : "",
          controlled: !0,
          show: s,
          width: 170,
          children: /* @__PURE__ */ a.jsx(
            ge,
            {
              iconName: s ? "checkmark" : "copy",
              sx: { fontSize: 15 },
              name: o
            }
          )
        }
      )
    }
  ) });
}
function og(e) {
  const { isExit: t = !1 } = e, n = "#0f1f45";
  return /* @__PURE__ */ a.jsx(
    W,
    {
      component: "svg",
      viewBox: "0 0 16 16",
      "aria-hidden": !0,
      sx: { width: 14, height: 14, display: "block" },
      children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M2.5 13.5 L6.5 9.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M5.5 13.5 H2.5 V10.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M13.5 2.5 L9.5 6.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M10.5 2.5 H13.5 V5.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        )
      ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M6.5 6.5 L2.5 2.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M2.5 5.5 V2.5 H5.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M9.5 9.5 L13.5 13.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "path",
          {
            d: "M10.5 13.5 H13.5 V10.5",
            stroke: n,
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none"
          }
        )
      ] })
    }
  );
}
function yt(e, t, n) {
  return n <= t ? 0 : (e - t) / (n - t) * 100;
}
function ag(e) {
  return e.startDay === e.endDay ? e.startDay : e.openStart && e.openEnd ? 0 : !e.openStart && e.endDay <= 0 ? e.endDay : !e.openEnd && e.startDay >= 0 ? e.startDay : e.startDay <= 0 && e.endDay >= 0 ? 0 : e.openStart && !e.openEnd ? e.endDay : !e.openStart && e.openEnd ? e.startDay : Math.round((e.startDay + e.endDay) / 2);
}
function od(e, t) {
  return e.startDay === e.endDay || !e.openStart && e.openEnd ? e.startDay : e.openStart && !e.openEnd ? e.endDay : e.openStart && e.openEnd ? t : ag(e);
}
function sg(e, t, n) {
  const r = [];
  return e.map((i) => ({
    ...i,
    pct: yt(i.day, t, n),
    // Approximate text width in axis percent to avoid label collisions.
    halfWidthPct: Math.max(2.2, Math.min(18, i.text.length * 0.42))
  })).sort((i, o) => i.pct - o.pct).map((i) => {
    const o = i.pct - i.halfWidthPct, s = i.pct + i.halfWidthPct;
    let l = 0;
    for (; r[l] !== void 0 && o - r[l] < HC; )
      l++;
    return r[l] = s, {
      id: i.id,
      day: i.day,
      text: i.text,
      color: i.color,
      lane: l
    };
  });
}
function lg(e) {
  return vn.domains[e] || vn.domains.other;
}
function fa(e) {
  return e.groupedInclusion ? KC : lg(e.domain);
}
function lr(e) {
  return e.criteriaBadge ? e.criteriaBadge : e.groupedInclusion ? "group" : e.domain;
}
function _i(e) {
  return e.tooltipTitle ? e.tooltipTitle : e.groupedInclusion ? "GROUP" : e.label;
}
function cg(e, t) {
  return e ? e.split(`
`).map((n) => n.trimEnd()).filter((n) => n.trim() !== "").filter((n) => {
    if (!t)
      return !0;
    const r = n.trim();
    return !(r === t || r.startsWith(`${t}:`));
  }) : [];
}
function ug(e) {
  const t = e.trim().toLowerCase();
  if (t === "#111111" || t === "#000" || t === "#000000")
    return "#E2E8F0";
  const n = t.startsWith("#") ? t.slice(1) : t;
  if (!/^[0-9a-f]{3}$|^[0-9a-f]{6}$/.test(n))
    return e;
  const i = n.length === 3 ? n.split("").map((u) => u + u).join("") : n, o = parseInt(i.slice(0, 2), 16) / 255, s = parseInt(i.slice(2, 4), 16) / 255, l = parseInt(i.slice(4, 6), 16) / 255;
  return 0.2126 * o + 0.7152 * s + 0.0722 * l < 0.35 ? "#E2E8F0" : e;
}
function Pn(e, t = !1) {
  return {
    cursor: "pointer",
    transition: "filter 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease, opacity 0.15s ease",
    "&:hover": {
      filter: "brightness(1.18) saturate(1.22)",
      ...t ? { boxShadow: `0 0 0 1px ${e}66, 0 8px 18px ${e}33` } : {},
      zIndex: 14
    }
  };
}
function dg(e) {
  return {
    cursor: "pointer",
    transition: "background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease",
    "&:hover": {
      background: e,
      borderColor: e,
      boxShadow: `0 0 0 1px ${e}, 0 10px 22px ${e}40`,
      filter: "brightness(1.04) saturate(1.12)",
      zIndex: 7
    },
    "&:hover .timeline-open-cap": {
      backgroundColor: "#FFFFFF",
      color: e,
      borderColor: e
    },
    "&:hover .timeline-bar-text": {
      color: "#FFFFFF",
      backgroundColor: "transparent",
      textShadow: "0 1px 2px rgba(15, 23, 42, 0.35)"
    },
    "&:hover .timeline-inline-tag": {
      color: "#FFFFFF",
      borderColor: "#FFFFFFB3",
      backgroundColor: `${e}C0`
    }
  };
}
function pg(e) {
  return {
    cursor: "pointer",
    transition: "box-shadow 0.15s ease, filter 0.15s ease",
    "&:hover": {
      boxShadow: `0 0 0 2px #ffffff, 0 0 0 1px ${e}66, 0 8px 18px ${e}33`,
      filter: "brightness(1.08) saturate(1.15)"
    }
  };
}
function nn(e) {
  const {
    title: t,
    color: n,
    details: r,
    domainBadge: i,
    domainBadgeVariant: o = "chip"
  } = e, s = ug(n), l = cg(r, t);
  return /* @__PURE__ */ a.jsxs(W, { sx: { minWidth: "260px" }, children: [
    /* @__PURE__ */ a.jsxs(W, { sx: { display: "flex", alignItems: "center", gap: 1, mb: 0.75 }, children: [
      /* @__PURE__ */ a.jsx(
        fe,
        {
          sx: {
            color: s,
            fontSize: "13px",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            fontWeight: 800,
            fontFamily: '"IBM Plex Sans Condensed", "IBM Plex Sans", sans-serif'
          },
          children: t
        }
      ),
      i && o === "inline" && /* @__PURE__ */ a.jsxs(
        fe,
        {
          sx: {
            color: s,
            fontSize: "11px",
            fontWeight: 800,
            fontFamily: '"IBM Plex Sans Condensed", "IBM Plex Sans", sans-serif'
          },
          children: [
            "(",
            i,
            ")"
          ]
        }
      ),
      i && o === "chip" && /* @__PURE__ */ a.jsx(
        W,
        {
          sx: {
            fontSize: "12px",
            fontWeight: 700,
            color: s,
            border: `1px solid ${s}66`,
            backgroundColor: `${s}1F`,
            borderRadius: "6px",
            px: 0.75,
            py: "1px",
            textTransform: "uppercase",
            letterSpacing: "0.06em"
          },
          children: i
        }
      )
    ] }),
    l.length > 0 && /* @__PURE__ */ a.jsx(W, { sx: { display: "flex", flexDirection: "column", gap: 0.35 }, children: l.map((c, u) => /* @__PURE__ */ a.jsx(
      fe,
      {
        sx: {
          color: "#E2E8F0",
          fontSize: "14px",
          lineHeight: 1.35,
          fontFamily: '"IBM Plex Sans", "Segoe UI", sans-serif',
          whiteSpace: "pre-wrap"
        },
        children: c
      },
      `${c}-${u}`
    )) })
  ] });
}
function hg(e) {
  const { row: t, copiedKey: n, onCopyJson: r } = e, i = fa(t);
  return t.kind === "demographic" ? /* @__PURE__ */ a.jsxs(
    W,
    {
      sx: {
        height: `${kt + 6}px`,
        mb: `${YC}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        pr: 1,
        gap: 0.75
      },
      children: [
        /* @__PURE__ */ a.jsx(
          fe,
          {
            sx: {
              fontSize: "14px",
              color: "#94a3b8",
              fontStyle: "italic"
            },
            children: t.label
          }
        ),
        /* @__PURE__ */ a.jsx(
          W,
          {
            sx: {
              fontSize: "11px",
              fontWeight: 700,
              color: i,
              border: `1px solid ${i}33`,
              backgroundColor: `${i}14`,
              borderRadius: "4px",
              px: 0.75,
              py: "1px",
              textTransform: "uppercase",
              letterSpacing: "0.03em"
            },
            children: lr(t)
          }
        ),
        /* @__PURE__ */ a.jsx(
          ha,
          {
            copyKey: `timeline-row-${t.id}`,
            data: t.sourceJson ?? t,
            copiedKey: n,
            onCopy: r,
            tooltip: "Copy element JSON"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ a.jsxs(
    W,
    {
      sx: {
        height: `${kt}px`,
        mb: `${Un}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        pr: 1,
        gap: t.secondaryIndexAnchor ? 0.35 : 0.75
      },
      children: [
        t.secondaryIndexAnchor && /* @__PURE__ */ a.jsx(
          W,
          {
            sx: {
              width: "11px",
              height: "11px",
              borderRadius: "2px",
              backgroundColor: vn.secondaryIndex,
              transform: "rotate(45deg)",
              flexShrink: 0,
              mr: 0
            }
          }
        ),
        /* @__PURE__ */ a.jsx(
          fe,
          {
            sx: {
              fontSize: "14px",
              color: "#323b4b",
              maxWidth: `${to - 84}px`,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: t.label
          }
        ),
        /* @__PURE__ */ a.jsx(
          W,
          {
            sx: {
              fontSize: "11px",
              fontWeight: 700,
              color: i,
              border: `1px solid ${i}33`,
              backgroundColor: `${i}14`,
              borderRadius: "4px",
              px: 0.75,
              py: "1px",
              textTransform: "uppercase",
              letterSpacing: "0.03em"
            },
            children: lr(t)
          }
        ),
        t.exclusion && /* @__PURE__ */ a.jsx(
          W,
          {
            sx: {
              fontSize: "11px",
              fontWeight: 700,
              color: "#B45309",
              border: "1px solid #FCD34D",
              backgroundColor: "#FFFBEB",
              borderRadius: "4px",
              px: 0.75,
              py: "1px",
              textTransform: "uppercase",
              letterSpacing: "0.03em"
            },
            children: "Excl"
          }
        ),
        /* @__PURE__ */ a.jsx(
          ha,
          {
            copyKey: `timeline-row-${t.id}`,
            data: t.sourceJson ?? t,
            copiedKey: n,
            onCopy: r,
            tooltip: "Copy element JSON"
          }
        )
      ]
    }
  );
}
function fg(e) {
  var L, te, $;
  const {
    rows: t,
    axis: n,
    indexMarkers: r,
    observationStartDay: i,
    observationEndDay: o,
    exitMarkerDay: s,
    exitColor: l,
    exitTooltip: c,
    secondaryMarkerDay: u,
    secondaryMarkerLabel: p,
    secondaryMarkerColor: d,
    secondaryMarkerTooltip: f,
    markerSpan: h,
    copiedKey: g,
    onCopyJson: C
  } = e, y = r.length > 0, I = y ? 1 : 0, O = t.length + I, S = ((L = r[0]) == null ? void 0 : L.day) ?? 0, N = (te = r.find(
    (v) => v.id === "index-secondary"
  )) == null ? void 0 : te.day, _ = Math.max(
    O * (kt + Un) + Un,
    qC
  ), R = (v) => Un + v * (kt + Un), P = R(0) + kt / 2, U = t.findIndex(
    (v) => v.secondaryIndexAnchor
  ), M = t.findIndex((v) => v.kind !== "demographic"), w = U >= 0 && (($ = t[U]) != null && $.secondaryIndexAnchor) ? 10 : 0, V = U >= 0 ? R(U + I) + kt / 2 - w : M >= 0 ? R(M + I) + kt / 2 : P;
  return /* @__PURE__ */ a.jsxs(W, { sx: { display: "flex", width: "100%" }, children: [
    /* @__PURE__ */ a.jsxs(W, { sx: { width: `${to}px`, flexShrink: 0, mt: "6px" }, children: [
      y && /* @__PURE__ */ a.jsxs(
        W,
        {
          sx: {
            height: `${kt}px`,
            mb: `${Un}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            pr: 1,
            gap: 1
          },
          children: [
            /* @__PURE__ */ a.jsx(
              fe,
              {
                sx: {
                  fontSize: "15px",
                  color: vn.index,
                  fontWeight: 700
                },
                children: r[0].label
              }
            ),
            /* @__PURE__ */ a.jsx(
              ha,
              {
                copyKey: `timeline-marker-${r[0].id}`,
                data: r[0].sourceJson ?? r[0],
                copiedKey: g,
                onCopy: C,
                tooltip: "Copy index JSON"
              }
            )
          ]
        }
      ),
      t.map((v) => /* @__PURE__ */ a.jsx(
        We,
        {
          text: /* @__PURE__ */ a.jsx(
            nn,
            {
              title: _i(v),
              color: fa(v),
              details: v.tooltip || v.label,
              domainBadge: lr(v)
            }
          ),
          placement: "left",
          sx: tn,
          children: /* @__PURE__ */ a.jsx("span", { children: /* @__PURE__ */ a.jsx(
            hg,
            {
              row: v,
              copiedKey: g,
              onCopyJson: C
            }
          ) })
        },
        v.id
      ))
    ] }),
    /* @__PURE__ */ a.jsxs(W, { sx: { flex: 1, position: "relative", height: `${_}px` }, children: [
      n.ticks.map((v) => /* @__PURE__ */ a.jsx(
        W,
        {
          sx: {
            position: "absolute",
            left: `${yt(v, n.minDay, n.maxDay)}%`,
            top: 0,
            bottom: 0,
            width: "1px",
            transform: "translateX(-0.5px)",
            backgroundColor: "#eef1f5"
          }
        },
        `tick-${v}`
      )),
      /* @__PURE__ */ a.jsx(
        We,
        {
          text: /* @__PURE__ */ a.jsx(
            nn,
            {
              title: "Obs Start",
              color: "#94a3b8",
              details: "Observation start boundary"
            }
          ),
          sx: tn,
          children: /* @__PURE__ */ a.jsx(
            W,
            {
              sx: {
                position: "absolute",
                left: `${yt(
                  i,
                  n.minDay,
                  n.maxDay
                )}%`,
                top: 0,
                bottom: 0,
                borderLeft: "1.5px dashed #94a3b8",
                transform: "translateX(-0.5px)",
                zIndex: 2,
                ...Pn("#94a3b8")
              }
            }
          )
        }
      ),
      /* @__PURE__ */ a.jsx(
        We,
        {
          text: /* @__PURE__ */ a.jsx(
            nn,
            {
              title: "Obs End",
              color: "#94a3b8",
              details: "Observation end boundary"
            }
          ),
          sx: tn,
          children: /* @__PURE__ */ a.jsx(
            W,
            {
              sx: {
                position: "absolute",
                left: `${yt(
                  o,
                  n.minDay,
                  n.maxDay
                )}%`,
                top: 0,
                bottom: 0,
                borderLeft: "1.5px dashed #94a3b8",
                transform: "translateX(-0.5px)",
                zIndex: 2,
                ...Pn("#94a3b8")
              }
            }
          )
        }
      ),
      r.map((v, J) => {
        const j = J === 0 ? P : V, ee = `${yt(v.day, n.minDay, n.maxDay)}%`;
        return /* @__PURE__ */ a.jsxs(
          W,
          {
            sx: {
              position: "absolute",
              left: ee,
              top: 0,
              bottom: 0,
              width: "24px",
              transform: "translateX(-12px)",
              zIndex: 12,
              pointerEvents: "none"
            },
            children: [
              /* @__PURE__ */ a.jsx(
                W,
                {
                  className: "timeline-index-line",
                  sx: {
                    position: "absolute",
                    left: "50%",
                    top: 0,
                    bottom: 0,
                    width: 0,
                    borderLeft: `2px solid ${v.color}`,
                    transform: "translateX(-1px)",
                    opacity: J === 0 ? 1 : 0.85,
                    pointerEvents: "none"
                  }
                }
              ),
              /* @__PURE__ */ a.jsx(
                We,
                {
                  text: /* @__PURE__ */ a.jsx(
                    nn,
                    {
                      title: v.label,
                      color: v.color,
                      details: v.tooltip || v.label,
                      domainBadge: J === 0 ? "any of" : "index 2",
                      domainBadgeVariant: J === 0 ? "inline" : "chip"
                    }
                  ),
                  sx: tn,
                  children: /* @__PURE__ */ a.jsx(
                    W,
                    {
                      className: "timeline-index-diamond",
                      sx: {
                        position: "absolute",
                        left: "50%",
                        top: `${j - 7}px`,
                        width: "14px",
                        height: "14px",
                        borderRadius: "2px",
                        backgroundColor: v.color,
                        transform: "translateX(-50%) rotate(45deg)",
                        boxShadow: "0 0 0 2px #ffffff",
                        pointerEvents: "auto",
                        ...pg(v.color)
                      }
                    }
                  )
                }
              )
            ]
          },
          v.id
        );
      }),
      /* @__PURE__ */ a.jsx(
        We,
        {
          text: /* @__PURE__ */ a.jsx(
            nn,
            {
              title: "Cohort Exit",
              color: l,
              details: c
            }
          ),
          sx: tn,
          children: /* @__PURE__ */ a.jsx(
            W,
            {
              sx: {
                position: "absolute",
                left: `${yt(s, n.minDay, n.maxDay)}%`,
                top: 0,
                bottom: 0,
                width: "3px",
                backgroundColor: l,
                transform: "translateX(-1.5px)",
                borderRadius: "2px",
                zIndex: 4,
                ...Pn(l)
              }
            }
          )
        }
      ),
      typeof u == "number" && /* @__PURE__ */ a.jsx(
        We,
        {
          text: /* @__PURE__ */ a.jsx(
            nn,
            {
              title: p || "Secondary marker",
              color: d || "#334155",
              details: f || p || "Secondary exit marker"
            }
          ),
          sx: tn,
          children: /* @__PURE__ */ a.jsx(
            W,
            {
              sx: {
                position: "absolute",
                left: `${yt(
                  u,
                  n.minDay,
                  n.maxDay
                )}%`,
                top: 0,
                bottom: 0,
                width: "2px",
                borderLeft: `2px dashed ${d || "#334155"}`,
                transform: "translateX(-1px)",
                borderRadius: "2px",
                zIndex: 4,
                ...Pn(d || "#334155")
              }
            }
          )
        }
      ),
      h && /* @__PURE__ */ a.jsx(
        We,
        {
          text: /* @__PURE__ */ a.jsx(
            nn,
            {
              title: h.label,
              color: l,
              details: `Interval between Drug Exposure End and Cohort Exit: ${Math.abs(
                h.endDay - h.startDay
              )} days.`,
              domainBadge: "exit interval"
            }
          ),
          sx: tn,
          children: /* @__PURE__ */ a.jsx(
            W,
            {
              sx: {
                position: "absolute",
                top: "-3px",
                left: `${Math.max(
                  0,
                  Math.min(
                    100,
                    yt(h.endDay, n.minDay, n.maxDay) - QC
                  )
                )}%`,
                width: `${XC}px`,
                height: `${JC}px`,
                transform: "translateX(-12px)",
                borderTop: `${Vo}px solid ${l}`,
                borderLeft: `${Vo}px solid ${l}`,
                borderRight: `${Vo}px solid ${l}`,
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "2px",
                boxSizing: "border-box",
                zIndex: 6,
                ...Pn(l)
              },
              children: /* @__PURE__ */ a.jsx(
                fe,
                {
                  sx: {
                    position: "absolute",
                    bottom: "calc(200% - 6px)",
                    left: "212%",
                    transform: "translateX(-100%)",
                    fontSize: "11px",
                    fontWeight: 700,
                    color: l,
                    whiteSpace: "nowrap",
                    lineHeight: 1,
                    textAlign: "right"
                  },
                  children: h.label
                }
              )
            }
          )
        }
      ),
      t.map((v, J) => {
        const j = R(J + I), ee = fa(v), Q = v.secondaryIndexAnchor ? 10 : 0, x = kt + bl, Y = v.secondaryIndexAnchor && v.inlineTagText ? 40 : x, k = v.secondaryIndexAnchor && v.inlineTagText ? Math.max(
          0,
          j - Q - (Y - kt) / 2
        ) : j - bl / 2 - Q, T = yt(v.startDay, n.minDay, n.maxDay), re = yt(v.endDay, n.minDay, n.maxDay), b = Math.max(0.6, re - T);
        v.openStart && v.openEnd || v.openStart || v.openEnd;
        const z = v.secondaryIndexAnchor && typeof N == "number" ? Math.max(
          6,
          Math.min(
            94,
            (yt(N, n.minDay, n.maxDay) - T) / b * 100
          )
        ) : void 0;
        if (v.kind === "demographic")
          return /* @__PURE__ */ a.jsx(
            We,
            {
              text: /* @__PURE__ */ a.jsx(
                nn,
                {
                  title: _i(v),
                  color: "#94a3b8",
                  details: v.tooltip || v.label,
                  domainBadge: lr(v)
                }
              ),
              sx: tn,
              children: /* @__PURE__ */ a.jsx(
                W,
                {
                  sx: {
                    position: "absolute",
                    left: `${yt(0, n.minDay, n.maxDay)}%`,
                    top: `${j + kt / 2 - 6}px`,
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: "#94a3b8",
                    transform: "translateX(-6px)",
                    zIndex: 16,
                    boxShadow: "0 0 0 2px white",
                    ...Pn("#94a3b8")
                  }
                }
              )
            },
            v.id
          );
        if (v.domain === "death") {
          const me = od(v, o), ae = me === S, le = ae ? 4 : 2;
          return /* @__PURE__ */ a.jsx(
            We,
            {
              text: /* @__PURE__ */ a.jsx(
                nn,
                {
                  title: _i(v),
                  color: ee,
                  details: v.tooltip || v.label,
                  domainBadge: lr(v)
                }
              ),
              sx: tn,
              children: /* @__PURE__ */ a.jsx(
                W,
                {
                  "data-testid": `timeline-death-line-${v.id}`,
                  sx: {
                    position: "absolute",
                    left: `${yt(me, n.minDay, n.maxDay)}%`,
                    top: ae ? `${j - 2}px` : 0,
                    bottom: ae ? "auto" : 0,
                    height: ae ? `${kt + 4}px` : "auto",
                    width: `${le}px`,
                    background: ee,
                    transform: `translateX(-${le / 2}px)`,
                    zIndex: 18,
                    borderRadius: "2px",
                    ...Pn(ee)
                  },
                  children: !ae && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx(
                      W,
                      {
                        sx: {
                          position: "absolute",
                          left: "50%",
                          bottom: "25px",
                          width: "4px",
                          height: "4px",
                          borderRadius: "50%",
                          backgroundColor: ee,
                          transform: "translateX(-50%)"
                        }
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      W,
                      {
                        sx: {
                          position: "absolute",
                          left: "50%",
                          bottom: "12px",
                          width: "9px",
                          height: "9px",
                          borderRadius: "50%",
                          backgroundColor: ee,
                          transform: "translateX(-50%)"
                        }
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      W,
                      {
                        sx: {
                          position: "absolute",
                          left: "50%",
                          bottom: "4px",
                          width: "4px",
                          height: "4px",
                          borderRadius: "50%",
                          backgroundColor: ee,
                          transform: "translateX(-50%)"
                        }
                      }
                    )
                  ] })
                }
              )
            },
            v.id
          );
        }
        return /* @__PURE__ */ a.jsx(
          We,
          {
            text: /* @__PURE__ */ a.jsx(
              nn,
              {
                title: _i(v),
                color: ee,
                details: v.tooltip || v.label,
                domainBadge: lr(v)
              }
            ),
            sx: tn,
            children: /* @__PURE__ */ a.jsxs(
              W,
              {
                sx: {
                  position: "absolute",
                  left: `${T}%`,
                  top: `${k}px`,
                  height: `${Y}px`,
                  width: `${b}%`,
                  border: `1px solid ${ee}55`,
                  background: v.exclusion ? `repeating-linear-gradient(135deg, ${ee}22, ${ee}22 4px, transparent 4px, transparent 8px)` : `${ee}2B`,
                  zIndex: 3,
                  borderRadius: "12px",
                  ...dg(ee)
                },
                children: [
                  v.openStart && /* @__PURE__ */ a.jsx(
                    W,
                    {
                      className: "timeline-open-cap",
                      sx: {
                        position: "absolute",
                        left: "2px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: `${Zn}px`,
                        height: `${Zn}px`,
                        borderRadius: "50%",
                        backgroundColor: ee,
                        color: "white",
                        border: `1px solid ${ee}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        lineHeight: 1,
                        fontWeight: 800,
                        transition: "background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease"
                      },
                      children: "❮"
                    }
                  ),
                  v.openEnd && /* @__PURE__ */ a.jsx(
                    W,
                    {
                      className: "timeline-open-cap",
                      sx: {
                        position: "absolute",
                        right: "2px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: `${Zn}px`,
                        height: `${Zn}px`,
                        borderRadius: "50%",
                        backgroundColor: ee,
                        color: "white",
                        border: `1px solid ${ee}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        lineHeight: 1,
                        fontWeight: 800,
                        transition: "background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease"
                      },
                      children: "❯"
                    }
                  ),
                  v.eraText && /* @__PURE__ */ a.jsx(
                    fe,
                    {
                      className: "timeline-bar-text",
                      sx: {
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        maxWidth: v.openStart || v.openEnd ? `calc(100% - ${Zn + 12}px)` : "calc(100% - 12px)",
                        fontSize: "12px",
                        lineHeight: 1,
                        fontWeight: 700,
                        color: ee,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "center",
                        px: 0.5,
                        backgroundColor: "transparent",
                        borderRadius: "3px",
                        pointerEvents: "none"
                      },
                      children: v.eraText
                    }
                  ),
                  typeof z == "number" && !v.secondaryIndexAnchor && /* @__PURE__ */ a.jsx(
                    W,
                    {
                      sx: {
                        position: "absolute",
                        left: `${z}%`,
                        top: "50%",
                        width: "14px",
                        height: "14px",
                        borderRadius: "3px",
                        backgroundColor: vn.secondaryIndex,
                        transform: "translate(-50%, -50%) rotate(45deg)",
                        boxShadow: "0 0 0 2px #ffffff",
                        zIndex: 5,
                        pointerEvents: "none"
                      }
                    }
                  ),
                  v.inlineTagText && /* @__PURE__ */ a.jsx(
                    fe,
                    {
                      className: "timeline-inline-tag",
                      sx: {
                        position: "absolute",
                        ...typeof z == "number" ? {
                          left: `calc(${z}% - 3px)`
                        } : {
                          right: v.openEnd ? `${Zn + 8}px` : "6px"
                        },
                        top: typeof z == "number" ? "calc(50% + 5px)" : "50%",
                        transform: typeof z == "number" ? "translate(-100%, 0)" : "translateY(-50%)",
                        maxWidth: typeof z == "number" ? "40px" : "56px",
                        fontSize: typeof z == "number" ? "10px" : "11px",
                        lineHeight: 1,
                        fontWeight: 700,
                        color: ee,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textTransform: "uppercase",
                        px: typeof z == "number" ? 0.5 : 0.75,
                        py: typeof z == "number" ? "1px" : "2px",
                        borderRadius: typeof z == "number" ? "3px" : "4px",
                        border: `1px solid ${ee}66`,
                        backgroundColor: `${ee}22`,
                        pointerEvents: "none",
                        transition: "color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease"
                      },
                      children: v.inlineTagText
                    }
                  )
                ]
              }
            )
          },
          v.id
        );
      }),
      /* @__PURE__ */ a.jsx(
        W,
        {
          sx: {
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            borderTop: "1px solid #a9afb9",
            zIndex: 1
          }
        }
      )
    ] })
  ] });
}
const mg = ({
  definition: e
}) => {
  const [t, n] = K(!1), [r, i] = K(!1), [o, s] = K(null), l = Te(null), c = Te(null), u = t || r, p = Z(
    () => WC(e || null),
    [e]
  ), d = Z(() => {
    const C = [
      {
        id: "obs-start",
        day: p.observation.startDay,
        text: "Obs Start",
        color: "#94a3b8"
      },
      {
        id: "obs-end",
        day: p.observation.endDay,
        text: "Obs End",
        color: "#94a3b8"
      },
      {
        id: "cohort-exit",
        day: p.exit.markerDay,
        text: "Cohort Exit",
        color: p.exit.markerColor
      }
    ];
    p.index.markers.forEach((I) => {
      C.push({
        id: I.id,
        day: I.day,
        text: I.label,
        color: I.color
      });
    });
    const y = p.rows.find((I) => I.domain === "death");
    return y && C.push({
      id: `death-label-${y.id}`,
      day: od(y, p.observation.endDay),
      text: "Death",
      color: "#111111"
    }), typeof p.exit.secondaryMarkerDay == "number" && C.push({
      id: "secondary-exit-marker",
      day: p.exit.secondaryMarkerDay,
      text: p.exit.secondaryMarkerLabel || "Secondary marker",
      color: p.exit.secondaryMarkerColor || "#334155"
    }), sg(C, p.axis.minDay, p.axis.maxDay);
  }, [p]), f = (Math.max(0, ...d.map((C) => C.lane)) + 1) * Al + 4;
  q(() => {
    const C = () => {
      const y = document.fullscreenElement === l.current;
      n(y), y && i(!1);
    };
    return document.addEventListener("fullscreenchange", C), () => document.removeEventListener("fullscreenchange", C);
  }, []), q(() => () => {
    c.current && clearTimeout(c.current);
  }, []), q(() => {
    if (!r)
      return;
    const C = document.body.style.overflow;
    return document.body.style.overflow = "hidden", () => {
      document.body.style.overflow = C;
    };
  }, [r]);
  const h = async () => {
    var O, S, N;
    if (!l.current)
      return;
    if (r) {
      i(!1);
      return;
    }
    if (document.fullscreenElement) {
      try {
        await ((O = document.exitFullscreen) == null ? void 0 : O.call(document));
      } catch {
        n(!1);
      }
      return;
    }
    const C = document.permissionsPolicy, y = document.featurePolicy;
    if (!(((S = C == null ? void 0 : C.allowsFeature) == null ? void 0 : S.call(C, "fullscreen")) ?? ((N = y == null ? void 0 : y.allowsFeature) == null ? void 0 : N.call(y, "fullscreen")) ?? !0) || typeof l.current.requestFullscreen != "function") {
      i(!0);
      return;
    }
    try {
      await l.current.requestFullscreen();
    } catch {
      i(!0);
    }
  }, g = async (C, y) => {
    await navigator.clipboard.writeText(eg(y)), s(C), c.current && clearTimeout(c.current), c.current = setTimeout(() => {
      s(null), c.current = null;
    }, ZC);
  };
  return /* @__PURE__ */ a.jsx(
    W,
    {
      ref: l,
      sx: {
        backgroundColor: "#f5f6f8",
        borderRadius: r ? 0 : "10px",
        p: u ? 4 : 1,
        ...r ? {
          position: "fixed",
          inset: 0,
          zIndex: 1400,
          overflowY: "auto"
        } : {}
      },
      children: /* @__PURE__ */ a.jsxs(
        Qp,
        {
          variant: "outlined",
          sx: { p: 2, borderRadius: "10px", borderColor: "#e5e7eb" },
          children: [
            /* @__PURE__ */ a.jsxs(A, { item: !0, sx: { display: "flex", gap: 1, justifyContent: "end" }, children: [
              /* @__PURE__ */ a.jsx(
                We,
                {
                  text: "Copy cohort JSON",
                  placement: "left",
                  disabled: o === "timeline-cohort",
                  children: /* @__PURE__ */ a.jsx(W, { component: "span", sx: { display: "inline-flex" }, children: /* @__PURE__ */ a.jsx(
                    We,
                    {
                      text: "Cohort JSON copied to clipboard!",
                      controlled: !0,
                      show: o === "timeline-cohort",
                      placement: "left",
                      width: 190,
                      children: /* @__PURE__ */ a.jsx(
                        Qr,
                        {
                          size: "small",
                          "aria-label": "Copy cohort JSON",
                          onClick: () => g(
                            "timeline-cohort",
                            ig(e)
                          ),
                          disabled: !e,
                          sx: Rl,
                          name: "Copy cohort JSON",
                          children: /* @__PURE__ */ a.jsx(
                            ge,
                            {
                              iconName: o === "timeline-cohort" ? "checkmark" : "copy",
                              sx: { fontSize: 18, color: "inherit" },
                              name: "Copy cohort JSON"
                            }
                          )
                        }
                      )
                    }
                  ) })
                }
              ),
              /* @__PURE__ */ a.jsx(
                We,
                {
                  text: u ? "Exit Fullscreen" : "Expand to full screen",
                  placement: "left",
                  children: /* @__PURE__ */ a.jsx(
                    Qr,
                    {
                      size: "small",
                      "aria-label": u ? "Exit Fullscreen" : "Expand to full screen",
                      onClick: h,
                      sx: Rl,
                      name: u ? "Exit Fullscreen" : "Expand to full screen",
                      children: /* @__PURE__ */ a.jsx(og, { isExit: u })
                    }
                  )
                }
              )
            ] }),
            /* @__PURE__ */ a.jsx(
              W,
              {
                sx: {
                  ml: `${to}px`,
                  mb: 0.5,
                  height: `${f}px`,
                  position: "relative",
                  fontSize: "12px"
                },
                children: d.map((C) => /* @__PURE__ */ a.jsx(
                  fe,
                  {
                    sx: {
                      position: "absolute",
                      left: `${yt(
                        C.day,
                        p.axis.minDay,
                        p.axis.maxDay
                      )}%`,
                      top: `${C.lane * Al}px`,
                      transform: "translateX(-50%)",
                      fontSize: "12px",
                      lineHeight: 1.1,
                      color: C.color,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      fontWeight: 700,
                      px: 0.25,
                      backgroundColor: "white",
                      borderRadius: "2px",
                      whiteSpace: "nowrap"
                    },
                    children: C.text
                  },
                  C.id
                ))
              }
            ),
            /* @__PURE__ */ a.jsx(
              fg,
              {
                rows: p.rows,
                axis: p.axis,
                indexMarkers: p.index.markers,
                observationStartDay: p.observation.startDay,
                observationEndDay: p.observation.endDay,
                exitMarkerDay: p.exit.markerDay,
                exitColor: p.exit.markerColor,
                exitTooltip: p.exit.tooltip,
                secondaryMarkerDay: p.exit.secondaryMarkerDay,
                secondaryMarkerLabel: p.exit.secondaryMarkerLabel,
                secondaryMarkerColor: p.exit.secondaryMarkerColor,
                secondaryMarkerTooltip: p.exit.secondaryMarkerTooltip,
                markerSpan: p.exit.markerSpan,
                copiedKey: o,
                onCopyJson: g
              }
            ),
            /* @__PURE__ */ a.jsxs(
              W,
              {
                sx: {
                  ml: `${to}px`,
                  mt: 0.75,
                  mb: 1.25,
                  position: "relative",
                  height: "30px"
                },
                children: [
                  /* @__PURE__ */ a.jsxs(
                    fe,
                    {
                      sx: {
                        position: "absolute",
                        left: 0,
                        top: 2,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        color: "#8b93a2",
                        textTransform: "uppercase",
                        fontWeight: 700,
                        letterSpacing: "0.04em"
                      },
                      children: [
                        /* @__PURE__ */ a.jsx(
                          W,
                          {
                            component: "span",
                            sx: { fontSize: "10px", lineHeight: 1, color: "#8b93a2" },
                            children: "◄"
                          }
                        ),
                        "All days before"
                      ]
                    }
                  ),
                  p.axis.ticks.map((C) => /* @__PURE__ */ a.jsxs(
                    W,
                    {
                      sx: {
                        position: "absolute",
                        left: `${yt(
                          C,
                          p.axis.minDay,
                          p.axis.maxDay
                        )}%`,
                        transform: "translateX(-50%)",
                        textAlign: "center",
                        color: C === 0 ? vn.index : "#9ca3af",
                        fontSize: "12px"
                      },
                      children: [
                        /* @__PURE__ */ a.jsx(
                          W,
                          {
                            sx: {
                              width: "1px",
                              height: "5px",
                              backgroundColor: "#d5dbe3",
                              mx: "auto"
                            }
                          }
                        ),
                        /* @__PURE__ */ a.jsx(W, { children: C === 0 ? "0" : `${C > 0 ? "+" : ""}${C}d` })
                      ]
                    },
                    `axis-${C}`
                  )),
                  /* @__PURE__ */ a.jsxs(
                    fe,
                    {
                      sx: {
                        position: "absolute",
                        right: 0,
                        top: 2,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        color: "#8b93a2",
                        textTransform: "uppercase",
                        fontWeight: 700,
                        letterSpacing: "0.04em"
                      },
                      children: [
                        "All days after",
                        /* @__PURE__ */ a.jsx(
                          W,
                          {
                            component: "span",
                            sx: { fontSize: "10px", lineHeight: 1, color: "#8b93a2" },
                            children: "►"
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ a.jsx(Lc, {}),
            /* @__PURE__ */ a.jsxs(W, { sx: { mt: 1.25, display: "flex", gap: 2, flexWrap: "wrap" }, children: [
              p.index.markers.length > 0 && /* @__PURE__ */ a.jsxs(W, { sx: { display: "flex", alignItems: "center", gap: 0.75 }, children: [
                /* @__PURE__ */ a.jsx(
                  W,
                  {
                    sx: {
                      width: "10px",
                      height: "10px",
                      borderRadius: "2px",
                      transform: "rotate(45deg)",
                      backgroundColor: vn.index
                    }
                  }
                ),
                /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: "#4b5563" }, children: "Entry / Index" })
              ] }),
              /* @__PURE__ */ a.jsxs(W, { sx: { display: "flex", alignItems: "center", gap: 0.75 }, children: [
                /* @__PURE__ */ a.jsx(
                  W,
                  {
                    sx: {
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor: "#94a3b8"
                    }
                  }
                ),
                /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: "#4b5563" }, children: "Demographic (index)" })
              ] }),
              /* @__PURE__ */ a.jsxs(W, { sx: { display: "flex", alignItems: "center", gap: 0.75 }, children: [
                /* @__PURE__ */ a.jsx(
                  W,
                  {
                    sx: {
                      width: "14px",
                      height: "3px",
                      backgroundColor: p.exit.markerColor
                    }
                  }
                ),
                /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: "#4b5563" }, children: "Cohort Exit" })
              ] }),
              /* @__PURE__ */ a.jsxs(W, { sx: { display: "flex", alignItems: "center", gap: 0.75 }, children: [
                /* @__PURE__ */ a.jsx(W, { sx: { width: "14px", borderTop: "1.5px dashed #94a3b8" } }),
                /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: "#4b5563" }, children: "Observation boundary" })
              ] }),
              p.domainLegend.map((C) => /* @__PURE__ */ a.jsxs(
                W,
                {
                  sx: { display: "flex", alignItems: "center", gap: 0.75 },
                  children: [
                    /* @__PURE__ */ a.jsx(
                      W,
                      {
                        sx: {
                          width: "12px",
                          height: "9px",
                          borderRadius: "2px",
                          border: `1px solid ${C.color}55`,
                          backgroundColor: `${C.color}2B`
                        }
                      }
                    ),
                    /* @__PURE__ */ a.jsx(fe, { sx: { fontSize: "13px", color: C.color }, children: C.label })
                  ]
                },
                C.domain
              ))
            ] })
          ]
        }
      )
    }
  );
};
function Eg(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const xg = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Cg = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, gg = {};
function Ol(e, t) {
  return (gg.jsx ? Cg : xg).test(e);
}
const yg = /[ \t\n\f\r]/g;
function Tg(e) {
  return typeof e == "object" ? e.type === "text" ? Dl(e.value) : !1 : Dl(e);
}
function Dl(e) {
  return e.replace(yg, "") === "";
}
class Ei {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
Ei.prototype.normal = {};
Ei.prototype.property = {};
Ei.prototype.space = void 0;
function ad(e, t) {
  const n = {}, r = {};
  for (const i of e)
    Object.assign(n, i.property), Object.assign(r, i.normal);
  return new Ei(n, r, t);
}
function ma(e) {
  return e.toLowerCase();
}
class wt {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
wt.prototype.attribute = "";
wt.prototype.booleanish = !1;
wt.prototype.boolean = !1;
wt.prototype.commaOrSpaceSeparated = !1;
wt.prototype.commaSeparated = !1;
wt.prototype.defined = !1;
wt.prototype.mustUseProperty = !1;
wt.prototype.number = !1;
wt.prototype.overloadedBoolean = !1;
wt.prototype.property = "";
wt.prototype.spaceSeparated = !1;
wt.prototype.space = void 0;
let Sg = 0;
const Se = Jn(), Je = Jn(), Ea = Jn(), X = Jn(), Me = Jn(), dr = Jn(), Lt = Jn();
function Jn() {
  return 2 ** ++Sg;
}
const xa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Se,
  booleanish: Je,
  commaOrSpaceSeparated: Lt,
  commaSeparated: dr,
  number: X,
  overloadedBoolean: Ea,
  spaceSeparated: Me
}, Symbol.toStringTag, { value: "Module" })), Uo = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(xa)
);
class Xa extends wt {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), vl(this, "space", i), typeof r == "number")
      for (; ++o < Uo.length; ) {
        const s = Uo[o];
        vl(this, Uo[o], (r & xa[s]) === xa[s]);
      }
  }
}
Xa.prototype.defined = !0;
function vl(e, t, n) {
  n && (e[t] = n);
}
function br(e) {
  const t = {}, n = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const o = new Xa(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[ma(r)] = r, n[ma(o.attribute)] = r;
  }
  return new Ei(t, n, e.space);
}
const sd = br({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Je,
    ariaAutoComplete: null,
    ariaBusy: Je,
    ariaChecked: Je,
    ariaColCount: X,
    ariaColIndex: X,
    ariaColSpan: X,
    ariaControls: Me,
    ariaCurrent: null,
    ariaDescribedBy: Me,
    ariaDetails: null,
    ariaDisabled: Je,
    ariaDropEffect: Me,
    ariaErrorMessage: null,
    ariaExpanded: Je,
    ariaFlowTo: Me,
    ariaGrabbed: Je,
    ariaHasPopup: null,
    ariaHidden: Je,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Me,
    ariaLevel: X,
    ariaLive: null,
    ariaModal: Je,
    ariaMultiLine: Je,
    ariaMultiSelectable: Je,
    ariaOrientation: null,
    ariaOwns: Me,
    ariaPlaceholder: null,
    ariaPosInSet: X,
    ariaPressed: Je,
    ariaReadOnly: Je,
    ariaRelevant: null,
    ariaRequired: Je,
    ariaRoleDescription: Me,
    ariaRowCount: X,
    ariaRowIndex: X,
    ariaRowSpan: X,
    ariaSelected: Je,
    ariaSetSize: X,
    ariaSort: null,
    ariaValueMax: X,
    ariaValueMin: X,
    ariaValueNow: X,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function ld(e, t) {
  return t in e ? e[t] : t;
}
function cd(e, t) {
  return ld(e, t.toLowerCase());
}
const Ig = br({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: dr,
    acceptCharset: Me,
    accessKey: Me,
    action: null,
    allow: null,
    allowFullScreen: Se,
    allowPaymentRequest: Se,
    allowUserMedia: Se,
    alt: null,
    as: null,
    async: Se,
    autoCapitalize: null,
    autoComplete: Me,
    autoFocus: Se,
    autoPlay: Se,
    blocking: Me,
    capture: null,
    charSet: null,
    checked: Se,
    cite: null,
    className: Me,
    cols: X,
    colSpan: null,
    content: null,
    contentEditable: Je,
    controls: Se,
    controlsList: Me,
    coords: X | dr,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Se,
    defer: Se,
    dir: null,
    dirName: null,
    disabled: Se,
    download: Ea,
    draggable: Je,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Se,
    formTarget: null,
    headers: Me,
    height: X,
    hidden: Ea,
    high: X,
    href: null,
    hrefLang: null,
    htmlFor: Me,
    httpEquiv: Me,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Se,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Se,
    itemId: null,
    itemProp: Me,
    itemRef: Me,
    itemScope: Se,
    itemType: Me,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Se,
    low: X,
    manifest: null,
    max: null,
    maxLength: X,
    media: null,
    method: null,
    min: null,
    minLength: X,
    multiple: Se,
    muted: Se,
    name: null,
    nonce: null,
    noModule: Se,
    noValidate: Se,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Se,
    optimum: X,
    pattern: null,
    ping: Me,
    placeholder: null,
    playsInline: Se,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Se,
    referrerPolicy: null,
    rel: Me,
    required: Se,
    reversed: Se,
    rows: X,
    rowSpan: X,
    sandbox: Me,
    scope: null,
    scoped: Se,
    seamless: Se,
    selected: Se,
    shadowRootClonable: Se,
    shadowRootDelegatesFocus: Se,
    shadowRootMode: null,
    shape: null,
    size: X,
    sizes: null,
    slot: null,
    span: X,
    spellCheck: Je,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: X,
    step: null,
    style: null,
    tabIndex: X,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Se,
    useMap: null,
    value: Je,
    width: X,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Me,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: X,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: X,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Se,
    // Lists. Use CSS to reduce space between items instead
    declare: Se,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: X,
    // `<img>` and `<object>`
    leftMargin: X,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: X,
    // `<body>`
    marginWidth: X,
    // `<body>`
    noResize: Se,
    // `<frame>`
    noHref: Se,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Se,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Se,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: X,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Je,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: X,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: X,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Se,
    disableRemotePlayback: Se,
    prefix: null,
    property: null,
    results: X,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: cd
}), Ag = br({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Lt,
    accentHeight: X,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: X,
    amplitude: X,
    arabicForm: null,
    ascent: X,
    attributeName: null,
    attributeType: null,
    azimuth: X,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: X,
    by: null,
    calcMode: null,
    capHeight: X,
    className: Me,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: X,
    diffuseConstant: X,
    direction: null,
    display: null,
    dur: null,
    divisor: X,
    dominantBaseline: null,
    download: Se,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: X,
    enableBackground: null,
    end: null,
    event: null,
    exponent: X,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: X,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: dr,
    g2: dr,
    glyphName: dr,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: X,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: X,
    horizOriginX: X,
    horizOriginY: X,
    id: null,
    ideographic: X,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: X,
    k: X,
    k1: X,
    k2: X,
    k3: X,
    k4: X,
    kernelMatrix: Lt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: X,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: X,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: X,
    overlineThickness: X,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: X,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Me,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: X,
    pointsAtY: X,
    pointsAtZ: X,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Lt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Lt,
    rev: Lt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Lt,
    requiredFeatures: Lt,
    requiredFonts: Lt,
    requiredFormats: Lt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: X,
    specularExponent: X,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: X,
    strikethroughThickness: X,
    string: null,
    stroke: null,
    strokeDashArray: Lt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: X,
    strokeOpacity: X,
    strokeWidth: null,
    style: null,
    surfaceScale: X,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Lt,
    tabIndex: X,
    tableValues: null,
    target: null,
    targetX: X,
    targetY: X,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Lt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: X,
    underlineThickness: X,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: X,
    values: null,
    vAlphabetic: X,
    vMathematical: X,
    vectorEffect: null,
    vHanging: X,
    vIdeographic: X,
    version: null,
    vertAdvY: X,
    vertOriginX: X,
    vertOriginY: X,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: X,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: ld
}), ud = br({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), dd = br({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: cd
}), pd = br({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), bg = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Rg = /[A-Z]/g, _l = /-[a-z]/g, Og = /^data[-\w.:]+$/i;
function Dg(e, t) {
  const n = ma(t);
  let r = t, i = wt;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && Og.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(_l, _g);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!_l.test(o)) {
        let s = o.replace(Rg, vg);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    i = Xa;
  }
  return new i(r, t);
}
function vg(e) {
  return "-" + e.toLowerCase();
}
function _g(e) {
  return e.charAt(1).toUpperCase();
}
const Ng = ad([sd, Ig, ud, dd, pd], "html"), Ja = ad([sd, Ag, ud, dd, pd], "svg");
function wg(e) {
  return e.join(" ").trim();
}
var Qa = {}, Nl = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Pg = /\n/g, jg = /^\s*/, Lg = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, kg = /^:\s*/, Mg = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Vg = /^[;\s]*/, Ug = /^\s+|\s+$/g, Fg = `
`, wl = "/", Pl = "*", Fn = "", Bg = "comment", $g = "declaration", Gg = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function i(g) {
    var C = g.match(Pg);
    C && (n += C.length);
    var y = g.lastIndexOf(Fg);
    r = ~y ? g.length - y : r + g.length;
  }
  function o() {
    var g = { line: n, column: r };
    return function(C) {
      return C.position = new s(g), u(), C;
    };
  }
  function s(g) {
    this.start = g, this.end = { line: n, column: r }, this.source = t.source;
  }
  s.prototype.content = e;
  function l(g) {
    var C = new Error(
      t.source + ":" + n + ":" + r + ": " + g
    );
    if (C.reason = g, C.filename = t.source, C.line = n, C.column = r, C.source = e, !t.silent) throw C;
  }
  function c(g) {
    var C = g.exec(e);
    if (C) {
      var y = C[0];
      return i(y), e = e.slice(y.length), C;
    }
  }
  function u() {
    c(jg);
  }
  function p(g) {
    var C;
    for (g = g || []; C = d(); )
      C !== !1 && g.push(C);
    return g;
  }
  function d() {
    var g = o();
    if (!(wl != e.charAt(0) || Pl != e.charAt(1))) {
      for (var C = 2; Fn != e.charAt(C) && (Pl != e.charAt(C) || wl != e.charAt(C + 1)); )
        ++C;
      if (C += 2, Fn === e.charAt(C - 1))
        return l("End of comment missing");
      var y = e.slice(2, C - 2);
      return r += 2, i(y), e = e.slice(C), r += 2, g({
        type: Bg,
        comment: y
      });
    }
  }
  function f() {
    var g = o(), C = c(Lg);
    if (C) {
      if (d(), !c(kg)) return l("property missing ':'");
      var y = c(Mg), I = g({
        type: $g,
        property: jl(C[0].replace(Nl, Fn)),
        value: y ? jl(y[0].replace(Nl, Fn)) : Fn
      });
      return c(Vg), I;
    }
  }
  function h() {
    var g = [];
    p(g);
    for (var C; C = f(); )
      C !== !1 && (g.push(C), p(g));
    return g;
  }
  return u(), h();
};
function jl(e) {
  return e ? e.replace(Ug, Fn) : Fn;
}
var zg = Yi && Yi.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qa, "__esModule", { value: !0 });
Qa.default = Yg;
var Wg = zg(Gg);
function Yg(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, Wg.default)(e), i = typeof t == "function";
  return r.forEach(function(o) {
    if (o.type === "declaration") {
      var s = o.property, l = o.value;
      i ? t(s, l, o) : l && (n = n || {}, n[s] = l);
    }
  }), n;
}
var Co = {};
Object.defineProperty(Co, "__esModule", { value: !0 });
Co.camelCase = void 0;
var Hg = /^--[a-zA-Z0-9_-]+$/, qg = /-([a-z])/g, Xg = /^[^-]+$/, Jg = /^-(webkit|moz|ms|o|khtml)-/, Qg = /^-(ms)-/, Kg = function(e) {
  return !e || Xg.test(e) || Hg.test(e);
}, Zg = function(e, t) {
  return t.toUpperCase();
}, Ll = function(e, t) {
  return "".concat(t, "-");
}, ey = function(e, t) {
  return t === void 0 && (t = {}), Kg(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(Qg, Ll) : e = e.replace(Jg, Ll), e.replace(qg, Zg));
};
Co.camelCase = ey;
var ty = Yi && Yi.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, ny = ty(Qa), ry = Co;
function Ca(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, ny.default)(e, function(r, i) {
    r && i && (n[(0, ry.camelCase)(r, t)] = i);
  }), n;
}
Ca.default = Ca;
var iy = Ca;
const oy = /* @__PURE__ */ Wc(iy), hd = fd("end"), Ka = fd("start");
function fd(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function ay(e) {
  const t = Ka(e), n = hd(e);
  if (t && n)
    return { start: t, end: n };
}
function Wr(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? kl(e.position) : "start" in e || "end" in e ? kl(e) : "line" in e || "column" in e ? ga(e) : "";
}
function ga(e) {
  return Ml(e && e.line) + ":" + Ml(e && e.column);
}
function kl(e) {
  return ga(e && e.start) + "-" + ga(e && e.end);
}
function Ml(e) {
  return e && typeof e == "number" ? e : 1;
}
class ft extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", o = {}, s = !1;
    if (n && ("line" in n && "column" in n ? o = { place: n } : "start" in n && "end" in n ? o = { place: n } : "type" in n ? o = {
      ancestors: [n],
      place: n.position
    } : o = { ...n }), typeof t == "string" ? i = t : !o.cause && t && (s = !0, i = t.message, o.cause = t), !o.ruleId && !o.source && typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? o.ruleId = r : (o.source = r.slice(0, c), o.ruleId = r.slice(c + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const c = o.ancestors[o.ancestors.length - 1];
      c && (o.place = c.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = l ? l.line : void 0, this.name = Wr(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
ft.prototype.file = "";
ft.prototype.name = "";
ft.prototype.reason = "";
ft.prototype.message = "";
ft.prototype.stack = "";
ft.prototype.column = void 0;
ft.prototype.line = void 0;
ft.prototype.ancestors = void 0;
ft.prototype.cause = void 0;
ft.prototype.fatal = void 0;
ft.prototype.place = void 0;
ft.prototype.ruleId = void 0;
ft.prototype.source = void 0;
const Za = {}.hasOwnProperty, sy = /* @__PURE__ */ new Map(), ly = /[A-Z]/g, cy = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), uy = /* @__PURE__ */ new Set(["td", "th"]), md = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function dy(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = gy(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = Cy(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? Ja : Ng,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, o = Ed(i, e, void 0);
  return o && typeof o != "string" ? o : i.create(
    e,
    i.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function Ed(e, t, n) {
  if (t.type === "element")
    return py(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return hy(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return my(e, t, n);
  if (t.type === "mdxjsEsm")
    return fy(e, t);
  if (t.type === "root")
    return Ey(e, t, n);
  if (t.type === "text")
    return xy(e, t);
}
function py(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = Ja, e.schema = i), e.ancestors.push(t);
  const o = Cd(e, t.tagName, !1), s = yy(e, t);
  let l = ts(e, t);
  return cy.has(t.tagName) && (l = l.filter(function(c) {
    return typeof c == "string" ? !Tg(c) : !0;
  })), xd(e, s, o, t), es(s, l), e.ancestors.pop(), e.schema = r, e.create(t, o, s, n);
}
function hy(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  li(e, t.position);
}
function fy(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  li(e, t.position);
}
function my(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = Ja, e.schema = i), e.ancestors.push(t);
  const o = t.name === null ? e.Fragment : Cd(e, t.name, !0), s = Ty(e, t), l = ts(e, t);
  return xd(e, s, o, t), es(s, l), e.ancestors.pop(), e.schema = r, e.create(t, o, s, n);
}
function Ey(e, t, n) {
  const r = {};
  return es(r, ts(e, t)), e.create(t, e.Fragment, r, n);
}
function xy(e, t) {
  return t.value;
}
function xd(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function es(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function Cy(e, t, n) {
  return r;
  function r(i, o, s, l) {
    const u = Array.isArray(s.children) ? n : t;
    return l ? u(o, s, l) : u(o, s);
  }
}
function gy(e, t) {
  return n;
  function n(r, i, o, s) {
    const l = Array.isArray(o.children), c = Ka(r);
    return t(
      i,
      o,
      s,
      l,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function yy(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && Za.call(t.properties, i)) {
      const o = Sy(e, i, t.properties[i]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && uy.has(t.tagName) ? r = l : n[s] = l;
      }
    }
  if (r) {
    const o = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function Ty(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const o = r.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        li(e, t.position);
    else {
      const i = r.name;
      let o;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const l = r.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          li(e, t.position);
      else
        o = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      o;
    }
  return n;
}
function ts(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : sy;
  for (; ++r < t.children.length; ) {
    const o = t.children[r];
    let s;
    if (e.passKeys) {
      const c = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (c) {
        const u = i.get(c) || 0;
        s = c + "-" + u, i.set(c, u + 1);
      }
    }
    const l = Ed(e, o, s);
    l !== void 0 && n.push(l);
  }
  return n;
}
function Sy(e, t, n) {
  const r = Dg(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? Eg(n) : wg(n)), r.property === "style") {
      let i = typeof n == "object" ? n : Iy(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = Ay(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? bg[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function Iy(e, t) {
  try {
    return oy(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), i = new ft("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = md + "#cannot-parse-style-attribute", i;
  }
}
function Cd(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let o = -1, s;
    for (; ++o < i.length; ) {
      const l = Ol(i[o]) ? { type: "Identifier", name: i[o] } : { type: "Literal", value: i[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    r = s;
  } else
    r = Ol(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return Za.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  li(e);
}
function li(e, t) {
  const n = new ft(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = md + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function Ay(e) {
  const t = {};
  let n;
  for (n in e)
    Za.call(e, n) && (t[by(n)] = e[n]);
  return t;
}
function by(e) {
  let t = e.replace(ly, Ry);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function Ry(e) {
  return "-" + e.toLowerCase();
}
const Fo = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, Oy = {};
function Dy(e, t) {
  const n = Oy, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return gd(e, r, i);
}
function gd(e, t, n) {
  if (vy(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Vl(e.children, t, n);
  }
  return Array.isArray(e) ? Vl(e, t, n) : "";
}
function Vl(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = gd(e[i], t, n);
  return r.join("");
}
function vy(e) {
  return !!(e && typeof e == "object");
}
const Ul = document.createElement("i");
function ns(e) {
  const t = "&" + e + ";";
  Ul.innerHTML = t;
  const n = Ul.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
function un(e, t, n, r) {
  const i = e.length;
  let o = 0, s;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    s = Array.from(r), s.unshift(t, n), e.splice(...s);
  else
    for (n && e.splice(t, n); o < r.length; )
      s = r.slice(o, o + 1e4), s.unshift(t, 0), e.splice(...s), o += 1e4, t += 1e4;
}
function zt(e, t) {
  return e.length > 0 ? (un(e, e.length, 0, t), e) : t;
}
const Fl = {}.hasOwnProperty;
function _y(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    Ny(t, e[n]);
  return t;
}
function Ny(e, t) {
  let n;
  for (n in t) {
    const i = (Fl.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let s;
    if (o)
      for (s in o) {
        Fl.call(i, s) || (i[s] = []);
        const l = o[s];
        wy(
          // @ts-expect-error Looks like a list.
          i[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function wy(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  un(e, 0, 0, r);
}
function yd(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function pr(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const ln = Nn(/[A-Za-z]/), Vt = Nn(/[\dA-Za-z]/), Py = Nn(/[#-'*+\--9=?A-Z^-~]/);
function ya(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Ta = Nn(/\d/), jy = Nn(/[\dA-Fa-f]/), Ly = Nn(/[!-/:-@[-`{-~]/);
function he(e) {
  return e !== null && e < -2;
}
function _t(e) {
  return e !== null && (e < 0 || e === 32);
}
function _e(e) {
  return e === -2 || e === -1 || e === 32;
}
const ky = Nn(new RegExp("\\p{P}|\\p{S}", "u")), My = Nn(/\s/);
function Nn(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Rr(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const o = e.charCodeAt(n);
    let s = "";
    if (o === 37 && Vt(e.charCodeAt(n + 1)) && Vt(e.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(n + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), i = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (t.push(e.slice(r, n), encodeURIComponent(s)), r = n + i + 1, s = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function Ve(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(c) {
    return _e(c) ? (e.enter(n), l(c)) : t(c);
  }
  function l(c) {
    return _e(c) && o++ < i ? (e.consume(c), l) : (e.exit(n), t(c));
  }
}
const Vy = {
  tokenize: Uy
};
function Uy(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, i);
  let n;
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Ve(e, t, "linePrefix");
  }
  function i(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return he(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const Fy = {
  tokenize: By
}, Bl = {
  tokenize: $y
};
function By(e) {
  const t = this, n = [];
  let r = 0, i, o, s;
  return l;
  function l(S) {
    if (r < n.length) {
      const N = n[r];
      return t.containerState = N[1], e.attempt(N[0].continuation, c, u)(S);
    }
    return u(S);
  }
  function c(S) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && O();
      const N = t.events.length;
      let _ = N, R;
      for (; _--; )
        if (t.events[_][0] === "exit" && t.events[_][1].type === "chunkFlow") {
          R = t.events[_][1].end;
          break;
        }
      I(r);
      let P = N;
      for (; P < t.events.length; )
        t.events[P][1].end = {
          ...R
        }, P++;
      return un(t.events, _ + 1, 0, t.events.slice(N)), t.events.length = P, u(S);
    }
    return l(S);
  }
  function u(S) {
    if (r === n.length) {
      if (!i)
        return f(S);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return g(S);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Bl, p, d)(S);
  }
  function p(S) {
    return i && O(), I(r), f(S);
  }
  function d(S) {
    return t.parser.lazy[t.now().line] = r !== n.length, s = t.now().offset, g(S);
  }
  function f(S) {
    return t.containerState = {}, e.attempt(Bl, h, g)(S);
  }
  function h(S) {
    return r++, n.push([t.currentConstruct, t.containerState]), f(S);
  }
  function g(S) {
    if (S === null) {
      i && O(), I(0), e.consume(S);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: o
    }), C(S);
  }
  function C(S) {
    if (S === null) {
      y(e.exit("chunkFlow"), !0), I(0), e.consume(S);
      return;
    }
    return he(S) ? (e.consume(S), y(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, l) : (e.consume(S), C);
  }
  function y(S, N) {
    const _ = t.sliceStream(S);
    if (N && _.push(null), S.previous = o, o && (o.next = S), o = S, i.defineSkip(S.start), i.write(_), t.parser.lazy[S.start.line]) {
      let R = i.events.length;
      for (; R--; )
        if (
          // The token starts before the line ending…
          i.events[R][1].start.offset < s && // …and either is not ended yet…
          (!i.events[R][1].end || // …or ends after it.
          i.events[R][1].end.offset > s)
        )
          return;
      const P = t.events.length;
      let U = P, M, w;
      for (; U--; )
        if (t.events[U][0] === "exit" && t.events[U][1].type === "chunkFlow") {
          if (M) {
            w = t.events[U][1].end;
            break;
          }
          M = !0;
        }
      for (I(r), R = P; R < t.events.length; )
        t.events[R][1].end = {
          ...w
        }, R++;
      un(t.events, U + 1, 0, t.events.slice(P)), t.events.length = R;
    }
  }
  function I(S) {
    let N = n.length;
    for (; N-- > S; ) {
      const _ = n[N];
      t.containerState = _[1], _[0].exit.call(t, e);
    }
    n.length = S;
  }
  function O() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function $y(e, t, n) {
  return Ve(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function $l(e) {
  if (e === null || _t(e) || My(e))
    return 1;
  if (ky(e))
    return 2;
}
function rs(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const Sa = {
  name: "attention",
  resolveAll: Gy,
  tokenize: zy
};
function Gy(e, t) {
  let n = -1, r, i, o, s, l, c, u, p;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = {
            ...e[r][1].end
          }, f = {
            ...e[n][1].start
          };
          Gl(d, -c), Gl(f, c), s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: {
              ...e[r][1].end
            }
          }, l = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: f
          }, o = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[r][1].end = {
            ...s.start
          }, e[n][1].start = {
            ...l.end
          }, u = [], e[r][1].end.offset - e[r][1].start.offset && (u = zt(u, [["enter", e[r][1], t], ["exit", e[r][1], t]])), u = zt(u, [["enter", i, t], ["enter", s, t], ["exit", s, t], ["enter", o, t]]), u = zt(u, rs(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), u = zt(u, [["exit", o, t], ["enter", l, t], ["exit", l, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (p = 2, u = zt(u, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : p = 0, un(e, r - 1, n - r + 3, u), n = r + u.length - p - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function zy(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = $l(r);
  let o;
  return s;
  function s(c) {
    return o = c, e.enter("attentionSequence"), l(c);
  }
  function l(c) {
    if (c === o)
      return e.consume(c), l;
    const u = e.exit("attentionSequence"), p = $l(c), d = !p || p === 2 && i || n.includes(c), f = !i || i === 2 && p || n.includes(r);
    return u._open = !!(o === 42 ? d : d && (i || !f)), u._close = !!(o === 42 ? f : f && (p || !d)), t(c);
  }
}
function Gl(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Wy = {
  name: "autolink",
  tokenize: Yy
};
function Yy(e, t, n) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(h) {
    return ln(h) ? (e.consume(h), s) : h === 64 ? n(h) : u(h);
  }
  function s(h) {
    return h === 43 || h === 45 || h === 46 || Vt(h) ? (r = 1, l(h)) : u(h);
  }
  function l(h) {
    return h === 58 ? (e.consume(h), r = 0, c) : (h === 43 || h === 45 || h === 46 || Vt(h)) && r++ < 32 ? (e.consume(h), l) : (r = 0, u(h));
  }
  function c(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || ya(h) ? n(h) : (e.consume(h), c);
  }
  function u(h) {
    return h === 64 ? (e.consume(h), p) : Py(h) ? (e.consume(h), u) : n(h);
  }
  function p(h) {
    return Vt(h) ? d(h) : n(h);
  }
  function d(h) {
    return h === 46 ? (e.consume(h), r = 0, p) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : f(h);
  }
  function f(h) {
    if ((h === 45 || Vt(h)) && r++ < 63) {
      const g = h === 45 ? f : d;
      return e.consume(h), g;
    }
    return n(h);
  }
}
const go = {
  partial: !0,
  tokenize: Hy
};
function Hy(e, t, n) {
  return r;
  function r(o) {
    return _e(o) ? Ve(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || he(o) ? t(o) : n(o);
  }
}
const Td = {
  continuation: {
    tokenize: Xy
  },
  exit: Jy,
  name: "blockQuote",
  tokenize: qy
};
function qy(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    if (s === 62) {
      const l = r.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return n(s);
  }
  function o(s) {
    return _e(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(s));
  }
}
function Xy(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return _e(s) ? Ve(e, o, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(Td, t, n)(s);
  }
}
function Jy(e) {
  e.exit("blockQuote");
}
const Sd = {
  name: "characterEscape",
  tokenize: Qy
};
function Qy(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return Ly(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const Id = {
  name: "characterReference",
  tokenize: Ky
};
function Ky(e, t, n) {
  const r = this;
  let i = 0, o, s;
  return l;
  function l(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), c;
  }
  function c(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), o = 31, s = Vt, p(d));
  }
  function u(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = jy, p) : (e.enter("characterReferenceValue"), o = 7, s = Ta, p(d));
  }
  function p(d) {
    if (d === 59 && i) {
      const f = e.exit("characterReferenceValue");
      return s === Vt && !ns(r.sliceSerialize(f)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return s(d) && i++ < o ? (e.consume(d), p) : n(d);
  }
}
const zl = {
  partial: !0,
  tokenize: eT
}, Wl = {
  concrete: !0,
  name: "codeFenced",
  tokenize: Zy
};
function Zy(e, t, n) {
  const r = this, i = {
    partial: !0,
    tokenize: _
  };
  let o = 0, s = 0, l;
  return c;
  function c(R) {
    return u(R);
  }
  function u(R) {
    const P = r.events[r.events.length - 1];
    return o = P && P[1].type === "linePrefix" ? P[2].sliceSerialize(P[1], !0).length : 0, l = R, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), p(R);
  }
  function p(R) {
    return R === l ? (s++, e.consume(R), p) : s < 3 ? n(R) : (e.exit("codeFencedFenceSequence"), _e(R) ? Ve(e, d, "whitespace")(R) : d(R));
  }
  function d(R) {
    return R === null || he(R) ? (e.exit("codeFencedFence"), r.interrupt ? t(R) : e.check(zl, C, N)(R)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), f(R));
  }
  function f(R) {
    return R === null || he(R) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(R)) : _e(R) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Ve(e, h, "whitespace")(R)) : R === 96 && R === l ? n(R) : (e.consume(R), f);
  }
  function h(R) {
    return R === null || he(R) ? d(R) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), g(R));
  }
  function g(R) {
    return R === null || he(R) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(R)) : R === 96 && R === l ? n(R) : (e.consume(R), g);
  }
  function C(R) {
    return e.attempt(i, N, y)(R);
  }
  function y(R) {
    return e.enter("lineEnding"), e.consume(R), e.exit("lineEnding"), I;
  }
  function I(R) {
    return o > 0 && _e(R) ? Ve(e, O, "linePrefix", o + 1)(R) : O(R);
  }
  function O(R) {
    return R === null || he(R) ? e.check(zl, C, N)(R) : (e.enter("codeFlowValue"), S(R));
  }
  function S(R) {
    return R === null || he(R) ? (e.exit("codeFlowValue"), O(R)) : (e.consume(R), S);
  }
  function N(R) {
    return e.exit("codeFenced"), t(R);
  }
  function _(R, P, U) {
    let M = 0;
    return w;
    function w(v) {
      return R.enter("lineEnding"), R.consume(v), R.exit("lineEnding"), V;
    }
    function V(v) {
      return R.enter("codeFencedFence"), _e(v) ? Ve(R, L, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(v) : L(v);
    }
    function L(v) {
      return v === l ? (R.enter("codeFencedFenceSequence"), te(v)) : U(v);
    }
    function te(v) {
      return v === l ? (M++, R.consume(v), te) : M >= s ? (R.exit("codeFencedFenceSequence"), _e(v) ? Ve(R, $, "whitespace")(v) : $(v)) : U(v);
    }
    function $(v) {
      return v === null || he(v) ? (R.exit("codeFencedFence"), P(v)) : U(v);
    }
  }
}
function eT(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return s === null ? n(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
const Bo = {
  name: "codeIndented",
  tokenize: nT
}, tT = {
  partial: !0,
  tokenize: rT
};
function nT(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), Ve(e, o, "linePrefix", 5)(u);
  }
  function o(u) {
    const p = r.events[r.events.length - 1];
    return p && p[1].type === "linePrefix" && p[2].sliceSerialize(p[1], !0).length >= 4 ? s(u) : n(u);
  }
  function s(u) {
    return u === null ? c(u) : he(u) ? e.attempt(tT, s, c)(u) : (e.enter("codeFlowValue"), l(u));
  }
  function l(u) {
    return u === null || he(u) ? (e.exit("codeFlowValue"), s(u)) : (e.consume(u), l);
  }
  function c(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function rT(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : he(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i) : Ve(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(s) : he(s) ? i(s) : n(s);
  }
}
const iT = {
  name: "codeText",
  previous: aT,
  resolve: oT,
  tokenize: sT
};
function oT(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function aT(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function sT(e, t, n) {
  let r = 0, i, o;
  return s;
  function s(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(d);
  }
  function l(d) {
    return d === 96 ? (e.consume(d), r++, l) : (e.exit("codeTextSequence"), c(d));
  }
  function c(d) {
    return d === null ? n(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), c) : d === 96 ? (o = e.enter("codeTextSequence"), i = 0, p(d)) : he(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), c) : (e.enter("codeTextData"), u(d));
  }
  function u(d) {
    return d === null || d === 32 || d === 96 || he(d) ? (e.exit("codeTextData"), c(d)) : (e.consume(d), u);
  }
  function p(d) {
    return d === 96 ? (e.consume(d), i++, p) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (o.type = "codeTextData", u(d));
  }
}
class lT {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const o = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && Lr(this.left, r), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Lr(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Lr(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Lr(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Lr(this.left, n.reverse());
      }
  }
}
function Lr(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Ad(e) {
  const t = {};
  let n = -1, r, i, o, s, l, c, u;
  const p = new lT(e);
  for (; ++n < p.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = p.get(n), n && r[1].type === "chunkFlow" && p.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, o = 0, o < c.length && c[o][1].type === "lineEndingBlank" && (o += 2), o < c.length && c[o][1].type === "content"))
      for (; ++o < c.length && c[o][1].type !== "content"; )
        c[o][1].type === "chunkText" && (c[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, cT(p, n)), n = t[n], u = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o--; )
        if (s = p.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank")
          s[0] === "enter" && (i && (p.get(i)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", i = o);
        else if (!(s[1].type === "linePrefix" || s[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...p.get(i)[1].start
      }, l = p.slice(i, n), l.unshift(r), p.splice(i, n - i + 1, l));
    }
  }
  return un(e, 0, Number.POSITIVE_INFINITY, p.slice(0)), !u;
}
function cT(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const o = [];
  let s = n._tokenizer;
  s || (s = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (s._contentTypeTextTrailing = !0));
  const l = s.events, c = [], u = {};
  let p, d, f = -1, h = n, g = 0, C = 0;
  const y = [C];
  for (; h; ) {
    for (; e.get(++i)[1] !== h; )
      ;
    o.push(i), h._tokenizer || (p = r.sliceStream(h), h.next || p.push(null), d && s.defineSkip(h.start), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(p), h._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), d = h, h = h.next;
  }
  for (h = n; ++f < l.length; )
    // Find a void token that includes a break.
    l[f][0] === "exit" && l[f - 1][0] === "enter" && l[f][1].type === l[f - 1][1].type && l[f][1].start.line !== l[f][1].end.line && (C = f + 1, y.push(C), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (s.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : y.pop(), f = y.length; f--; ) {
    const I = l.slice(y[f], y[f + 1]), O = o.pop();
    c.push([O, O + I.length - 1]), e.splice(O, 2, I);
  }
  for (c.reverse(), f = -1; ++f < c.length; )
    u[g + c[f][0]] = g + c[f][1], g += c[f][1] - c[f][0] - 1;
  return u;
}
const uT = {
  resolve: pT,
  tokenize: hT
}, dT = {
  partial: !0,
  tokenize: fT
};
function pT(e) {
  return Ad(e), e;
}
function hT(e, t) {
  let n;
  return r;
  function r(l) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(l);
  }
  function i(l) {
    return l === null ? o(l) : he(l) ? e.check(dT, s, o)(l) : (e.consume(l), i);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function fT(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Ve(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || he(s))
      return n(s);
    const l = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(s) : e.interrupt(r.parser.constructs.flow, n, t)(s);
  }
}
function bd(e, t, n, r, i, o, s, l, c) {
  const u = c || Number.POSITIVE_INFINITY;
  let p = 0;
  return d;
  function d(I) {
    return I === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(I), e.exit(o), f) : I === null || I === 32 || I === 41 || ya(I) ? n(I) : (e.enter(r), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), C(I));
  }
  function f(I) {
    return I === 62 ? (e.enter(o), e.consume(I), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), h(I));
  }
  function h(I) {
    return I === 62 ? (e.exit("chunkString"), e.exit(l), f(I)) : I === null || I === 60 || he(I) ? n(I) : (e.consume(I), I === 92 ? g : h);
  }
  function g(I) {
    return I === 60 || I === 62 || I === 92 ? (e.consume(I), h) : h(I);
  }
  function C(I) {
    return !p && (I === null || I === 41 || _t(I)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(r), t(I)) : p < u && I === 40 ? (e.consume(I), p++, C) : I === 41 ? (e.consume(I), p--, C) : I === null || I === 32 || I === 40 || ya(I) ? n(I) : (e.consume(I), I === 92 ? y : C);
  }
  function y(I) {
    return I === 40 || I === 41 || I === 92 ? (e.consume(I), C) : C(I);
  }
}
function Rd(e, t, n, r, i, o) {
  const s = this;
  let l = 0, c;
  return u;
  function u(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(o), p;
  }
  function p(h) {
    return l > 999 || h === null || h === 91 || h === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? n(h) : h === 93 ? (e.exit(o), e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : he(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), p) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === null || h === 91 || h === 93 || he(h) || l++ > 999 ? (e.exit("chunkString"), p(h)) : (e.consume(h), c || (c = !_e(h)), h === 92 ? f : d);
  }
  function f(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), l++, d) : d(h);
  }
}
function Od(e, t, n, r, i, o) {
  let s;
  return l;
  function l(f) {
    return f === 34 || f === 39 || f === 40 ? (e.enter(r), e.enter(i), e.consume(f), e.exit(i), s = f === 40 ? 41 : f, c) : n(f);
  }
  function c(f) {
    return f === s ? (e.enter(i), e.consume(f), e.exit(i), e.exit(r), t) : (e.enter(o), u(f));
  }
  function u(f) {
    return f === s ? (e.exit(o), c(s)) : f === null ? n(f) : he(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), Ve(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), p(f));
  }
  function p(f) {
    return f === s || f === null || he(f) ? (e.exit("chunkString"), u(f)) : (e.consume(f), f === 92 ? d : p);
  }
  function d(f) {
    return f === s || f === 92 ? (e.consume(f), p) : p(f);
  }
}
function Yr(e, t) {
  let n;
  return r;
  function r(i) {
    return he(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : _e(i) ? Ve(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
  }
}
const mT = {
  name: "definition",
  tokenize: xT
}, ET = {
  partial: !0,
  tokenize: CT
};
function xT(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(h) {
    return e.enter("definition"), s(h);
  }
  function s(h) {
    return Rd.call(
      r,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function l(h) {
    return i = pr(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), c) : n(h);
  }
  function c(h) {
    return _t(h) ? Yr(e, u)(h) : u(h);
  }
  function u(h) {
    return bd(
      e,
      p,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function p(h) {
    return e.attempt(ET, d, d)(h);
  }
  function d(h) {
    return _e(h) ? Ve(e, f, "whitespace")(h) : f(h);
  }
  function f(h) {
    return h === null || he(h) ? (e.exit("definition"), r.parser.defined.push(i), t(h)) : n(h);
  }
}
function CT(e, t, n) {
  return r;
  function r(l) {
    return _t(l) ? Yr(e, i)(l) : n(l);
  }
  function i(l) {
    return Od(e, o, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return _e(l) ? Ve(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || he(l) ? t(l) : n(l);
  }
}
const gT = {
  name: "hardBreakEscape",
  tokenize: yT
};
function yT(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return he(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const TT = {
  name: "headingAtx",
  resolve: ST,
  tokenize: IT
};
function ST(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, un(e, r, n - r + 1, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["exit", i, t]])), e;
}
function IT(e, t, n) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("atxHeading"), o(p);
  }
  function o(p) {
    return e.enter("atxHeadingSequence"), s(p);
  }
  function s(p) {
    return p === 35 && r++ < 6 ? (e.consume(p), s) : p === null || _t(p) ? (e.exit("atxHeadingSequence"), l(p)) : n(p);
  }
  function l(p) {
    return p === 35 ? (e.enter("atxHeadingSequence"), c(p)) : p === null || he(p) ? (e.exit("atxHeading"), t(p)) : _e(p) ? Ve(e, l, "whitespace")(p) : (e.enter("atxHeadingText"), u(p));
  }
  function c(p) {
    return p === 35 ? (e.consume(p), c) : (e.exit("atxHeadingSequence"), l(p));
  }
  function u(p) {
    return p === null || p === 35 || _t(p) ? (e.exit("atxHeadingText"), l(p)) : (e.consume(p), u);
  }
}
const AT = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Yl = ["pre", "script", "style", "textarea"], bT = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: DT,
  tokenize: vT
}, RT = {
  partial: !0,
  tokenize: NT
}, OT = {
  partial: !0,
  tokenize: _T
};
function DT(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function vT(e, t, n) {
  const r = this;
  let i, o, s, l, c;
  return u;
  function u(T) {
    return p(T);
  }
  function p(T) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(T), d;
  }
  function d(T) {
    return T === 33 ? (e.consume(T), f) : T === 47 ? (e.consume(T), o = !0, C) : T === 63 ? (e.consume(T), i = 3, r.interrupt ? t : x) : ln(T) ? (e.consume(T), s = String.fromCharCode(T), y) : n(T);
  }
  function f(T) {
    return T === 45 ? (e.consume(T), i = 2, h) : T === 91 ? (e.consume(T), i = 5, l = 0, g) : ln(T) ? (e.consume(T), i = 4, r.interrupt ? t : x) : n(T);
  }
  function h(T) {
    return T === 45 ? (e.consume(T), r.interrupt ? t : x) : n(T);
  }
  function g(T) {
    const re = "CDATA[";
    return T === re.charCodeAt(l++) ? (e.consume(T), l === re.length ? r.interrupt ? t : L : g) : n(T);
  }
  function C(T) {
    return ln(T) ? (e.consume(T), s = String.fromCharCode(T), y) : n(T);
  }
  function y(T) {
    if (T === null || T === 47 || T === 62 || _t(T)) {
      const re = T === 47, b = s.toLowerCase();
      return !re && !o && Yl.includes(b) ? (i = 1, r.interrupt ? t(T) : L(T)) : AT.includes(s.toLowerCase()) ? (i = 6, re ? (e.consume(T), I) : r.interrupt ? t(T) : L(T)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(T) : o ? O(T) : S(T));
    }
    return T === 45 || Vt(T) ? (e.consume(T), s += String.fromCharCode(T), y) : n(T);
  }
  function I(T) {
    return T === 62 ? (e.consume(T), r.interrupt ? t : L) : n(T);
  }
  function O(T) {
    return _e(T) ? (e.consume(T), O) : w(T);
  }
  function S(T) {
    return T === 47 ? (e.consume(T), w) : T === 58 || T === 95 || ln(T) ? (e.consume(T), N) : _e(T) ? (e.consume(T), S) : w(T);
  }
  function N(T) {
    return T === 45 || T === 46 || T === 58 || T === 95 || Vt(T) ? (e.consume(T), N) : _(T);
  }
  function _(T) {
    return T === 61 ? (e.consume(T), R) : _e(T) ? (e.consume(T), _) : S(T);
  }
  function R(T) {
    return T === null || T === 60 || T === 61 || T === 62 || T === 96 ? n(T) : T === 34 || T === 39 ? (e.consume(T), c = T, P) : _e(T) ? (e.consume(T), R) : U(T);
  }
  function P(T) {
    return T === c ? (e.consume(T), c = null, M) : T === null || he(T) ? n(T) : (e.consume(T), P);
  }
  function U(T) {
    return T === null || T === 34 || T === 39 || T === 47 || T === 60 || T === 61 || T === 62 || T === 96 || _t(T) ? _(T) : (e.consume(T), U);
  }
  function M(T) {
    return T === 47 || T === 62 || _e(T) ? S(T) : n(T);
  }
  function w(T) {
    return T === 62 ? (e.consume(T), V) : n(T);
  }
  function V(T) {
    return T === null || he(T) ? L(T) : _e(T) ? (e.consume(T), V) : n(T);
  }
  function L(T) {
    return T === 45 && i === 2 ? (e.consume(T), J) : T === 60 && i === 1 ? (e.consume(T), j) : T === 62 && i === 4 ? (e.consume(T), Y) : T === 63 && i === 3 ? (e.consume(T), x) : T === 93 && i === 5 ? (e.consume(T), Q) : he(T) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(RT, k, te)(T)) : T === null || he(T) ? (e.exit("htmlFlowData"), te(T)) : (e.consume(T), L);
  }
  function te(T) {
    return e.check(OT, $, k)(T);
  }
  function $(T) {
    return e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), v;
  }
  function v(T) {
    return T === null || he(T) ? te(T) : (e.enter("htmlFlowData"), L(T));
  }
  function J(T) {
    return T === 45 ? (e.consume(T), x) : L(T);
  }
  function j(T) {
    return T === 47 ? (e.consume(T), s = "", ee) : L(T);
  }
  function ee(T) {
    if (T === 62) {
      const re = s.toLowerCase();
      return Yl.includes(re) ? (e.consume(T), Y) : L(T);
    }
    return ln(T) && s.length < 8 ? (e.consume(T), s += String.fromCharCode(T), ee) : L(T);
  }
  function Q(T) {
    return T === 93 ? (e.consume(T), x) : L(T);
  }
  function x(T) {
    return T === 62 ? (e.consume(T), Y) : T === 45 && i === 2 ? (e.consume(T), x) : L(T);
  }
  function Y(T) {
    return T === null || he(T) ? (e.exit("htmlFlowData"), k(T)) : (e.consume(T), Y);
  }
  function k(T) {
    return e.exit("htmlFlow"), t(T);
  }
}
function _T(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return he(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : n(s);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
function NT(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(go, t, n);
  }
}
const wT = {
  name: "htmlText",
  tokenize: PT
};
function PT(e, t, n) {
  const r = this;
  let i, o, s;
  return l;
  function l(x) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(x), c;
  }
  function c(x) {
    return x === 33 ? (e.consume(x), u) : x === 47 ? (e.consume(x), _) : x === 63 ? (e.consume(x), S) : ln(x) ? (e.consume(x), U) : n(x);
  }
  function u(x) {
    return x === 45 ? (e.consume(x), p) : x === 91 ? (e.consume(x), o = 0, g) : ln(x) ? (e.consume(x), O) : n(x);
  }
  function p(x) {
    return x === 45 ? (e.consume(x), h) : n(x);
  }
  function d(x) {
    return x === null ? n(x) : x === 45 ? (e.consume(x), f) : he(x) ? (s = d, j(x)) : (e.consume(x), d);
  }
  function f(x) {
    return x === 45 ? (e.consume(x), h) : d(x);
  }
  function h(x) {
    return x === 62 ? J(x) : x === 45 ? f(x) : d(x);
  }
  function g(x) {
    const Y = "CDATA[";
    return x === Y.charCodeAt(o++) ? (e.consume(x), o === Y.length ? C : g) : n(x);
  }
  function C(x) {
    return x === null ? n(x) : x === 93 ? (e.consume(x), y) : he(x) ? (s = C, j(x)) : (e.consume(x), C);
  }
  function y(x) {
    return x === 93 ? (e.consume(x), I) : C(x);
  }
  function I(x) {
    return x === 62 ? J(x) : x === 93 ? (e.consume(x), I) : C(x);
  }
  function O(x) {
    return x === null || x === 62 ? J(x) : he(x) ? (s = O, j(x)) : (e.consume(x), O);
  }
  function S(x) {
    return x === null ? n(x) : x === 63 ? (e.consume(x), N) : he(x) ? (s = S, j(x)) : (e.consume(x), S);
  }
  function N(x) {
    return x === 62 ? J(x) : S(x);
  }
  function _(x) {
    return ln(x) ? (e.consume(x), R) : n(x);
  }
  function R(x) {
    return x === 45 || Vt(x) ? (e.consume(x), R) : P(x);
  }
  function P(x) {
    return he(x) ? (s = P, j(x)) : _e(x) ? (e.consume(x), P) : J(x);
  }
  function U(x) {
    return x === 45 || Vt(x) ? (e.consume(x), U) : x === 47 || x === 62 || _t(x) ? M(x) : n(x);
  }
  function M(x) {
    return x === 47 ? (e.consume(x), J) : x === 58 || x === 95 || ln(x) ? (e.consume(x), w) : he(x) ? (s = M, j(x)) : _e(x) ? (e.consume(x), M) : J(x);
  }
  function w(x) {
    return x === 45 || x === 46 || x === 58 || x === 95 || Vt(x) ? (e.consume(x), w) : V(x);
  }
  function V(x) {
    return x === 61 ? (e.consume(x), L) : he(x) ? (s = V, j(x)) : _e(x) ? (e.consume(x), V) : M(x);
  }
  function L(x) {
    return x === null || x === 60 || x === 61 || x === 62 || x === 96 ? n(x) : x === 34 || x === 39 ? (e.consume(x), i = x, te) : he(x) ? (s = L, j(x)) : _e(x) ? (e.consume(x), L) : (e.consume(x), $);
  }
  function te(x) {
    return x === i ? (e.consume(x), i = void 0, v) : x === null ? n(x) : he(x) ? (s = te, j(x)) : (e.consume(x), te);
  }
  function $(x) {
    return x === null || x === 34 || x === 39 || x === 60 || x === 61 || x === 96 ? n(x) : x === 47 || x === 62 || _t(x) ? M(x) : (e.consume(x), $);
  }
  function v(x) {
    return x === 47 || x === 62 || _t(x) ? M(x) : n(x);
  }
  function J(x) {
    return x === 62 ? (e.consume(x), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(x);
  }
  function j(x) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(x), e.exit("lineEnding"), ee;
  }
  function ee(x) {
    return _e(x) ? Ve(e, Q, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(x) : Q(x);
  }
  function Q(x) {
    return e.enter("htmlTextData"), s(x);
  }
}
const is = {
  name: "labelEnd",
  resolveAll: MT,
  resolveTo: VT,
  tokenize: UT
}, jT = {
  tokenize: FT
}, LT = {
  tokenize: BT
}, kT = {
  tokenize: $T
};
function MT(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += i;
    }
  }
  return e.length !== n.length && un(e, 0, e.length, n), e;
}
function VT(e, t) {
  let n = e.length, r = 0, i, o, s, l;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (s) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (s = n);
  const c = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, u = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, p = {
    type: "labelText",
    start: {
      ...e[o + r + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", c, t], ["enter", u, t]], l = zt(l, e.slice(o + 1, o + r + 3)), l = zt(l, [["enter", p, t]]), l = zt(l, rs(t.parser.constructs.insideSpan.null, e.slice(o + r + 4, s - 3), t)), l = zt(l, [["exit", p, t], e[s - 2], e[s - 1], ["exit", u, t]]), l = zt(l, e.slice(s + 1)), l = zt(l, [["exit", c, t]]), un(e, o, e.length, l), e;
}
function UT(e, t, n) {
  const r = this;
  let i = r.events.length, o, s;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return l;
  function l(f) {
    return o ? o._inactive ? d(f) : (s = r.parser.defined.includes(pr(r.sliceSerialize({
      start: o.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(f), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(f);
  }
  function c(f) {
    return f === 40 ? e.attempt(jT, p, s ? p : d)(f) : f === 91 ? e.attempt(LT, p, s ? u : d)(f) : s ? p(f) : d(f);
  }
  function u(f) {
    return e.attempt(kT, p, d)(f);
  }
  function p(f) {
    return t(f);
  }
  function d(f) {
    return o._balanced = !0, n(f);
  }
}
function FT(e, t, n) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return _t(d) ? Yr(e, o)(d) : o(d);
  }
  function o(d) {
    return d === 41 ? p(d) : bd(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function s(d) {
    return _t(d) ? Yr(e, c)(d) : p(d);
  }
  function l(d) {
    return n(d);
  }
  function c(d) {
    return d === 34 || d === 39 || d === 40 ? Od(e, u, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : p(d);
  }
  function u(d) {
    return _t(d) ? Yr(e, p)(d) : p(d);
  }
  function p(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), t) : n(d);
  }
}
function BT(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return Rd.call(r, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return r.parser.defined.includes(pr(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(l) : n(l);
  }
  function s(l) {
    return n(l);
  }
}
function $T(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const GT = {
  name: "labelStartImage",
  resolveAll: is.resolveAll,
  tokenize: zT
};
function zT(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : n(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(l) : t(l);
  }
}
const WT = {
  name: "labelStartLink",
  resolveAll: is.resolveAll,
  tokenize: YT
};
function YT(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const $o = {
  name: "lineEnding",
  tokenize: HT
};
function HT(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Ve(e, t, "linePrefix");
  }
}
const Vi = {
  name: "thematicBreak",
  tokenize: qT
};
function qT(e, t, n) {
  let r = 0, i;
  return o;
  function o(u) {
    return e.enter("thematicBreak"), s(u);
  }
  function s(u) {
    return i = u, l(u);
  }
  function l(u) {
    return u === i ? (e.enter("thematicBreakSequence"), c(u)) : r >= 3 && (u === null || he(u)) ? (e.exit("thematicBreak"), t(u)) : n(u);
  }
  function c(u) {
    return u === i ? (e.consume(u), r++, c) : (e.exit("thematicBreakSequence"), _e(u) ? Ve(e, l, "whitespace")(u) : l(u));
  }
}
const vt = {
  continuation: {
    tokenize: KT
  },
  exit: eS,
  name: "list",
  tokenize: QT
}, XT = {
  partial: !0,
  tokenize: tS
}, JT = {
  partial: !0,
  tokenize: ZT
};
function QT(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, s = 0;
  return l;
  function l(h) {
    const g = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : Ta(h)) {
      if (r.containerState.type || (r.containerState.type = g, e.enter(g, {
        _container: !0
      })), g === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(Vi, n, u)(h) : u(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(h);
    }
    return n(h);
  }
  function c(h) {
    return Ta(h) && ++s < 10 ? (e.consume(h), c) : (!r.interrupt || s < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), u(h)) : n(h);
  }
  function u(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      go,
      // Can’t be empty when interrupting.
      r.interrupt ? n : p,
      e.attempt(XT, f, d)
    );
  }
  function p(h) {
    return r.containerState.initialBlankLine = !0, o++, f(h);
  }
  function d(h) {
    return _e(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), f) : n(h);
  }
  function f(h) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function KT(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(go, i, o);
  function i(l) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Ve(e, t, "listItemIndent", r.containerState.size + 1)(l);
  }
  function o(l) {
    return r.containerState.furtherBlankLines || !_e(l) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, s(l)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(JT, t, s)(l));
  }
  function s(l) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Ve(e, e.attempt(vt, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function ZT(e, t, n) {
  const r = this;
  return Ve(e, i, "listItemIndent", r.containerState.size + 1);
  function i(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function eS(e) {
  e.exit(this.containerState.type);
}
function tS(e, t, n) {
  const r = this;
  return Ve(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(o) {
    const s = r.events[r.events.length - 1];
    return !_e(o) && s && s[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const Hl = {
  name: "setextUnderline",
  resolveTo: nS,
  tokenize: rS
};
function nS(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const s = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", s, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[o][1].end
  }) : e[r][1] = s, e.push(["exit", s, t]), e;
}
function rS(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(u) {
    let p = r.events.length, d;
    for (; p--; )
      if (r.events[p][1].type !== "lineEnding" && r.events[p][1].type !== "linePrefix" && r.events[p][1].type !== "content") {
        d = r.events[p][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = u, s(u)) : n(u);
  }
  function s(u) {
    return e.enter("setextHeadingLineSequence"), l(u);
  }
  function l(u) {
    return u === i ? (e.consume(u), l) : (e.exit("setextHeadingLineSequence"), _e(u) ? Ve(e, c, "lineSuffix")(u) : c(u));
  }
  function c(u) {
    return u === null || he(u) ? (e.exit("setextHeadingLine"), t(u)) : n(u);
  }
}
const iS = {
  tokenize: oS
};
function oS(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    go,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, Ve(e, e.attempt(this.parser.constructs.flow, i, e.attempt(uT, i)), "linePrefix"))
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const aS = {
  resolveAll: vd()
}, sS = Dd("string"), lS = Dd("text");
function Dd(e) {
  return {
    resolveAll: vd(e === "text" ? cS : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, s, l);
    return s;
    function s(p) {
      return u(p) ? o(p) : l(p);
    }
    function l(p) {
      if (p === null) {
        n.consume(p);
        return;
      }
      return n.enter("data"), n.consume(p), c;
    }
    function c(p) {
      return u(p) ? (n.exit("data"), o(p)) : (n.consume(p), c);
    }
    function u(p) {
      if (p === null)
        return !0;
      const d = i[p];
      let f = -1;
      if (d)
        for (; ++f < d.length; ) {
          const h = d[f];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function vd(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function cS(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, s = -1, l = 0, c;
      for (; o--; ) {
        const u = i[o];
        if (typeof u == "string") {
          for (s = u.length; u.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (u === -2)
          c = !0, l++;
        else if (u !== -1) {
          o++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (l = 0), l) {
        const u = {
          type: n === e.length || c || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : r.start._bufferIndex + s,
            _index: r.start._index + o,
            line: r.end.line,
            column: r.end.column - l,
            offset: r.end.offset - l
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...u.start
        }, r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(n, 0, ["enter", u, t], ["exit", u, t]), n += 2);
      }
      n++;
    }
  return e;
}
const uS = {
  42: vt,
  43: vt,
  45: vt,
  48: vt,
  49: vt,
  50: vt,
  51: vt,
  52: vt,
  53: vt,
  54: vt,
  55: vt,
  56: vt,
  57: vt,
  62: Td
}, dS = {
  91: mT
}, pS = {
  [-2]: Bo,
  [-1]: Bo,
  32: Bo
}, hS = {
  35: TT,
  42: Vi,
  45: [Hl, Vi],
  60: bT,
  61: Hl,
  95: Vi,
  96: Wl,
  126: Wl
}, fS = {
  38: Id,
  92: Sd
}, mS = {
  [-5]: $o,
  [-4]: $o,
  [-3]: $o,
  33: GT,
  38: Id,
  42: Sa,
  60: [Wy, wT],
  91: WT,
  92: [gT, Sd],
  93: is,
  95: Sa,
  96: iT
}, ES = {
  null: [Sa, aS]
}, xS = {
  null: [42, 95]
}, CS = {
  null: []
}, gS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: xS,
  contentInitial: dS,
  disable: CS,
  document: uS,
  flow: hS,
  flowInitial: pS,
  insideSpan: ES,
  string: fS,
  text: mS
}, Symbol.toStringTag, { value: "Module" }));
function yS(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const i = {}, o = [];
  let s = [], l = [];
  const c = {
    attempt: P(_),
    check: P(R),
    consume: O,
    enter: S,
    exit: N,
    interrupt: P(R, {
      interrupt: !0
    })
  }, u = {
    code: null,
    containerState: {},
    defineSkip: C,
    events: [],
    now: g,
    parser: e,
    previous: null,
    sliceSerialize: f,
    sliceStream: h,
    write: d
  };
  let p = t.tokenize.call(u, c);
  return t.resolveAll && o.push(t), u;
  function d(V) {
    return s = zt(s, V), y(), s[s.length - 1] !== null ? [] : (U(t, 0), u.events = rs(o, u.events, u), u.events);
  }
  function f(V, L) {
    return SS(h(V), L);
  }
  function h(V) {
    return TS(s, V);
  }
  function g() {
    const {
      _bufferIndex: V,
      _index: L,
      line: te,
      column: $,
      offset: v
    } = r;
    return {
      _bufferIndex: V,
      _index: L,
      line: te,
      column: $,
      offset: v
    };
  }
  function C(V) {
    i[V.line] = V.column, w();
  }
  function y() {
    let V;
    for (; r._index < s.length; ) {
      const L = s[r._index];
      if (typeof L == "string")
        for (V = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === V && r._bufferIndex < L.length; )
          I(L.charCodeAt(r._bufferIndex));
      else
        I(L);
    }
  }
  function I(V) {
    p = p(V);
  }
  function O(V) {
    he(V) ? (r.line++, r.column = 1, r.offset += V === -3 ? 2 : 1, w()) : V !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = V;
  }
  function S(V, L) {
    const te = L || {};
    return te.type = V, te.start = g(), u.events.push(["enter", te, u]), l.push(te), te;
  }
  function N(V) {
    const L = l.pop();
    return L.end = g(), u.events.push(["exit", L, u]), L;
  }
  function _(V, L) {
    U(V, L.from);
  }
  function R(V, L) {
    L.restore();
  }
  function P(V, L) {
    return te;
    function te($, v, J) {
      let j, ee, Q, x;
      return Array.isArray($) ? (
        /* c8 ignore next 1 */
        k($)
      ) : "tokenize" in $ ? (
        // Looks like a construct.
        k([
          /** @type {Construct} */
          $
        ])
      ) : Y($);
      function Y(z) {
        return me;
        function me(ae) {
          const le = ae !== null && z[ae], de = ae !== null && z.null, $e = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(le) ? le : le ? [le] : [],
            ...Array.isArray(de) ? de : de ? [de] : []
          ];
          return k($e)(ae);
        }
      }
      function k(z) {
        return j = z, ee = 0, z.length === 0 ? J : T(z[ee]);
      }
      function T(z) {
        return me;
        function me(ae) {
          return x = M(), Q = z, z.partial || (u.currentConstruct = z), z.name && u.parser.constructs.disable.null.includes(z.name) ? b() : z.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            L ? Object.assign(Object.create(u), L) : u,
            c,
            re,
            b
          )(ae);
        }
      }
      function re(z) {
        return V(Q, x), v;
      }
      function b(z) {
        return x.restore(), ++ee < j.length ? T(j[ee]) : J;
      }
    }
  }
  function U(V, L) {
    V.resolveAll && !o.includes(V) && o.push(V), V.resolve && un(u.events, L, u.events.length - L, V.resolve(u.events.slice(L), u)), V.resolveTo && (u.events = V.resolveTo(u.events, u));
  }
  function M() {
    const V = g(), L = u.previous, te = u.currentConstruct, $ = u.events.length, v = Array.from(l);
    return {
      from: $,
      restore: J
    };
    function J() {
      r = V, u.previous = L, u.currentConstruct = te, u.events.length = $, l = v, w();
    }
  }
  function w() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function TS(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let s;
  if (n === i)
    s = [e[n].slice(r, o)];
  else {
    if (s = e.slice(n, i), r > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(r) : s.shift();
    }
    o > 0 && s.push(e[i].slice(0, o));
  }
  return s;
}
function SS(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && i) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    i = o === -2, r.push(s);
  }
  return r.join("");
}
function IS(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      _y([gS, ...(e || {}).extensions || []])
    ),
    content: i(Vy),
    defined: [],
    document: i(Fy),
    flow: i(iS),
    lazy: {},
    string: i(sS),
    text: i(lS)
  };
  return r;
  function i(o) {
    return s;
    function s(l) {
      return yS(r, o, l);
    }
  }
}
function AS(e) {
  for (; !Ad(e); )
    ;
  return e;
}
const ql = /[\0\t\n\r]/g;
function bS() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, s, l) {
    const c = [];
    let u, p, d, f, h;
    for (o = t + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), d = 0, t = "", n && (o.charCodeAt(0) === 65279 && d++, n = void 0); d < o.length; ) {
      if (ql.lastIndex = d, u = ql.exec(o), f = u && u.index !== void 0 ? u.index : o.length, h = o.charCodeAt(f), !u) {
        t = o.slice(d);
        break;
      }
      if (h === 10 && d === f && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), d < f && (c.push(o.slice(d, f)), e += f - d), h) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (p = Math.ceil(e / 4) * 4, c.push(-2); e++ < p; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = f + 1;
    }
    return l && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
const RS = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function OS(e) {
  return e.replace(RS, DS);
}
function DS(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return yd(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return ns(n) || e;
}
const _d = {}.hasOwnProperty;
function vS(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), _S(n)(AS(IS(n).document().write(bS()(e, t, !0))));
}
function _S(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(ce),
      autolinkProtocol: M,
      autolinkEmail: M,
      atxHeading: o(ot),
      blockQuote: o(de),
      characterEscape: M,
      characterReference: M,
      codeFenced: o($e),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o($e, s),
      codeText: o(we, s),
      codeTextData: M,
      data: M,
      codeFlowValue: M,
      definition: o(At),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(qe),
      hardBreakEscape: o(ct),
      hardBreakTrailing: o(ct),
      htmlFlow: o(bt, s),
      htmlFlowData: M,
      htmlText: o(bt, s),
      htmlTextData: M,
      image: o(Yt),
      label: s,
      link: o(ce),
      listItem: o(Ue),
      listItemValue: f,
      listOrdered: o(ne, d),
      listUnordered: o(ne),
      paragraph: o(mt),
      reference: T,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(ot),
      strong: o(Rt),
      thematicBreak: o(tt)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: _,
      autolink: c(),
      autolinkEmail: le,
      autolinkProtocol: ae,
      blockQuote: c(),
      characterEscapeValue: w,
      characterReferenceMarkerHexadecimal: b,
      characterReferenceMarkerNumeric: b,
      characterReferenceValue: z,
      characterReference: me,
      codeFenced: c(y),
      codeFencedFence: C,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: g,
      codeFlowValue: w,
      codeIndented: c(I),
      codeText: c(v),
      codeTextData: w,
      data: w,
      definition: c(),
      definitionDestinationString: N,
      definitionLabelString: O,
      definitionTitleString: S,
      emphasis: c(),
      hardBreakEscape: c(L),
      hardBreakTrailing: c(L),
      htmlFlow: c(te),
      htmlFlowData: w,
      htmlText: c($),
      htmlTextData: w,
      image: c(j),
      label: Q,
      labelText: ee,
      lineEnding: V,
      link: c(J),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: re,
      resourceDestinationString: x,
      resourceTitleString: Y,
      resource: k,
      setextHeading: c(U),
      setextHeadingLineSequence: P,
      setextHeadingText: R,
      strong: c(),
      thematicBreak: c()
    }
  };
  Nd(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(F) {
    let H = {
      type: "root",
      children: []
    };
    const oe = {
      stack: [H],
      tokenStack: [],
      config: t,
      enter: l,
      exit: u,
      buffer: s,
      resume: p,
      data: n
    }, Ce = [];
    let Oe = -1;
    for (; ++Oe < F.length; )
      if (F[Oe][1].type === "listOrdered" || F[Oe][1].type === "listUnordered")
        if (F[Oe][0] === "enter")
          Ce.push(Oe);
        else {
          const Ge = Ce.pop();
          Oe = i(F, Ge, Oe);
        }
    for (Oe = -1; ++Oe < F.length; ) {
      const Ge = t[F[Oe][0]];
      _d.call(Ge, F[Oe][1].type) && Ge[F[Oe][1].type].call(Object.assign({
        sliceSerialize: F[Oe][2].sliceSerialize
      }, oe), F[Oe][1]);
    }
    if (oe.tokenStack.length > 0) {
      const Ge = oe.tokenStack[oe.tokenStack.length - 1];
      (Ge[1] || Xl).call(oe, void 0, Ge[0]);
    }
    for (H.position = {
      start: An(F.length > 0 ? F[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: An(F.length > 0 ? F[F.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Oe = -1; ++Oe < t.transforms.length; )
      H = t.transforms[Oe](H) || H;
    return H;
  }
  function i(F, H, oe) {
    let Ce = H - 1, Oe = -1, Ge = !1, Ft, Pt, dn, Ht;
    for (; ++Ce <= oe; ) {
      const at = F[Ce];
      switch (at[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          at[0] === "enter" ? Oe++ : Oe--, Ht = void 0;
          break;
        }
        case "lineEndingBlank": {
          at[0] === "enter" && (Ft && !Ht && !Oe && !dn && (dn = Ce), Ht = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Ht = void 0;
      }
      if (!Oe && at[0] === "enter" && at[1].type === "listItemPrefix" || Oe === -1 && at[0] === "exit" && (at[1].type === "listUnordered" || at[1].type === "listOrdered")) {
        if (Ft) {
          let Qt = Ce;
          for (Pt = void 0; Qt--; ) {
            const dt = F[Qt];
            if (dt[1].type === "lineEnding" || dt[1].type === "lineEndingBlank") {
              if (dt[0] === "exit") continue;
              Pt && (F[Pt][1].type = "lineEndingBlank", Ge = !0), dt[1].type = "lineEnding", Pt = Qt;
            } else if (!(dt[1].type === "linePrefix" || dt[1].type === "blockQuotePrefix" || dt[1].type === "blockQuotePrefixWhitespace" || dt[1].type === "blockQuoteMarker" || dt[1].type === "listItemIndent")) break;
          }
          dn && (!Pt || dn < Pt) && (Ft._spread = !0), Ft.end = Object.assign({}, Pt ? F[Pt][1].start : at[1].end), F.splice(Pt || Ce, 0, ["exit", Ft, at[2]]), Ce++, oe++;
        }
        if (at[1].type === "listItemPrefix") {
          const Qt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, at[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Ft = Qt, F.splice(Ce, 0, ["enter", Qt, at[2]]), Ce++, oe++, dn = void 0, Ht = !0;
        }
      }
    }
    return F[H][1]._spread = Ge, oe;
  }
  function o(F, H) {
    return oe;
    function oe(Ce) {
      l.call(this, F(Ce), Ce), H && H.call(this, Ce);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(F, H, oe) {
    this.stack[this.stack.length - 1].children.push(F), this.stack.push(F), this.tokenStack.push([H, oe || void 0]), F.position = {
      start: An(H.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(F) {
    return H;
    function H(oe) {
      F && F.call(this, oe), u.call(this, oe);
    }
  }
  function u(F, H) {
    const oe = this.stack.pop(), Ce = this.tokenStack.pop();
    if (Ce)
      Ce[0].type !== F.type && (H ? H.call(this, F, Ce[0]) : (Ce[1] || Xl).call(this, F, Ce[0]));
    else throw new Error("Cannot close `" + F.type + "` (" + Wr({
      start: F.start,
      end: F.end
    }) + "): it’s not open");
    oe.position.end = An(F.end);
  }
  function p() {
    return Dy(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(F) {
    if (this.data.expectingFirstListItemValue) {
      const H = this.stack[this.stack.length - 2];
      H.start = Number.parseInt(this.sliceSerialize(F), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.lang = F;
  }
  function g() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.meta = F;
  }
  function C() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function y() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.value = F.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function I() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.value = F.replace(/(\r?\n|\r)$/g, "");
  }
  function O(F) {
    const H = this.resume(), oe = this.stack[this.stack.length - 1];
    oe.label = H, oe.identifier = pr(this.sliceSerialize(F)).toLowerCase();
  }
  function S() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.title = F;
  }
  function N() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.url = F;
  }
  function _(F) {
    const H = this.stack[this.stack.length - 1];
    if (!H.depth) {
      const oe = this.sliceSerialize(F).length;
      H.depth = oe;
    }
  }
  function R() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function P(F) {
    const H = this.stack[this.stack.length - 1];
    H.depth = this.sliceSerialize(F).codePointAt(0) === 61 ? 1 : 2;
  }
  function U() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function M(F) {
    const oe = this.stack[this.stack.length - 1].children;
    let Ce = oe[oe.length - 1];
    (!Ce || Ce.type !== "text") && (Ce = et(), Ce.position = {
      start: An(F.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, oe.push(Ce)), this.stack.push(Ce);
  }
  function w(F) {
    const H = this.stack.pop();
    H.value += this.sliceSerialize(F), H.position.end = An(F.end);
  }
  function V(F) {
    const H = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const oe = H.children[H.children.length - 1];
      oe.position.end = An(F.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(H.type) && (M.call(this, F), w.call(this, F));
  }
  function L() {
    this.data.atHardBreak = !0;
  }
  function te() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.value = F;
  }
  function $() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.value = F;
  }
  function v() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.value = F;
  }
  function J() {
    const F = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const H = this.data.referenceType || "shortcut";
      F.type += "Reference", F.referenceType = H, delete F.url, delete F.title;
    } else
      delete F.identifier, delete F.label;
    this.data.referenceType = void 0;
  }
  function j() {
    const F = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const H = this.data.referenceType || "shortcut";
      F.type += "Reference", F.referenceType = H, delete F.url, delete F.title;
    } else
      delete F.identifier, delete F.label;
    this.data.referenceType = void 0;
  }
  function ee(F) {
    const H = this.sliceSerialize(F), oe = this.stack[this.stack.length - 2];
    oe.label = OS(H), oe.identifier = pr(H).toLowerCase();
  }
  function Q() {
    const F = this.stack[this.stack.length - 1], H = this.resume(), oe = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, oe.type === "link") {
      const Ce = F.children;
      oe.children = Ce;
    } else
      oe.alt = H;
  }
  function x() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.url = F;
  }
  function Y() {
    const F = this.resume(), H = this.stack[this.stack.length - 1];
    H.title = F;
  }
  function k() {
    this.data.inReference = void 0;
  }
  function T() {
    this.data.referenceType = "collapsed";
  }
  function re(F) {
    const H = this.resume(), oe = this.stack[this.stack.length - 1];
    oe.label = H, oe.identifier = pr(this.sliceSerialize(F)).toLowerCase(), this.data.referenceType = "full";
  }
  function b(F) {
    this.data.characterReferenceType = F.type;
  }
  function z(F) {
    const H = this.sliceSerialize(F), oe = this.data.characterReferenceType;
    let Ce;
    oe ? (Ce = yd(H, oe === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Ce = ns(H);
    const Oe = this.stack[this.stack.length - 1];
    Oe.value += Ce;
  }
  function me(F) {
    const H = this.stack.pop();
    H.position.end = An(F.end);
  }
  function ae(F) {
    w.call(this, F);
    const H = this.stack[this.stack.length - 1];
    H.url = this.sliceSerialize(F);
  }
  function le(F) {
    w.call(this, F);
    const H = this.stack[this.stack.length - 1];
    H.url = "mailto:" + this.sliceSerialize(F);
  }
  function de() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function $e() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function we() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function At() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function qe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ot() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ct() {
    return {
      type: "break"
    };
  }
  function bt() {
    return {
      type: "html",
      value: ""
    };
  }
  function Yt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function ce() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ne(F) {
    return {
      type: "list",
      ordered: F.type === "listOrdered",
      start: null,
      spread: F._spread,
      children: []
    };
  }
  function Ue(F) {
    return {
      type: "listItem",
      spread: F._spread,
      checked: null,
      children: []
    };
  }
  function mt() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Rt() {
    return {
      type: "strong",
      children: []
    };
  }
  function et() {
    return {
      type: "text",
      value: ""
    };
  }
  function tt() {
    return {
      type: "thematicBreak"
    };
  }
}
function An(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Nd(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Nd(e, r) : NS(e, r);
  }
}
function NS(e, t) {
  let n;
  for (n in t)
    if (_d.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function Xl(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Wr({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Wr({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Wr({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function wS(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return vS(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function PS(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function jS(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function LS(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function kS(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function MS(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function VS(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = Rr(r.toLowerCase()), o = e.footnoteOrder.indexOf(r);
  let s, l = e.footnoteCounts.get(r);
  l === void 0 ? (l = 0, e.footnoteOrder.push(r), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(r, l);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(t, c);
  const u = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(t, u), e.applyData(t, u);
}
function US(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function FS(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function wd(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const s = i[i.length - 1];
  return s && s.type === "text" ? s.value += r : i.push({ type: "text", value: r }), i;
}
function BS(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return wd(e, t);
  const i = { src: Rr(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, o), e.applyData(t, o);
}
function $S(e, t) {
  const n = { src: Rr(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function GS(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function zS(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return wd(e, t);
  const i = { href: Rr(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function WS(e, t) {
  const n = { href: Rr(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function YS(e, t, n) {
  const r = e.all(t), i = n ? HS(n) : Pd(t), o = {}, s = [];
  if (typeof t.checked == "boolean") {
    const p = r[0];
    let d;
    p && p.type === "element" && p.tagName === "p" ? d = p : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < r.length; ) {
    const p = r[l];
    (i || l !== 0 || p.type !== "element" || p.tagName !== "p") && s.push({ type: "text", value: `
` }), p.type === "element" && p.tagName === "p" && !i ? s.push(...p.children) : s.push(p);
  }
  const c = r[r.length - 1];
  c && (i || c.type !== "element" || c.tagName !== "p") && s.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(t, u), e.applyData(t, u);
}
function HS(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = Pd(n[r]);
  }
  return t;
}
function Pd(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function qS(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const s = r[i];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function XS(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function JS(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function QS(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function KS(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], s), i.push(s);
  }
  if (n.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, l = Ka(t.children[1]), c = hd(t.children[t.children.length - 1]);
    l && c && (s.position = { start: l, end: c }), i.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function ZS(e, t, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", s = n && n.type === "table" ? n.align : void 0, l = s ? s.length : t.children.length;
  let c = -1;
  const u = [];
  for (; ++c < l; ) {
    const d = t.children[c], f = {}, h = s ? s[c] : void 0;
    h && (f.align = h);
    let g = { type: "element", tagName: o, properties: f, children: [] };
    d && (g.children = e.all(d), e.patch(d, g), g = e.applyData(d, g)), u.push(g);
  }
  const p = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(t, p), e.applyData(t, p);
}
function eI(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Jl = 9, Ql = 32;
function tI(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const o = [];
  for (; r; )
    o.push(
      Kl(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return o.push(Kl(t.slice(i), i > 0, !1)), o.join("");
}
function Kl(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let o = e.codePointAt(r);
    for (; o === Jl || o === Ql; )
      r++, o = e.codePointAt(r);
  }
  if (n) {
    let o = e.codePointAt(i - 1);
    for (; o === Jl || o === Ql; )
      i--, o = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function nI(e, t) {
  const n = { type: "text", value: tI(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function rI(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const iI = {
  blockquote: PS,
  break: jS,
  code: LS,
  delete: kS,
  emphasis: MS,
  footnoteReference: VS,
  heading: US,
  html: FS,
  imageReference: BS,
  image: $S,
  inlineCode: GS,
  linkReference: zS,
  link: WS,
  listItem: YS,
  list: qS,
  paragraph: XS,
  // @ts-expect-error: root is different, but hard to type.
  root: JS,
  strong: QS,
  table: KS,
  tableCell: eI,
  tableRow: ZS,
  text: nI,
  thematicBreak: rI,
  toml: Ni,
  yaml: Ni,
  definition: Ni,
  footnoteDefinition: Ni
};
function Ni() {
}
const jd = -1, yo = 0, Hr = 1, no = 2, os = 3, as = 4, ss = 5, ls = 6, Ld = 7, kd = 8, Zl = typeof self == "object" ? self : globalThis, oI = (e, t) => {
  const n = (i, o) => (e.set(o, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [o, s] = t[i];
    switch (o) {
      case yo:
      case jd:
        return n(s, i);
      case Hr: {
        const l = n([], i);
        for (const c of s)
          l.push(r(c));
        return l;
      }
      case no: {
        const l = n({}, i);
        for (const [c, u] of s)
          l[r(c)] = r(u);
        return l;
      }
      case os:
        return n(new Date(s), i);
      case as: {
        const { source: l, flags: c } = s;
        return n(new RegExp(l, c), i);
      }
      case ss: {
        const l = n(/* @__PURE__ */ new Map(), i);
        for (const [c, u] of s)
          l.set(r(c), r(u));
        return l;
      }
      case ls: {
        const l = n(/* @__PURE__ */ new Set(), i);
        for (const c of s)
          l.add(r(c));
        return l;
      }
      case Ld: {
        const { name: l, message: c } = s;
        return n(new Zl[l](c), i);
      }
      case kd:
        return n(BigInt(s), i);
      case "BigInt":
        return n(Object(BigInt(s)), i);
      case "ArrayBuffer":
        return n(new Uint8Array(s).buffer, s);
      case "DataView": {
        const { buffer: l } = new Uint8Array(s);
        return n(new DataView(l), s);
      }
    }
    return n(new Zl[o](s), i);
  };
  return r;
}, ec = (e) => oI(/* @__PURE__ */ new Map(), e)(0), er = "", { toString: aI } = {}, { keys: sI } = Object, kr = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [yo, t];
  const n = aI.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Hr, er];
    case "Object":
      return [no, er];
    case "Date":
      return [os, er];
    case "RegExp":
      return [as, er];
    case "Map":
      return [ss, er];
    case "Set":
      return [ls, er];
    case "DataView":
      return [Hr, n];
  }
  return n.includes("Array") ? [Hr, n] : n.includes("Error") ? [Ld, n] : [no, n];
}, wi = ([e, t]) => e === yo && (t === "function" || t === "symbol"), lI = (e, t, n, r) => {
  const i = (s, l) => {
    const c = r.push(s) - 1;
    return n.set(l, c), c;
  }, o = (s) => {
    if (n.has(s))
      return n.get(s);
    let [l, c] = kr(s);
    switch (l) {
      case yo: {
        let p = s;
        switch (c) {
          case "bigint":
            l = kd, p = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            p = null;
            break;
          case "undefined":
            return i([jd], s);
        }
        return i([l, p], s);
      }
      case Hr: {
        if (c) {
          let f = s;
          return c === "DataView" ? f = new Uint8Array(s.buffer) : c === "ArrayBuffer" && (f = new Uint8Array(s)), i([c, [...f]], s);
        }
        const p = [], d = i([l, p], s);
        for (const f of s)
          p.push(o(f));
        return d;
      }
      case no: {
        if (c)
          switch (c) {
            case "BigInt":
              return i([c, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return i([c, s.valueOf()], s);
          }
        if (t && "toJSON" in s)
          return o(s.toJSON());
        const p = [], d = i([l, p], s);
        for (const f of sI(s))
          (e || !wi(kr(s[f]))) && p.push([o(f), o(s[f])]);
        return d;
      }
      case os:
        return i([l, s.toISOString()], s);
      case as: {
        const { source: p, flags: d } = s;
        return i([l, { source: p, flags: d }], s);
      }
      case ss: {
        const p = [], d = i([l, p], s);
        for (const [f, h] of s)
          (e || !(wi(kr(f)) || wi(kr(h)))) && p.push([o(f), o(h)]);
        return d;
      }
      case ls: {
        const p = [], d = i([l, p], s);
        for (const f of s)
          (e || !wi(kr(f))) && p.push(o(f));
        return d;
      }
    }
    const { message: u } = s;
    return i([l, { name: c, message: u }], s);
  };
  return o;
}, tc = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return lI(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, ro = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? ec(tc(e, t)) : structuredClone(e)
) : (e, t) => ec(tc(e, t));
function cI(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function uI(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function dI(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || cI, r = e.options.footnoteBackLabel || uI, i = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const u = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!u)
      continue;
    const p = e.all(u), d = String(u.identifier).toUpperCase(), f = Rr(d.toLowerCase());
    let h = 0;
    const g = [], C = e.footnoteCounts.get(d);
    for (; C !== void 0 && ++h <= C; ) {
      g.length > 0 && g.push({ type: "text", value: " " });
      let O = typeof n == "string" ? n : n(c, h);
      typeof O == "string" && (O = { type: "text", value: O }), g.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + f + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(c, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(O) ? O : [O]
      });
    }
    const y = p[p.length - 1];
    if (y && y.type === "element" && y.tagName === "p") {
      const O = y.children[y.children.length - 1];
      O && O.type === "text" ? O.value += " " : y.children.push({ type: "text", value: " " }), y.children.push(...g);
    } else
      p.push(...g);
    const I = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + f },
      children: e.wrap(p, !0)
    };
    e.patch(u, I), l.push(I);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...ro(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Md = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return mI;
    if (typeof e == "function")
      return To(e);
    if (typeof e == "object")
      return Array.isArray(e) ? pI(e) : hI(e);
    if (typeof e == "string")
      return fI(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function pI(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Md(e[n]);
  return To(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].apply(this, i)) return !0;
    return !1;
  }
}
function hI(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return To(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let o;
    for (o in e)
      if (i[o] !== t[o]) return !1;
    return !0;
  }
}
function fI(e) {
  return To(t);
  function t(n) {
    return n && n.type === e;
  }
}
function To(e) {
  return t;
  function t(n, r, i) {
    return !!(EI(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function mI() {
  return !0;
}
function EI(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Vd = [], xI = !0, nc = !1, CI = "skip";
function gI(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const o = Md(i), s = r ? -1 : 1;
  l(e, void 0, [])();
  function l(c, u, p) {
    const d = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof d.type == "string") {
      const h = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(f, "name", {
        value: "node (" + (c.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return f;
    function f() {
      let h = Vd, g, C, y;
      if ((!t || o(c, u, p[p.length - 1] || void 0)) && (h = yI(n(c, p)), h[0] === nc))
        return h;
      if ("children" in c && c.children) {
        const I = (
          /** @type {UnistParent} */
          c
        );
        if (I.children && h[0] !== CI)
          for (C = (r ? I.children.length : -1) + s, y = p.concat(I); C > -1 && C < I.children.length; ) {
            const O = I.children[C];
            if (g = l(O, C, y)(), g[0] === nc)
              return g;
            C = typeof g[1] == "number" ? g[1] : C + s;
          }
      }
      return h;
    }
  }
}
function yI(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [xI, e] : e == null ? Vd : [e];
}
function Ud(e, t, n, r) {
  let i, o, s;
  typeof t == "function" && typeof n != "function" ? (o = void 0, s = t, i = n) : (o = t, s = n, i = r), gI(e, o, l, i);
  function l(c, u) {
    const p = u[u.length - 1], d = p ? p.children.indexOf(c) : void 0;
    return s(c, d, p);
  }
}
const Ia = {}.hasOwnProperty, TI = {};
function SI(e, t) {
  const n = t || TI, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...iI, ...n.handlers }, l = {
    all: u,
    applyData: AI,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: c,
    options: n,
    patch: II,
    wrap: RI
  };
  return Ud(e, function(p) {
    if (p.type === "definition" || p.type === "footnoteDefinition") {
      const d = p.type === "definition" ? r : i, f = String(p.identifier).toUpperCase();
      d.has(f) || d.set(f, p);
    }
  }), l;
  function c(p, d) {
    const f = p.type, h = l.handlers[f];
    if (Ia.call(l.handlers, f) && h)
      return h(l, p, d);
    if (l.options.passThrough && l.options.passThrough.includes(f)) {
      if ("children" in p) {
        const { children: C, ...y } = p, I = ro(y);
        return I.children = l.all(p), I;
      }
      return ro(p);
    }
    return (l.options.unknownHandler || bI)(l, p, d);
  }
  function u(p) {
    const d = [];
    if ("children" in p) {
      const f = p.children;
      let h = -1;
      for (; ++h < f.length; ) {
        const g = l.one(f[h], p);
        if (g) {
          if (h && f[h - 1].type === "break" && (!Array.isArray(g) && g.type === "text" && (g.value = rc(g.value)), !Array.isArray(g) && g.type === "element")) {
            const C = g.children[0];
            C && C.type === "text" && (C.value = rc(C.value));
          }
          Array.isArray(g) ? d.push(...g) : d.push(g);
        }
      }
    }
    return d;
  }
}
function II(e, t) {
  e.position && (t.position = ay(e));
}
function AI(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, o = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const s = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: s };
      }
    n.type === "element" && o && Object.assign(n.properties, ro(o)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function bI(e, t) {
  const n = t.data || {}, r = "value" in t && !(Ia.call(n, "hProperties") || Ia.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function RI(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function rc(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function ic(e, t) {
  const n = SI(e, t), r = n.one(e, void 0), i = dI(n), o = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && o.children.push({ type: "text", value: `
` }, i), o;
}
function OI(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      ic(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      ic(n, { file: r, ...e || t })
    );
  };
}
function oc(e) {
  if (e)
    throw e;
}
var Ui = Object.prototype.hasOwnProperty, Fd = Object.prototype.toString, ac = Object.defineProperty, sc = Object.getOwnPropertyDescriptor, lc = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : Fd.call(t) === "[object Array]";
}, cc = function(t) {
  if (!t || Fd.call(t) !== "[object Object]")
    return !1;
  var n = Ui.call(t, "constructor"), r = t.constructor && t.constructor.prototype && Ui.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || Ui.call(t, i);
}, uc = function(t, n) {
  ac && n.name === "__proto__" ? ac(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, dc = function(t, n) {
  if (n === "__proto__")
    if (Ui.call(t, n)) {
      if (sc)
        return sc(t, n).value;
    } else return;
  return t[n];
}, DI = function e() {
  var t, n, r, i, o, s, l = arguments[0], c = 1, u = arguments.length, p = !1;
  for (typeof l == "boolean" && (p = l, l = arguments[1] || {}, c = 2), (l == null || typeof l != "object" && typeof l != "function") && (l = {}); c < u; ++c)
    if (t = arguments[c], t != null)
      for (n in t)
        r = dc(l, n), i = dc(t, n), l !== i && (p && i && (cc(i) || (o = lc(i))) ? (o ? (o = !1, s = r && lc(r) ? r : []) : s = r && cc(r) ? r : {}, uc(l, { name: n, newValue: e(p, s, i) })) : typeof i < "u" && uc(l, { name: n, newValue: i }));
  return l;
};
const Go = /* @__PURE__ */ Wc(DI);
function Aa(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function vI() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const s = i.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...i);
    function l(c, ...u) {
      const p = e[++o];
      let d = -1;
      if (c) {
        s(c);
        return;
      }
      for (; ++d < i.length; )
        (u[d] === null || u[d] === void 0) && (u[d] = i[d]);
      i = u, p ? _I(p, l)(...u) : s(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function _I(e, t) {
  let n;
  return r;
  function r(...s) {
    const l = e.length > s.length;
    let c;
    l && s.push(i);
    try {
      c = e.apply(this, s);
    } catch (u) {
      const p = (
        /** @type {Error} */
        u
      );
      if (l && n)
        throw p;
      return i(p);
    }
    l || (c && c.then && typeof c.then == "function" ? c.then(o, i) : c instanceof Error ? i(c) : o(c));
  }
  function i(s, ...l) {
    n || (n = !0, t(s, ...l));
  }
  function o(s) {
    i(null, s);
  }
}
const an = { basename: NI, dirname: wI, extname: PI, join: jI, sep: "/" };
function NI(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  xi(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let s = -1, l = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = i + 1), l > -1 && (e.codePointAt(i) === t.codePointAt(l--) ? l < 0 && (r = i) : (l = -1, r = s));
  return n === r ? r = s : r < 0 && (r = e.length), e.slice(n, r);
}
function wI(e) {
  if (xi(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function PI(e) {
  xi(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, s;
  for (; t--; ) {
    const l = e.codePointAt(t);
    if (l === 47) {
      if (s) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (s = !0, n = t + 1), l === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function jI(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    xi(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : LI(n);
}
function LI(e) {
  xi(e);
  const t = e.codePointAt(0) === 47;
  let n = kI(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function kI(e, t) {
  let n = "", r = 0, i = -1, o = 0, s = -1, l, c;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(i === s - 1 || o === 1)) if (i !== s - 1 && o === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (c = n.lastIndexOf("/"), c !== n.length - 1) {
              c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = s, o = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = s, o = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, s) : n = e.slice(i + 1, s), r = s - i - 1;
      i = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function xi(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const MI = { cwd: VI };
function VI() {
  return "/";
}
function ba(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function UI(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!ba(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return FI(e);
}
function FI(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const zo = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class Bd {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? ba(t) ? n = { path: t } : typeof t == "string" || BI(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : MI.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < zo.length; ) {
      const o = zo[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      zo.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? an.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Yo(t, "basename"), Wo(t, "basename"), this.path = an.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? an.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    pc(this.basename, "dirname"), this.path = an.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? an.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (Wo(t, "extname"), pc(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = an.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    ba(t) && (t = UI(t)), Yo(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? an.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Yo(t, "stem"), Wo(t, "stem"), this.path = an.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new ft(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function Wo(e, t) {
  if (e && e.includes(an.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + an.sep + "`"
    );
}
function Yo(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function pc(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function BI(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const $I = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], o = function() {
      return i.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, r), o;
  }
), GI = {}.hasOwnProperty;
class cs extends $I {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = vI();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new cs()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(Go(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (Xo("data", this.frozen), this.namespace[t] = n, this) : GI.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (Xo("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = Pi(t), r = this.parser || this.Parser;
    return Ho("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), Ho("process", this.parser || this.Parser), qo("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(o, s) {
      const l = Pi(t), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(l)
      );
      r.run(c, l, function(p, d, f) {
        if (p || !d || !f)
          return u(p);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), g = r.stringify(h, f);
        YI(g) ? f.value = g : f.result = g, u(
          p,
          /** @type {VFileWithOutput<CompileResult>} */
          f
        );
      });
      function u(p, d) {
        p || !d ? s(p) : o ? o(d) : n(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), Ho("processSync", this.parser || this.Parser), qo("processSync", this.compiler || this.Compiler), this.process(t, i), fc("processSync", "process", n), r;
    function i(o, s) {
      n = !0, oc(o), r = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    hc(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? o(void 0, r) : new Promise(o);
    function o(s, l) {
      const c = Pi(n);
      i.run(t, c, u);
      function u(p, d, f) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || t
        );
        p ? l(p) : s ? s(h) : r(void 0, h, f);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, o), fc("runSync", "run", r), i;
    function o(s, l) {
      oc(s), i = l, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = Pi(n), i = this.compiler || this.Compiler;
    return qo("stringify", i), hc(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (Xo("use", this.frozen), t != null) if (typeof t == "function")
      c(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? l(t) : s(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function o(u) {
      if (typeof u == "function")
        c(u, []);
      else if (typeof u == "object")
        if (Array.isArray(u)) {
          const [p, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            u
          );
          c(p, d);
        } else
          s(u);
      else
        throw new TypeError("Expected usable value, not `" + u + "`");
    }
    function s(u) {
      if (!("plugins" in u) && !("settings" in u))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(u.plugins), u.settings && (i.settings = Go(!0, i.settings, u.settings));
    }
    function l(u) {
      let p = -1;
      if (u != null) if (Array.isArray(u))
        for (; ++p < u.length; ) {
          const d = u[p];
          o(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + u + "`");
    }
    function c(u, p) {
      let d = -1, f = -1;
      for (; ++d < r.length; )
        if (r[d][0] === u) {
          f = d;
          break;
        }
      if (f === -1)
        r.push([u, ...p]);
      else if (p.length > 0) {
        let [h, ...g] = p;
        const C = r[f][1];
        Aa(C) && Aa(h) && (h = Go(!0, C, h)), r[f] = [u, h, ...g];
      }
    }
  }
}
const zI = new cs().freeze();
function Ho(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function qo(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Xo(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function hc(e) {
  if (!Aa(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function fc(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Pi(e) {
  return WI(e) ? e : new Bd(e);
}
function WI(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function YI(e) {
  return typeof e == "string" || HI(e);
}
function HI(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const qI = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", mc = [], Ec = { allowDangerousHtml: !0 }, XI = /^(https?|ircs?|mailto|xmpp)$/i, JI = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function QI(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || mc, c = e.remarkPlugins || mc, u = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Ec } : Ec, p = e.skipHtml, d = e.unwrapDisallowed, f = e.urlTransform || KI, h = zI().use(wS).use(c).use(OI, u).use(l), g = new Bd();
  typeof r == "string" && (g.value = r);
  for (const O of JI)
    Object.hasOwn(e, O.from) && ("" + O.from + (O.to ? "use `" + O.to + "` instead" : "remove it") + qI + O.id, void 0);
  const C = h.parse(g);
  let y = h.runSync(C, g);
  return i && (y = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      y.type === "root" ? y.children : [y]
    )
  }), Ud(y, I), dy(y, {
    Fragment: a.Fragment,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: o,
    ignoreInvalidStyle: !0,
    jsx: a.jsx,
    jsxs: a.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function I(O, S, N) {
    if (O.type === "raw" && N && typeof S == "number")
      return p ? N.children.splice(S, 1) : N.children[S] = { type: "text", value: O.value }, S;
    if (O.type === "element") {
      let _;
      for (_ in Fo)
        if (Object.hasOwn(Fo, _) && Object.hasOwn(O.properties, _)) {
          const R = O.properties[_], P = Fo[_];
          (P === null || P.includes(O.tagName)) && (O.properties[_] = f(String(R || ""), _, O));
        }
    }
    if (O.type === "element") {
      let _ = t ? !t.includes(O.tagName) : s ? s.includes(O.tagName) : !1;
      if (!_ && n && typeof S == "number" && (_ = !n(O, S, N)), _ && N && typeof S == "number")
        return d && O.children ? N.children.splice(S, 1, ...O.children) : N.children.splice(S, 1), S;
    }
  }
}
function KI(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && t > i || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    XI.test(e.slice(0, t)) ? e : ""
  );
}
const ZI = /appendix\s*\d*\s*:?\s*concept\s*set\s*definitions/i, xc = 20, Cc = 14, eA = (e) => /<\/?[a-z][\w:-]*(?:\s[^<>]*)?>/i.test(e), tA = (e) => e ? e.replace(/^\uFEFF/, "").replace(/\u200B/g, "").replace(/\\r\\n/g, `
`).replace(/\\n/g, `
`).replace(/\\r/g, `
`).replace(/\r\n/g, `
`).replace(/\r/g, `
`).trim() : "", jn = (e) => typeof e == "number" ? String(e) : typeof e == "string" && e.trim().length > 0 ? e.trim() : "-", ji = (e) => e ? "YES" : "NO", Li = (e) => !!e, nA = (e) => Array.isArray(e) ? e : e && typeof e == "object" ? Object.values(e) : [], rA = (e) => e.map((t) => {
  var n, r, i, o, s, l, c, u;
  return {
    conceptId: jn((n = t == null ? void 0 : t.concept) == null ? void 0 : n.CONCEPT_ID),
    conceptCode: jn((r = t == null ? void 0 : t.concept) == null ? void 0 : r.CONCEPT_CODE),
    conceptName: jn((i = t == null ? void 0 : t.concept) == null ? void 0 : i.CONCEPT_NAME),
    standardConcept: jn(
      ((o = t == null ? void 0 : t.concept) == null ? void 0 : o.STANDARD_CONCEPT_CAPTION) ?? ((s = t == null ? void 0 : t.concept) == null ? void 0 : s.STANDARD_CONCEPT)
    ),
    conceptClass: jn((l = t == null ? void 0 : t.concept) == null ? void 0 : l.CONCEPT_CLASS_ID),
    domain: jn((c = t == null ? void 0 : t.concept) == null ? void 0 : c.DOMAIN_ID),
    vocabulary: jn((u = t == null ? void 0 : t.concept) == null ? void 0 : u.VOCABULARY_ID),
    excluded: Li((t == null ? void 0 : t.excluded) ?? (t == null ? void 0 : t.isExcluded)),
    descendants: Li((t == null ? void 0 : t.includeDescendants) ?? (t == null ? void 0 : t.descendants)),
    mapped: Li((t == null ? void 0 : t.includeMapped) ?? (t == null ? void 0 : t.mapped)),
    hierarchy: Li(t == null ? void 0 : t.hierarchy)
  };
}), iA = (e) => rA(nA(e)), oA = [
  {
    header: "Id",
    accessorKey: "conceptId",
    id: "conceptId",
    size: 120,
    enableColumnFilter: !1
  },
  {
    header: "Code",
    accessorKey: "conceptCode",
    id: "conceptCode",
    size: 130,
    enableColumnFilter: !1
  },
  {
    header: "Name",
    accessorKey: "conceptName",
    id: "conceptName",
    size: 250,
    minSize: 140,
    filterFn: (e, t, n) => {
      const r = Array.isArray(n) ? n[0] : n, i = String(r || "").trim().toLowerCase();
      return i ? [
        e.original.conceptId,
        e.original.conceptCode,
        e.original.conceptName
      ].map((o) => String(o || "").toLowerCase()).some((o) => o.includes(i)) : !0;
    },
    meta: {
      filterVariant: "value"
    }
  },
  {
    header: "Standard Concept",
    accessorKey: "standardConcept",
    id: "standardConcept",
    size: 150,
    enableColumnFilter: !1
  },
  {
    header: "Class",
    accessorKey: "conceptClass",
    id: "conceptClass",
    size: 120,
    enableColumnFilter: !1
  },
  {
    header: "Domain",
    accessorKey: "domain",
    id: "domain",
    size: 120,
    enableColumnFilter: !1
  },
  {
    header: "Vocabulary",
    accessorKey: "vocabulary",
    id: "vocabulary",
    size: 140,
    enableColumnFilter: !1
  },
  {
    header: "Exclude",
    accessorKey: "excluded",
    id: "excluded",
    size: 110,
    enableSorting: !1,
    enableColumnFilter: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    },
    cell: (e) => /* @__PURE__ */ a.jsx(
      Ti,
      {
        ...e,
        value: e.renderValue(),
        align: "center",
        disabled: !0
      }
    )
  },
  {
    header: "Descendants",
    accessorKey: "descendants",
    id: "descendants",
    size: 130,
    enableSorting: !1,
    enableColumnFilter: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    },
    cell: (e) => /* @__PURE__ */ a.jsx(
      Ti,
      {
        ...e,
        value: e.renderValue(),
        align: "center",
        disabled: !0
      }
    )
  },
  {
    header: "Mapped",
    accessorKey: "mapped",
    id: "mapped",
    size: 110,
    enableSorting: !1,
    enableColumnFilter: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    },
    cell: (e) => /* @__PURE__ */ a.jsx(
      Ti,
      {
        ...e,
        value: e.renderValue(),
        align: "center",
        disabled: !0
      }
    )
  },
  {
    header: "Hierarchy",
    accessorKey: "hierarchy",
    id: "hierarchy",
    size: 120,
    enableSorting: !1,
    enableColumnFilter: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    },
    cell: (e) => /* @__PURE__ */ a.jsx(
      Ti,
      {
        ...e,
        value: e.renderValue(),
        align: "center",
        disabled: !0
      }
    )
  }
], aA = (e) => {
  if (!e.length)
    return "";
  const t = "Id	Code	Name	Standard Concept	Class	Domain	Vocabulary	Exclude	Descendants	Mapped	Hierarchy", n = (i, o) => o.length ? [
    i,
    t,
    ...o.map(
      (s) => [
        s.conceptId,
        s.conceptCode,
        s.conceptName,
        s.standardConcept,
        s.conceptClass,
        s.domain,
        s.vocabulary,
        ji(s.excluded),
        ji(s.descendants),
        ji(s.mapped),
        ji(s.hierarchy)
      ].join("	")
    )
  ].join(`
`) : `${i}
[no concepts]`;
  return ["Concept Set Definitions", ...e.map((i, o) => [
    `${o + 1}. ${i.name}`,
    n("Expression", i.expressionRows)
  ].join(`

`))].join(`

`);
}, gc = (e) => {
  if (!e)
    return !1;
  const t = document.createElement("textarea");
  t.value = e, t.style.position = "fixed", t.style.left = "-9999px", document.body.appendChild(t), t.focus(), t.select();
  let n = !1;
  try {
    n = document.execCommand("copy");
  } catch {
    n = !1;
  }
  return document.body.removeChild(t), n;
}, sA = ({ conceptSet: e }) => /* @__PURE__ */ a.jsx(
  Kp,
  {
    variant: "uncontrolled",
    columns: oA,
    data: e.expressionRows,
    enableFiltering: !0,
    showFilterToggle: !0,
    filtersDefaultClosed: !0,
    noDataText: "No concept rows available."
  }
), lA = ({
  definition: e,
  printFriendlyExpression: t = ""
}) => {
  var f, h;
  const { enqueueSnackbar: n } = Xn(), r = Te(null), i = (f = e == null ? void 0 : e.name) == null ? void 0 : f.trim(), o = Z(
    () => tA(t),
    [t]
  ), s = Z(
    () => {
      var g;
      return ((g = e == null ? void 0 : e.expression) == null ? void 0 : g.ConceptSets) || [];
    },
    [(h = e == null ? void 0 : e.expression) == null ? void 0 : h.ConceptSets]
  ), l = Z(
    () => ZI.test(o),
    [o]
  ), c = s.length > 0 && !l, u = Z(
    () => c ? s.map((g, C) => {
      const I = (g || {}).expression || {}, O = iA(I == null ? void 0 : I.items);
      return {
        id: String((g == null ? void 0 : g.id) ?? `${g == null ? void 0 : g.name}-${C}`),
        name: (g == null ? void 0 : g.name) || `Concept set ${C + 1}`,
        expressionRows: O
      };
    }) : [],
    [s, c]
  ), p = Z(
    () => aA(u),
    [u]
  ), d = ie(async () => {
    var I, O;
    const g = r.current, C = ((I = g == null ? void 0 : g.innerText) == null ? void 0 : I.trim()) || "", y = [i, C, p].filter(Boolean).join(`

`).trim();
    if (!y) {
      n({
        message: "Nothing to copy.",
        variant: "warning"
      });
      return;
    }
    try {
      if ((O = navigator == null ? void 0 : navigator.clipboard) != null && O.writeText)
        await navigator.clipboard.writeText(y);
      else if (!gc(y))
        throw new Error("Copy is not supported");
      n({
        message: "Text copied to clipboard.",
        variant: "success"
      });
    } catch {
      if (gc(y)) {
        n({
          message: "Text copied to clipboard.",
          variant: "success"
        });
        return;
      }
      n({
        message: "Unable to copy text. Please copy manually.",
        variant: "error"
      });
    }
  }, [i, p, n]);
  return /* @__PURE__ */ a.jsx(W, { sx: { pr: 0 }, children: /* @__PURE__ */ a.jsxs(
    W,
    {
      sx: {
        backgroundColor: "#fff",
        border: "1px solid #d8dee9",
        borderRadius: 1,
        color: "textColor.primary"
      },
      children: [
        i && /* @__PURE__ */ a.jsxs(
          W,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3.5,
              pt: 2.5,
              pb: 2
            },
            children: [
              /* @__PURE__ */ a.jsx(
                fe,
                {
                  component: "h1",
                  variant: "h1",
                  sx: {
                    fontSize: xc,
                    fontWeight: 700,
                    lineHeight: "24px",
                    m: 0
                  },
                  children: i
                }
              ),
              /* @__PURE__ */ a.jsx(We, { text: "Copy text", placement: "left", children: /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  "aria-label": "Copy text",
                  onClick: d,
                  style: {
                    width: 38,
                    height: 38,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #D8DEE9",
                    borderRadius: 6,
                    background: "#FFFFFF",
                    color: "#1F2A44",
                    cursor: "pointer",
                    boxShadow: "0 1px 2px rgba(31, 42, 68, 0.08)"
                  },
                  children: /* @__PURE__ */ a.jsx(
                    ge,
                    {
                      iconName: "copy",
                      iconStatus: void 0,
                      ref: void 0,
                      sx: { fontSize: 18, color: "#1F2A44" }
                    }
                  )
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ a.jsx(
          W,
          {
            sx: {
              borderBottom: "1px solid #e8edf5"
            }
          }
        ),
        /* @__PURE__ */ a.jsx(
          W,
          {
            ref: r,
            sx: {
              px: 3.5,
              pt: 2.5,
              pb: 0,
              overflowX: "auto",
              fontSize: Cc,
              "& h1": {
                fontSize: xc,
                lineHeight: "24px",
                margin: "0 0 16px 0"
              },
              "& h2": { fontSize: 19, lineHeight: 1.32, margin: "24px 0 12px 0" },
              "& h3": { fontSize: 16, lineHeight: 1.35, margin: "18px 0 8px 0" },
              "& h1:first-of-type, & h2:first-of-type, & h3:first-of-type": {
                marginTop: 0
              },
              "& p": { margin: "8px 0", lineHeight: 1.5 },
              "& ol, & ul": { margin: "8px 0 8px 20px", padding: 0 },
              "& li": { marginBottom: "6px", lineHeight: 1.45 },
              "& table": {
                width: "100%",
                borderCollapse: "collapse",
                marginTop: 8,
                marginBottom: 16,
                fontSize: 14
              },
              "& th, & td": {
                border: "1px solid #d8dee9",
                padding: "8px 10px",
                textAlign: "left",
                verticalAlign: "top"
              },
              "& th": {
                backgroundColor: "#f5f7fb",
                fontWeight: 700
              },
              "& a": {
                color: "#1976d2",
                textDecoration: "underline"
              }
            },
            children: o ? eA(o) ? /* @__PURE__ */ a.jsx(
              W,
              {
                dangerouslySetInnerHTML: {
                  __html: o
                }
              }
            ) : /* @__PURE__ */ a.jsx(
              QI,
              {
                components: {
                  a: ({ node: g, ...C }) => /* @__PURE__ */ a.jsx("a", { ...C, target: "_blank", rel: "noreferrer" })
                },
                children: o
              }
            ) : /* @__PURE__ */ a.jsx(
              fe,
              {
                variant: "body2",
                color: "textColor.secondary",
                sx: {
                  fontSize: Cc,
                  lineHeight: "20px",
                  m: 0
                },
                children: "Text view is not available for this cohort yet."
              }
            )
          }
        ),
        c && /* @__PURE__ */ a.jsx(W, { sx: { px: 3.5, pb: 3.5 }, children: /* @__PURE__ */ a.jsxs(W, { sx: { mt: 4 }, children: [
          /* @__PURE__ */ a.jsx(
            fe,
            {
              component: "h2",
              variant: "h2",
              sx: { mb: 2, fontSize: 20, lineHeight: 1.3 },
              children: "Concept Set Definitions"
            }
          ),
          u.map((g, C) => {
            const y = C === u.length - 1;
            return /* @__PURE__ */ a.jsxs(
              W,
              {
                sx: { mb: y ? 0 : 1.5 },
                children: [
                  /* @__PURE__ */ a.jsxs(
                    fe,
                    {
                      variant: "h4",
                      sx: { mt: 1, mb: 0.5, fontSize: 20, lineHeight: 1.3 },
                      children: [
                        C + 1,
                        ". ",
                        g.name,
                        g.expressionRows.length ? "" : " - [no concepts]"
                      ]
                    }
                  ),
                  /* @__PURE__ */ a.jsx(sA, { conceptSet: g })
                ]
              },
              g.id
            );
          })
        ] }) })
      ]
    }
  ) });
}, cA = [
  { id: "builder", label: "Design" },
  { id: "visual", label: "Visual" },
  { id: "text", label: "Text" }
], uA = ({ tab: e, active: t }) => {
  const n = t ? "#1F2A44" : "#4F4F4F", r = {
    width: 18,
    height: 18,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { display: "block", flexShrink: 0 }
  };
  return e === "builder" ? /* @__PURE__ */ a.jsxs("svg", { ...r, "aria-hidden": "true", children: [
    /* @__PURE__ */ a.jsx(
      "rect",
      {
        x: "4",
        y: "4.5",
        width: "14",
        height: "3",
        rx: "0.7",
        stroke: n,
        strokeWidth: "2"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "rect",
      {
        x: "4",
        y: "11",
        width: "5",
        height: "5",
        rx: "0.7",
        stroke: n,
        strokeWidth: "2"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M12 11.7H17.8M12 15.4H16",
        stroke: n,
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    )
  ] }) : e === "visual" ? /* @__PURE__ */ a.jsxs("svg", { ...r, "aria-hidden": "true", children: [
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M11 6.4V10.2M7.4 15L10 12M14.6 15L12 12",
        stroke: n,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ a.jsx("circle", { cx: "11", cy: "5", r: "1.8", stroke: n, strokeWidth: "2" }),
    /* @__PURE__ */ a.jsx("circle", { cx: "6.2", cy: "16.2", r: "1.8", stroke: n, strokeWidth: "2" }),
    /* @__PURE__ */ a.jsx("circle", { cx: "15.8", cy: "16.2", r: "1.8", stroke: n, strokeWidth: "2" })
  ] }) : /* @__PURE__ */ a.jsxs("svg", { ...r, "aria-hidden": "true", children: [
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M8.2 6.7L4.5 11L8.2 15.3",
        stroke: n,
        strokeWidth: "2.2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M13.8 6.7L17.5 11L13.8 15.3",
        stroke: n,
        strokeWidth: "2.2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "path",
      {
        d: "M12.7 5.5L9.3 16.5",
        stroke: n,
        strokeWidth: "2.2",
        strokeLinecap: "round"
      }
    )
  ] });
}, qr = (e) => typeof e == "object" && e !== null, yc = (e) => e || {}, Tc = (e) => typeof e == "string" ? e : void 0, dA = (e) => typeof e == "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
  e.trim()
), Yn = (e) => {
  if (typeof e == "string") {
    const t = e.trim();
    return t.length > 0 ? t : null;
  }
  return typeof e == "number" ? String(e) : null;
}, Ln = (e) => [
  e == null ? void 0 : e.id,
  e == null ? void 0 : e.uuid,
  e == null ? void 0 : e.referenceId,
  e == null ? void 0 : e.externalId
].map(Yn).filter(Boolean), pA = (e) => {
  const t = /* @__PURE__ */ new Set(), n = (r) => {
    if (!(!r || typeof r != "object")) {
      if (Array.isArray(r)) {
        r.forEach(n);
        return;
      }
      Object.entries(r).forEach(
        ([i, o]) => {
          if (i === "CodesetId" || i === "codesetId" || i === "DrugCodesetId") {
            const s = Yn(o);
            s && s !== "-1" && t.add(s);
            return;
          }
          n(o);
        }
      );
    }
  };
  return n(e), t;
}, hA = (e) => e ? Array.isArray(e) ? e.map((t) => ({
  concept: yc(t == null ? void 0 : t.concept),
  includeDescendants: (t == null ? void 0 : t.includeDescendants) ?? (t == null ? void 0 : t.descendants) ?? !1,
  includeMapped: (t == null ? void 0 : t.includeMapped) ?? (t == null ? void 0 : t.mapped) ?? !1,
  excluded: (t == null ? void 0 : t.excluded) ?? (t == null ? void 0 : t.isExcluded) ?? !1,
  hierarchy: (t == null ? void 0 : t.hierarchy) ?? !1,
  id: Tc(t == null ? void 0 : t.id)
})) : Gc(
  e
).map((t) => ({
  concept: yc(t == null ? void 0 : t.concept),
  includeDescendants: (t == null ? void 0 : t.includeDescendants) ?? !1,
  includeMapped: (t == null ? void 0 : t.includeMapped) ?? !1,
  excluded: (t == null ? void 0 : t.isExcluded) ?? !1,
  hierarchy: (t == null ? void 0 : t.hierarchy) ?? !1,
  id: Tc(t == null ? void 0 : t.id)
})) : [], fA = (e) => {
  const t = qr(e) && qr(e.data) ? e.data : qr(e) ? e : {};
  return {
    id: typeof t.id == "string" || typeof t.id == "number" ? t.id : void 0,
    name: typeof t.name == "string" ? t.name : void 0,
    items: t.items
  };
}, mA = (e) => {
  if (!qr(e))
    return null;
  const t = e.ordinal;
  if (typeof t == "number" || typeof t == "string")
    return t;
  const n = qr(e.data) ? e.data : {}, r = n.versionOrdinal;
  if (typeof r == "number" || typeof r == "string")
    return r;
  const i = n.version;
  if (typeof i == "number" || typeof i == "string")
    return i;
  const o = e.versionOrdinal;
  if (typeof o == "number" || typeof o == "string")
    return o;
  const s = e.version;
  return typeof s == "number" || typeof s == "string" ? s : null;
}, EA = ({
  subModules: e,
  typeContainer: t,
  parentId: n,
  conceptSetId: r,
  conceptSetModulePath: i,
  onClose: o,
  onConceptSetSaved: s,
  storage: l,
  initStorage: c
}) => {
  const [u, p] = K(!0);
  return q(() => {
    const d = window.setTimeout(() => {
      p(!1);
    }, 15e3);
    return () => {
      clearTimeout(d);
    };
  }, []), /* @__PURE__ */ a.jsxs(
    W,
    {
      sx: {
        width: "100%",
        height: "100vh",
        minHeight: "100vh",
        overflow: "hidden",
        borderRadius: 1,
        backgroundColor: "#fff",
        position: "relative"
      },
      children: [
        u && /* @__PURE__ */ a.jsx(
          W,
          {
            sx: {
              position: "absolute",
              inset: 0,
              zIndex: 2,
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ a.jsx(pt, { size: 56 })
          }
        ),
        /* @__PURE__ */ a.jsx(
          W,
          {
            sx: {
              width: "100%",
              height: "100%",
              minHeight: "100%",
              overflow: "auto",
              backgroundColor: "#fff"
            },
            children: /* @__PURE__ */ a.jsx(
              e.concept,
              {
                type: "component",
                name: "concept-set-entity-embedded",
                path: i,
                title: "Concept sets",
                subModules: e,
                storage: l,
                initStorage: c,
                rootSettings: {
                  rootPath: i,
                  rootTitle: "Concept sets"
                },
                config: {
                  typeContainer: t,
                  parentId: n,
                  conceptSetId: r,
                  onCancel: o,
                  saveOnlyActions: !0,
                  onConceptSetEntityReady: () => {
                    p(!1);
                  },
                  onConceptSetEntitySaved: s
                }
              }
            )
          }
        )
      ]
    }
  );
}, Sc = (e = [], t = [], n = !1, r = !1) => {
  if (!(t != null && t.length))
    return e;
  const i = t.reduce((c, u) => {
    const p = Yn(u.externalId);
    return p && (c[p] = u), c;
  }, {}), o = /* @__PURE__ */ new Set(), s = e.map((c) => {
    const u = Yn(c == null ? void 0 : c.id), p = u ? i[u] : void 0, d = c;
    if (!p)
      return c;
    u && o.add(u);
    const f = rl(p, "currentVersionId"), h = f && p.currentVersionId ? p.currentVersionId : d.currentVersionId, g = r && !h ? p.versionId ?? d.versionId : h, C = !!g || d.currentVersionId !== void 0;
    return {
      ...c,
      referenceId: p.id,
      externalId: p.externalId,
      versionId: p.versionId ?? d.versionId,
      versionOrdinal: p.versionOrdinal ?? d.versionOrdinal,
      version: d.version,
      ...C && { currentVersionId: g },
      currentVersionOrdinal: p.currentVersionOrdinal ?? d.currentVersionOrdinal,
      terminated: !r && f ? !g : d.terminated,
      name: c.name || p.name
    };
  });
  if (!n)
    return s;
  const l = t.filter((c) => {
    const u = Yn(c.externalId);
    return u && !o.has(u);
  }).map((c) => {
    const u = rl(c, "currentVersionId"), p = u ? c.currentVersionId : void 0, d = r && !p ? c.versionId : p;
    return {
      id: c.externalId,
      name: c.name || "Archived concept set",
      expression: { items: [] },
      referenceId: c.id,
      externalId: c.externalId,
      versionId: c.versionId,
      versionOrdinal: c.versionOrdinal,
      ...(u || r) && {
        currentVersionId: d
      },
      currentVersionOrdinal: c.currentVersionOrdinal,
      terminated: !r
    };
  });
  return [...s, ...l];
}, Jo = (e = []) => Ch(
  e.map((t) => {
    const n = t;
    return {
      id: t.id,
      name: t.name,
      uuid: t.uuid,
      expression: t.expression,
      referenceId: n.referenceId,
      externalId: n.externalId,
      versionId: n.versionId,
      currentVersionId: n.currentVersionId,
      version: n.version,
      versionOrdinal: n.versionOrdinal,
      currentVersionOrdinal: n.currentVersionOrdinal,
      terminated: n.terminated
    };
  })
), Ic = (e, t) => JSON.stringify(e) === JSON.stringify(t), Or = qn({
  conceptSets: [],
  updateConceptSets: () => {
  },
  refreshConceptSetReference: async () => {
  }
}), xA = () => {
  var fs, ms, Es, xs, Cs, gs, ys;
  const { id: e } = kc(), t = Zp(), n = zc(), [r] = eh(), i = yr(), { enqueueSnackbar: o } = Xn(), [s, l] = Le.useState(""), [c, u] = K(!1), [p, d] = Le.useState({}), f = !!((fs = t.state) != null && fs.aiGenerateRequested), {
    rootSettings: h,
    path: g,
    title: C,
    config: y,
    subModules: I,
    storage: O,
    initStorage: S
  } = je(
    gn
  ), { showDialog: N, hideDialog: _ } = je(lp), { openModal: R, closeModal: P } = je(En), { rootPath: U, rootTitle: M } = h, { parentId: w, parentTitle: V, typeContainer: L, analysisTypes: te } = y, $ = Z(() => Vf(L, w), [w]), v = Z(() => Kr(y.typeContainer, y.parentId), [y.typeContainer, y.parentId]), J = Da(
    (G) => {
      var se;
      return ((se = G.user.data.moduleIds) == null ? void 0 : se.includes("ai")) ?? !1;
    }
  ), {
    entity: j,
    aiGenerate: ee,
    isAiCohort: Q,
    summary: x,
    isVersionMode: Y,
    status: k,
    aiValues: T,
    error: re,
    definition: b,
    definitionStatus: z,
    setVersionEntity: me,
    revertEntity: ae,
    deleteEntity: le,
    copyEntity: de,
    getCountsSummary: $e,
    updateDefinition: we,
    updateDefinitionBase: At,
    saveDefinition: qe,
    clearDefinition: ot,
    setDefinition: ct,
    refetchEntity: bt,
    startGeneration: Yt,
    isEqual: ce,
    actions: ne
  } = Vx($, e, "Cohort"), { start: Ue, stop: mt, status: Rt } = cp(), et = Dp({
    getMessages: cf,
    fixEntity: (G) => {
      Fx(G, j.expression, we);
    },
    fixEntityAvailability: Bx
  }), tt = vp(), F = Z(() => L === Ee.LIBRARY ? tt : !!(ne != null && ne["update.metadata"] || ne != null && ne[Ps.UPDATE]), [ne, tt, L]), H = Z(() => {
    const se = (T == null ? void 0 : T.some(Uc)) ? 1 : 0;
    return {
      ...x,
      metadata: (x.metadata || 0) + se,
      "metadata-ai": Math.max(
        (x["metadata-ai"] || 0) - se,
        0
      )
    };
  }, [T, x]), oe = Z(() => j != null && j.terminated ? !0 : L === Ee.WORKSPACE ? !1 : !(ne != null && ne[Ps.UPDATE]), [j == null ? void 0 : j.actions, ne, L]), Ce = !!(ne["update.name"] || ne["update.description"]), Oe = L === Ee.LIBRARY && r.get("from") !== Ee.LIBRARY, [Ge] = Ox(b, 1e3), Ft = () => {
    R(
      () => /* @__PURE__ */ a.jsx(
        kp,
        {
          propId: "cohortId",
          onClose: P,
          item: j,
          inviteMethod: uf
        }
      ),
      "Publish cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: P
      }
    );
  }, Pt = (G) => {
    R(
      () => /* @__PURE__ */ a.jsx(
        I.analyses,
        {
          type: "component",
          name: "create-analysis-from-cohort",
          subModules: I,
          config: {
            onCancel: P,
            entity: j,
            analysisType: G.id,
            parentId: w,
            typeContainer: L
          }
        }
      ),
      G.name,
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: P
      }
    );
  }, dn = () => {
    R(
      () => /* @__PURE__ */ a.jsx(
        Mp,
        {
          id: j.id,
          name: b.name,
          parentId: w,
          currentContainer: L,
          subModules: I,
          jsonImportTabName: "JSON",
          createCopyMethod: iC,
          entityAtlas: Ra.COHORT,
          typeEntity: "cohorts",
          defaultResolution: Fe.CREATE_NEW_OBJECT,
          hideConflictResolutionControls: !0,
          validateName: async (G) => G.typeContainer === Ee.WORKSPACE ? ur(
            Ee.WORKSPACE,
            G.name
          ) : G.typeContainer === Ee.STUDY ? G.studyId ? ur(
            Ee.STUDY,
            G.name,
            String(G.studyId)
          ) : {
            isValid: !1,
            message: "Study is required."
          } : { isValid: !0 },
          onChange: () => {
            P();
          },
          exportJson: /* @__PURE__ */ a.jsx($x, { data: b }),
          exportSql: /* @__PURE__ */ a.jsx(
            Hx,
            {
              cohortId: j.id,
              cohortName: b.name,
              cohortShortcut: j.shortcut
            }
          )
        }
      ),
      "Export cohort",
      {
        closeOnClickOutside: !0,
        onClose: P
      }
    );
  }, Ht = () => {
    R(
      () => /* @__PURE__ */ a.jsx(
        I.users,
        {
          type: "component",
          name: "share-entity",
          subModules: I,
          config: {
            ...y,
            entity: j,
            entityType: "Cohort",
            onClose: P,
            onChange: P
          }
        }
      ),
      "Share Cohort",
      {
        closeOnClickOutside: !0,
        onClose: P,
        width: "700px"
      }
    );
  }, at = () => {
    var se;
    const G = (se = T == null ? void 0 : T.find(
      (Ae) => {
        var be;
        return ((be = Ae.attribute) == null ? void 0 : be.name) == "ai-prompt";
      }
    )) == null ? void 0 : se.value;
    R(
      () => /* @__PURE__ */ a.jsx(
        zu,
        {
          parentId: y.parentId,
          typeContainer: y.typeContainer,
          entity: j,
          createMethod: v,
          onCancel: P,
          prompt: G,
          attributes: T ?? void 0,
          onGenerateStart: () => {
            Yt(), P(), o({
              message: "Cohort regenerate in progress...",
              variant: "success"
            });
          },
          onGenerateError: () => {
            bt();
          },
          afterCreate: async (Ae) => {
            Ue({
              subjectId: Ae.id
            }), bt(), await $e();
          }
        }
      ),
      "Regenerate Cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: P
      }
    );
  }, Qt = ie(() => L === Ee.STUDY ? `study-manager/${w}/concept-sets` : "workspace/concept-sets", [w, L]), dt = Z(
    () => `/${g}/${e}/concept-sets`,
    [e, g]
  ), Ci = Z(
    () => [
      "",
      "/",
      "/included",
      "/source-codes",
      "/versions",
      "/meta-attributes",
      "/ai-meta-attributes",
      "/ai-suggested",
      "/usage",
      "/statistics"
    ],
    []
  ), Qn = ie(() => {
    u(!1), P(), bt();
  }, [P, bt]);
  q(() => {
    if (!c)
      return;
    if (!t.pathname.startsWith(
      dt
    )) {
      Qn();
      return;
    }
    const be = ((t.pathname.slice(dt.length) || "").split("/modal")[0] || "").replace(/\/+$/, "") || "/";
    Ci.some(
      (Re) => {
        const Ne = Re.replace(/\/+$/, "") || "/";
        return be === Ne;
      }
    ) || Qn();
  }, [
    Ci,
    Qn,
    dt,
    c,
    t.pathname
  ]);
  const Dr = ie((G) => {
    d((se) => {
      if (!se[String(G)])
        return se;
      const Ae = { ...se };
      return delete Ae[String(G)], Ae;
    });
  }, []), nt = ie(() => {
    var ke;
    const G = ((ke = b == null ? void 0 : b.expression) == null ? void 0 : ke.ConceptSets) || [], se = /* @__PURE__ */ new Map();
    G.forEach((Re, Ne) => {
      const xe = ((Re == null ? void 0 : Re.name) || "").trim().toLowerCase();
      if (!xe)
        return;
      const De = se.get(xe) || [];
      De.push(Ne), se.set(xe, De);
    });
    const Ae = "A concept set with this name already exists. Please choose a different name.", be = {};
    return se.forEach((Re) => {
      Re.length > 1 && Re.forEach((Ne) => {
        be[String(Ne)] = Ae;
      });
    }), d((Re) => ({ ...Re, ...be })), Object.keys(be).length > 0 ? (o({
      message: "Duplicate concept set names in this cohort. Please make names unique before saving.",
      variant: "error"
    }), !1) : !0;
  }, [(ms = b == null ? void 0 : b.expression) == null ? void 0 : ms.ConceptSets, o]), Et = ie(
    async (G, se) => {
      var xe;
      const Ae = "A concept set with this name already exists. Please choose a different name.", be = se == null ? void 0 : se.trim();
      return be ? (((xe = b == null ? void 0 : b.expression) == null ? void 0 : xe.ConceptSets) || []).some((De, He) => He === G ? !1 : ((De == null ? void 0 : De.name) || "").trim().toLowerCase() === be.toLowerCase()) ? (d((De) => ({
        ...De,
        [String(G)]: Ae
      })), o({
        message: Ae,
        variant: "error"
      }), !1) : (await mx(
        L,
        be,
        w
      )).isValid ? (Dr(G), !0) : (d((De) => ({
        ...De,
        [String(G)]: Ae
      })), o({
        message: Ae,
        variant: "error"
      }), !1) : !1;
    },
    [
      Dr,
      (Es = b == null ? void 0 : b.expression) == null ? void 0 : Es.ConceptSets,
      o,
      w,
      L
    ]
  ), xt = ie(
    async (G) => {
      if (Object.keys(p).length > 0) {
        o({
          message: "Please resolve concept set name errors before saving.",
          variant: "error"
        });
        return;
      }
      if ((G == null ? void 0 : G.name) !== (j == null ? void 0 : j.name) && L !== Ee.LIBRARY) {
        const ke = await ur(
          L,
          G.name,
          w,
          j == null ? void 0 : j.id
        );
        if (!ke.isValid) {
          l(ke.message || "");
          return;
        }
      }
      nt() && (l(""), await qe({
        name: G.name,
        description: G.description
      }));
    },
    [
      j == null ? void 0 : j.id,
      j == null ? void 0 : j.name,
      p,
      w,
      qe,
      L,
      nt
    ]
  ), Kt = ie(
    (G, se, Ae, be, ke, Re, Ne) => Ff(
      G,
      se,
      {
        messages: Ae ? xh(Ae, ["messagesCnt", "severity", "isLoading"]) : null
      },
      be,
      ke,
      t,
      Re,
      Ne
    ),
    [e, Q]
  ), Ot = Z(() => {
    var G;
    return Kt(
      g,
      e,
      et,
      {
        conceptSets: (G = b == null ? void 0 : b.expression) == null ? void 0 : G.ConceptSets.length,
        ...H
      },
      oe,
      L,
      Q
    );
  }, [
    e,
    et.messagesCnt,
    et.severity,
    et.isLoading,
    b == null ? void 0 : b.expression.ConceptSets,
    H,
    g,
    oe,
    L,
    Q
  ]), [Ct, Bt] = Le.useState("builder"), yn = Z(
    () => ({
      data: b == null ? void 0 : b.expression.EndStrategy,
      update: (G) => we("EndStrategy", G),
      clear: () => ot(["EndStrategy"])
    }),
    [(xs = b == null ? void 0 : b.expression) == null ? void 0 : xs.EndStrategy]
  ), rt = Z(
    () => {
      var G;
      return {
        data: (G = b == null ? void 0 : b.expression) == null ? void 0 : G.CensoringCriteria,
        update: (se) => we("CensoringCriteria", se),
        clear: () => we("CensoringCriteria", [])
      };
    },
    [(Cs = b == null ? void 0 : b.expression) == null ? void 0 : Cs.CensoringCriteria]
  ), Zt = Z(
    () => {
      var G, se;
      return {
        dataAddition: {
          CollapseSettings: (G = b == null ? void 0 : b.expression) == null ? void 0 : G.CollapseSettings,
          CensorWindow: (se = b == null ? void 0 : b.expression) == null ? void 0 : se.CensorWindow
        },
        updateAddition: (Ae, be) => we(be, Ae)
      };
    },
    [
      (gs = b == null ? void 0 : b.expression) == null ? void 0 : gs.CensorWindow,
      (ys = b == null ? void 0 : b.expression) == null ? void 0 : ys.CollapseSettings
    ]
  ), jt = ie(
    async (G) => {
      var se;
      if (!(!(G != null && G.currentVersionId) || !((se = b == null ? void 0 : b.expression) != null && se.ConceptSets)))
        try {
          const Ae = await lu(
            G.currentVersionId
          ), be = fA(
            Ae
          ), ke = hA(
            be == null ? void 0 : be.items
          ), Re = b.expression.ConceptSets.map((xe) => String(xe == null ? void 0 : xe.id) !== String(G == null ? void 0 : G.id) ? xe : {
            ...xe,
            name: be.name ?? (xe == null ? void 0 : xe.name),
            expression: {
              ...xe == null ? void 0 : xe.expression,
              items: ke
            }
          }), Ne = ((b == null ? void 0 : b.conceptSetRefs) || []).map(
            (xe) => {
              if (String(xe.externalId) !== String(G == null ? void 0 : G.id))
                return xe;
              const De = mA(Ae) ?? xe.currentVersionOrdinal, He = G.currentVersionId || xe.currentVersionId;
              return {
                ...xe,
                name: be.name ?? xe.name,
                versionId: He,
                currentVersionId: He,
                versionOrdinal: De ?? xe.versionOrdinal,
                currentVersionOrdinal: De ?? xe.currentVersionOrdinal
              };
            }
          );
          ct({
            ...b,
            expression: {
              ...b.expression,
              ConceptSets: Re
            },
            conceptSetRefs: Ne
          });
        } catch {
          o({
            message: "Could not refresh concept set. Please try again.",
            variant: "error"
          });
        }
    },
    [b, ct, o]
  ), gt = Z(
    () => Sc(
      ws(b == null ? void 0 : b.expression.ConceptSets),
      b == null ? void 0 : b.conceptSetRefs,
      !1,
      Y
    ),
    [
      b == null ? void 0 : b.expression.ConceptSets,
      b == null ? void 0 : b.conceptSetRefs,
      Y
    ]
  ), [Tn, Sn] = Le.useState([]), Dt = Z(
    () => pA(b == null ? void 0 : b.expression),
    [b == null ? void 0 : b.expression]
  );
  q(() => {
    Sn([]);
  }, [e]);
  const In = ie(
    (G) => {
      if (Ic(
        Jo(G),
        Jo(gt)
      ))
        return;
      const se = new Set(
        G.flatMap((Ne) => Ln(Ne))
      ), Ae = new Set(
        gt.flatMap(
          (Ne) => Ln(Ne)
        )
      ), be = gt.filter((Ne) => {
        const xe = Ln(Ne), De = xe.some(
          (qt) => Dt.has(qt)
        ), He = !xe.some(
          (qt) => se.has(qt)
        );
        return De && He;
      }).map((Ne) => ({
        ...Ne,
        terminated: !0
      }));
      Sn((Ne) => {
        const xe = /* @__PURE__ */ new Map();
        return [...Ne, ...be].forEach(
          (De) => {
            const He = Ln(De), qt = He.some(
              (Ao) => Dt.has(Ao)
            ), gi = He.some(
              (Ao) => se.has(Ao)
            ), Ts = He[0];
            Ts && qt && !gi && xe.set(Ts, De);
          }
        ), Array.from(xe.values());
      });
      const ke = G.filter((Ne) => Ln(Ne).some(
        (He) => Ae.has(He)
      ) || !Ne.terminated), Re = Jo(ke);
      Ic(
        Re,
        b == null ? void 0 : b.expression.ConceptSets
      ) || we("ConceptSets", Re);
    },
    [
      gt,
      b == null ? void 0 : b.expression.ConceptSets,
      Dt,
      we
    ]
  ), pn = Z(() => {
    const G = Sc(
      ws(b == null ? void 0 : b.expression.ConceptSets),
      b == null ? void 0 : b.conceptSetRefs,
      !0,
      Y
    ), se = new Set(
      G.flatMap(
        (be) => Ln(be)
      )
    ), Ae = Tn.filter((be) => {
      const ke = Ln(be), Re = ke.some(
        (xe) => Dt.has(xe)
      ), Ne = ke.some(
        (xe) => se.has(xe)
      );
      return Re && !Ne;
    });
    return {
      conceptSets: [...G, ...Ae],
      updateConceptSets: In,
      refreshConceptSetReference: jt
    };
  }, [
    Tn,
    b == null ? void 0 : b.expression.ConceptSets,
    b == null ? void 0 : b.conceptSetRefs,
    Y,
    Dt,
    jt,
    In
  ]), Hd = ie(
    (G, se) => {
      var xe;
      if (!((xe = b == null ? void 0 : b.conceptSetRefs) != null && xe.length))
        return;
      const Ae = G.currentVersionId ?? G.versionId, be = G.currentVersionOrdinal ?? G.versionOrdinal ?? G.version;
      if (!Ae)
        return;
      const ke = /* @__PURE__ */ new Set();
      if ([se == null ? void 0 : se.externalId, G.id].forEach((De) => {
        const He = Yn(De);
        He && ke.add(He);
      }), ke.size === 0)
        return;
      let Re = !1;
      const Ne = ((b == null ? void 0 : b.conceptSetRefs) || []).map(
        (De) => {
          const He = Yn(De.externalId);
          if (!He || !ke.has(He))
            return De;
          const qt = Ae, gi = be ?? De.currentVersionOrdinal;
          return De.currentVersionId === qt && De.currentVersionOrdinal === gi ? De : (Re = !0, {
            ...De,
            currentVersionId: qt,
            currentVersionOrdinal: gi
          });
        }
      );
      Re && ct({
        ...b,
        conceptSetRefs: Ne
      });
    },
    [b, ct]
  ), wn = Z(() => {
    var ke, Re, Ne, xe, De, He, qt;
    const G = (b == null ? void 0 : b.expression.PrimaryCriteria.CriteriaList.length) + (((Re = (ke = b == null ? void 0 : b.expression) == null ? void 0 : ke.AdditionalCriteria) == null ? void 0 : Re.CriteriaList.length) || 0) + (((Ne = b == null ? void 0 : b.expression.AdditionalCriteria) == null ? void 0 : Ne.DemographicCriteriaList.length) || 0) + (((xe = b == null ? void 0 : b.expression.AdditionalCriteria) == null ? void 0 : xe.Groups.length) || 0) || 0, se = (b == null ? void 0 : b.expression.InclusionRules.length) || 0, Ae = (b == null ? void 0 : b.expression.CensoringCriteria.length) + 1 || 0, be = (((He = Object.keys(((De = b == null ? void 0 : b.expression) == null ? void 0 : De.CensorWindow) || {})) == null ? void 0 : He.length) || 0) + (((qt = b == null ? void 0 : b.expression.CollapseSettings) == null ? void 0 : qt.EraPad) > 0 ? 1 : 0);
    return {
      entryEvent: G,
      inclusion: se,
      exit: Ae,
      eras: be
    };
  }, [b]), Kn = Z(() => j != null && j.expression ? j : b, [j, b]), qd = Z(
    () => ({
      ...Kn,
      expression: {
        ...Kn == null ? void 0 : Kn.expression,
        ConceptSets: pn.conceptSets
      }
    }),
    [Kn, pn.conceptSets]
  ), Xd = Z(
    () => (b == null ? void 0 : b.printFriendlyExpression) || (j == null ? void 0 : j.printFriendlyExpression),
    [b == null ? void 0 : b.printFriendlyExpression, j == null ? void 0 : j.printFriendlyExpression]
  ), Jd = () => {
    N(Vp, {
      onSubmit: async () => {
        try {
          await le(), i(`/${g}`);
        } catch {
        }
      },
      onClose: _,
      text: "Are you sure you want to delete this cohort?",
      confirmButtonText: "DELETE",
      variant: "error"
    });
  }, Qd = _p(
    j == null ? void 0 : j.id,
    L === Ee.LIBRARY,
    g
  );
  q(() => {
    k === ue.SUCCESS && Ge && et.runCheck(Ge);
  }, [Ge, k]), q(() => {
    b != null && b.id && ee && Ue({
      subjectId: b == null ? void 0 : b.id
    });
  }, [ee, b == null ? void 0 : b.id]), q(() => {
    f && (Yt(), i(
      {
        pathname: t.pathname,
        search: t.search,
        hash: t.hash
      },
      { replace: !0, state: null }
    ));
  }, [
    f,
    t.hash,
    t.pathname,
    t.search,
    i,
    Yt
  ]), q(() => () => mt(), []), q(() => {
    let G;
    return ["DONE", "ERROR"].includes(Rt) && (G = setTimeout(() => {
      bt(Rt), mt();
    }, 3e3)), () => clearTimeout(G);
  }, [Rt]), q(() => {
    j && n(
      Th(
        Uf(e, j == null ? void 0 : j.name, {
          path: g,
          title: C,
          rootPath: U,
          rootTitle: M,
          parentTitle: V,
          parentId: w
        })
      )
    );
  }, [g, j]), q(() => {
    document.title = "Prometheus - " + M + " - Cohorts";
  }, [M]);
  const ps = r.get("from") && r.get("from") === Ee.LIBRARY, hs = e !== "new", Io = hs ? Ct : "builder";
  if (!ee && k === ue.ERROR)
    return /* @__PURE__ */ a.jsx(Xt, { children: /* @__PURE__ */ a.jsx(Np, { ...re.response, path: g }) });
  if ([ue.INITIAL, ue.IN_PROGRESS].includes(k) || [ue.INITIAL].includes(z) || ee || f) {
    const G = ee || f;
    return /* @__PURE__ */ a.jsx(
      Xt,
      {
        background: G && "/images/back.png",
        children: G ? /* @__PURE__ */ a.jsx(jc, {}) : /* @__PURE__ */ a.jsx(pt, { size: 62 })
      }
    );
  }
  return /* @__PURE__ */ a.jsxs(A, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ a.jsx(wp, { children: /* @__PURE__ */ a.jsx(
      Pp,
      {
        entity: (Y || L !== Ee.LIBRARY) && b || j,
        analysisTypes: te,
        onDelete: Jd,
        onArchive: Qd,
        onSubmit: async (G) => {
          await xt(G);
        },
        onChange: L !== Ee.LIBRARY ? (G) => {
          At({
            name: G.name,
            description: G.description
          });
        } : void 0,
        onExport: dn,
        onPublish: Ft,
        onGenerate: J && Q && L != Ee.LIBRARY ? at : null,
        onCopy: async (G) => {
          const se = await de(b);
          se != null && se.id && (i(`/${g}/${se.id}`, { replace: !0 }), $e());
        },
        onClickExtraActions: (G) => {
          Pt(G);
        },
        versionPreview: Y,
        onVersionRevert: ae,
        onVersionSave: async () => {
          await qe({
            name: b.originName
          });
        },
        disableSave: k !== ue.SUCCESS || z !== ue.SUCCESS || ce,
        viewMode: oe,
        libraryMode: Ce,
        backToListPath: ps ? "../../" : "",
        AdditionalActions: ps && /* @__PURE__ */ a.jsx(
          I.library,
          {
            type: "component",
            name: "answer-publish-widget",
            subModules: I,
            config: {
              ...y,
              type: r.get("typePublish"),
              typeEntity: ki.COHORT,
              nameEntity: j == null ? void 0 : j.name,
              id: r.get("id"),
              isRedirect: !0,
              requestStatus: r.get("status")
            }
          }
        ),
        shareable: Oe,
        onShare: Ht,
        nameError: s
      }
    ) }),
    /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 12, children: [
      /* @__PURE__ */ a.jsx(jp, { tabs: Ot, withRouting: !0, secondary: !0 }),
      /* @__PURE__ */ a.jsx(Lc, {})
    ] }),
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, py: 2, children: z === ue.SUCCESS && /* @__PURE__ */ a.jsxs(Mc, { children: [
      /* @__PURE__ */ a.jsx(
        on,
        {
          index: !0,
          element: /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsxs(W, { sx: { position: "relative" }, children: [
            hs && /* @__PURE__ */ a.jsx(
              W,
              {
                sx: {
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.25,
                  mb: 2,
                  p: 0.25,
                  border: "1px solid #D8DEE9",
                  borderRadius: "8px",
                  backgroundColor: "#F7F9FC",
                  boxShadow: "0 1px 2px rgba(31, 42, 68, 0.08)"
                },
                children: cA.map((G) => {
                  const se = Io === G.id;
                  return /* @__PURE__ */ a.jsxs(
                    "button",
                    {
                      type: "button",
                      onClick: () => Bt(G.id),
                      "aria-pressed": se,
                      "aria-label": G.label,
                      style: {
                        minWidth: 88,
                        height: 30,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                        border: "1px solid",
                        borderColor: se ? "#53A3ED" : "transparent",
                        borderRadius: 6,
                        background: se ? "#FFFFFF" : "transparent",
                        color: se ? "#1F2A44" : "#56637A",
                        fontSize: 12,
                        lineHeight: "16px",
                        fontWeight: se ? 700 : 600,
                        cursor: "pointer",
                        padding: "0 10px",
                        transition: "background 120ms ease-out, border-color 120ms ease-out, color 120ms ease-out, box-shadow 120ms ease-out",
                        whiteSpace: "nowrap",
                        userSelect: "none",
                        boxShadow: se ? "0 1px 3px rgba(31, 42, 68, 0.14)" : "none"
                      },
                      children: [
                        /* @__PURE__ */ a.jsx(
                          uA,
                          {
                            tab: G.id,
                            active: se
                          }
                        ),
                        /* @__PURE__ */ a.jsx(
                          fe,
                          {
                            component: "span",
                            sx: {
                              fontSize: "12px",
                              lineHeight: "16px",
                              fontWeight: se ? 700 : 600
                            },
                            children: G.label
                          }
                        )
                      ]
                    },
                    G.id
                  );
                })
              }
            ),
            /* @__PURE__ */ a.jsx(yi, { children: z != ue.SUCCESS || k != ue.SUCCESS ? /* @__PURE__ */ a.jsx(Pc, { children: /* @__PURE__ */ a.jsx(pt, { size: 62 }) }) : Io === "visual" ? /* @__PURE__ */ a.jsx(mg, { definition: Kn }) : Io === "text" ? /* @__PURE__ */ a.jsx(
              lA,
              {
                definition: qd,
                printFriendlyExpression: Xd
              }
            ) : /* @__PURE__ */ a.jsx(
              Or.Provider,
              {
                value: { ...pn },
                children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 2, children: [
                  /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
                    _A,
                    {
                      titleText: "Cohort Entry Event",
                      counts: wn.entryEvent,
                      className: "cohort-entry-event__block",
                      viewMode: oe,
                      primaryCriteria: b == null ? void 0 : b.expression.PrimaryCriteria,
                      additionalCriteria: b == null ? void 0 : b.expression.AdditionalCriteria,
                      qualifiedLimit: b == null ? void 0 : b.expression.QualifiedLimit,
                      update: we,
                      clear: ot
                    }
                  ) }),
                  (!oe || oe && wn.inclusion > 0) && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
                    NA,
                    {
                      titleText: "Inclusion criteria",
                      counts: wn.inclusion,
                      className: "inclusion-criteria__block",
                      viewMode: oe,
                      inclusionRules: b == null ? void 0 : b.expression.InclusionRules,
                      expressionLimit: b == null ? void 0 : b.expression.ExpressionLimit,
                      update: we,
                      clear: ot
                    }
                  ) }),
                  /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(
                    nr,
                    {
                      collapsible: !0,
                      className: "cohort-exit__block",
                      title: /* @__PURE__ */ a.jsx(
                        Jr,
                        {
                          title: "Cohort Exit",
                          count: wn.exit
                        }
                      ),
                      defaultState: oe,
                      outlined: !0,
                      children: [
                        /* @__PURE__ */ a.jsx(
                          Zx,
                          {
                            ...yn,
                            viewMode: oe
                          }
                        ),
                        (!oe || oe && wn.exit > 1) && /* @__PURE__ */ a.jsx(
                          tC,
                          {
                            ...rt,
                            viewMode: oe
                          }
                        )
                      ]
                    }
                  ) }),
                  (!oe || oe && wn.eras > 0) && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
                    nr,
                    {
                      collapsible: !0,
                      className: "cohort-eras__block",
                      title: /* @__PURE__ */ a.jsx(
                        Jr,
                        {
                          title: "Cohort Eras",
                          count: wn.eras
                        }
                      ),
                      defaultState: oe,
                      outlined: !0,
                      children: /* @__PURE__ */ a.jsx(
                        rC,
                        {
                          ...Zt,
                          viewMode: oe
                        }
                      )
                    }
                  ) })
                ] })
              }
            ) })
          ] }) })
        }
      ),
      /* @__PURE__ */ a.jsx(
        on,
        {
          path: "concept-sets/*",
          element: /* @__PURE__ */ a.jsx(
            I.concept,
            {
              type: "component",
              name: "concept-set-sections-widget-new",
              subModules: I,
              config: {
                ...y,
                onChange: pn.updateConceptSets,
                conceptSets: gt,
                conceptSetNameErrors: p,
                onConceptSetNameSubmit: Et,
                onConceptSetNameCancel: Dr,
                refreshConceptSetReference: pn.refreshConceptSetReference,
                viewMode: oe,
                exportConceptSet: !0,
                circleMode: !0,
                hideSectionContent: !0,
                hideAddConceptSetAction: !0,
                hideCopySectionAction: !0,
                renderSectionTitleAddon: (G, se, Ae) => /* @__PURE__ */ a.jsx(
                  Hn,
                  {
                    conceptSet: G,
                    viewMode: oe,
                    onRefresh: Ae == null ? void 0 : Ae.onRefreshReference,
                    marginLeft: 0
                  }
                ),
                onEditSection: (G) => {
                  const se = (G == null ? void 0 : G.externalId) ?? (G == null ? void 0 : G.id), Ae = [
                    G == null ? void 0 : G.uuid,
                    G == null ? void 0 : G.externalId,
                    G == null ? void 0 : G.id
                  ].map(
                    (Re) => typeof Re == "string" ? Re.trim() : typeof Re == "number" ? String(Re) : ""
                  ).find(dA);
                  if (!Ae) {
                    o({
                      message: "Concept set is not available for editing yet.",
                      variant: "error"
                    });
                    return;
                  }
                  const be = Qt(), ke = () => {
                    Qn();
                  };
                  u(!0), R(
                    () => /* @__PURE__ */ a.jsx(
                      EA,
                      {
                        subModules: I,
                        typeContainer: L,
                        parentId: w,
                        conceptSetId: String(Ae),
                        conceptSetModulePath: be,
                        onClose: ke,
                        onConceptSetSaved: (Re) => {
                          Hd(
                            Re,
                            {
                              externalId: se
                            }
                          );
                        },
                        storage: O,
                        initStorage: S
                      }
                    ),
                    "Concept Set",
                    {
                      closeOnClickOutside: !0,
                      width: "96vw",
                      closeOnRouteChangeOutside: `/${g}/${e}/concept-sets`,
                      onClose: ke
                    }
                  );
                }
              }
            }
          )
        }
      ),
      /* @__PURE__ */ a.jsx(
        on,
        {
          path: "messages",
          element: /* @__PURE__ */ a.jsx(yi, { children: /* @__PURE__ */ a.jsx(nr, { outlined: !0, children: /* @__PURE__ */ a.jsx(Ux, { ...et }) }) })
        }
      ),
      /* @__PURE__ */ a.jsx(
        on,
        {
          path: "versions",
          element: /* @__PURE__ */ a.jsx(yi, { children: /* @__PURE__ */ a.jsx(
            Lp,
            {
              data: b,
              path: g,
              makeCopy: () => {
              },
              setPreviewEntity: me,
              apiMethods: Bf,
              originVersionId: j.versionId
            }
          ) })
        }
      ),
      /* @__PURE__ */ a.jsx(
        on,
        {
          path: "meta-attributes",
          element: /* @__PURE__ */ a.jsx(
            Os,
            {
              id: j.id,
              name: j.name,
              metadataSubject: ki.COHORT,
              title: "Cohort",
              initialTypeContainer: L,
              initialParentId: w,
              initialParentName: V,
              getBaseUrl: (G, se) => {
                switch (G) {
                  case Ee.WORKSPACE:
                    return "/workspace/cohorts/";
                  case Ee.STUDY:
                    return `/studies/${se}/cohorts/`;
                  default:
                    return "/cohorts/";
                }
              },
              url: "cohortdefinition",
              canUpdate: F,
              configMetadataValuesApi: {
                entityFilter: "subject",
                getListValues: qi,
                updateMetadataValue: ta,
                removeMetadataValue: Bs,
                createMetadataValue: ea,
                copyMetadataValue: $s
              },
              callback: () => {
                $e();
              }
            },
            `${j.id}-metadata`
          )
        }
      ),
      /* @__PURE__ */ a.jsx(
        on,
        {
          path: "ai-meta-attributes",
          element: /* @__PURE__ */ a.jsx(
            Os,
            {
              id: j.id,
              name: j.name,
              aiMode: !0,
              metadataSubject: ki.COHORT,
              title: "Cohort",
              initialTypeContainer: L,
              initialParentId: w,
              initialParentName: V,
              getBaseUrl: (G, se) => {
                switch (G) {
                  case Ee.WORKSPACE:
                    return "/workspace/cohorts/";
                  case Ee.STUDY:
                    return `/studies/${se}/cohorts/`;
                  default:
                    return "/cohorts/";
                }
              },
              url: "cohortdefinition",
              canUpdate: F,
              configMetadataValuesApi: {
                entityFilter: "subject",
                getListValues: qi,
                updateMetadataValue: ta,
                removeMetadataValue: Bs,
                createMetadataValue: ea,
                copyMetadataValue: $s
              },
              callback: () => {
                $e();
              }
            },
            `${j.id}-aimetadata`
          )
        }
      ),
      /* @__PURE__ */ a.jsx(
        on,
        {
          path: "usage",
          element: /* @__PURE__ */ a.jsx(yi, { children: /* @__PURE__ */ a.jsx(nr, { outlined: !0, children: /* @__PURE__ */ a.jsx(
            oC,
            {
              id: j.id,
              typeContainer: L,
              parentId: w
            }
          ) }) })
        }
      ),
      /* @__PURE__ */ a.jsx(on, { path: "statistics", element: /* @__PURE__ */ a.jsx(aC, {}) })
    ] }) })
  ] });
}, gn = qn(null), CA = (e) => {
  const { path: t, title: n, name: r, rootSettings: i, initStorage: o, viewMode: s } = e, [l, c] = K(i), [u, p] = K(!0);
  return q(() => {
    i || c({
      rootPath: t,
      rootTitle: n
    }), p(!1);
  }, []), u ? /* @__PURE__ */ a.jsx(Xt, { children: /* @__PURE__ */ a.jsx(pt, { size: 32 }) }) : /* @__PURE__ */ a.jsx(gn.Provider, { value: { ...e, rootSettings: l }, children: /* @__PURE__ */ a.jsxs(Mc, { children: [
    /* @__PURE__ */ a.jsx(on, { index: !0, element: /* @__PURE__ */ a.jsx(Ax, { viewMode: s }) }),
    /* @__PURE__ */ a.jsx(on, { path: ":id/*", element: /* @__PURE__ */ a.jsx(xA, {}) })
  ] }) });
}, gA = pe.div`
  border-bottom: 1px solid #d6d4d4;
  padding-bottom: 16px;
`;
pe.div`
  font-size: 14px;
  margin-bottom: 20px;
`;
const yA = {
  title: "Initial Event",
  addCriteriaButton: "Add initial event",
  description: "Events having any of the following criteria:",
  optionsForCriteriaButton: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.OBSERVATION_PERIOD,
    D.PAYER_PLAN_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ],
  textControlTextSections: {
    observationDays: {
      startText: "with continuous observation of at least",
      type: "autocomplete",
      options: zn,
      endText: "days before"
    },
    daysAfterEvent: {
      startText: "and",
      options: zn,
      endText: "days after event index date"
    },
    limit: {
      startText: "Limit initial events to:",
      options: fr,
      endText: "per person."
    }
  }
}, TA = Ze(
  (e) => {
    const {
      data: t,
      update: n,
      viewMode: r,
      parentCriteriaElement: i,
      clearParentCriteriaElement: o
    } = e, s = je(
      Or
    ), { subModules: l, config: c } = je(
      gn
    ), u = Z(() => s, [s.conceptSets]), [p, d] = K(
      t ? t.ObservationWindow.PriorDays : void 0
    ), [f, h] = K(
      t ? t.ObservationWindow.PostDays : void 0
    ), [g, C] = K(
      t ? t.PrimaryCriteriaLimit.Type : Wt.FIRST
    ), [y, I] = K(
      Bc(t.CriteriaList)
    ), { typeContainer: O, parentId: S } = c, {
      addCriteriaButton: N,
      title: _,
      description: R,
      optionsForCriteriaButton: P,
      textControlTextSections: U
    } = yA, { observationDays: M, daysAfterEvent: w, limit: V } = U, L = Z(() => _n(
      P,
      xn
    ), [P]), te = ($) => {
      I($);
    };
    return q(() => {
      const v = {
        CriteriaList: $c(y),
        ObservationWindow: {
          PriorDays: p,
          PostDays: f
        },
        PrimaryCriteriaLimit: {
          Type: g
        }
      };
      Pe(t, v) || n(v);
    }, [y, p, f, g]), /* @__PURE__ */ a.jsx(gA, { className: "cohort-definition-initial-event__container", children: /* @__PURE__ */ a.jsxs(A, { container: !0, children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
        Ga,
        {
          viewMode: r,
          extend: !1,
          subModules: l,
          initialCriteries: y,
          addTextButton: N,
          optionsDropdown: L,
          updateModel: te,
          typeContainer: O,
          parentId: S,
          titleText: _,
          descriptionText: R,
          parentCriteriaElement: i,
          isParentCriteriaAction: !0,
          clearParentCriteriaElement: o,
          ...u
        }
      ) }),
      Object.keys(y).length > 0 && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 12, display: "flex", children: [
          /* @__PURE__ */ a.jsx(
            Ut,
            {
              viewMode: r,
              startText: M.startText,
              endText: M.endText,
              options: M.options,
              onChange: d,
              type: M.type,
              value: p
            }
          ),
          /* @__PURE__ */ a.jsx(
            Ut,
            {
              viewMode: r,
              startText: w.startText,
              endText: w.endText,
              options: w.options,
              onChange: h,
              type: M.type,
              value: f
            }
          )
        ] }),
        /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
          Ut,
          {
            viewMode: r,
            startText: V.startText,
            endText: V.endText,
            options: V.options,
            onChange: C,
            value: g
          }
        ) })
      ] })
    ] }) });
  }
), SA = {
  title: "Restrict Initial Event",
  addCriteriaButton: "Restrict Initial Event",
  textControlTextSections: {
    limit: {
      startText: "Limit initial events to:",
      options: fr,
      endText: "per person."
    }
  }
}, IA = Ze((e) => {
  var M;
  const {
    data: t,
    dataAddition: n,
    update: r,
    clear: i,
    updateAddition: o,
    parentCriteriaElement: s,
    clearParentCriteriaElement: l,
    viewMode: c = !1,
    actions: u
  } = e, p = je(
    Or
  ), { subModules: d, config: f } = je(
    gn
  ), [h, g] = K(
    (t == null ? void 0 : t.CriteriaList.length) + (t == null ? void 0 : t.DemographicCriteriaList.length) + (t == null ? void 0 : t.Groups.length) || 0
  ), [C, y] = K(
    ((M = n == null ? void 0 : n.QualifiedLimit) == null ? void 0 : M.Type) || "All"
  ), { typeContainer: I, parentId: O } = f, { title: S, addCriteriaButton: N, textControlTextSections: _ } = SA, { limit: R } = _;
  q(() => {
    o({
      Type: C
    });
  }, [C]);
  const P = (w) => {
    var V, L, te, $, v, J;
    w != null && w.CriteriaList && w.DemographicCriteriaList && (w != null && w.Groups) && g(
      (w == null ? void 0 : w.CriteriaList.length) + w.DemographicCriteriaList.length + (w == null ? void 0 : w.Groups.length)
    ), !Pe(
      {
        ...t,
        Count: t == null ? void 0 : t.Count
      },
      w
    ) && (w == null ? void 0 : w.CriteriaList.length) + w.DemographicCriteriaList.length + (w == null ? void 0 : w.Groups.length) > 0 && r && r(w), ((V = t == null ? void 0 : t.CriteriaList) == null ? void 0 : V.length) + ((L = t == null ? void 0 : t.DemographicCriteriaList) == null ? void 0 : L.length) + ((te = t == null ? void 0 : t.Groups) == null ? void 0 : te.length) > 0 && (($ = w == null ? void 0 : w.CriteriaList) == null ? void 0 : $.length) + ((v = w.DemographicCriteriaList) == null ? void 0 : v.length) + ((J = w == null ? void 0 : w.Groups) == null ? void 0 : J.length) === 0 && i();
  }, U = (w) => {
    P(w);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      A,
      {
        container: !0,
        className: "cohort-definition-restrict-initial-event__container",
        children: [
          /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 12, display: "flex", alignItems: "center", children: [
            /* @__PURE__ */ a.jsx(W, { whiteSpace: "nowrap", children: /* @__PURE__ */ a.jsx(Jr, { title: S, count: h }) }),
            u
          ] }),
          /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
            Ar,
            {
              extend: !0,
              subModules: d,
              value: t,
              updateModel: U,
              viewMode: c,
              typeContainer: I,
              parentId: O,
              addTextButton: N,
              parentCriteriaElement: s,
              clearParentCriteriaElement: l,
              hasAction: !1,
              isParentCriteriaAction: !0,
              ...p
            }
          ) })
        ]
      }
    ),
    h > 0 && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ a.jsx(
      Ut,
      {
        viewMode: c,
        startText: R.startText,
        endText: R.endText,
        options: R.options,
        onChange: y,
        value: C
      }
    ) })
  ] });
}), AA = {
  addCriteriaButton: "New inclusion criteria",
  optionsForCriteriaButton: [
    D.DEMOGRAPHIC,
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.LOCATION_REGION,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.OBSERVATION_PERIOD,
    D.PAYER_PLAN_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.GROUP
  ],
  textControlTextSections: {
    limit: {
      startText: "Limit qualifying events to:",
      options: fr,
      endText: "per person."
    }
  }
}, bA = Ze((e) => {
  var v;
  const {
    data: t,
    dataAddition: n,
    update: r,
    updateAddition: i,
    viewMode: o,
    parentCriteriaElement: s,
    clearParentCriteriaElement: l
  } = e, [c, u] = K(
    n ? (v = n.ExpressionLimit) == null ? void 0 : v.Type : "All"
  ), { openModal: p, closeModal: d } = je(En), f = je(
    Or
  ), { subModules: h, config: g } = je(
    gn
  ), C = Z(() => f, [f.conceptSets]), { typeContainer: y, parentId: I } = g, {
    addCriteriaButton: O,
    textControlTextSections: S,
    optionsForCriteriaButton: N
  } = AA, { limit: _ } = S;
  q(() => {
    s && ($(s), l());
  }, [s]), Z(() => {
    const J = _n(
      N,
      xn
    );
    return [
      {
        id: $n.ADD_NEW_SUBGROUP,
        name: "Add new criteria",
        desc: ""
      },
      {
        id: $n.CHOOSE_CRITERIA,
        name: "Choose criteria from library",
        desc: "",
        endGroup: !0
      },
      ...J.map((j) => ({
        ...j,
        name: `${j.name} criteria`,
        originalName: j.name
      }))
    ];
  }, [N]);
  const {
    sections: R,
    addSection: P,
    copySection: U,
    updateSection: M,
    removeSection: w,
    status: V
  } = Oc(t.map((J) => ({ ...J, id: Gn() })));
  q(() => {
    i && i({
      Type: c
    });
  }, [c]);
  const L = (J) => {
    p(
      () => /* @__PURE__ */ a.jsx(
        Uu,
        {
          onCLose: d,
          onChange: (j) => {
            j.forEach((ee) => {
              P({
                id: Gn(),
                name: ee.name,
                description: ee.description,
                expression: ee.expression
              });
            }), d();
          }
        }
      ),
      J.name,
      {
        onClose: d,
        closeOnClickOutside: !0
      }
    );
  }, te = (J) => {
    const j = {
      Type: "ALL",
      CriteriaList: [],
      DemographicCriteriaList: J.predefinedAttribute ? [J.predefinedAttribute] : [],
      Groups: []
    };
    return J.id === D.DEMOGRAPHIC ? (j.DemographicCriteriaList.length === 0 && j.DemographicCriteriaList.push({}), j) : J.id === D.GROUP ? (j.Groups = [{ ...j }], j) : (j.CriteriaList.push({
      Criteria: { [J.value]: {} }
    }), j);
  }, $ = (J) => {
    switch (J.id) {
      case $n.ADD_NEW_SUBGROUP:
        P({
          id: Gn(),
          name: O,
          expression: {
            Type: "ALL",
            CriteriaList: [],
            DemographicCriteriaList: [],
            Groups: []
          }
        });
        break;
      case $n.CHOOSE_CRITERIA:
        L(J);
        break;
      default:
        P({
          id: Gn(),
          name: `${O} with ${J.originalName}`,
          expression: te(J)
        });
    }
  };
  return q(() => {
    const J = R.map(
      (j) => j.description == null ? {
        name: j.name,
        expression: j.expression
      } : {
        name: j.name,
        expression: j.expression,
        description: j.description
      }
    );
    !Pe(J, t) && V === ue.SUCCESS && r(J);
  }, [R]), /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 1, className: "inclusion-criteria__block", children: [
    R.map((J, j) => /* @__PURE__ */ a.jsx(
      A,
      {
        item: !0,
        xs: 12,
        className: "cohort-definition-inclusion-criteria-data",
        children: /* @__PURE__ */ a.jsx(
          Oa,
          {
            index: j,
            item: J,
            copySection: U,
            updateSection: M,
            removeSection: w,
            viewMode: o,
            defaultState: J.defaultState,
            children: /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, mt: o ? 0 : 1, children: /* @__PURE__ */ a.jsx(
              Ar,
              {
                extend: !0,
                subModules: h,
                value: J.expression,
                updateModel: (ee) => {
                  M(j, "expression", ee);
                },
                viewMode: o,
                typeContainer: y,
                parentId: I,
                groupTitleText: "",
                isParentCriteriaAction: !1,
                hasAction: !1,
                ...C
              },
              J.id
            ) })
          },
          J.id
        )
      },
      "inclusion-criteria__" + j
    )),
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      Ut,
      {
        viewMode: o,
        startText: _.startText,
        endText: _.endText,
        options: _.options,
        onChange: u,
        value: c
      }
    ) })
  ] });
}), RA = Vc(
  [
    m.AGE_OCCURRENCE,
    m.GENDER,
    m.GENDER_CS,
    m.CONDITION_START_DATE,
    m.CONDITION_END_DATE,
    m.RACE,
    m.RACE_CS,
    m.ETHNICITY,
    m.ETHNICITY_CS
  ],
  Yc,
  []
), OA = _n(
  [D.LOCATION_REGION],
  xn
).map((e) => ({
  ...e,
  name: `${e.name}`,
  originalName: e.name
})), DA = _n(
  [
    D.CONDITION_ERA,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.OBSERVATION_PERIOD,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ],
  xn
).map((e) => ({
  ...e,
  name: `${e.name}`,
  originalName: e.name
})), vA = _n(
  [D.PAYER_PLAN_PERIOD],
  xn
).map((e) => ({
  ...e,
  name: `${e.name}`,
  originalName: e.name
})), ci = ({
  hasTemplates: e = !1,
  hideGroup: t = !1,
  isInitialEvent: n = !1,
  sx: r,
  onChange: i
}) => /* @__PURE__ */ a.jsxs(
  A,
  {
    container: !0,
    spacing: 1,
    alignItems: "baseline",
    justifyContent: "flex-end",
    lineHeight: "30px",
    py: 1,
    sx: r,
    children: [
      e && /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        Be,
        {
          onClick: (o) => {
            o.stopPropagation(), i({
              id: $n.CHOOSE_CRITERIA,
              name: "Choose criteria from library",
              desc: ""
            });
          },
          variant: "outlined",
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          name: "button-library",
          sx: { "&.MuiButton-outlined": { borderColor: "primary.main" } },
          children: "Templates"
        }
      ) }),
      !n && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        !t && /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
          Be,
          {
            onClick: (o) => {
              o.stopPropagation(), i({
                id: D.GROUP,
                name: "Group",
                desc: "",
                originalName: "Group"
              });
            },
            variant: "outlined",
            color: "primary",
            startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
            name: "button-group",
            sx: { "&.MuiButton-outlined": { borderColor: "primary.main" } },
            children: "Group"
          }
        ) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
          Rn,
          {
            variant: "contained",
            color: "info",
            options: RA,
            onClick: (o) => {
              const s = mr[o.value], l = {
                id: o.value,
                name: o.name,
                value: Zc(
                  s.type,
                  s.defaultOp
                )
              };
              i({
                id: D.DEMOGRAPHIC,
                name: "Demographics",
                desc: "",
                originalName: "Demographics",
                predefinedAttribute: {
                  [l.id]: l.value
                }
              });
            },
            name: "button-demographics",
            title: "Demographics",
            startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
            endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" }),
            closeOnSelect: !0,
            preventOverflow: !0
          }
        ) }),
        /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
          Rn,
          {
            variant: "contained",
            color: "info",
            options: OA,
            onClick: i,
            name: "button-health-system",
            title: "Health System",
            startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
            endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" }),
            closeOnSelect: !0,
            preventOverflow: !0
          }
        ) })
      ] }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        Rn,
        {
          variant: "contained",
          color: "info",
          options: DA,
          onClick: i,
          title: "Clinical Events",
          name: "Clinical events",
          closeOnSelect: !0,
          preventOverflow: !0,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" })
        }
      ) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(
        Rn,
        {
          variant: "contained",
          color: "info",
          options: vA,
          onClick: i,
          title: "Health economics",
          name: "Health economics",
          closeOnSelect: !0,
          preventOverflow: !0,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          endIcon: /* @__PURE__ */ a.jsx(ge, { fontSize: "small", iconName: "chevronFilled" })
        }
      ) })
    ]
  }
), $d = (e) => {
  const { titleText: t, counts: n, viewMode: r, children: i, className: o, actions: s } = e;
  return /* @__PURE__ */ a.jsx(
    nr,
    {
      collapsible: !0,
      className: o,
      title: /* @__PURE__ */ a.jsx(Jr, { title: t, count: n }),
      actions: r ? /* @__PURE__ */ a.jsx(a.Fragment, {}) : s,
      outlined: !0,
      elevated: !0,
      children: i
    }
  );
}, _A = (e) => {
  var g, C, y;
  const {
    primaryCriteria: t,
    additionalCriteria: n,
    qualifiedLimit: r,
    update: i,
    clear: o,
    viewMode: s,
    ...l
  } = e, [c, u] = K(), [p, d] = K(), f = Z(
    () => ({
      data: t,
      update: (I) => i("PrimaryCriteria", I),
      clear: () => i("PrimaryCriteria", Nh)
    }),
    [t]
  ), h = Z(
    () => ({
      data: n,
      dataAddition: {
        QualifiedLimit: r
      },
      update: (I) => i("AdditionalCriteria", I),
      updateAddition: (I) => i("QualifiedLimit", I),
      clear: () => o(["AdditionalCriteria", "QualifiedLimit"])
    }),
    [n, r]
  );
  return /* @__PURE__ */ a.jsx(
    $d,
    {
      ...l,
      viewMode: s,
      actions: /* @__PURE__ */ a.jsx(
        ci,
        {
          isInitialEvent: !0,
          onChange: u
        }
      ),
      children: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx(
          TA,
          {
            ...f,
            viewMode: s,
            parentCriteriaElement: c,
            clearParentCriteriaElement: () => {
              u(null);
            }
          }
        ),
        (!s || s && ((g = h.data) == null ? void 0 : g.CriteriaList.length) + ((C = h.data) == null ? void 0 : C.DemographicCriteriaList.length) + ((y = h.data) == null ? void 0 : y.Groups.length) > 0) && /* @__PURE__ */ a.jsx(
          IA,
          {
            ...h,
            viewMode: s,
            parentCriteriaElement: p,
            actions: !s && /* @__PURE__ */ a.jsx(
              ci,
              {
                onChange: d
              }
            ),
            clearParentCriteriaElement: () => {
              d(null);
            }
          }
        )
      ] })
    }
  );
}, NA = (e) => {
  const {
    inclusionRules: t,
    expressionLimit: n,
    update: r,
    clear: i,
    viewMode: o,
    ...s
  } = e, [l, c] = K(), u = Z(
    () => ({
      data: t,
      dataAddition: {
        ExpressionLimit: n
      },
      update: (p) => r("InclusionRules", p),
      updateAddition: (p) => r("ExpressionLimit", p),
      clear: () => r("InclusionRules", [])
    }),
    [t, n]
  );
  return /* @__PURE__ */ a.jsx(
    $d,
    {
      ...s,
      viewMode: o,
      actions: /* @__PURE__ */ a.jsx(ci, { hasTemplates: !0, onChange: c }),
      children: /* @__PURE__ */ a.jsx(
        bA,
        {
          ...u,
          viewMode: o,
          parentCriteriaElement: l,
          clearParentCriteriaElement: () => c(null)
        }
      )
    }
  );
}, wA = (e) => {
  const {
    values: t,
    addCriteriaButton: n,
    title: r,
    contextConceptSets: i,
    viewMode: o = !1,
    onChange: s,
    typeContainer: l,
    subModules: c,
    parentId: u,
    isDesignStrata: p,
    strataParams: d,
    onChangeStrataOnly: f,
    onChangeStrataBy: h,
    hiddenParentConcept: g,
    hideIgnoreObservationPeriod: C,
    hideOccurrence: y,
    renderSectionContentBeforeCriteria: I,
    useCohortSectionButtons: O,
    hideCriteriaGroupHeader: S,
    hideTopLevelCriteriaControls: N,
    criteriaSectionsSx: _,
    criteriaButtonsSx: R
  } = e, { openModal: P, closeModal: U } = je(En), [M, w] = K(
    d || {
      stratifiedBy: "",
      strataOnly: !1
    }
  ), {
    isStartHook: V,
    sections: L,
    addSection: te,
    copySection: $,
    updateSection: v,
    removeSection: J
  } = Oc(t), j = (x) => {
    switch (x.id) {
      case $n.ADD_NEW_SUBGROUP:
        te({
          id: Gn(),
          name: n,
          expression: {
            Type: "ALL",
            CriteriaList: [],
            DemographicCriteriaList: [],
            Groups: []
          }
        });
        break;
      case $n.CHOOSE_CRITERIA:
        Q(x);
        break;
      default:
        te({
          id: Gn(),
          name: `${n} with ${x.originalName}`,
          expression: ee(x)
        });
        break;
    }
  }, ee = (x) => {
    const Y = {
      Type: "ALL",
      CriteriaList: [],
      DemographicCriteriaList: x.predefinedAttribute ? [x.predefinedAttribute] : [],
      Groups: []
    };
    return x.id === D.DEMOGRAPHIC ? (Y.DemographicCriteriaList.length === 0 && Y.DemographicCriteriaList.push({}), Y) : (Y.CriteriaList.push({
      Criteria: { [x.value]: {} }
    }), Y);
  }, Q = (x) => {
    P(
      () => /* @__PURE__ */ a.jsx(
        Uu,
        {
          onCLose: U,
          onChange: (Y) => {
            Y.forEach((k) => {
              te({
                name: k.name,
                description: k.description,
                expression: k.expression
              });
            }), U();
          }
        }
      ),
      x.name,
      {
        onClose: U,
        closeOnClickOutside: !0
      }
    );
  };
  return q(() => {
    V && !Pe(L, t) && (L.length === 0 && w({
      stratifiedBy: "",
      strataOnly: !1
    }), s(L));
  }, [L]), q(() => {
    M.stratifiedBy !== (d == null ? void 0 : d.stratifiedBy) && (h == null || h(M.stratifiedBy));
  }, [M.stratifiedBy]), q(() => {
    M.strataOnly !== (d == null ? void 0 : d.strataOnly) && (f == null || f(M.strataOnly));
  }, [M.strataOnly]), /* @__PURE__ */ a.jsxs(Le.Fragment, { children: [
    !S && /* @__PURE__ */ a.jsx(fx, { children: /* @__PURE__ */ a.jsxs(A, { container: !0, py: 1, alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 5, children: /* @__PURE__ */ a.jsx(hx, { className: "criteria-title", children: r }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 7, textAlign: "right", className: "criteria-action", children: !o && (O ? /* @__PURE__ */ a.jsx(
        ci,
        {
          hideGroup: !0,
          onChange: (x) => {
            j(x);
          }
        }
      ) : /* @__PURE__ */ a.jsx(
        Rn,
        {
          variant: "contained",
          color: "info",
          options: hp,
          onClick: (x) => {
            j(x);
          },
          title: n,
          name: n,
          closeOnSelect: !0,
          preventOverflow: !0,
          startIcon: /* @__PURE__ */ a.jsx(
            ge,
            {
              iconName: "add",
              sx: { "&.MuiSvgIcon-root": { fontSize: 16 } }
            }
          )
        }
      )) })
    ] }) }),
    S && O && !o && /* @__PURE__ */ a.jsx(
      ci,
      {
        hideGroup: !0,
        sx: R,
        onChange: (x) => {
          j(x);
        }
      }
    ),
    p && L.length > 0 && /* @__PURE__ */ a.jsxs(A, { container: !0, py: 1, spacing: 1, className: "criteria-content", children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(ze, { name: "stratifiedBy", textLabel: "Stratified by", children: /* @__PURE__ */ a.jsx(
        Ye,
        {
          id: "stratifiedBy",
          name: "stratifiedBy",
          type: "text",
          size: "medium",
          placeholder: "Enter stratified by",
          value: M.stratifiedBy,
          onChange: (x) => {
            w({
              ...M,
              stratifiedBy: x.target.value
            });
          },
          fullWidth: !0,
          disabled: o
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
        ze,
        {
          name: "strataOnly",
          textLabel: "Calculate subgroup analyses only",
          inline: !0,
          children: /* @__PURE__ */ a.jsx(
            hr,
            {
              name: "strataOnly",
              id: "strataOnly",
              onChange: () => {
                w({
                  ...M,
                  strataOnly: !M.strataOnly
                });
              },
              sx: { ml: 1 },
              checked: M.strataOnly,
              disabled: o
            }
          )
        }
      ) })
    ] }),
    /* @__PURE__ */ a.jsx(
      A,
      {
        container: !0,
        spacing: _ ? 0 : 1,
        sx: _,
        children: L.map((x, Y) => /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(
          Oa,
          {
            index: Y,
            item: x,
            copySection: $,
            updateSection: v,
            removeSection: J,
            viewMode: o,
            defaultState: x.defaultState,
            children: [
              I == null ? void 0 : I({
                section: x,
                sectionId: Y,
                updateSection: v
              }),
              /* @__PURE__ */ a.jsx(
                Ar,
                {
                  extend: !0,
                  subModules: c,
                  value: x.expression,
                  updateModel: (k) => {
                    v(Y, "expression", k);
                  },
                  viewMode: o,
                  typeContainer: l,
                  parentId: u,
                  hiddenParentConcept: g,
                  hideIgnoreObservationPeriod: C,
                  hideOccurrence: y,
                  hideCriteriaControls: N,
                  hasAction: !1,
                  ...i
                }
              )
            ]
          }
        ) }, x.id ?? x.uuid ?? Y))
      }
    ),
    Object.keys(L).length > 0 && /* @__PURE__ */ a.jsx(A, { container: !0, children: /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12 }) })
  ] });
}, PA = () => {
  const e = yr(), { openModal: t, closeModal: n } = Le.useContext(En), { enqueueSnackbar: r } = Xn(), i = (o) => {
    o.stopPropagation(), t(
      () => /* @__PURE__ */ a.jsx(
        Gu,
        {
          typeContainer: Ee.WORKSPACE,
          createMethod: co,
          onCancel: n,
          afterCreate: (s) => {
            r({
              message: "Cohort created successfullly",
              variant: "success"
            }), e(`/workspace/cohorts/${s.id}`), n();
          }
        }
      ),
      "Add cohort",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ a.jsx(
    Up,
    {
      title: "Cohorts",
      description: "Cohort is a set of persons who satisfy one or more inclusion and/or exclusion criteria for a duration of time.",
      iconName: "cohorts",
      onCardClick: () => e("/workspace/cohorts"),
      children: /* @__PURE__ */ a.jsx(A, { item: !0, width: 90, textAlign: "right", children: /* @__PURE__ */ a.jsx(
        Be,
        {
          onClick: i,
          variant: "contained",
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "add" }),
          color: "info",
          name: "save",
          children: "Create"
        }
      ) })
    }
  );
};
var Bn = /* @__PURE__ */ ((e) => (e.INITIAL_EVENT = "PrimaryCriteria", e.RESTRICT_INITIAL_EVENT = "AdditionalCriteria", e.INCLUSION_CRITERIA = "InclusionRules", e.EVENT_PERSISTENCE = "EndStrategy", e.CENSORING_EVENT = "CensoringCriteria", e))(Bn || {});
const Ac = [
  {
    value: "PrimaryCriteria",
    name: "Initial Event"
  },
  {
    value: "AdditionalCriteria",
    name: "Restrict Initial Event"
  },
  {
    value: "InclusionRules",
    name: "Inclusion criteria"
  },
  {
    value: "EndStrategy",
    name: "Event persistence"
  },
  {
    value: "CensoringCriteria",
    name: "Censoring event"
  }
], jA = {
  PrimaryCriteria: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ],
  AdditionalCriteria: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.LOCATION_REGION,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT
  ],
  InclusionRules: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.LOCATION_REGION,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT
  ],
  CensoringCriteria: [
    D.CONDITION_ERA,
    D.CONDITION_OCCURRENCE,
    D.DEATH,
    D.DEVICE_EXPOSURE,
    D.DOSE_ERA,
    D.DRUG_ERA,
    D.DRUG_EXPOSURE,
    D.MEASUREMENT,
    D.OBSERVATION,
    D.PROCEDURE_OCCURRENCE,
    D.SPECIMEN,
    D.VISIT,
    D.VISIT_DETAILS
  ],
  EndStrategy: []
}, LA = {
  CriteriaList: [],
  ObservationWindow: {
    PriorDays: 0,
    PostDays: 0
  },
  PrimaryCriteriaLimit: {
    Type: Wt.FIRST
  }
}, kA = {
  Type: "ALL",
  CriteriaList: [],
  DemographicCriteriaList: [],
  Groups: []
}, Gd = (e, t) => ({
  ...kA,
  CriteriaList: e.map((r) => ({
    Criteria: {
      [r]: {
        CodesetId: t
      }
    }
  }))
}), MA = (e, t, n) => {
  const r = e.filter(
    (i) => !n.CriteriaList.find((o) => o.Criteria[i])
  );
  return {
    ...n,
    CriteriaList: [
      ...n.CriteriaList,
      ...r.map((i) => ({
        Criteria: {
          [i]: {
            CodesetId: t
          }
        }
      }))
    ]
  };
}, VA = (e, t) => ({
  ...LA,
  CriteriaList: e.map((r) => ({
    [r]: {
      CodesetId: t
    }
  }))
}), UA = (e, t, n) => ({
  name: e.name,
  description: e.description,
  expression: Gd(t, n)
}), FA = (e, t) => e.map((n) => ({
  [n]: {
    CodesetId: t
  }
})), BA = (e) => ({
  CustomEra: {
    DrugCodesetId: e,
    GapDays: 0,
    Offset: 0
  }
}), $A = (e, t, n) => {
  const r = e || {
    PrimaryCriteria: {
      CriteriaList: [],
      ObservationWindow: {
        PriorDays: 0,
        PostDays: 0
      },
      PrimaryCriteriaLimit: {
        Type: Wt.FIRST
      }
    },
    QualifiedLimit: {
      Type: Wt.FIRST
    },
    ExpressionLimit: {
      Type: Wt.FIRST
    },
    InclusionRules: [],
    CensoringCriteria: [],
    CollapseSettings: {
      CollapseType: "ERA",
      EraPad: void 0
    },
    CensorWindow: {
      StartDate: null,
      EndDate: null
    },
    ConceptSets: []
  }, i = {
    id: Gn(),
    name: n.name,
    expression: {
      items: Gc(n.items)
    }
  };
  switch (r.ConceptSets.push(i), t.attribute) {
    case Bn.INITIAL_EVENT:
      {
        const o = VA(
          Object.keys(t.criteries),
          i.id
        );
        r[t.attribute].CriteriaList = [
          ...r[t.attribute].CriteriaList,
          ...o.CriteriaList
        ];
      }
      break;
    case Bn.RESTRICT_INITIAL_EVENT:
      r[t.attribute] ? r[t.attribute] = MA(
        Object.keys(t.criteries),
        i.id,
        r[t.attribute]
      ) : r[t.attribute] = Gd(
        Object.keys(t.criteries),
        i.id
      );
      break;
    case Bn.INCLUSION_CRITERIA:
      {
        const o = UA(
          t.criteries,
          Object.keys(t.criteries).filter(
            (s) => !["name", "description"].includes(s)
          ),
          i.id
        );
        r[t.attribute].push(o);
      }
      break;
    case Bn.CENSORING_EVENT:
      {
        const o = FA(
          Object.keys(t.criteries),
          i.id
        );
        r[t.attribute] = [...r[t.attribute], ...o];
      }
      break;
    case Bn.EVENT_PERSISTENCE:
      r[t.attribute] = BA(i.id);
      break;
  }
  return r;
}, GA = {
  form: {
    entityId: void 0,
    title: void 0,
    section: void 0,
    attribute: void 0,
    studyId: void 0,
    typeContainer: void 0,
    createNew: !1,
    cohort: void 0,
    criteries: []
  },
  fetchStatus: ue.INITIAL,
  analysisList: [],
  status: ue.INITIAL
}, zA = (e, t) => ui(e, (n) => {
  switch (t.type) {
    case "INIT":
      n.form = t.payload;
      break;
    case "UPDATE":
      n.form[t.payload.prop] = t.payload.value;
      break;
    case "FETCH_ANAKYSES":
      n.fetchStatus = ue.IN_PROGRESS, n.form.cohort = void 0, n.analysisList = [];
      break;
    case "FETCH_ANAKYSES_DONE":
      n.fetchStatus = ue.SUCCESS, n.analysisList = t.payload;
      break;
    case "FETCH_ANAKYSES_FAILED":
      n.fetchStatus = ue.ERROR;
      break;
    case "SAVE_PROGRESS":
      n.status = ue.IN_PROGRESS;
      break;
    case "SAVE_DONE":
      n.status = ue.SUCCESS, n.form.cohort = t.payload;
      break;
  }
}), WA = (e, t) => {
  const [n, r] = xr(zA, GA), i = (c) => {
    r({
      type: "INIT",
      payload: c
    });
  }, o = ie(async () => {
    r({
      type: "SAVE_PROGRESS"
      /* SAVE_PROGRESS */
    });
    const c = Kr(
      n.form.typeContainer,
      n.form.studyId
    );
    try {
      const u = n.form.createNew ? await c({
        name: n.form.title,
        description: n.form.description,
        studyId: n.form.studyId
      }) : await Hi(n.form.cohort.id), p = $A(
        u == null ? void 0 : u.expression,
        n.form,
        t
      ), d = await lo(u.id, {
        ...u,
        expression: {
          ...p
        }
      });
      r({
        type: "SAVE_DONE",
        payload: d
      });
    } catch {
    }
  }, [n.form]), s = ie(async () => {
    const c = Ji(
      n.form.typeContainer,
      n.form.studyId
    );
    r({
      type: "FETCH_ANAKYSES"
      /* FETCH_ANALYSES */
    });
    try {
      const u = await c.fetch(0, 1e5);
      r({
        type: "FETCH_ANAKYSES_DONE",
        payload: u.content
      });
    } catch {
      r({
        type: "FETCH_ANAKYSES_FAILED"
        /* FETCH_ANALYSES_FAILED */
      });
    }
  }, [n.form.typeContainer, n.form.studyId, n.form.type]), l = (c, u) => {
    r({
      type: "UPDATE",
      payload: {
        prop: c,
        value: u
      }
    });
  };
  return q(() => {
    i(e);
  }, []), q(() => {
    n.form.typeContainer && s();
  }, [n.form.typeContainer, n.form.studyId, n.form.type]), {
    ...n,
    updateForm: l,
    saveCohort: o
  };
}, YA = (e) => {
  const { attribute: t, defaultValues: n, onChange: r } = e, [i, o] = K({}), [s, l] = K(!1), c = Z(() => _n(
    jA[t],
    xn
  ), [t]);
  return q(() => {
    l(!0), setTimeout(() => {
      l(!1), o({});
    }, 400);
  }, [t]), q(() => {
    r(i);
  }, [i]), /* @__PURE__ */ a.jsx(gr, { children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 2, p: 2, children: [
    t === Bn.INCLUSION_CRITERIA && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 6, children: /* @__PURE__ */ a.jsx(ze, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ a.jsx(
        Ye,
        {
          id: "name",
          name: "name",
          type: "text",
          size: "medium",
          value: i.name,
          placeholder: "Enter name",
          onChange: (u) => o({ ...i, name: u.target.value }),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(ze, { name: "description", textLabel: "Description", children: /* @__PURE__ */ a.jsx(
        Ye,
        {
          id: "description",
          name: "description",
          type: "text",
          size: "medium",
          value: i.description,
          placeholder: "Enter description",
          onChange: (u) => o({ ...i, description: u.target.value }),
          fullWidth: !0
        }
      ) }) })
    ] }),
    s ? /* @__PURE__ */ a.jsx(Xt, { children: /* @__PURE__ */ a.jsx(pt, { size: 32 }) }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: c == null ? void 0 : c.map((u) => /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 6, children: [
      /* @__PURE__ */ a.jsx(
        hr,
        {
          name: u.value,
          onChange: () => {
            o({
              ...i,
              [u.value]: !i[u.value]
            });
          },
          checked: i[u.value]
        }
      ),
      /* @__PURE__ */ a.jsx(fe, { sx: { marginLeft: "10px" }, variant: "caption", children: u.name })
    ] }, u.value)) })
  ] }) });
}, HA = (e) => {
  const { entity: t, onCancel: n, subModules: r, typeContainer: i, parentId: o } = e, s = yr(), { enqueueSnackbar: l } = Xn(), { form: c, analysisList: u, updateForm: p, saveCohort: d, status: f, fetchStatus: h } = WA(
    {
      title: t.name,
      description: t.description,
      attribute: void 0,
      studyId: o,
      typeContainer: i,
      createNew: !1
    },
    t
  ), g = ie(async () => {
    if (c.createNew) {
      const C = await ur(
        c.typeContainer,
        c.title,
        c.studyId
      );
      if (!C.isValid) {
        l({
          message: C.message || "Warning! Name is already used by another object.",
          variant: "error"
        });
        return;
      }
    }
    await d();
  }, [c, d, l]);
  return q(() => {
    f === ue.SUCCESS && (l({
      message: `Created cohort ${c.cohort.name} with concept set ${t.name}`,
      variant: "success"
    }), s(
      c.typeContainer === Ee.WORKSPACE ? `workspace/cohorts/${c.cohort.id}` : `study-manager/${c.studyId}/cohorts/${c.cohort.id}`
    ), n());
  }, [f]), c.typeContainer ? /* @__PURE__ */ a.jsx(A, { container: !0, p: 2, children: /* @__PURE__ */ a.jsx(gr, { children: /* @__PURE__ */ a.jsxs(A, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(fe, { variant: "h3", children: "Container:" }) }),
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(ze, { name: "typeContainer", textLabel: "Add to", required: !0, children: /* @__PURE__ */ a.jsx(
      It,
      {
        className: "",
        name: "typeContainer",
        disablePortal: !0,
        id: "typeContainer",
        options: fp.filter((C) => C.value !== "ATLAS"),
        value: c.typeContainer,
        placeholder: "Select type",
        onChange: (C) => {
          p("typeContainer", C);
        },
        fullWidth: !0
      }
    ) }) }),
    c.typeContainer === Ee.STUDY && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      r.study,
      {
        type: "component",
        name: "user-studies-list",
        subModules: r,
        config: {
          onChange: (C) => {
            C && p("studyId", C.id);
          },
          analysisMode: !0,
          studyInitialId: o
        }
      }
    ) }),
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(fe, { variant: "h3", children: "Cohort:" }) }),
    /* @__PURE__ */ a.jsxs(A, { item: !0, xs: 12, children: [
      /* @__PURE__ */ a.jsx(
        hr,
        {
          name: "createNew",
          onChange: () => {
            p("createNew", !c.createNew);
          },
          checked: c.createNew
        }
      ),
      /* @__PURE__ */ a.jsx(fe, { sx: { marginLeft: "5px" }, variant: "caption", children: "Create New Cohort" })
    ] }),
    c.createNew && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(ze, { name: "title", textLabel: "Title", required: !0, children: /* @__PURE__ */ a.jsx(
      Ye,
      {
        id: "title",
        name: "title",
        type: "text",
        size: "medium",
        value: c.title,
        placeholder: "Enter title",
        onChange: (C) => p("title", C.target.value),
        fullWidth: !0
      }
    ) }) }),
    !c.createNew && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: [ue.INITIAL, ue.IN_PROGRESS].includes(h) ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, mb: 0.5, children: /* @__PURE__ */ a.jsx(_s, { height: 15, width: 50 }) }),
      /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(_s, { height: 30, width: "100%" }) })
    ] }) : /* @__PURE__ */ a.jsx(ze, { name: "cohort", textLabel: "Cohort", required: !0, children: /* @__PURE__ */ a.jsx(
      Gi,
      {
        className: "",
        name: "cohort",
        id: "cohort",
        options: u,
        value: c.cohort,
        placeholder: "Select cohort...",
        fullWidth: !0,
        isOptionEqualToValue: (C, y) => {
          var I;
          return C.id === ((I = y.cohort) == null ? void 0 : I.id);
        },
        onChange: (C, y) => {
          p("cohort", y);
        },
        getOptionLabel: (C) => C.name
      }
    ) }) }),
    Ac.length > 0 && /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsx(
      ze,
      {
        name: "templateProp",
        textLabel: "Template attribute",
        required: !0,
        children: /* @__PURE__ */ a.jsx(
          It,
          {
            className: "",
            name: "templateProp",
            disablePortal: !0,
            id: "templateProp",
            options: Ac,
            value: c.attribute,
            placeholder: "Select attribute",
            onChange: (C) => {
              p("attribute", C);
            },
            fullWidth: !0
          }
        )
      }
    ) }),
    c.attribute && /* @__PURE__ */ a.jsx(
      YA,
      {
        attribute: c.attribute,
        onChange: (C) => {
          p("criteries", C);
        }
      }
    ),
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(oo, { children: [
      /* @__PURE__ */ a.jsx(
        Be,
        {
          variant: "outlined",
          onClick: n,
          startIcon: /* @__PURE__ */ a.jsx(ge, { iconName: "deactivate" }),
          name: "cancel",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ a.jsx(
        Be,
        {
          disabled: (c.createNew ? fn(c.title) : fn(c.cohort)) || fn(c.typeContainer) || fn(c.attribute) || f === ue.IN_PROGRESS,
          onClick: g,
          variant: "contained",
          color: "success",
          startIcon: f === ue.IN_PROGRESS ? /* @__PURE__ */ a.jsx(pt, { size: 16 }) : /* @__PURE__ */ a.jsx(ge, { iconName: "submit" }),
          name: "save",
          children: "Add"
        }
      )
    ] }) })
  ] }) }) }) : /* @__PURE__ */ a.jsx(Pc, { children: /* @__PURE__ */ a.jsx(pt, { size: 62 }) });
}, qA = (e) => {
  var n, r;
  let t = `having ${(n = Ko.find((i) => i.value === e.Type)) == null ? void 0 : n.name} ${e.Count} `;
  return e.IsDistinct && (t = `${t} distinct ${(r = Zo.find((i) => i.value === e.CountColumn)) == null ? void 0 : r.name} from `), t;
}, bc = (e) => {
  var o, s;
  const { Start: t, End: n } = e, r = e.UseEventEnd ? "ending" : "starting", i = e.UseIndexEnd ? "cohort entry end date" : "cohort entry start date";
  return !t.Days && !n.Days ? "" : `${r} between ${t.Days} days ${(o = or.find((l) => l.value === t.Coeff)) == null ? void 0 : o.name} and 
  ${n.Days} days ${(s = or.find((l) => l.value === t.Coeff)) == null ? void 0 : s.name} ${i}`;
}, XA = (e, t, n, r) => {
  const i = bc(e), o = t ? bc(t) : "";
  return !i && !o ? "" : ` ${i}${i ? ", " : ""}${o}${i && o && (r || n) ? ", " : ""}${r ? "at same visit as cohort entry" : ""} ${r && n ? "and" : ""} ${n ? "allow events outside observation period" : ""}`;
}, io = (e) => {
  var t;
  return (t = fr.find((n) => n.value === e)) == null ? void 0 : t.name;
}, us = (e = [], t, n = "invalid drug specified") => {
  var r;
  return t >= 0 && e.length > 0 ? `'${(r = e.find((i) => i.id === t)) == null ? void 0 : r.name}'` : n;
}, JA = (e) => e ? `forcing drug exposure days supply to: ${e} ${e > 1 ? "days" : "day"}.` : "using days supply and exposure end date for exposure duration.", QA = (e, t) => {
  var n;
  if (!e)
    return "The person exits the cohort at the end of continuous observation.";
  if (e.DateOffset)
    return `The cohort end date will be offset from index event's ${(n = Hc.find((r) => r.value === e.DateOffset.DateField)) == null ? void 0 : n.name} plus ${e.DateOffset.Offset} days`;
  if (e.CustomEra)
    return `The cohort end date will be based on a continuous exposure to 
      ${us(
      t,
      e.CustomEra.DrugCodesetId
    )}:
      allowing ${e.CustomEra.GapDays} days between exposures, adding ${e.CustomEra.Offset} 
      days after exposure ends, and ${JA(
      e.CustomEra.DaysSupplyOverride
    )}
      `;
}, KA = (e, t) => [ye.BETWEEN, ye.NOT_BETWEEN].includes(t.Op) ? `${e.viewModeTextStart || ""} ${Rs[t.Op]} ${t.Value} and ${t.Extent}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}` : `${e.viewModeTextStart || ""} ${Rs[t.Op]} ${t.Value}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}`, ZA = (e, t) => {
  let n = "";
  const r = t.map((o) => o.CONCEPT_NAME), i = r.length > 1 ? r.pop() : void 0;
  return n = r.join(", "), i ? n = `${e.viewModeTextStart || ""} ${n} or ${i}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}` : n = `${e.viewModeTextStart || ""} ${n}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}`, n;
}, eb = (e, t) => [ye.BETWEEN, ye.NOT_BETWEEN].includes(t.Op) ? `${e.viewModeTextStart || ""} ${bs[t.Op]} ${t.Value} and ${t.Extent}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}` : `${e.viewModeTextStart || ""} ${bs[t.Op]} ${t.Value}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}`, tb = (e, t) => `${e.viewModeTextStart || ""} ${mp[t.Op]} ${t.Text}${e.viewModeTextEnd ? " " + e.viewModeTextEnd : ""}`, Rc = (e, t) => {
  switch (e.type) {
    case B.DATE:
      return KA(e, t);
    case B.VOCABULARY:
      return ZA(e, t);
    case B.VALUE:
      return eb(e, t);
    case B.TEXT:
      return tb(e, t);
  }
}, nb = (e, t, n) => {
  let r = " who are ";
  return e.type === B.BOOL ? r = ` ${e.startText} ${r}` : r = n == 0 ? `${r} ${Rc(e, t)}` : `${Rc(e, t)};`, r;
}, rb = (e) => {
  const { details: t, attr: n, index: r, setConcept: i, conceptSetAttrName: o } = e;
  return q(() => {
    t.type === B.DROPDOWN && i((s) => [...s, o]);
  }, []), t.type === B.DROPDOWN ? /* @__PURE__ */ a.jsx(a.Fragment, {}) : /* @__PURE__ */ a.jsx(
    W,
    {
      component: "span",
      sx: { display: "inline-block", marginRight: "3px", marginLeft: "3px" },
      children: nb(t, n, r)
    }
  );
}, So = (e) => {
  const { criteriaList: t, conceptSets: n, demographicCriteriaList: r, groups: i } = e;
  return /* @__PURE__ */ a.jsxs("ol", { children: [
    r.length > 0 && /* @__PURE__ */ a.jsx(
      ds,
      {
        criteriaList: r.map((o) => ({
          Demographic: o
        })),
        conceptSets: n
      }
    ),
    t.map((o, s) => {
      var I;
      const {
        Occurrence: l,
        Criteria: c,
        StartWindow: u,
        EndWindow: p,
        IgnoreObservationPeriod: d,
        RestrictVisit: f
      } = o, h = Object.keys(c)[0], g = Object.values(c)[0], C = ao[h], y = us(
        n,
        g.CodesetId,
        (I = C.defaultValue) == null ? void 0 : I.toLowerCase()
      );
      return /* @__PURE__ */ a.jsxs("li", { children: [
        qA(l),
        /* @__PURE__ */ a.jsx(
          zd,
          {
            details: C,
            id: h,
            values: g,
            conceptSets: n,
            conceptSetName: y
          }
        ),
        XA(
          u,
          p,
          d,
          f
        ),
        /* @__PURE__ */ a.jsx("span", { children: "." })
      ] }, h + s);
    }),
    i.length > 0 && i.map((o) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsxs("p", { children: [
        "Restrict entry events to with ",
        On[o.Type],
        " ",
        o.Count || "",
        " of the following criteria:"
      ] }),
      /* @__PURE__ */ a.jsx(
        So,
        {
          criteriaList: o.CriteriaList,
          conceptSets: n,
          demographicCriteriaList: o.DemographicCriteriaList,
          groups: o.Groups
        }
      )
    ] }))
  ] });
}, ib = (e, t) => (e == null ? void 0 : e.filter((n) => t.includes(n))) || [], zd = (e) => {
  const { id: t, values: n, details: r, conceptSetName: i, conceptSets: o } = e, [s, l] = K([]);
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    r.baseTextViewMode,
    " ",
    i,
    /* @__PURE__ */ a.jsx("b", { children: s.length > 0 ? ` (including ${s.join(", ")} source concepts) ` : "" }),
    ib(
      r.attributesSort,
      Object.keys(n)
    ).map((c, u) => {
      var h;
      const p = mr[c], d = n[c], f = (h = o.find((g) => g.id === d)) == null ? void 0 : h.name;
      return p.type === B.GROUP ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsxs("p", { children: [
          "Restrict entry events to with ",
          On[d.Type],
          " ",
          d.Count || "",
          " of the following criteria:"
        ] }),
        /* @__PURE__ */ a.jsx(
          So,
          {
            criteriaList: d.CriteriaList,
            conceptSets: o,
            demographicCriteriaList: d.DemographicCriteriaList,
            groups: d.Groups
          }
        )
      ] }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx(
        rb,
        {
          details: p,
          attr: d,
          index: u,
          setConcept: l,
          conceptSetAttrName: f
        }
      ) });
    })
  ] });
}, ds = (e) => {
  const { criteriaList: t, conceptSets: n } = e;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: t.map((r) => {
    var c;
    const i = Object.keys(r)[0], o = Object.values(r)[0], s = ao[i], l = us(
      n,
      o.CodesetId,
      (c = s.defaultValue) == null ? void 0 : c.toLowerCase()
    );
    return /* @__PURE__ */ a.jsxs("li", { children: [
      /* @__PURE__ */ a.jsx(
        zd,
        {
          details: s,
          id: i,
          values: o,
          conceptSets: n,
          conceptSetName: l
        }
      ),
      /* @__PURE__ */ a.jsx("span", { children: "." })
    ] });
  }) });
}, ob = (e, t) => {
  if (e == 0 && t == 0) return "";
  let n = "with continuous observation of";
  return e > 0 && (n = t > 0 ? `${n} ${e} days before` : `${n} ${e} days before event`), t > 0 && (n = e > 0 ? `${n} and ${t} days after event` : `${n} ${t} days after event`), n;
}, ab = (e) => {
  const { CriteriaList: t, ObservationWindow: n, PrimaryCriteriaLimit: r, conceptSets: i } = e;
  return t.length == 0 ? /* @__PURE__ */ a.jsx("section", { children: /* @__PURE__ */ a.jsxs("p", { children: [
    "Limit cohort entry events to the",
    " ",
    io(r.Type),
    " per person"
  ] }) }) : /* @__PURE__ */ a.jsxs("section", { children: [
    /* @__PURE__ */ a.jsxs("p", { children: [
      "People",
      " ",
      ob(
        n.PriorDays,
        n.PostDays
      ),
      " ",
      "may enter the cohort when observing any of the following:"
    ] }),
    /* @__PURE__ */ a.jsx("ol", { children: /* @__PURE__ */ a.jsx(
      ds,
      {
        criteriaList: t,
        conceptSets: i
      }
    ) }),
    /* @__PURE__ */ a.jsxs("p", { children: [
      "Limit cohort entry events to the",
      " ",
      io(r.Type),
      " per person"
    ] })
  ] });
}, sb = (e) => {
  const {
    CriteriaList: t,
    DemographicCriteriaList: n,
    limit: r,
    conceptSets: i,
    Groups: o,
    Type: s,
    Count: l
  } = e;
  return t.length == 0 && n.length == 0 && o.length == 0 ? /* @__PURE__ */ a.jsx("section", { children: /* @__PURE__ */ a.jsxs("p", { children: [
    "Limit restrict initial events to the ",
    io(r.Type),
    " ",
    "per person"
  ] }) }) : /* @__PURE__ */ a.jsxs("section", { children: [
    /* @__PURE__ */ a.jsxs("p", { children: [
      "Restrict entry events to with ",
      On[s],
      " ",
      l || "",
      " of the following criteria:"
    ] }),
    /* @__PURE__ */ a.jsx(
      So,
      {
        criteriaList: t,
        conceptSets: i,
        demographicCriteriaList: n,
        groups: o
      }
    ),
    /* @__PURE__ */ a.jsxs("p", { children: [
      "Limit restrict initial events to the ",
      io(r.Type),
      " per person"
    ] })
  ] });
}, lb = (e) => {
  const { inclusionRules: t, conceptSets: n } = e;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: t.map((r) => {
    const {
      name: i,
      description: o,
      expression: { CriteriaList: s, DemographicCriteriaList: l, Groups: c }
    } = r;
    return /* @__PURE__ */ a.jsxs("section", { children: [
      /* @__PURE__ */ a.jsxs("h4", { children: [
        i,
        ": ",
        o
      ] }),
      /* @__PURE__ */ a.jsx(
        So,
        {
          criteriaList: s,
          conceptSets: n,
          demographicCriteriaList: l,
          groups: c
        }
      )
    ] });
  }) });
}, cb = (e) => {
  const { endStrategy: t, conceptSets: n, criteriaList: r } = e;
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx("section", { children: QA(t, n) }),
    /* @__PURE__ */ a.jsxs("section", { children: [
      r.length > 0 && /* @__PURE__ */ a.jsx("p", { children: "The person exits the cohort when encountering any of the following events:" }),
      /* @__PURE__ */ a.jsx("ol", { children: /* @__PURE__ */ a.jsx(
        ds,
        {
          criteriaList: r,
          conceptSets: n
        }
      ) })
    ] })
  ] });
}, ub = (e) => /* @__PURE__ */ a.jsxs("p", { children: [
  "Entry events will be combined into cohort eras if they are within",
  " ",
  e.collapseSettings.EraPad,
  " days of each other."
] }), db = ({ definition: e }) => {
  const { name: t, expression: n } = e;
  return /* @__PURE__ */ a.jsxs("div", { className: "cohort-view-mode", children: [
    /* @__PURE__ */ a.jsx("h1", { className: "cohort-name", children: t }),
    /* @__PURE__ */ a.jsxs("section", { className: "cohort-entry-events", children: [
      /* @__PURE__ */ a.jsx("h2", { children: "Cohort Entry Events" }),
      /* @__PURE__ */ a.jsx(
        ab,
        {
          ...n.PrimaryCriteria,
          conceptSets: n.ConceptSets
        }
      ),
      n.AdditionalCriteria && /* @__PURE__ */ a.jsx(
        sb,
        {
          ...n.AdditionalCriteria,
          conceptSets: n.ConceptSets,
          limit: n.QualifiedLimit
        }
      )
    ] }),
    n.InclusionRules.length > 0 && /* @__PURE__ */ a.jsxs("section", { className: "cohort-inclusion-criteria", children: [
      /* @__PURE__ */ a.jsx("h2", { children: "Inclusion Criteria" }),
      /* @__PURE__ */ a.jsx(
        lb,
        {
          inclusionRules: n.InclusionRules,
          conceptSets: n.ConceptSets,
          limit: n.ExpressionLimit
        }
      )
    ] }),
    /* @__PURE__ */ a.jsxs("section", { className: "cohort-exit", children: [
      /* @__PURE__ */ a.jsx("h2", { children: "Cohort Exit" }),
      /* @__PURE__ */ a.jsx(
        cb,
        {
          endStrategy: n.EndStrategy,
          criteriaList: n == null ? void 0 : n.CensoringCriteria,
          conceptSets: n.ConceptSets
        }
      )
    ] }),
    (n == null ? void 0 : n.CollapseSettings.EraPad) > 0 && /* @__PURE__ */ a.jsxs("section", { className: "cohort-eras", children: [
      /* @__PURE__ */ a.jsx("h2", { children: "Cohort Eras" }),
      /* @__PURE__ */ a.jsx(
        ub,
        {
          collapseSettings: n == null ? void 0 : n.CollapseSettings,
          censorWindow: n == null ? void 0 : n.CensorWindow
        }
      )
    ] })
  ] });
}, Wd = [
  {
    id: "RACE",
    name: "Race",
    startText: "a race of",
    attr: "race",
    domainId: "Race",
    desc: "",
    value: []
  },
  {
    id: "GENDER",
    name: "Gender",
    desc: "",
    attr: "gender",
    domainId: "Gender",
    startText: "a gender of",
    value: []
  },
  {
    id: "ETHNICITY",
    name: "Ethnicity",
    desc: "",
    attr: "ethnicity",
    startText: "a ethnicity of",
    domainId: "Ethnicity",
    value: []
  },
  {
    id: "AGE",
    name: "Age",
    attr: "age",
    desc: "",
    value: {
      Value: "",
      Extent: "",
      Op: ye.GREATER_THAN
    },
    startText: "with age in years"
  },
  {
    id: "INDEX_DATE",
    name: "Date Ranges",
    attr: "dateRanges",
    desc: "",
    value: {
      Value: "",
      Extent: "",
      Op: ye.LESS_THAN
    },
    startText: "date range of"
  }
], Yd = (e) => {
  const {
    name: t,
    startText: n,
    domainId: r,
    value: i,
    updateAttribute: o,
    subModules: s,
    viewMode: l,
    id: c,
    showSelectAll: u
  } = e, p = (i == null ? void 0 : i.map((d) => d.CONCEPT_NAME).filter(Boolean).join(", ")) || "-";
  return /* @__PURE__ */ a.jsxs(A, { container: !0, alignItems: l ? "baseline" : "center", spacing: 1, children: [
    n && /* @__PURE__ */ a.jsx(A, { item: !0, minWidth: l ? 120 : 175, mr: 1, children: /* @__PURE__ */ a.jsx(fe, { variant: "body2", color: "#000000", children: n }) }),
    /* @__PURE__ */ a.jsx(
      A,
      {
        item: !0,
        flexGrow: 1,
        minWidth: 0,
        maxWidth: `calc(100% - ${n ? l ? 130 : 190 : 0}px)`,
        children: l ? /* @__PURE__ */ a.jsx(fe, { variant: "body2", fontWeight: 700, children: p }) : /* @__PURE__ */ a.jsx(
          s.vocabulary,
          {
            type: "component",
            name: "add-concepts-widget",
            subModules: s,
            config: {
              value: i,
              domainId: r,
              onAddConcepts: (d) => o(c, d),
              placeholder: "Select " + (t == null ? void 0 : t.toLowerCase()) + "...",
              showSelectAll: u
            }
          }
        )
      }
    )
  ] });
}, pb = (e = {}) => e && Object.keys(e).flatMap((t) => {
  const n = Wd.find((r) => r.attr === t);
  if (n)
    return n.id === "AGE" || n.id === "INDEX_DATE" ? e[t].map((r) => ({
      ...n,
      id: Dn(),
      type: n.id,
      value: {
        Op: r.Op,
        Extent: r.Extent,
        Value: r.Value
      }
    })) : {
      ...n,
      id: Dn(),
      type: n.id,
      value: e[t].map((r) => ({
        CONCEPT_ID: r.CONCEPT_ID,
        CONCEPT_NAME: r.CONCEPT_NAME
      }))
    };
}).filter(Boolean), hb = (e) => {
  const { viewMode: t, values: n, subModules: r, onChange: i } = e, [o, s] = K(pb(n)), l = (d) => {
    s((f) => f.filter((h) => h.id !== d));
  }, c = ["RACE", "GENDER", "ETHNICITY"], u = ie(
    (d, f) => {
      const h = f.map((g) => g.type);
      return d.filter((g) => c.includes(g.id) ? !h.includes(g.id) : !0);
    },
    [o]
  );
  q(() => {
    const d = {};
    o.forEach((f) => {
      f.type === "AGE" || f.type === "INDEX_DATE" ? (d[f.attr] || (d[f.attr] = []), d[f.attr].push({
        Op: f.value.Op,
        Extent: f.value.Extent,
        Value: f.value.Value
      })) : d[f.attr] = f.value.map((h) => ({
        CONCEPT_ID: h.CONCEPT_ID,
        CONCEPT_NAME: h.CONCEPT_NAME
      }));
    }), i(d);
  }, [o]);
  const p = (d, f) => {
    switch (d.type) {
      case "RACE":
      case "GENDER":
      case "ETHNICITY":
        return /* @__PURE__ */ a.jsx(
          Yd,
          {
            id: d.id,
            name: d.name,
            startText: d.startText,
            type: d.domainId,
            value: d.value,
            subModules: r,
            updateAttribute: (h, g) => {
              s((C) => C.map(
                (y) => y.id === h ? { ...y, value: g } : y
              ));
            },
            domainId: d.domainId,
            viewMode: t,
            showSelectAll: d.type !== "RACE"
          }
        );
      case "AGE":
      case "INDEX_DATE":
        return /* @__PURE__ */ a.jsx(a.Fragment, { children: d.type == "INDEX_DATE" ? /* @__PURE__ */ a.jsx(
          ku,
          {
            id: d.id,
            name: d.name,
            startText: d.startText,
            value: d.value,
            updateAttribute: (h, g) => {
              s(
                (C) => C.map((y) => y.id !== h ? y : { ...y, value: g })
              );
            },
            viewMode: t
          }
        ) : /* @__PURE__ */ a.jsx(
          Ba,
          {
            id: d.id,
            name: d.name,
            startText: d.startText,
            value: d.value,
            updateAttribute: (h, g) => {
              s(
                (C) => C.map((y) => y.id !== h ? y : { ...y, value: g })
              );
            },
            viewMode: t
          }
        ) });
      default:
        return /* @__PURE__ */ a.jsx(a.Fragment, {});
    }
  };
  return /* @__PURE__ */ a.jsxs(A, { container: !0, children: [
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: /* @__PURE__ */ a.jsxs(
      A,
      {
        container: !0,
        alignItems: "center",
        justifyContent: "space-between",
        pb: 2,
        children: [
          /* @__PURE__ */ a.jsx(A, { item: !0, children: /* @__PURE__ */ a.jsx(fe, { variant: "subtitle2", children: "You can optionally provide additional attributes to explicitly check for existence of particular data. These checks will affect the final data source scoring." }) }),
          /* @__PURE__ */ a.jsx(A, { item: !0, textAlign: "right", className: "criteria-action", children: !t && /* @__PURE__ */ a.jsx(
            Rn,
            {
              variant: "contained",
              color: "info",
              options: u(
                Wd,
                o
              ),
              onClick: (d) => {
                s((f) => [
                  ...f,
                  {
                    ...d,
                    type: d.id,
                    id: Dn()
                  }
                ]);
              },
              title: "Add attribute",
              name: "Add attribute",
              closeOnSelect: !0,
              preventOverflow: !0,
              startIcon: /* @__PURE__ */ a.jsx(
                ge,
                {
                  iconName: "add",
                  sx: { "&.MuiSvgIcon-root": { fontSize: 16 } }
                }
              )
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ a.jsx(A, { item: !0, xs: 12, children: o.map((d, f) => /* @__PURE__ */ a.jsxs(Pu, { children: [
      /* @__PURE__ */ a.jsx(ju, { children: p(d) }),
      !t && /* @__PURE__ */ a.jsx(Lu, { children: /* @__PURE__ */ a.jsx(
        Cr,
        {
          color: "error",
          iconName: "delete",
          onClick: () => l(d.id),
          title: "Delete",
          tooltipText: "Delete",
          name: "closeCriteriaButton",
          noExpand: !0
        }
      ) })
    ] }, d.id)) })
  ] });
}, fb = Ze((e) => {
  const { name: t, config: n, ...r } = e, {
    onChange: i,
    parentId: o,
    typeContainer: s,
    values: l,
    viewMode: c,
    buttonText: u,
    titleText: p,
    contextConceptSets: d,
    initialData: f,
    isSelect: h,
    returnEntityText: g,
    isDesignStrata: C,
    strataParams: y,
    onChangeStrataOnly: I,
    onChangeStrataBy: O,
    hiddenParentConcept: S,
    classNameContainer: N,
    collapsible: _,
    description: R,
    defaultState: P,
    withAlias: U,
    attrName: M,
    value: w,
    startText: V,
    domainId: L,
    standardConcept: te,
    showSelectAll: $,
    hideIgnoreObservationPeriod: v,
    hideOccurrence: J,
    renderSectionContentBeforeCriteria: j,
    useCohortSectionButtons: ee,
    hideCriteriaGroupHeader: Q,
    hideTopLevelCriteriaControls: x,
    criteriaSectionsSx: Y,
    criteriaButtonsSx: k
  } = n;
  return /* @__PURE__ */ a.jsxs(Le.Fragment, { children: [
    t === "widget-cohort-import-button" && /* @__PURE__ */ a.jsx(
      $f,
      {
        ...r,
        typeContainer: s,
        parentId: o,
        onChange: i,
        initialData: f,
        multiple: h,
        returnEntityText: g,
        path: r.path,
        withAlias: U,
        containerProps: {
          titleText: p,
          buttonText: u,
          description: R,
          defaultState: P,
          collapsible: _,
          classNameContainer: N,
          viewMode: c
        }
      }
    ),
    t === "widget-criteria-group" && /* @__PURE__ */ a.jsx(
      wA,
      {
        ...r,
        onChange: i,
        typeContainer: s,
        parentId: o,
        values: l,
        viewMode: c,
        addCriteriaButton: u,
        title: p,
        contextConceptSets: d,
        isDesignStrata: C,
        strataParams: y,
        onChangeStrataOnly: I,
        onChangeStrataBy: O,
        hiddenParentConcept: S,
        hideIgnoreObservationPeriod: v,
        hideOccurrence: J,
        renderSectionContentBeforeCriteria: j,
        useCohortSectionButtons: ee,
        hideCriteriaGroupHeader: Q,
        hideTopLevelCriteriaControls: x,
        criteriaSectionsSx: Y,
        criteriaButtonsSx: k
      }
    ),
    t === "widget-criteria-attributes" && /* @__PURE__ */ a.jsx(
      hb,
      {
        ...r,
        viewMode: c,
        values: l,
        onChange: i
      }
    ),
    t === "widget-attribute-value" && /* @__PURE__ */ a.jsx(
      Ba,
      {
        id: M,
        name: M,
        startText: V,
        value: w,
        updateAttribute: i,
        viewMode: c
      }
    ),
    t === "widget-attribute-vocabulary" && // <AttributeVocabulary
    //   id={attrName}
    //   name={name}
    //   startText={startText || ''}
    //   value={value}
    //   subModules={props.subModules}
    //   updateAttribute={onChange}
    //   domainId={domainId}
    //   standardConcept={standardConcept}
    //   viewMode={viewMode}
    //   extend={false}
    // />
    /* @__PURE__ */ a.jsx(
      Yd,
      {
        name: M,
        startText: V || "",
        domainId: L,
        value: w,
        updateAttribute: i,
        subModules: e.subModules,
        viewMode: c,
        id: M,
        showSelectAll: $
      }
    ),
    t === "home-widget-cohort" && /* @__PURE__ */ a.jsx(PA, {}),
    t === "create-cohort-from-concept-set" && /* @__PURE__ */ a.jsx(
      HA,
      {
        ...e.config,
        subModules: e.subModules
      }
    ),
    t === "cohort-view-mode" && /* @__PURE__ */ a.jsx(db, { definition: f })
  ] });
}), Ob = (e) => {
  const { type: t } = e;
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    !t && /* @__PURE__ */ a.jsx(CA, { ...e }),
    t === "component" && /* @__PURE__ */ a.jsx(fb, { ...e })
  ] });
};
export {
  Ob as Cohort
};
//# sourceMappingURL=cohorts.js.map
